(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Order = {}));
})(this, (function (exports) { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function commonjsRequire (path) {
		throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
	}

	var lib$1 = {exports: {}};

	(function (module, exports) {
	  (function (global, factory) {
	    factory(exports) ;
	  })(commonjsGlobal, function (exports) {
	    /**
	     *  Used as a singleton event channel, which does not need any initialization.
	     *  Events can be listened to and emitted from any stage and anywhere.
	     *  Events are emitted over a tree of listeners, e.g. for `action/add-ticket/123`,
	     *  all listeners on `action`, `action/add-ticket` and `action/add-ticket/123` are
	     *  triggered.
	     */

	    class EventBus {
	      constructor(config) {
	        // Registered listeners
	        this.listeners = {}; // Internal map that keeps listener metadata by id

	        this._map = {};
	        this._config = config || {};
	      } // Subscribe to events by path


	      on(path, listener) {
	        if (path.length < 1) {
	          this.listeners.listeners = this.listeners.listeners || [];
	          this.listeners.listeners.push(listener);
	        } else {
	          // Set the root of the tree
	          let root = this.listeners; // Itererate over the path

	          for (let i = 0; i < path.length; i++) {
	            // Get the next node
	            const node = root[path[i]]; // If it is undefined, define it

	            if (!node) {
	              root[path[i]] = {};
	            } // Set the new root


	            root = root[path[i]]; // Check if it is the last part of the path

	            if (i === path.length - 1) {
	              // Make sure listeners is not undefined
	              root.listeners = root.listeners || []; // Add the listener

	              root.listeners.push(listener);
	            }
	          }
	        }

	        const id = this._generateId();

	        this._map[id] = {
	          path,
	          listener
	        };
	        return id;
	      }
	      /**
	       * Remove a listener from the event bus
	       * @param id - as provided by the 'on' method
	       */


	      off(id) {
	        var _a, _b;

	        if (!this._map[id]) {
	          throw Error('Listener does not exist');
	        }

	        const path = this._map[id].path;
	        const listener = this._map[id].listener;
	        let root = this.listeners;

	        while (path.length > 0) {
	          const part = path.shift();
	          root = root[part];

	          if (path.length < 1) {
	            const index = (_a = root.listeners) === null || _a === void 0 ? void 0 : _a.findIndex(value => value === listener);

	            if (index === undefined || index < 0) {
	              throw Error('Listener not found in tree');
	            }

	            (_b = root.listeners) === null || _b === void 0 ? void 0 : _b.splice(index, 1);
	          }
	        }

	        delete this._map[id];
	      } // Emit data to it's listeners by path


	      emit(path, data) {
	        // If the env is development, log all events to the console
	        if (this._config.isDebug) {
	          // eslint-disable-next-line no-console
	          console.info('EVENT', path, data);
	        } // Array of relevant listeners


	        let to = []; // Set the root of the tree

	        let root = this.listeners; // Iterate over the path's parts

	        for (let i = 0; i <= path.length; i++) {
	          // If the current node has listeners,
	          // add them to the list of relevant listeners
	          if (root.listeners) {
	            to = [...to, ...root.listeners];
	          } // Check if the next node exists


	          if (root[path[i]]) {
	            // If it does, set it as new root
	            root = root[path[i]];
	          } else {
	            // Otherwise, stop iterating
	            break;
	          }
	        } // Notify all listeners


	        for (const listener of to) {
	          const pathCopy = [...path];

	          if (data && typeof data === 'object') {
	            data = JSON.parse(JSON.stringify(data));
	          }

	          setTimeout(() => {
	            listener(pathCopy, data);
	          }, 0);
	        }
	      }
	      /**
	       * Basic id generator
	       * src: https://www.w3resource.com/javascript-exercises/javascript-math-exercise-23.php
	       */


	      _generateId() {
	        let dt = new Date().getTime();
	        const id = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[x]/g, function (c) {
	          var r = (dt + Math.random() * 16) % 16 | 0;
	          dt = Math.floor(dt / 16);
	          return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	        });
	        return id;
	      }

	    }

	    class EventScope {
	      constructor(eventBus) {
	        this._eventBus = eventBus;
	      }
	      /**
	       *  Listen to events by providing a path and a callback to the `on` function
	       *  @param path - Path to listen to
	       *  @param cb - Will be called when an event occurs
	       */


	      on(path, cb, noScope = false) {
	        // If the path is not yet an array, use it as a single path segment
	        if (!Array.isArray(path)) {
	          if (path === '*') {
	            path = [];
	          } else {
	            path = [path];
	          }
	        } else {
	          path = [...path];
	        } // If the eventScope is set, prefix the path with it


	        if (this._eventScope && !noScope) {
	          path = [this._eventScope, ...path];
	        } // Relay to the actual event bus


	        return this._eventBus.on(path, cb);
	      }
	      /**
	       * Remove a listener from the event bus
	       * @param id - listener id as provided by the 'on' method
	       */


	      off(id) {
	        this._eventBus.off(id);
	      }
	      /**
	       *  Emit an event from the eventScope
	       *  @param path - The path on which the event occurred
	       *  @param payload - The data to be send
	       */


	      emit(path, payload, noScope = false) {
	        // If the path is not yet an array, use it as a single path segment
	        if (!Array.isArray(path)) {
	          path = [path];
	        } // If the eventScope is set, prefix the path with it


	        if (this._eventScope && !noScope) {
	          path = [this._eventScope, ...path];
	        } // Relay to the actual event bus


	        this._eventBus.emit(path, payload);
	      }

	    }

	    const EventBusSingleton = new EventBus();
	    exports.EventBusSingleton = EventBusSingleton;
	    exports.EventScope = EventScope;
	    exports.default = EventBus;
	    Object.defineProperty(exports, '__esModule', {
	      value: true
	    });
	  });
	})(lib$1, lib$1.exports);

	var EventBus = /*@__PURE__*/getDefaultExportFromCjs(lib$1.exports);

	var pure$1 = {};

	Object.defineProperty(pure$1, '__esModule', {
	  value: true
	});

	function _typeof(obj) {
	  "@babel/helpers - typeof";

	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }

	  return _typeof(obj);
	}

	var V3_URL = 'https://js.stripe.com/v3';
	var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
	var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';

	var findScript = function findScript() {
	  var scripts = document.querySelectorAll("script[src^=\"".concat(V3_URL, "\"]"));

	  for (var i = 0; i < scripts.length; i++) {
	    var script = scripts[i];

	    if (!V3_URL_REGEX.test(script.src)) {
	      continue;
	    }

	    return script;
	  }

	  return null;
	};

	var injectScript = function injectScript(params) {
	  var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
	  var script = document.createElement('script');
	  script.src = "".concat(V3_URL).concat(queryString);
	  var headOrBody = document.head || document.body;

	  if (!headOrBody) {
	    throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
	  }

	  headOrBody.appendChild(script);
	  return script;
	};

	var registerWrapper = function registerWrapper(stripe, startTime) {
	  if (!stripe || !stripe._registerWrapper) {
	    return;
	  }

	  stripe._registerWrapper({
	    name: 'stripe-js',
	    version: "1.22.0",
	    startTime: startTime
	  });
	};

	var stripePromise = null;

	var loadScript$1 = function loadScript(params) {
	  // Ensure that we only attempt to load Stripe.js at most once
	  if (stripePromise !== null) {
	    return stripePromise;
	  }

	  stripePromise = new Promise(function (resolve, reject) {
	    if (typeof window === 'undefined') {
	      // Resolve to null when imported server side. This makes the module
	      // safe to import in an isomorphic code base.
	      resolve(null);
	      return;
	    }

	    if (window.Stripe && params) {
	      console.warn(EXISTING_SCRIPT_MESSAGE);
	    }

	    if (window.Stripe) {
	      resolve(window.Stripe);
	      return;
	    }

	    try {
	      var script = findScript();

	      if (script && params) {
	        console.warn(EXISTING_SCRIPT_MESSAGE);
	      } else if (!script) {
	        script = injectScript(params);
	      }

	      script.addEventListener('load', function () {
	        if (window.Stripe) {
	          resolve(window.Stripe);
	        } else {
	          reject(new Error('Stripe.js not available'));
	        }
	      });
	      script.addEventListener('error', function () {
	        reject(new Error('Failed to load Stripe.js'));
	      });
	    } catch (error) {
	      reject(error);
	      return;
	    }
	  });
	  return stripePromise;
	};

	var initStripe = function initStripe(maybeStripe, args, startTime) {
	  if (maybeStripe === null) {
	    return null;
	  }

	  var stripe = maybeStripe.apply(undefined, args);
	  registerWrapper(stripe, startTime);
	  return stripe;
	};

	var validateLoadParams = function validateLoadParams(params) {
	  var errorMessage = "invalid load parameters; expected object of shape\n\n    {advancedFraudSignals: boolean}\n\nbut received\n\n    ".concat(JSON.stringify(params), "\n");

	  if (params === null || _typeof(params) !== 'object') {
	    throw new Error(errorMessage);
	  }

	  if (Object.keys(params).length === 1 && typeof params.advancedFraudSignals === 'boolean') {
	    return params;
	  }

	  throw new Error(errorMessage);
	};

	var loadParams;
	var loadStripeCalled = false;

	var loadStripe = function loadStripe() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }

	  loadStripeCalled = true;
	  var startTime = Date.now();
	  return loadScript$1(loadParams).then(function (maybeStripe) {
	    return initStripe(maybeStripe, args, startTime);
	  });
	};

	loadStripe.setLoadParameters = function (params) {
	  if (loadStripeCalled) {
	    throw new Error('You cannot change load parameters after calling loadStripe');
	  }

	  loadParams = validateLoadParams(params);
	};

	pure$1.loadStripe = loadStripe;

	var pure = pure$1;

	var __awaiter$8 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	/**
	 * Base for connections to cross window clients
	 */


	class CrossWindowBase {
	  constructor(_config) {
	    /**
	     * Indicates if there is a connection initiated with a cross window client
	     */
	    this.isConnected = false;

	    if (!_config) {
	      throw new Error('No configuration provided');
	    }

	    if (!_config.scope || !_config.window) {
	      throw new Error('The provided configuration is incomplete');
	    }

	    if (_config.window === window) {
	      throw new Error('Cannot use the current window as a target');
	    } // Set the config


	    this._config = _config; // Prevent Vue from trying to observe a cross-domain address,
	    // as this will lead to a security error on modern browsers

	    Object.freeze(this._config);
	    this.connecting = new Promise((resolve, reject) => {
	      this._resolveConnecting = resolve;
	      this._rejectConnecting = reject;
	    }); // Start listening to events on its own window
	    // (the _config.window is used to post messages to the other peer's listener)

	    window.addEventListener('message', ev => this._onMessage(ev)); // Send initial handshake message

	    this._sendRawMessage({
	      _isOpenticket: true,
	      init: 'SYN',
	      scope: this._config.scope
	    });
	  }
	  /**
	   * Internal handler for messages to do basic checks and filter spam
	   * @param event - The event that is received
	   */


	  _onMessage(event) {
	    return __awaiter$8(this, void 0, void 0, function* () {
	      // Discard other messages
	      if (!event.data || !event.data._isOpenticket) {
	        return;
	      } // Clients can only interact with non-clients


	      if (event.data.scope === 'client' && this._config.scope === 'client') {
	        return;
	      } // Non-clients can only interact with clients


	      if (event.data.scope !== 'client' && this._config.scope !== 'client') {
	        return;
	      } // Discard if the origin of the event is different from the target window


	      if (event.source !== this._config.window && process.env.NODE_ENV !== 'test') {
	        return;
	      } // Check if the message is an `init` message


	      if (event.data.init) {
	        if (event.data.init === 'SYN') {
	          this._sendMessage({
	            init: 'SYN-ACK',
	            payload: this._initData
	          });
	        } else if (event.data.init === 'SYN-ACK') {
	          yield this.onConnect(event.data.payload);

	          this._sendMessage({
	            init: 'ACK',
	            payload: this._initData
	          });

	          this.isConnected = true;

	          this._resolveConnecting();
	        } else if (event.data.init === 'ACK') {
	          yield this.onConnect(event.data.payload);
	          this.isConnected = true;

	          this._resolveConnecting();
	        }

	        return;
	      } // Pass the message to the implemented handler


	      yield this.onMessage(event);
	    });
	  }
	  /**
	   * This method will be called when the connection is established
	   * @param data - The data that is received
	   */


	  onConnect(data) {
	    return __awaiter$8(this, void 0, void 0, function* () {// Implement this method in the super class
	    });
	  }
	  /**
	   * This method should be implemented by classes using this one,
	   * it will be called when a message arrives
	   * @param event - The event that is received
	   */


	  onMessage(event) {
	    return __awaiter$8(this, void 0, void 0, function* () {// Implement this method in the super class
	    });
	  }
	  /**
	   * Notify the peer of an error that occurred
	   * @param error - A string containing the error desription
	   */


	  _sendError(error) {
	    this._sendMessage({
	      error
	    });
	  }
	  /**
	   * Internal send method
	   * @param data - Payload of the message
	   */


	  _sendMessage(data) {
	    this._sendRawMessage(Object.assign({
	      _isOpenticket: true,
	      scope: this._config.scope
	    }, data));
	  }
	  /**
	   * Sends a raw message to the specified window
	   * @param data - Payload of the message
	   */


	  _sendRawMessage(data) {
	    this._config.window.postMessage(data, '*');
	  }

	}

	var __awaiter$7 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	/*
	 * Handles to cross window request for the order
	 */

	class CrossWindowShop extends CrossWindowBase {
	  constructor(_window, _shop) {
	    super({
	      window: _window,
	      scope: 'shop'
	    });
	    /**
	     * Data received from the client on connect
	     */

	    this.client = null;
	    /**
	     * Pass the tweak config to the client on connect
	     */

	    this._initData = null;
	    this.shop = _shop;
	    this._initData = {
	      localization: {
	        currency: this.shop.data.currency,
	        locale: this.shop.data.company.locale
	      },
	      initErrors: {
	        valid: !this.shop.initErrors.length,
	        errors: this.shop.initErrors
	      }
	    }; // Listen to all shop initialization events

	    this.shop.onLog(['shop', 'init'], (path, payload) => this._initError(path, payload));
	    this.shop.onLog(['shop', 'overwriteData'], (path, payload) => this._initError(path, payload));
	    this.shop.onLog(['shop', 'updateData'], (path, payload) => this._initError(path, payload)); // Listen to all shop events

	    this.shop._eventBus.on(['shop'], () => this._updateShopData()); // Listen to all cart events


	    this.shop._eventBus.on(['cart'], (path, data) => {
	      // Don't propagate loading state, as generating and passing through
	      // the cart data is too much overhead.
	      if (data && data.busy === true) {
	        return;
	      }

	      this._updateCartData();
	    }); // Listen to seats events


	    this.shop._eventBus.on(['seats'], path => {
	      this._sendMessage({
	        action: 'seats',
	        scope: 'shop',
	        data: {
	          state: path[1]
	        }
	      });
	    });

	    this.shop._eventBus.on(['cart', 'locale'], (path, locale) => {
	      this._sendMessage({
	        action: 'locale',
	        scope: 'shop',
	        data: {
	          locale
	        }
	      });
	    }); // Listen for notifications


	    this.shop._eventBus.on(['notification'], (path, data) => {
	      this._sendMessage({
	        action: 'notification',
	        data
	      });
	    }); // Listen for client-notifications (only meant for clients)


	    this.shop._eventBus.on(['client-notification'], (path, data) => {
	      this._sendMessage({
	        action: 'client-notification',
	        data
	      });
	    }); // Listen for router changes


	    this.shop._eventBus.on(['router'], (path, data) => {
	      this._sendMessage({
	        action: 'router',
	        data
	      });
	    });
	  }

	  sendCustomMessage(action, data) {
	    this._sendMessage({
	      action: 'custom',
	      scope: 'shop',
	      data
	    });
	  }
	  /**
	   * Handled messaging for the OpenTicketBase class
	   * @param event - data from the event
	   */


	  onMessage(event) {
	    return __awaiter$7(this, void 0, void 0, function* () {
	      const message = event.data;

	      if (message.scope !== 'client') {
	        return;
	      }

	      yield this.onClientMessage(event);
	    });
	  }
	  /**
	   *  Handle established connection data
	   *  @param data - The data that is received
	   */


	  onConnect(data) {
	    const _super = Object.create(null, {
	      onConnect: {
	        get: () => super.onConnect
	      }
	    });

	    return __awaiter$7(this, void 0, void 0, function* () {
	      yield _super.onConnect.call(this, data);
	      this.client = data;

	      if (data && Object.prototype.hasOwnProperty.call(data, 'debugMode')) {
	        this.shop.setDebugMode(!!data.debugMode);
	      }
	    });
	  }
	  /**
	   * Handle incoming messages
	   * @param event - Received message
	   */


	  onClientMessage(event) {
	    return __awaiter$7(this, void 0, void 0, function* () {
	      const message = event.data; // TODO: handle all cases

	      try {
	        switch (message.type) {
	          case 'ticket':
	            switch (message.action) {
	              case 'add':
	                yield this.shop.cart.addTicket(message.guid);
	                break;

	              case 'remove':
	                yield this.shop.cart.removeTicket(message.guid);
	                break;
	            }

	            break;

	          case 'product':
	            switch (message.action) {
	              case 'add':
	                yield this.shop.cart.addProduct(message.guid);
	                break;

	              case 'remove':
	                yield this.shop.cart.removeProduct(message.guid);
	                break;
	            }

	            break;

	          case 'coupon':
	            switch (message.action) {
	              case 'add':
	                yield this.shop.cart.addCoupon(message.code);
	                break;

	              case 'remove':
	                yield this.shop.cart.removeCoupon(message.code);
	                break;
	            }

	            break;

	          case 'booker_information':
	            this.shop.cart.setBookerInformation(message.data);
	            break;

	          case 'static_settings':
	            this.shop.events.emit(['settings', 'static'], message.data);
	        }
	      } catch (e) {
	        this._sendError(`${e}`);
	      }
	    });
	  }
	  /**
	   * Send an update for init errors
	   */


	  _initError(_, payload) {
	    this._sendMessage({
	      action: 'init',
	      scope: 'shop',
	      data: JSON.parse(JSON.stringify({
	        valid: !this.shop.initErrors.length,
	        errors: this.shop.initErrors,
	        session: payload.session,
	        id: payload.id,
	        slug: payload.slug,
	        message: payload.message
	      }))
	    });
	  }
	  /**
	   * Send an update event containing the shop data
	   */


	  _updateShopData() {
	    this._sendMessage({
	      action: 'update',
	      scope: 'shop',
	      data: JSON.parse(JSON.stringify(this.shop.data))
	    });
	  }
	  /**
	   * Send an update event containing the cart data
	   */


	  _updateCartData() {
	    const tickets = {};

	    for (const cartTicket of Object.values(this.shop.cart.flatItems.tickets)) {
	      const guid = cartTicket.item.guid;
	      tickets[guid] = this.shop.cart.getTicketInfo(guid);
	    }

	    const products = {};

	    for (const cartProduct of Object.values(this.shop.cart.flatItems.products)) {
	      const guid = cartProduct.item.guid;
	      products[guid] = this.shop.cart.getProductInfo(guid);
	    }

	    const checkout_details = JSON.parse(JSON.stringify(this.shop.cart.checkout_details));

	    this._sendMessage({
	      action: 'update',
	      scope: 'cart',
	      data: {
	        tickets,
	        products,
	        checkout_details
	      }
	    });
	  }

	}

	var lodash = {exports: {}};

	(function(module,exports){(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined$1;/** Used as the semantic version number. */var VERSION='4.17.21';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',FUNC_ERROR_TEXT='Expected a function',INVALID_TEMPL_VAR_ERROR_TEXT='Invalid `variable` option passed into `_.template`';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** Used to compose bitmasks for value comparisons. */var COMPARE_PARTIAL_FLAG=1,COMPARE_UNORDERED_FLAG=2;/** Used to compose bitmasks for function metadata. */var WRAP_BIND_FLAG=1,WRAP_BIND_KEY_FLAG=2,WRAP_CURRY_BOUND_FLAG=4,WRAP_CURRY_FLAG=8,WRAP_CURRY_RIGHT_FLAG=16,WRAP_PARTIAL_FLAG=32,WRAP_PARTIAL_RIGHT_FLAG=64,WRAP_ARY_FLAG=128,WRAP_REARG_FLAG=256,WRAP_FLIP_FLAG=512;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',WRAP_ARY_FLAG],['bind',WRAP_BIND_FLAG],['bindKey',WRAP_BIND_KEY_FLAG],['curry',WRAP_CURRY_FLAG],['curryRight',WRAP_CURRY_RIGHT_FLAG],['flip',WRAP_FLIP_FLAG],['partial',WRAP_PARTIAL_FLAG],['partialRight',WRAP_PARTIAL_RIGHT_FLAG],['rearg',WRAP_REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',asyncTag='[object AsyncFunction]',boolTag='[object Boolean]',dateTag='[object Date]',domExcTag='[object DOMException]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',nullTag='[object Null]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',undefinedTag='[object Undefined]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading whitespace. */var reTrimStart=/^\s+/;/** Used to match a single whitespace character. */var reWhitespace=/\s/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */var reForbiddenIdentifierChars=/[()=,{}\[\]\/\s]/;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange='\\ud800-\\udfff',rsComboMarksRange='\\u0300-\\u036f',reComboHalfMarksRange='\\ufe20-\\ufe2f',rsComboSymbolsRange='\\u20d0-\\u20ff',rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,rsDingbatRange='\\u2700-\\u27bf',rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange='\\u2000-\\u206f',rsSpaceRange=' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange='\\ufe0e\\ufe0f',rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos="['\u2019]",rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz='\\ud83c[\\udffb-\\udfff]',rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional='(?:\\ud83c[\\udde6-\\uddff]){2}',rsSurrPair='[\\ud800-\\udbff][\\udc00-\\udfff]',rsUpper='['+rsUpperRange+']',rsZWJ='\\u200d';/** Used to compose unicode regexes. */var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsOrdLower='\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',rsOrdUpper='\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,rsUpper+'+'+rsOptContrUpper,rsOrdUpper,rsOrdLower,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
	'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
	'\u0100':'A','\u0102':'A','\u0104':'A','\u0101':'a','\u0103':'a','\u0105':'a','\u0106':'C','\u0108':'C','\u010a':'C','\u010c':'C','\u0107':'c','\u0109':'c','\u010b':'c','\u010d':'c','\u010e':'D','\u0110':'D','\u010f':'d','\u0111':'d','\u0112':'E','\u0114':'E','\u0116':'E','\u0118':'E','\u011a':'E','\u0113':'e','\u0115':'e','\u0117':'e','\u0119':'e','\u011b':'e','\u011c':'G','\u011e':'G','\u0120':'G','\u0122':'G','\u011d':'g','\u011f':'g','\u0121':'g','\u0123':'g','\u0124':'H','\u0126':'H','\u0125':'h','\u0127':'h','\u0128':'I','\u012a':'I','\u012c':'I','\u012e':'I','\u0130':'I','\u0129':'i','\u012b':'i','\u012d':'i','\u012f':'i','\u0131':'i','\u0134':'J','\u0135':'j','\u0136':'K','\u0137':'k','\u0138':'k','\u0139':'L','\u013b':'L','\u013d':'L','\u013f':'L','\u0141':'L','\u013a':'l','\u013c':'l','\u013e':'l','\u0140':'l','\u0142':'l','\u0143':'N','\u0145':'N','\u0147':'N','\u014a':'N','\u0144':'n','\u0146':'n','\u0148':'n','\u014b':'n','\u014c':'O','\u014e':'O','\u0150':'O','\u014d':'o','\u014f':'o','\u0151':'o','\u0154':'R','\u0156':'R','\u0158':'R','\u0155':'r','\u0157':'r','\u0159':'r','\u015a':'S','\u015c':'S','\u015e':'S','\u0160':'S','\u015b':'s','\u015d':'s','\u015f':'s','\u0161':'s','\u0162':'T','\u0164':'T','\u0166':'T','\u0163':'t','\u0165':'t','\u0167':'t','\u0168':'U','\u016a':'U','\u016c':'U','\u016e':'U','\u0170':'U','\u0172':'U','\u0169':'u','\u016b':'u','\u016d':'u','\u016f':'u','\u0171':'u','\u0173':'u','\u0174':'W','\u0175':'w','\u0176':'Y','\u0177':'y','\u0178':'Y','\u0179':'Z','\u017b':'Z','\u017d':'Z','\u017a':'z','\u017c':'z','\u017e':'z','\u0132':'IJ','\u0133':'ij','\u0152':'Oe','\u0153':'oe','\u0149':"'n",'\u017f':'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r','\u2028':'u2028','\u2029':'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=typeof commonjsGlobal=='object'&&commonjsGlobal&&commonjsGlobal.Object===Object&&commonjsGlobal;/** Detect free variable `self`. */var freeSelf=typeof self=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports=exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&'object'=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{// Use `util.types` for Node.js 10+.
	var types=freeModule&&freeModule.require&&freeModule.require('util').types;if(types){return types;}// Legacy `process.binding('util')` for Node.js < 10.
	return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*/ /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array==null?0:array.length;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */function arrayEachRight(array,iteratee){var length=array==null?0:array.length;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */function arrayEvery(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */function arrayIncludes(array,value){var length=array==null?0:array.length;return !!length&&baseIndexOf(array,value,0)>-1;}/**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array==null?0:array.length;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array==null?0:array.length;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array==null?0:array.length;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */function arraySome(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */var asciiSize=baseProperty('length');/**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function asciiToArray(string){return string.split('');}/**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return -1;}/**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return -1;}/**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */function baseIsNaN(value){return value!==value;}/**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */function baseMean(array,iteratee){var length=array==null?0:array.length;return length?baseSum(array,iteratee)/length:NAN;}/**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */function baseProperty(key){return function(object){return object==null?undefined$1:object[key];};}/**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */function basePropertyOf(object){return function(key){return object==null?undefined$1:object[key];};}/**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined$1){result=result===undefined$1?current:result+current;}}return result;}/**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */function baseToPairs(object,props){return arrayMap(props,function(key){return [key,object[key]];});}/**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */function baseTrim(string){return string?string.slice(0,trimmedEndIndex(string)+1).replace(reTrimStart,''):string;}/**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */function baseUnary(func){return function(value){return func(value);};}/**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */function cacheHas(cache,key){return cache.has(key);}/**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */var deburrLetter=basePropertyOf(deburredLetters);/**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */function escapeStringChar(chr){return '\\'+stringEscapes[chr];}/**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */function getValue(object,key){return object==null?undefined$1:object[key];}/**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */function hasUnicode(string){return reHasUnicode.test(string);}/**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return -1;}/**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */function trimmedEndIndex(string){var index=string.length;while(index--&&reWhitespace.test(string.charAt(index))){}return index;}/**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*/ /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */var runInContext=function runInContext(context){context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */var nativeObjectToString=objectProto.toString;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined$1,Symbol=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined$1,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=Symbol?Symbol.isConcatSpreadable:undefined$1,symIterator=Symbol?Symbol.iterator:undefined$1,symToStringTag=Symbol?Symbol.toStringTag:undefined$1;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined$1,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=Symbol?Symbol.prototype:undefined$1,symbolValueOf=symbolProto?symbolProto.valueOf:undefined$1,symbolToString=symbolProto?symbolProto.toString:undefined$1;/*------------------------------------------------------------------------*/ /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return {};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined$1;return result;};}();/**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */function baseLodash(){// No operation performed.
	}/**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined$1;}/**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */lodash.templateSettings={/**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'escape':reEscape,/**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'evaluate':reEvaluate,/**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'interpolate':reInterpolate,/**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */'variable':'',/**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */'imports':{/**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*/ /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else {result=this.clone();result.__dir__*=-1;}return result;}/**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||!isRight&&arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else {break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*/ /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined$1:result;}return hasOwnProperty.call(data,key)?data[key]:undefined$1;}/**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined$1:hasOwnProperty.call(data,key);}/**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined$1?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
	Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*/ /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */function listCacheClear(){this.__data__=[];this.size=0;}/**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else {splice.call(data,index,1);}--this.size;return true;}/**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined$1:data[index][1];}/**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else {data[index][1]=value;}return this;}// Add methods to `ListCache`.
	ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*/ /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
	MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*/ /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */function SetCache(values){var index=-1,length=values==null?0:values.length;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
	SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*/ /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function stackGet(key){return this.__data__.get(key);}/**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function stackHas(key){return this.__data__.has(key);}/**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
	Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*/ /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
	key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
	isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
	isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
	isIndex(key,length)))){result.push(key);}}return result;}/**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined$1;}/**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function assignMergeValue(object,key,value){if(value!==undefined$1&&!eq(object[key],value)||value===undefined$1&&!(key in object)){baseAssignValue(object,key,value);}}/**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined$1&&!(key in object)){baseAssignValue(object,key,value);}}/**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return -1;}/**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}/**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else {object[key]=value;}}/**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */function baseAt(object,paths){var index=-1,length=paths.length,result=Array(length),skip=object==null;while(++index<length){result[index]=skip?undefined$1:get(object,paths[index]);}return result;}/**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined$1){number=number<=upper?number:upper;}if(lower!==undefined$1){number=number>=lower?number:lower;}}return number;}/**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined$1){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else {var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else {if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,isDeep);}}// Check for circular references and return its corresponding clone.
	stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(isSet(value)){value.forEach(function(subValue){result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));});}else if(isMap(value)){value.forEach(function(subValue,key){result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));});}var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined$1:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
	assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}/**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return !length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined$1&&!(key in object)||!predicate(value)){return false;}}return true;}/**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined$1,args);},wait);}/**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee==null?value:iteratee(value);value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */var baseEach=createBaseEach(baseForOwn);/**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined$1?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined$1||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
	baseFlatten(value,depth-1,predicate,isStrict,result);}else {arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */var baseFor=createBaseFor();/**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */var baseForRight=createBaseFor(true);/**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */function baseGet(object,path){path=castPath(path,object);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined$1;}/**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */function baseGetTag(value){if(value==null){return value===undefined$1?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}/**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */function baseGt(value,other){return value>other;}/**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined$1;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */function baseInvoke(object,path,args){path=castPath(path,object);object=parent(object,path);var func=object==null?object:object[toKey(last(path))];return func==null?undefined$1:apply(func,object,args);}/**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}/**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */function baseIsArrayBuffer(value){return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;}/**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */function baseIsDate(value){return isObjectLike(value)&&baseGetTag(value)==dateTag;}/**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */function baseIsEqual(value,other,bitmask,customizer,stack){if(value===other){return true;}if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);}/**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=objIsArr?arrayTag:getTag(object),othTag=othIsArr?arrayTag:getTag(other);objTag=objTag==argsTag?objectTag:objTag;othTag=othTag==argsTag?objectTag:othTag;var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,bitmask,customizer,equalFunc,stack):equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);}if(!(bitmask&COMPARE_PARTIAL_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,bitmask,customizer,equalFunc,stack);}/**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return !length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined$1&&!(key in object)){return false;}}else {var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined$1?baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):result)){return false;}}}return true;}/**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */function baseIsRegExp(value){return isObjectLike(value)&&baseGetTag(value)==regexpTag;}/**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}/**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	if(typeof value=='function'){return value;}if(value==null){return identity;}if(typeof value=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */function baseLt(value,other){return value<other;}/**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined$1&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);};}/**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){stack||(stack=new Stack());if(isObject(srcValue)){baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else {var newValue=customizer?customizer(safeGet(object,key),srcValue,key+'',object,source,stack):undefined$1;if(newValue===undefined$1){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=safeGet(object,key),srcValue=safeGet(source,key),stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined$1;var isCommon=newValue===undefined$1;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else {newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||isFunction(objValue)){newValue=initCloneObject(srcValue);}}else {isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined$1;}/**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */function baseOrderBy(collection,iteratees,orders){if(iteratees.length){iteratees=arrayMap(iteratees,function(iteratee){if(isArray(iteratee)){return function(value){return baseGet(value,iteratee.length===1?iteratee[0]:iteratee);};}return iteratee;});}else {iteratees=[identity];}var index=-1;iteratees=arrayMap(iteratees,baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return {'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */function basePick(object,paths){return basePickBy(object,paths,function(value,path){return hasIn(object,path);});}/**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */function basePickBy(object,paths,predicate){var index=-1,length=paths.length,result={};while(++index<length){var path=paths[index],value=baseGet(object,path);if(predicate(value,path)){baseSet(result,castPath(path,object),value);}}return result;}/**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else {baseUnset(array,index);}}}return array;}/**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
	// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */function baseSample(collection){return arraySample(values(collection));}/**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=castPath(path,object);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(key==='__proto__'||key==='constructor'||key==='prototype'){return object;}if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined$1;if(newValue===undefined$1){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};/**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return !result;});return !!result;}/**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */function baseSortedIndex(array,value,retHighest){var low=0,high=array==null?low:array.length;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else {high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */function baseSortedIndexBy(array,value,iteratee,retHighest){var low=0,high=array==null?0:array.length;if(high===0){return 0;}value=iteratee(value);var valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined$1;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined$1,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else {setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else {high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return +value;}/**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
	if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
	return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else {seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */function baseUnset(object,path){path=castPath(path,object);object=parent(object,path);return object==null||delete object[toKey(last(path))];}/**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */function baseXor(arrays,iteratee,comparator){var length=arrays.length;if(length<2){return length?baseUniq(arrays[0]):[];}var index=-1,result=Array(length);while(++index<length){var array=arrays[index],othIndex=-1;while(++othIndex<length){if(othIndex!=index){result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);}}}return baseUniq(baseFlatten(result,1),iteratee,comparator);}/**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined$1;assignFunc(result,props[index],value);}return result;}/**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */function castFunction(value){return typeof value=='function'?value:identity;}/**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */function castPath(value,object){if(isArray(value)){return value;}return isKey(value,object)?[value]:stringToPath(toString(value));}/**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */var castRest=baseRest;/**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */function castSlice(array,start,end){var length=array.length;end=end===undefined$1?length:end;return !start&&end>=length?array:baseSlice(array,start,end);}/**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined$1,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined$1,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return -1;}}return 0;}/**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	// that causes it, under certain circumstances, to provide the same value for
	// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	// for more details.
	//
	// This also ensures a stable sort in V8 and other engines.
	// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	return object.index-other.index;}/**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined$1;if(newValue===undefined$1){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else {assignValue(object,key,newValue);}}return object;}/**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}/**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined$1,guard=length>2?sources[2]:undefined$1;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined$1;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined$1:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createBind(func,bitmask,thisArg){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined$1;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
	// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	// for more details.
	var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
	// See https://es5.github.io/#x13.2.2 for more details.
	return isObject(result)?result:thisBinding;};}/**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined$1,args,holders,undefined$1,undefined$1,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined$1;};}/**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined$1;if(data&&isLaziable(data[0])&&data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else {wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&WRAP_ARY_FLAG,isBind=bitmask&WRAP_BIND_FLAG,isBindKey=bitmask&WRAP_BIND_KEY_FLAG,isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),isFlip=bitmask&WRAP_FLIP_FLAG,Ctor=isBindKey?undefined$1:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined$1&&other===undefined$1){return defaultValue;}if(value!==undefined$1){result=value;}if(other!==undefined$1){if(result===undefined$1){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else {value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */function createPadding(length,chars){chars=chars===undefined$1?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined$1;}// Ensure the sign of `-0` is preserved.
	start=toFinite(start);if(end===undefined$1){end=start;start=0;}else {end=toFinite(end);}step=step===undefined$1?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&WRAP_CURRY_FLAG,newHolders=isCurry?holders:undefined$1,newHoldersRight=isCurry?undefined$1:holders,newPartials=isCurry?partials:undefined$1,newPartialsRight=isCurry?undefined$1:partials;bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined$1,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=precision==null?0:nativeMin(toInteger(precision),292);if(precision&&nativeIsFinite(number)){// Shift with exponential notation to avoid floating-point issues.
	// See [MDN](https://mdn.io/round#Examples) for more details.
	var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return +(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);partials=holders=undefined$1;}ary=ary===undefined$1?ary:nativeMax(toInteger(ary),0);arity=arity===undefined$1?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined$1;}var data=isBindKey?undefined$1:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]===undefined$1?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==WRAP_BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else {result=createHybrid.apply(undefined$1,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */function customDefaultsAssignIn(objValue,srcValue,key,object){if(objValue===undefined$1||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */function customDefaultsMerge(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined$1,customDefaultsMerge,stack);stack['delete'](srcValue);}return objValue;}/**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */function customOmitClone(value){return isPlainObject(value)?undefined$1:value;}/**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */function equalArrays(array,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Check that cyclic values are equal.
	var arrStacked=stack.get(array);var othStacked=stack.get(other);if(arrStacked&&othStacked){return arrStacked==other&&othStacked==array;}var index=-1,result=true,seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined$1;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
	while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined$1){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
	if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
	// Invalid dates are coerced to `NaN`.
	return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
	// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	// for more details.
	return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&COMPARE_PARTIAL_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
	var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=COMPARE_UNORDERED_FLAG;// Recursively compare objects (susceptible to call stack limits).
	stack.set(object,other);var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function equalObjects(object,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,objProps=getAllKeys(object),objLength=objProps.length,othProps=getAllKeys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Check that cyclic values are equal.
	var objStacked=stack.get(object);var othStacked=stack.get(other);if(objStacked&&othStacked){return objStacked==other&&othStacked==object;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
	if(!(compared===undefined$1?objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
	if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */function flatRest(func){return setToString(overRest(func,undefined$1,flatten),func+'');}/**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined$1;}/**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined$1;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else {delete value[symToStringTag];}}return result;}/**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return [];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};/**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined$1,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return {'start':start,'end':end};}/**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */function hasPath(object,path,hasFunc){path=castPath(path,object);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object==null?0:object.length;return !!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */function initCloneArray(array){var length=array.length,result=new array.constructor(length);// Add properties assigned by `RegExp#exec`.
	if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return new Ctor();case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return new Ctor();case symbolTag:return cloneSymbol(object);}}/**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */function isIndex(value,length){var type=typeof value;length=length==null?MAX_SAFE_INTEGER:length;return !!length&&(type=='number'||type!='symbol'&&reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=typeof index;if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */function isKey(value,object){if(isArray(value)){return false;}var type=typeof value;if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */function isKeyable(value){var type=typeof value;return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return !!data&&func===data[0];}/**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */function isMasked(func){return !!maskSrcKey&&maskSrcKey in func;}/**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */var isMaskable=coreJsData?isFunction:stubFalse;/**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined$1||key in Object(object));};}/**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);var isCombo=srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;// Exit early if metadata can't be merged.
	if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
	if(srcBitmask&WRAP_BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
	newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;}// Compose partial arguments.
	var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
	value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
	value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
	if(srcBitmask&WRAP_ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
	if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
	data[0]=source[0];data[1]=newBitmask;return data;}/**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */function objectToString(value){return nativeObjectToString.call(value);}/**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */function overRest(func,start,transform){start=nativeMax(start===undefined$1?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */function parent(object,path){return path.length<2?object:baseGet(object,baseSlice(path,0,-1));}/**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined$1;}return array;}/**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */function safeGet(object,key){if(key==='constructor'&&typeof object[key]==='function'){return;}if(key=='__proto__'){return;}return object[key];}/**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */var setData=shortOut(baseSetData);/**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */var setToString=shortOut(baseSetToString);/**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else {count=0;}return func.apply(undefined$1,arguments);};}/**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined$1?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */var stringToPath=memoizeCapped(function(string){var result=[];if(string.charCodeAt(0)===46/* . */){result.push('');}string.replace(rePropName,function(match,number,quote,subString){result.push(quote?subString.replace(reEscapeChar,'$1'):number||match);});return result;});/**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return '';}/**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*/ /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined$1){size=1;}else {size=nativeMax(toInteger(size),0);}var length=array==null?0:array.length;if(!length||size<1){return [];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */function compact(array){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */function concat(){var length=arguments.length;if(!length){return [];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined$1;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined$1;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined$1,comparator):[];});/**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */function drop(array,n,guard){var length=array==null?0:array.length;if(!length){return [];}n=guard||n===undefined$1?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */function dropRight(array,n,guard){var length=array==null?0:array.length;if(!length){return [];}n=guard||n===undefined$1?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */function fill(array,value,start,end){var length=array==null?0:array.length;if(!length){return [];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */function findIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return -1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */function findLastIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return -1;}var index=length-1;if(fromIndex!==undefined$1){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */function flatten(array){var length=array==null?0:array.length;return length?baseFlatten(array,1):[];}/**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */function flattenDeep(array){var length=array==null?0:array.length;return length?baseFlatten(array,INFINITY):[];}/**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */function flattenDepth(array,depth){var length=array==null?0:array.length;if(!length){return [];}depth=depth===undefined$1?1:toInteger(depth);return baseFlatten(array,depth);}/**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */function fromPairs(pairs){var index=-1,length=pairs==null?0:pairs.length,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */function head(array){return array&&array.length?array[0]:undefined$1;}/**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */function indexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return -1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */function initial(array){var length=array==null?0:array.length;return length?baseSlice(array,0,-1):[];}/**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined$1;}else {mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);comparator=typeof comparator=='function'?comparator:undefined$1;if(comparator){mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined$1,comparator):[];});/**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */function join(array,separator){return array==null?'':nativeJoin.call(array,separator);}/**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */function last(array){var length=array==null?0:array.length;return length?array[length-1]:undefined$1;}/**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */function lastIndexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return -1;}var index=length;if(fromIndex!==undefined$1){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined$1;}/**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */var pull=baseRest(pullAll);/**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined$1,comparator):array;}/**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */var pullAt=flatRest(function(array,indexes){var length=array==null?0:array.length,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */function reverse(array){return array==null?array:nativeReverse.call(array);}/**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */function slice(array,start,end){var length=array==null?0:array.length;if(!length){return [];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else {start=start==null?0:toInteger(start);end=end===undefined$1?length:toInteger(end);}return baseSlice(array,start,end);}/**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */function sortedIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return -1;}/**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */function sortedLastIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return -1;}/**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */function tail(array){var length=array==null?0:array.length;return length?baseSlice(array,1,length):[];}/**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */function take(array,n,guard){if(!(array&&array.length)){return [];}n=guard||n===undefined$1?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */function takeRight(array,n,guard){var length=array==null?0:array.length;if(!length){return [];}n=guard||n===undefined$1?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined$1;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined$1;return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined$1,comparator);});/**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */function uniqWith(array,comparator){comparator=typeof comparator=='function'?comparator:undefined$1;return array&&array.length?baseUniq(array,undefined$1,comparator):[];}/**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */function unzip(array){if(!(array&&array.length)){return [];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */function unzipWith(array,iteratee){if(!(array&&array.length)){return [];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined$1,group);});}/**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined$1;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined$1;return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined$1,comparator);});/**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */var zip=baseRest(unzip);/**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined$1;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined$1;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*/ /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */function tap(value,interceptor){interceptor(value);return value;}/**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */function thru(value,interceptor){return interceptor(value);}/**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined$1});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined$1);}return array;});});/**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */function wrapperChain(){return chain(this);}/**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */function wrapperNext(){if(this.__values__===undefined$1){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined$1:this.__values__[this.__index__++];return {'done':done,'value':value};}/**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */function wrapperToIterator(){return this;}/**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined$1;if(result){previous.__wrapped__=clone;}else {result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined$1});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*/ /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else {baseAssignValue(result,key,1);}});/**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined$1;}return func(collection,getIteratee(predicate,3));}/**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */var find=createFind(findIndex);/**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */var findLast=createFind(findLastIndex);/**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined$1?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else {baseAssignValue(result,key,[value]);}});/**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);});return result;});/**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return [];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined$1:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return [[],[]];});/**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined$1){n=1;}else {n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined$1;}return func(collection,getIteratee(predicate,3));}/**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return [];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*/ /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*/ /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */function ary(func,n,guard){n=guard?undefined$1:n;n=func&&n==null?func.length:n;return createWrap(func,WRAP_ARY_FLAG,undefined$1,undefined$1,undefined$1,undefined$1,n);}/**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined$1;}return result;};}/**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */var bind=baseRest(function(func,thisArg,partials){var bitmask=WRAP_BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */var bindKey=baseRest(function(object,key,partials){var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */function curry(func,arity,guard){arity=guard?undefined$1:arity;var result=createWrap(func,WRAP_CURRY_FLAG,undefined$1,undefined$1,undefined$1,undefined$1,undefined$1,arity);result.placeholder=curry.placeholder;return result;}/**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */function curryRight(func,arity,guard){arity=guard?undefined$1:arity;var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined$1,undefined$1,undefined$1,undefined$1,undefined$1,arity);result.placeholder=curryRight.placeholder;return result;}/**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined$1;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
	lastInvokeTime=time;// Start the timer for the trailing edge.
	timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
	return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,timeWaiting=wait-timeSinceLastCall;return maxing?nativeMin(timeWaiting,maxWait-timeSinceLastInvoke):timeWaiting;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
	// trailing edge, the system time has gone backwards and we're treating
	// it as the trailing edge, or we've hit the `maxWait` limit.
	return lastCallTime===undefined$1||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
	timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined$1;// Only invoke if we have `lastArgs` which means `func` has been
	// debounced at least once.
	if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined$1;return result;}function cancel(){if(timerId!==undefined$1){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined$1;}function flush(){return timerId===undefined$1?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined$1){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
	clearTimeout(timerId);timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined$1){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */function flip(func){return createWrap(func,WRAP_FLIP_FLAG);}/**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */function memoize(func,resolver){if(typeof func!='function'||resolver!=null&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
	memoize.Cache=MapCache;/**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return !predicate.call(this);case 1:return !predicate.call(this,args[0]);case 2:return !predicate.call(this,args[0],args[1]);case 3:return !predicate.call(this,args[0],args[1],args[2]);}return !predicate.apply(this,args);};}/**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */function once(func){return before(2,func);}/**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,WRAP_PARTIAL_FLAG,undefined$1,partials,holders);});/**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined$1,partials,holders);});/**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */var rearg=flatRest(function(func,indexes){return createWrap(func,WRAP_REARG_FLAG,undefined$1,undefined$1,undefined$1,indexes);});/**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined$1?start:toInteger(start);return baseRest(func,start);}/**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start==null?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */function unary(func){return ary(func,1);}/**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */function wrap(value,wrapper){return partial(castFunction(wrapper),value);}/*------------------------------------------------------------------------*/ /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */function castArray(){if(!arguments.length){return [];}var value=arguments[0];return isArray(value)?value:[value];}/**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */function clone(value){return baseClone(value,CLONE_SYMBOLS_FLAG);}/**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */function cloneWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined$1;return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);}/**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}/**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */function cloneDeepWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined$1;return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);}/**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */var gt=createRelationalOperation(baseGt);/**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */var isArray=Array.isArray;/**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&baseGetTag(value)==boolTag;}/**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */var isBuffer=nativeIsBuffer||stubFalse;/**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */function isElement(value){return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);}/**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */function isEmpty(value){if(value==null){return true;}if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return !value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return !value.size;}if(isPrototype(value)){return !baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */function isEqual(value,other){return baseIsEqual(value,other);}/**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined$1;var result=customizer?customizer(value,other):undefined$1;return result===undefined$1?baseIsEqual(value,other,undefined$1,customizer):!!result;}/**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */function isError(value){if(!isObjectLike(value)){return false;}var tag=baseGetTag(value);return tag==errorTag||tag==domExcTag||typeof value.message=='string'&&typeof value.name=='string'&&!isPlainObject(value);}/**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
	// in Safari 9 which returns 'object' for typed arrays and other constructors.
	var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}/**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */function isObject(value){var type=typeof value;return value!=null&&(type=='object'||type=='function');}/**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */function isObjectLike(value){return value!=null&&typeof value=='object';}/**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined$1;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
	// Perform the `toStringTag` check first to avoid errors with some
	// ActiveX objects in IE.
	return isNumber(value)&&value!=+value;}/**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */function isNull(value){return value===null;}/**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */function isNil(value){return value==null;}/**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&baseGetTag(value)==numberTag;}/**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}/**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */function isSymbol(value){return typeof value=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}/**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */function isUndefined(value){return value===undefined$1;}/**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */function isWeakSet(value){return isObjectLike(value)&&baseGetTag(value)==weakSetTag;}/**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */var lt=createRelationalOperation(baseLt);/**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */function toArray(value){if(!value){return [];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(symIterator&&value[symIterator]){return iteratorToArray(value[symIterator]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=baseTrim(value);var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */function toSafeInteger(value){return value?baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):value===0?value:0;}/**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*/ /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */var at=flatRest(baseAt);/**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */function create(prototype,properties){var result=baseCreate(prototype);return properties==null?result:baseAssign(result,properties);}/**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var defaults=baseRest(function(object,sources){object=Object(object);var index=-1;var length=sources.length;var guard=length>2?sources[2]:undefined$1;if(guard&&isIterateeCall(sources[0],sources[1],guard)){length=1;}while(++index<length){var source=sources[index];var props=keysIn(source);var propsIndex=-1;var propsLength=props.length;while(++propsIndex<propsLength){var key=props[propsIndex];var value=object[key];if(value===undefined$1||eq(value,objectProto[key])&&!hasOwnProperty.call(object,key)){object[key]=source[key];}}}return object;});/**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */var defaultsDeep=baseRest(function(args){args.push(undefined$1,customDefaultsMerge);return apply(mergeWith,undefined$1,args);});/**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */function get(object,path,defaultValue){var result=object==null?undefined$1:baseGet(object,path);return result===undefined$1?defaultValue:result;}/**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */var invert=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}result[value]=key;},constant(identity));/**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */var invertBy=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}if(hasOwnProperty.call(result,value)){result[value].push(key);}else {result[value]=[key];}},getIteratee);/**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */var invoke=baseRest(baseInvoke);/**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */var omit=flatRest(function(object,paths){var result={};if(object==null){return result;}var isDeep=false;paths=arrayMap(paths,function(path){path=castPath(path,object);isDeep||(isDeep=path.length>1);return path;});copyObject(object,getAllKeysIn(object),result);if(isDeep){result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);}var length=paths.length;while(length--){baseUnset(result,paths[length]);}return result;});/**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */var pick=flatRest(function(object,paths){return object==null?{}:basePick(object,paths);});/**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */function pickBy(object,predicate){if(object==null){return {};}var props=arrayMap(getAllKeysIn(object),function(prop){return [prop];});predicate=getIteratee(predicate);return basePickBy(object,props,function(value,path){return predicate(value,path[0]);});}/**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */function result(object,path,defaultValue){path=castPath(path,object);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
	if(!length){length=1;object=undefined$1;}while(++index<length){var value=object==null?undefined$1:object[toKey(path[index])];if(value===undefined$1){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined$1;return object==null?object:baseSet(object,path,value,customizer);}/**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */var toPairs=createToPairs(keys);/**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */var toPairsIn=createToPairs(keysIn);/**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else {accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined$1;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */function values(object){return object==null?[]:baseValues(object,keys(object));}/**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*/ /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */function clamp(number,lower,upper){if(upper===undefined$1){upper=lower;lower=undefined$1;}if(upper!==undefined$1){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined$1){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */function inRange(number,start,end){start=toFinite(start);if(end===undefined$1){end=start;start=0;}else {end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined$1;}if(floating===undefined$1){if(typeof upper=='boolean'){floating=upper;upper=undefined$1;}else if(typeof lower=='boolean'){floating=lower;lower=undefined$1;}}if(lower===undefined$1&&upper===undefined$1){lower=0;upper=1;}else {lower=toFinite(lower);if(upper===undefined$1){upper=lower;lower=0;}else {upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*/ /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined$1?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */var lowerFirst=createCaseFirst('toLowerCase');/**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined$1){n=1;}else {n=toInteger(n);}return baseRepeat(toString(string),n);}/**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined$1;}limit=limit===undefined$1?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return [];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */function startsWith(string,target,position){string=toString(string);position=position==null?0:baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
	// (http://ejohn.org/blog/javascript-micro-templating/)
	// and Laura Doktorova's doT.js (https://github.com/olado/doT).
	var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined$1;}string=toString(string);options=assignInWith({},options,settings,customDefaultsAssignIn);var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
	var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
	// The sourceURL gets injected into the source that's eval-ed, so be careful
	// to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	// and escape the comment, thus injecting code that gets evaled.
	var sourceURL='//# sourceURL='+(hasOwnProperty.call(options,'sourceURL')?(options.sourceURL+'').replace(/\s/g,' '):'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
	source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
	if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
	// order to produce the correct `offset` value.
	return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
	// code to add the data object to the top of the scope chain.
	var variable=hasOwnProperty.call(options,'variable')&&options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Throw an error if a forbidden character was found in `variable`, to prevent
	// potential command injection attacks.
	else if(reForbiddenIdentifierChars.test(variable)){throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);}// Cleanup code by stripping empty strings.
	source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
	source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined$1,importsValues);});// Provide the compiled function's source by its `toString` method or
	// the `source` property as a convenience for inlining compiled templates.
	result.source=source;if(isError(result)){throw result;}return result;}/**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */function toLower(value){return toString(value).toLowerCase();}/**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */function toUpper(value){return toString(value).toUpperCase();}/**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined$1)){return baseTrim(string);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined$1)){return string.slice(0,trimmedEndIndex(string)+1);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined$1)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined$1){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined$1?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */var upperFirst=createCaseFirst('toUpperCase');/**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined$1:pattern;if(pattern===undefined$1){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*/ /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */var attempt=baseRest(function(func,args){try{return apply(func,undefined$1,args);}catch(e){return isError(e)?e:new Error(e);}});/**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */function cond(pairs){var length=pairs==null?0:pairs.length,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return [toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */function conforms(source){return baseConforms(baseClone(source,CLONE_DEEP_FLAG));}/**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */function constant(value){return function(){return value;};}/**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */var flow=createFlow();/**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */var flowRight=createFlow(true);/**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */function identity(value){return value;}/**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,CLONE_DEEP_FLAG));}/**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */function matches(source){return baseMatches(baseClone(source,CLONE_DEEP_FLAG));}/**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));}/**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */function noop(){// No operation performed.
	}/**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */var over=createOver(arrayMap);/**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */var overEvery=createOver(arrayEvery);/**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */var overSome=createOver(arraySome);/**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */function propertyOf(object){return function(path){return object==null?undefined$1:baseGet(object,path);};}/**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */var range=createRange();/**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */var rangeRight=createRange(true);/**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */function stubArray(){return [];}/**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */function stubFalse(){return false;}/**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */function stubObject(){return {};}/**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */function stubString(){return '';}/**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */function stubTrue(){return true;}/**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return [];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));}/**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*/ /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */var ceil=createRound('ceil');/**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */var floor=createRound('floor');/**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined$1;}/**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined$1;}/**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */function mean(array){return baseMean(array,identity);}/**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined$1;}/**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined$1;}/**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */var round=createRound('round');/**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
	lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
	lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
	mixin(lodash,lodash);/*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
	lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
	lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*/ /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */lodash.VERSION=VERSION;// Assign default placeholders.
	arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){n=n===undefined$1?1:nativeMax(toInteger(n),0);var result=this.__filtered__&&!index?new LazyWrapper(this):this.clone();if(result.__filtered__){result.__takeCount__=nativeMin(n,result.__takeCount__);}else {result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
	arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
	arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined$1){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
	baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
	isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined$1});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
	arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
	baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'';if(!hasOwnProperty.call(realNames,key)){realNames[key]=[];}realNames[key].push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined$1,WRAP_BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined$1}];// Add methods to `LazyWrapper`.
	LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
	lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
	lodash.prototype.first=lodash.prototype.head;if(symIterator){lodash.prototype[symIterator]=wrapperToIterator;}return lodash;};/*--------------------------------------------------------------------------*/ // Export lodash.
	var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
	if(freeModule){// Export for Node.js.
	(freeModule.exports=_)._=_;// Export for CommonJS support.
	freeExports._=_;}else {// Export to the global object.
	root._=_;}}).call(commonjsGlobal);})(lodash,lodash.exports);

	/**
	 *  @internal Used for iterating over an object's keys. Any inherited or custom properties will be skipped.
	 *
	 *  > Note that order is not guaranteed!
	 *
	 *  Optionally the callback can be bound to some object/instance by providing it as the last argument.
	 *  E.g.: `callback.call(thisArg, ...arguments);`
	 *
	 *  ```ts
	 *
	 *  interface SomeInterface {
	 *      [key: string]: string
	 *  }
	 *
	 *  const SomeObject = function (this: SomeInterface) {
	 *
	 *      this.value_a = 'test-value-a';
	 *      this.value_b = 'test-value-b';
	 *      this.value_c = 'test-value-c';
	 *      this.value_d = 'test-value-d';
	 *
	 *  } as any as { new(): SomeInterface, currentIndex: number, increment: () => number };
	 *
	 *  SomeObject.prototype.currentIndex = 0;
	 *
	 *  SomeObject.prototype.increment = function (): number {
	 *
	 *      SomeObject.prototype.currentIndex++;
	 *
	 *      return SomeObject.prototype.currentIndex;
	 *
	 *  };
	 *
	 *  const someObject = new SomeObject();
	 *
	 *  forOwn(someObject, function (this: typeof SomeObject, currentValue: string, currentKey: string, fullObject: SomeInterface) {
	 *
	 *      if (this.currentIndex > 1) {
	 *
	 *          // Returning false (not falsy) will abort the iteration, any remaining key-value pairs will not be visited
	 *          return false;
	 *
	 *      }
	 *
	 *      console.log(currentKey, currentValue);
	 *
	 *      this.increment();
	 *
	 *      // Returning true or void will continue the iteration.
	 *      return; //return true;
	 *
	 *  }, someObject);
	 *
	 *  ```
	 *
	 *  @internal
	 *
	 */
	function forOwn(obj, cb, thisArg) {
	  for (const key in obj) {
	    // Ignore any prototype properties
	    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
	      continue;
	    } // Break if callback returns false


	    if (false === cb.call(thisArg, obj[key], key, obj)) {
	      break;
	    }
	  }
	}

	/**
	 *  @internal Used to iterate over an Array his members, with the ability to break if
	 *  needed - by returning false in the callback.
	 */
	function forEach$2(items, cb, thisArg) {
	  if (!Array.isArray(items)) {
	    throw new TypeError(`ForEach util: provided items is not an Array: ${items}`);
	  }

	  items.every((item, index) => {
	    return false !== cb.call(thisArg, item, index, items);
	  });
	}

	/**
	 *  @internal
	 *
	 *  Used to determine if two arrays include the same values.
	 *  No more, no less.
	 */
	function arraysMatch(a, b) {
	  // First try some things to see if early fail/succeed is possible
	  // This is WAY more efficient
	  if (a === b) {
	    return true;
	  }

	  if (!Array.isArray(a) || !Array.isArray(b)) {
	    return false;
	  }

	  if (a.length !== b.length) {
	    return false;
	  }

	  if (!a.length) {
	    return true;
	  }

	  const aSorted = Array.from(a).sort();
	  const bSorted = Array.from(b).sort();
	  let matches = true;
	  forEach$2(aSorted, valueA => {
	    if (valueA !== bSorted.shift()) {
	      matches = false;
	    }

	    return matches;
	  });
	  return matches;
	}

	function flattenObject(data, separator = '.') {
	  if (!data) {
	    return {};
	  }

	  return _flattenObject(data, separator, '', {}, [data]);
	}

	function _flattenObject(data, separator, prefix, flatData, cyclic) {
	  if (prefix) {
	    prefix += separator;
	  } // Holds objects to be handled after all current level values/references are processed.


	  const objects = {};
	  forOwn(data, (value, key) => {
	    if (typeof value === 'object' && value !== null && !(value instanceof String) && !(value instanceof Number) && !(value instanceof Boolean)) {
	      if (cyclic.indexOf(value) > -1) {
	        return;
	      }

	      cyclic.push(value); // Register object to handle AFTER all current level values/references.
	      // As higher level references are preferred over nested cyclic references.

	      objects[key] = value;
	    } else {
	      flatData[`${prefix}${key}`] = value;
	    }
	  }); // Handle all objects recursively

	  forOwn(objects, (value, key) => {
	    _flattenObject(value, separator, `${prefix}${key}`, flatData, cyclic);
	  });
	  return flatData;
	}

	/**
	 *  @internal Used to define if an enum includes the provided
	 *  value, as TypeScript transpiles enums to objects.
	 */

	function enumIncludes(enumValues, value) {
	  if (enumValues.constructor !== Object) {
	    throw new TypeError(`EnumIncludes util: provided enum is not an Object: ${enumValues}`);
	  }

	  if (!value) {
	    throw new Error('EnumIncludes util: value to check not provided');
	  }

	  let includes = false;
	  forOwn(enumValues, enumValue => {
	    if (enumValue === value) {
	      includes = true;
	    }

	    return !includes;
	  });
	  return includes;
	}

	function isIndexSortable(model) {
	  // noinspection SuspiciousTypeOfGuard
	  return model && typeof model.index === 'number';
	}

	function isStartSortable(model) {
	  // noinspection SuspiciousTypeOfGuard
	  return model && model.start instanceof Date;
	}
	/**
	 *  @internal Used to sort a collection of models. It first tries
	 *  to sort them based on index, otherwise based on start.
	 *
	 *  (!) Even though returning A - B seems to be faster in FireFox and Safari
	 *  based on a performance test - instead of returning 0 when A === B - the
	 *  latter seems to be faster in practice for also FireFox and Safari.
	 */


	function modelSort(modelA, modelB) {
	  // First try to sort on index
	  if (isIndexSortable(modelA) && isIndexSortable(modelB)) {
	    return modelA.index === modelB.index ? 0 : modelA.index < modelB.index ? -1 : 1;
	  } // Secondly try to sort on start (date)


	  if (isStartSortable(modelA) && isStartSortable(modelB)) {
	    const timeA = modelA.start.getTime();
	    const timeB = modelB.start.getTime();
	    return timeA === timeB ? 0 : timeA - timeB;
	  }

	  return 0;
	}

	const promises = {};
	function loadScript(src) {
	  if (promises[src]) {
	    return promises[src];
	  }

	  promises[src] = new Promise((resolve, reject) => {
	    try {
	      const script = document.createElement('script');
	      script.src = src;
	      script.addEventListener('load', () => {
	        resolve(script);
	      });
	      script.addEventListener('error', () => {
	        reject(new Error(`Failed to load script: ${src}`));
	      });
	      document.head.appendChild(script);
	    } catch (error) {
	      reject(error);
	    }
	  });
	  return promises[src];
	}

	/**
	 *  Parse the URI's query into keys and values.
	 *
	 *  Multiple values per key are supported, as are key only query params.
	 */

	function parseQuery() {
	  if (!document || !document.location || !document.location.search) {
	    return {};
	  }

	  const queryString = document.location.search; // Split the query string into parts after stripping the leading `?`

	  const queryParts = queryString.substr(queryString.indexOf('?') === 0 ? 1 : 0).split('&'); // Split the query parts into key and value if applicable
	  // Note: There is no specified query format, so empty values are possible.

	  const queryPartsZipped = queryParts.map(part => {
	    const eqPos = queryString.indexOf('=');
	    return [part.substr(0, eqPos > -1 ? eqPos : undefined), eqPos > -1 ? part.substr(eqPos + 1) : ''];
	  }).filter(([key]) => !!key); // Transform the parts into a map.
	  // Note: keys can be present multiple times,
	  // so we will start with assuming multiple values.
	  // However, due to the unspecified format,
	  // we will not split a single key with comma separated values,
	  // as there is no way of knowing if the comma is a separator or a value!

	  const queryMap = {};
	  forEach$2(queryPartsZipped, ([key, value]) => {
	    queryMap[key] = queryMap[key] || [];
	    queryMap[key].push(value);
	  }); // Transform all single length arrays into strings

	  const query = {};
	  forOwn(queryMap, (values, key) => {
	    if (values.length > 1) {
	      query[key] = values;
	    } else {
	      query[key] = values[0];
	    }
	  });
	  return query;
	}

	function guessTimezone() {
	  try {
	    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	    if (zone && zone.length > 3) {
	      return zone;
	    }
	  } catch (e) {// Cannot precisely retrieve timezone!
	  }

	  return undefined;
	}

	var __awaiter$6 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};

	let adsBlockedPromise;
	/**
	 *  @internal Used to guess if the user uses an ad blocker.
	 *
	 *  (!) This will make a (HEAD) call to google's ad services,
	 *  without cors, credentials (cookies) and referrer.
	 */

	function adsBlocked() {
	  return __awaiter$6(this, void 0, void 0, function* () {
	    if (adsBlockedPromise) {
	      return yield adsBlockedPromise;
	    }

	    if (!window || !window.fetch) {
	      return true;
	    }

	    adsBlockedPromise = window.fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
	      method: 'HEAD',
	      mode: 'no-cors',
	      credentials: 'omit',
	      referrerPolicy: 'no-referrer',
	      cache: 'no-store'
	    }).then(() => false).catch(() => true);
	    return yield adsBlockedPromise;
	  });
	}

	const realIds = {};
	let counter = 0;
	const MAX_DELAY = Math.pow(2, 31) - 1;
	function setLargeTimeout(handler, timeout, ...args) {
	  return _setLargeTimeout(counter++, handler, timeout, ...args);
	}

	function _setLargeTimeout(index, handler, timeout, ...args) {
	  if (!timeout || timeout <= MAX_DELAY) {
	    realIds[index] = window.setTimeout(() => {
	      delete realIds[index];
	      handler.call(undefined, ...args);
	    }, timeout, ...args);
	    return index;
	  }

	  timeout -= MAX_DELAY;
	  realIds[index] = window.setTimeout(() => {
	    _setLargeTimeout(index, handler, timeout, ...args);
	  }, MAX_DELAY);
	  return index;
	}

	let random$1 = bytes => crypto.getRandomValues(new Uint8Array(bytes));

	let customRandom$1 = (alphabet, size, getRandom) => {
	  let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
	  let step = -~(1.6 * mask * size / alphabet.length);
	  return () => {
	    let id = '';

	    while (true) {
	      let bytes = getRandom(step);
	      let j = step;

	      while (j--) {
	        id += alphabet[bytes[j] & mask] || '';
	        if (id.length === size) return id;
	      }
	    }
	  };
	};

	let customAlphabet$1 = (alphabet, size) => customRandom$1(alphabet, size, random$1);

	// This is assuming 100.000 ids per hour.
	// src: https://zelark.github.io/nano-id-cc/

	customAlphabet$1('346789ABCDEFGHJKLMNPQRTUVWXY', 12);

	function leapYear$1(year) {
	  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	}

	function checkFalsePositiveDates$1(dateString = '') {
	  if (dateString.length === 10) {
	    // massage input to use yyyy-mm-dd format
	    // we support yyyy/mm/dd or yyyy.mm.dd
	    let normalizedDate = dateString.replace('.', '-').replace('/', '-');
	    let parts = normalizedDate.split('-');

	    if (parts.length === 3) {
	      if (parts[0].length === 4) {
	        // yyyy-mm-dd format
	        let y = parseInt(parts[0]);
	        let m = parseInt(parts[1]);
	        let d = parseInt(parts[2]);

	        if (m === 2) {
	          // return leapYear(y) ? d <= 29 : d <= 28;
	          if (leapYear$1(y)) {
	            if (d > 29) {
	              return false;
	            }
	          } else {
	            if (d > 28) {
	              return false;
	            }
	          }
	        }

	        if (m === 4 || m === 6 || m === 9 || m === 11) {
	          if (d > 30) {
	            return false;
	          }
	        }
	      }
	    }

	    return true; // we are not in feburary, proceed
	  }

	  return true; // we are not testing formatted date, proceed to rest of validation
	}

	function isValidDate$1(dateString) {
	  let testDate;

	  if (typeof dateString === 'number') {
	    testDate = new Date(dateString);

	    if (typeof testDate === 'object') {
	      return true;
	    }
	  } // first convert incoming string to date object and see if it correct date and format


	  testDate = new Date(dateString);

	  if (typeof testDate === 'object') {
	    if (testDate.toString() === 'Invalid Date') {
	      return false;
	    }
	    /**
	     * Check for false positive dates
	     * perform special check on february as JS `new Date` incorrectly returns valid date
	     * Eg.  let newDate = new Date('2020-02-29')  // returns as March 02 2020
	     * Eg.  let newDate = new Date('2019-02-29')  // returns as March 01 2020
	     * Eg.  let newDate = new Date('2019-04-31')  // returns as April 30 2020
	     */


	    if (!checkFalsePositiveDates$1(dateString)) {
	      return false;
	    } // valid date object and not a february date


	    return true;
	  } // First check for the pattern


	  var regex_date = /^\d{4}\-\d{1,2}\-\d{1,2}$/;

	  if (!regex_date.test(dateString)) {
	    return false;
	  } // Parse the date parts to integers


	  var parts = dateString.split("-");
	  var day = parseInt(parts[2], 10);
	  var month = parseInt(parts[1], 10);
	  var year = parseInt(parts[0], 10); // Check the ranges of month and year

	  if (year < 1000 || year > 3000 || month == 0 || month > 12) {
	    return false;
	  }

	  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Adjust for leap years

	  if (year % 400 == 0 || year % 100 != 0 && year % 4 == 0) {
	    monthLength[1] = 29;
	  } // Check the range of the day


	  return day > 0 && day <= monthLength[month - 1];
	}

	var rules = {
	  required: function (val) {
	    var str;

	    if (val === undefined || val === null) {
	      return false;
	    }

	    str = String(val).replace(/\s/g, "");
	    return str.length > 0 ? true : false;
	  },
	  required_if: function (val, req, attribute) {
	    req = this.getParameters();

	    if (this.validator._objectPath(this.validator.input, req[0]) === req[1]) {
	      return this.validator.getRule("required").validate(val);
	    }

	    return true;
	  },
	  required_unless: function (val, req, attribute) {
	    req = this.getParameters();

	    if (this.validator._objectPath(this.validator.input, req[0]) !== req[1]) {
	      return this.validator.getRule("required").validate(val);
	    }

	    return true;
	  },
	  required_with: function (val, req, attribute) {
	    if (this.validator._objectPath(this.validator.input, req)) {
	      return this.validator.getRule("required").validate(val);
	    }

	    return true;
	  },
	  required_with_all: function (val, req, attribute) {
	    req = this.getParameters();

	    for (var i = 0; i < req.length; i++) {
	      if (!this.validator._objectPath(this.validator.input, req[i])) {
	        return true;
	      }
	    }

	    return this.validator.getRule("required").validate(val);
	  },
	  required_without: function (val, req, attribute) {
	    if (this.validator._objectPath(this.validator.input, req)) {
	      return true;
	    }

	    return this.validator.getRule("required").validate(val);
	  },
	  required_without_all: function (val, req, attribute) {
	    req = this.getParameters();

	    for (var i = 0; i < req.length; i++) {
	      if (this.validator._objectPath(this.validator.input, req[i])) {
	        return true;
	      }
	    }

	    return this.validator.getRule("required").validate(val);
	  },
	  boolean: function (val) {
	    return val === true || val === false || val === 0 || val === 1 || val === "0" || val === "1" || val === "true" || val === "false";
	  },
	  // compares the size of strings
	  // with numbers, compares the value
	  size: function (val, req, attribute) {
	    if (val) {
	      req = parseFloat(req);
	      var size = this.getSize();
	      return size === req;
	    }

	    return true;
	  },
	  string: function (val, req, attribute) {
	    return typeof val === "string";
	  },
	  sometimes: function (val) {
	    return true;
	  },

	  /**
	   * Compares the size of strings or the value of numbers if there is a truthy value
	   */
	  min: function (val, req, attribute) {
	    var size = this.getSize();
	    return size >= req;
	  },

	  /**
	   * Compares the size of strings or the value of numbers if there is a truthy value
	   */
	  max: function (val, req, attribute) {
	    var size = this.getSize();
	    return size <= req;
	  },
	  between: function (val, req, attribute) {
	    req = this.getParameters();
	    var size = this.getSize();
	    var min = parseFloat(req[0], 10);
	    var max = parseFloat(req[1], 10);
	    return size >= min && size <= max;
	  },
	  email: function (val) {
	    // Added umlaut support https://github.com/skaterdav85/validatorjs/issues/308
	    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	    if (!re.test(val)) {
	      // added support domain 3-n level https://github.com/skaterdav85/validatorjs/issues/384
	      re = /^((?:[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]|[^\u0000-\u007F])+@(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?(?:\.(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?)+)*$/;
	    }

	    return re.test(val);
	  },
	  numeric: function (val) {
	    var num;
	    num = Number(val); // tries to convert value to a number. useful if value is coming from form element

	    if (typeof num === "number" && !isNaN(num) && typeof val !== "boolean") {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  array: function (val) {
	    return val instanceof Array;
	  },
	  url: function (url) {
	    return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&/=]*)/i.test(url);
	  },
	  alpha: function (val) {
	    return /^[a-zA-Z]+$/.test(val);
	  },
	  alpha_dash: function (val) {
	    return /^[a-zA-Z0-9_\-]+$/.test(val);
	  },
	  alpha_num: function (val) {
	    return /^[a-zA-Z0-9]+$/.test(val);
	  },
	  same: function (val, req) {
	    var val1 = this.validator._flattenObject(this.validator.input)[req];

	    var val2 = val;

	    if (val1 === val2) {
	      return true;
	    }

	    return false;
	  },
	  different: function (val, req) {
	    var val1 = this.validator._flattenObject(this.validator.input)[req];

	    var val2 = val;

	    if (val1 !== val2) {
	      return true;
	    }

	    return false;
	  },
	  in: function (val, req) {
	    var list, i;

	    if (val) {
	      list = this.getParameters();
	    }

	    if (val && !(val instanceof Array)) {
	      var localValue = val;

	      for (i = 0; i < list.length; i++) {
	        if (typeof list[i] === "string") {
	          localValue = String(val);
	        }

	        if (localValue === list[i]) {
	          return true;
	        }
	      }

	      return false;
	    }

	    if (val && val instanceof Array) {
	      for (i = 0; i < val.length; i++) {
	        if (list.indexOf(val[i]) < 0) {
	          return false;
	        }
	      }
	    }

	    return true;
	  },
	  not_in: function (val, req) {
	    var list = this.getParameters();
	    var len = list.length;
	    var returnVal = true;

	    for (var i = 0; i < len; i++) {
	      var localValue = val;

	      if (typeof list[i] === "string") {
	        localValue = String(val);
	      }

	      if (localValue === list[i]) {
	        returnVal = false;
	        break;
	      }
	    }

	    return returnVal;
	  },
	  accepted: function (val) {
	    if (val === "on" || val === "yes" || val === 1 || val === "1" || val === true) {
	      return true;
	    }

	    return false;
	  },
	  confirmed: function (val, req, key) {
	    var confirmedKey = key + "_confirmation";

	    if (this.validator.input[confirmedKey] === val) {
	      return true;
	    }

	    return false;
	  },
	  integer: function (val) {
	    return String(parseInt(val, 10)) === String(val);
	  },
	  digits: function (val, req) {
	    var numericRule = this.validator.getRule('numeric');

	    if (numericRule.validate(val) && String(val.trim()).length === parseInt(req)) {
	      return true;
	    }

	    return false;
	  },
	  digits_between: function (val) {
	    var numericRule = this.validator.getRule("numeric");
	    var req = this.getParameters();
	    var valueDigitsCount = String(val).length;
	    var min = parseFloat(req[0], 10);
	    var max = parseFloat(req[1], 10);

	    if (numericRule.validate(val) && valueDigitsCount >= min && valueDigitsCount <= max) {
	      return true;
	    }

	    return false;
	  },
	  regex: function (val, req) {
	    var mod = /[g|i|m]{1,3}$/;
	    var flag = req.match(mod);
	    flag = flag ? flag[0] : "";
	    req = req.replace(mod, "").slice(1, -1);
	    req = new RegExp(req, flag);
	    return !!req.test(val);
	  },
	  date: function (val, format) {
	    return isValidDate$1(val);
	  },
	  present: function (val) {
	    return typeof val !== "undefined";
	  },
	  after: function (val, req) {
	    var val1 = this.validator.input[req];
	    var val2 = val;

	    if (!isValidDate$1(val1)) {
	      return false;
	    }

	    if (!isValidDate$1(val2)) {
	      return false;
	    }

	    if (new Date(val1).getTime() < new Date(val2).getTime()) {
	      return true;
	    }

	    return false;
	  },
	  after_or_equal: function (val, req) {
	    var val1 = this.validator.input[req];
	    var val2 = val;

	    if (!isValidDate$1(val1)) {
	      return false;
	    }

	    if (!isValidDate$1(val2)) {
	      return false;
	    }

	    if (new Date(val1).getTime() <= new Date(val2).getTime()) {
	      return true;
	    }

	    return false;
	  },
	  before: function (val, req) {
	    var val1 = this.validator.input[req];
	    var val2 = val;

	    if (!isValidDate$1(val1)) {
	      return false;
	    }

	    if (!isValidDate$1(val2)) {
	      return false;
	    }

	    if (new Date(val1).getTime() > new Date(val2).getTime()) {
	      return true;
	    }

	    return false;
	  },
	  before_or_equal: function (val, req) {
	    var val1 = this.validator.input[req];
	    var val2 = val;

	    if (!isValidDate$1(val1)) {
	      return false;
	    }

	    if (!isValidDate$1(val2)) {
	      return false;
	    }

	    if (new Date(val1).getTime() >= new Date(val2).getTime()) {
	      return true;
	    }

	    return false;
	  },
	  hex: function (val) {
	    return /^[0-9a-f]+$/i.test(val);
	  },
	  ipv4: function (val, req, attribute) {
	    if (typeof val != 'string') return false; // regex to check that each octet is valid

	    var er = /^[0-9]+$/; // ipv4 octets are delimited by dot

	    octets = val.split('.'); // check 1: ipv4 address should contains 4 octets

	    if (octets.length != 4) return false;

	    for (let i = 0; i < octets.length; i++) {
	      const element = octets[i]; // check 2: each octet should be integer bigger than 0

	      if (!er.test(element)) return false; // check 3: each octet value should be less than 256

	      var octetValue = parseInt(element);
	      if (octetValue >= 256) return false;
	    } // if all checks passed, we know it's valid IPv4 address!


	    return true;
	  },
	  ipv6: function (val, req, attribute) {
	    if (typeof val != 'string') return false; // regex to check that each hextet is valid

	    var er = /^[0-9a-f]+$/; // ipv6 hextets are delimited by colon

	    hextets = val.split(':'); // check 1: ipv6 should contain only one consecutive colons

	    colons = val.match(/::/);
	    if (colons != null && val.match(/::/g).length > 1) return false; // check 2: ipv6 should not be ending or starting with colon
	    //          edge case: not with consecutive colons

	    if (val[0] == ':' && (colons == null || colons != null && colons.index != 0)) return false;
	    if (val[val.length - 1] == ':' && (colons == null || colons != null && colons.index != val.length - 2)) return false; // check 3: ipv6 should contain no less than 3 sector
	    //         minimum ipv6 addres - ::1

	    if (3 > hextets.length) return false; // check 4: ipv6 should contain no more than 8 sectors
	    //         only 1 edge case: when first or last sector is ommited

	    var isEdgeCase = hextets.length == 9 && colons != null && (colons.index == 0 || colons.index == val.length - 2);
	    if (hextets.length > 8 && !isEdgeCase) return false; // check 5: ipv6 should contain exactly one consecutive colons if it has less than 8 sectors

	    if (hextets.length != 8 && colons == null) return false;

	    for (let i = 0; i < hextets.length; i++) {
	      const element = hextets[i];
	      if (element.length == 0) continue; // check 6: all of hextets should contain numbers from 0 to f (in hexadecimal)

	      if (!er.test(element)) return false; // check 7: all of hextet values should be less then ffff (in hexadeimal)
	      //          checking using length of hextet. lowest invalid value's length is 5.
	      //          so all valid hextets are length of 4 or less

	      if (element.length > 4) return false;
	    }

	    return true;
	  },
	  ip: function (val, req, attribute) {
	    return rules['ipv4'](val, req, attribute) || rules['ipv6'](val, req, attribute);
	  }
	};

	var missedRuleValidator = function () {
	  throw new Error("Validator `" + this.name + "` is not defined!");
	};

	var missedRuleMessage;

	function Rule(name, fn, async) {
	  this.name = name;
	  this.fn = fn;
	  this.passes = null;
	  this._customMessage = undefined;
	  this.async = async;
	}

	Rule.prototype = {
	  /**
	   * Validate rule
	   *
	   * @param  {mixed} inputValue
	   * @param  {mixed} ruleValue
	   * @param  {string} attribute
	   * @param  {function} callback
	   * @return {boolean|undefined}
	   */
	  validate: function (inputValue, ruleValue, attribute, callback) {
	    var _this = this;

	    this._setValidatingData(attribute, inputValue, ruleValue);

	    if (typeof callback === "function") {
	      this.callback = callback;

	      var handleResponse = function (passes, message) {
	        _this.response(passes, message);
	      };

	      if (this.async) {
	        return this._apply(inputValue, ruleValue, attribute, handleResponse);
	      } else {
	        return handleResponse(this._apply(inputValue, ruleValue, attribute));
	      }
	    }

	    return this._apply(inputValue, ruleValue, attribute);
	  },

	  /**
	   * Apply validation function
	   *
	   * @param  {mixed} inputValue
	   * @param  {mixed} ruleValue
	   * @param  {string} attribute
	   * @param  {function} callback
	   * @return {boolean|undefined}
	   */
	  _apply: function (inputValue, ruleValue, attribute, callback) {
	    var fn = this.isMissed() ? missedRuleValidator : this.fn;
	    return fn.apply(this, [inputValue, ruleValue, attribute, callback]);
	  },

	  /**
	   * Set validating data
	   *
	   * @param {string} attribute
	   * @param {mixed} inputValue
	   * @param {mixed} ruleValue
	   * @return {void}
	   */
	  _setValidatingData: function (attribute, inputValue, ruleValue) {
	    this.attribute = attribute;
	    this.inputValue = inputValue;
	    this.ruleValue = ruleValue;
	  },

	  /**
	   * Get parameters
	   *
	   * @return {array}
	   */
	  getParameters: function () {
	    var value = [];

	    if (typeof this.ruleValue === "string") {
	      value = this.ruleValue.split(",");
	    }

	    if (typeof this.ruleValue === "number") {
	      value.push(this.ruleValue);
	    }

	    if (this.ruleValue instanceof Array) {
	      value = this.ruleValue;
	    }

	    return value;
	  },

	  /**
	   * Get true size of value
	   *
	   * @return {integer|float}
	   */
	  getSize: function () {
	    var value = this.inputValue;

	    if (value instanceof Array) {
	      return value.length;
	    }

	    if (typeof value === "number") {
	      return value;
	    }

	    if (this.validator._hasNumericRule(this.attribute)) {
	      return parseFloat(value, 10);
	    }

	    return value.length;
	  },

	  /**
	   * Get the type of value being checked; numeric or string.
	   *
	   * @return {string}
	   */
	  _getValueType: function () {
	    if (typeof this.inputValue === "number" || this.validator._hasNumericRule(this.attribute)) {
	      return "numeric";
	    }

	    return "string";
	  },

	  /**
	   * Set the async callback response
	   *
	   * @param  {boolean|undefined} passes  Whether validation passed
	   * @param  {string|undefined} message Custom error message
	   * @return {void}
	   */
	  response: function (passes, message) {
	    this.passes = passes === undefined || passes === true;
	    this._customMessage = message;
	    this.callback(this.passes, message);
	  },

	  /**
	   * Set validator instance
	   *
	   * @param {Validator} validator
	   * @return {void}
	   */
	  setValidator: function (validator) {
	    this.validator = validator;
	  },

	  /**
	   * Check if rule is missed
	   *
	   * @return {boolean}
	   */
	  isMissed: function () {
	    return typeof this.fn !== "function";
	  },

	  get customMessage() {
	    return this.isMissed() ? missedRuleMessage : this._customMessage;
	  }

	};
	var manager = {
	  /**
	   * List of async rule names
	   *
	   * @type {Array}
	   */
	  asyncRules: [],

	  /**
	   * Implicit rules (rules to always validate)
	   *
	   * @type {Array}
	   */
	  implicitRules: ["required", "required_if", "required_unless", "required_with", "required_with_all", "required_without", "required_without_all", "accepted", "present"],

	  /**
	   * Get rule by name
	   *
	   * @param  {string} name
	   * @param {Validator}
	   * @return {Rule}
	   */
	  make: function (name, validator) {
	    var async = this.isAsync(name);
	    var rule = new Rule(name, rules[name], async);
	    rule.setValidator(validator);
	    return rule;
	  },

	  /**
	   * Determine if given rule is async
	   *
	   * @param  {string}  name
	   * @return {boolean}
	   */
	  isAsync: function (name) {
	    for (var i = 0, len = this.asyncRules.length; i < len; i++) {
	      if (this.asyncRules[i] === name) {
	        return true;
	      }
	    }

	    return false;
	  },

	  /**
	   * Determine if rule is implicit (should always validate)
	   *
	   * @param {string} name
	   * @return {boolean}
	   */
	  isImplicit: function (name) {
	    return this.implicitRules.indexOf(name) > -1;
	  },

	  /**
	   * Register new rule
	   *
	   * @param  {string}   name
	   * @param  {function} fn
	   * @return {void}
	   */
	  register: function (name, fn) {
	    rules[name] = fn;
	  },

	  /**
	   * Register new implicit rule
	   *
	   * @param  {string}   name
	   * @param  {function} fn
	   * @return {void}
	   */
	  registerImplicit: function (name, fn) {
	    this.register(name, fn);
	    this.implicitRules.push(name);
	  },

	  /**
	   * Register async rule
	   *
	   * @param  {string}   name
	   * @param  {function} fn
	   * @return {void}
	   */
	  registerAsync: function (name, fn) {
	    this.register(name, fn);
	    this.asyncRules.push(name);
	  },

	  /**
	   * Register implicit async rule
	   *
	   * @param  {string}   name
	   * @param  {function} fn
	   * @return {void}
	   */
	  registerAsyncImplicit: function (name, fn) {
	    this.registerImplicit(name, fn);
	    this.asyncRules.push(name);
	  },
	  registerMissedRuleValidator: function (fn, message) {
	    missedRuleValidator = fn;
	    missedRuleMessage = message;
	  }
	};
	var rules_1 = manager;

	var replacements = {
	  /**
	   * Between replacement (replaces :min and :max)
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  between: function (template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      min: parameters[0],
	      max: parameters[1]
	    });
	  },

	  /**
	   * Digits-Between replacement (replaces :min and :max)
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  digits_between: function (template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      min: parameters[0],
	      max: parameters[1]
	    });
	  },

	  /**
	   * Required_if replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  required_if: function (template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      other: this._getAttributeName(parameters[0]),
	      value: parameters[1]
	    });
	  },

	  /**
	   * Required_unless replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  required_unless: function (template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      other: this._getAttributeName(parameters[0]),
	      value: parameters[1]
	    });
	  },

	  /**
	   * Required_with replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  required_with: function (template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      field: this._getAttributeName(parameters[0])
	    });
	  },

	  /**
	   * Required_with_all replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  required_with_all: function (template, rule) {
	    var parameters = rule.getParameters();

	    var getAttributeName = this._getAttributeName.bind(this);

	    return this._replacePlaceholders(rule, template, {
	      fields: parameters.map(getAttributeName).join(', ')
	    });
	  },

	  /**
	   * Required_without replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  required_without: function (template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      field: this._getAttributeName(parameters[0])
	    });
	  },

	  /**
	   * Required_without_all replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  required_without_all: function (template, rule) {
	    var parameters = rule.getParameters();

	    var getAttributeName = this._getAttributeName.bind(this);

	    return this._replacePlaceholders(rule, template, {
	      fields: parameters.map(getAttributeName).join(', ')
	    });
	  },

	  /**
	   * After replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  after: function (template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      after: this._getAttributeName(parameters[0])
	    });
	  },

	  /**
	   * Before replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  before: function (template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      before: this._getAttributeName(parameters[0])
	    });
	  },

	  /**
	   * After_or_equal replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  after_or_equal: function (template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      after_or_equal: this._getAttributeName(parameters[0])
	    });
	  },

	  /**
	   * Before_or_equal replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  before_or_equal: function (template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      before_or_equal: this._getAttributeName(parameters[0])
	    });
	  },

	  /**
	   * Same replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  same: function (template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      same: this._getAttributeName(parameters[0])
	    });
	  }
	};

	function formatter(attribute) {
	  return attribute.replace(/[_\[]/g, ' ').replace(/]/g, '');
	}

	var attributes = {
	  replacements: replacements,
	  formatter: formatter
	};

	var Attributes$1 = attributes;

	var Messages$1 = function (lang, messages) {
	  this.lang = lang;
	  this.messages = messages;
	  this.customMessages = {};
	  this.attributeNames = {};
	};

	Messages$1.prototype = {
	  constructor: Messages$1,

	  /**
	   * Set custom messages
	   *
	   * @param {object} customMessages
	   * @return {void}
	   */
	  _setCustom: function (customMessages) {
	    this.customMessages = customMessages || {};
	  },

	  /**
	   * Set custom attribute names.
	   *
	   * @param {object} attributes
	   */
	  _setAttributeNames: function (attributes) {
	    this.attributeNames = attributes;
	  },

	  /**
	   * Set the attribute formatter.
	   *
	   * @param {fuction} func
	   * @return {void}
	   */
	  _setAttributeFormatter: function (func) {
	    this.attributeFormatter = func;
	  },

	  /**
	   * Get attribute name to display.
	   *
	   * @param  {string} attribute
	   * @return {string}
	   */
	  _getAttributeName: function (attribute) {
	    var name = attribute;

	    if (this.attributeNames.hasOwnProperty(attribute)) {
	      return this.attributeNames[attribute];
	    } else if (this.messages.attributes.hasOwnProperty(attribute)) {
	      name = this.messages.attributes[attribute];
	    }

	    if (this.attributeFormatter) {
	      name = this.attributeFormatter(name);
	    }

	    return name;
	  },

	  /**
	   * Get all messages
	   *
	   * @return {object}
	   */
	  all: function () {
	    return this.messages;
	  },

	  /**
	   * Render message
	   *
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  render: function (rule) {
	    if (rule.customMessage) {
	      return rule.customMessage;
	    }

	    var template = this._getTemplate(rule);

	    var message;

	    if (Attributes$1.replacements[rule.name]) {
	      message = Attributes$1.replacements[rule.name].apply(this, [template, rule]);
	    } else {
	      message = this._replacePlaceholders(rule, template, {});
	    }

	    return message;
	  },

	  /**
	   * Get the template to use for given rule
	   *
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  _getTemplate: function (rule) {
	    var messages = this.messages;
	    var template = messages.def;
	    var customMessages = this.customMessages;
	    var formats = [rule.name + '.' + rule.attribute, rule.name];

	    for (var i = 0, format; i < formats.length; i++) {
	      format = formats[i];

	      if (customMessages.hasOwnProperty(format)) {
	        template = customMessages[format];
	        break;
	      } else if (messages.hasOwnProperty(format)) {
	        template = messages[format];
	        break;
	      }
	    }

	    if (typeof template === 'object') {
	      template = template[rule._getValueType()];
	    }

	    return template;
	  },

	  /**
	   * Replace placeholders in the template using the data object
	   *
	   * @param  {Rule} rule
	   * @param  {string} template
	   * @param  {object} data
	   * @return {string}
	   */
	  _replacePlaceholders: function (rule, template, data) {
	    var message, attribute;
	    data.attribute = this._getAttributeName(rule.attribute);
	    data[rule.name] = data[rule.name] || rule.getParameters().join(',');

	    if (typeof template === 'string' && typeof data === 'object') {
	      message = template;

	      for (attribute in data) {
	        message = message.replace(new RegExp(':' + attribute, 'g'), data[attribute]);
	      }
	    }

	    return message;
	  }
	};
	var messages$1 = Messages$1;

	var en = {
	  accepted: 'The :attribute must be accepted.',
	  after: 'The :attribute must be after :after.',
	  after_or_equal: 'The :attribute must be equal or after :after_or_equal.',
	  alpha: 'The :attribute field must contain only alphabetic characters.',
	  alpha_dash: 'The :attribute field may only contain alpha-numeric characters, as well as dashes and underscores.',
	  alpha_num: 'The :attribute field must be alphanumeric.',
	  before: 'The :attribute must be before :before.',
	  before_or_equal: 'The :attribute must be equal or before :before_or_equal.',
	  between: {
	    numeric: 'The :attribute field must be between :min and :max.',
	    string: 'The :attribute field must be between :min and :max characters.'
	  },
	  confirmed: 'The :attribute confirmation does not match.',
	  email: 'The :attribute format is invalid.',
	  date: 'The :attribute is not a valid date format.',
	  def: 'The :attribute attribute has errors.',
	  digits: 'The :attribute must be :digits digits.',
	  digits_between: 'The :attribute field must be between :min and :max digits.',
	  different: 'The :attribute and :different must be different.',
	  in: 'The selected :attribute is invalid.',
	  integer: 'The :attribute must be an integer.',
	  hex: 'The :attribute field should have hexadecimal format',
	  min: {
	    numeric: 'The :attribute must be at least :min.',
	    string: 'The :attribute must be at least :min characters.'
	  },
	  max: {
	    numeric: 'The :attribute may not be greater than :max.',
	    string: 'The :attribute may not be greater than :max characters.'
	  },
	  not_in: 'The selected :attribute is invalid.',
	  numeric: 'The :attribute must be a number.',
	  present: 'The :attribute field must be present (but can be empty).',
	  required: 'The :attribute field is required.',
	  required_if: 'The :attribute field is required when :other is :value.',
	  required_unless: 'The :attribute field is required when :other is not :value.',
	  required_with: 'The :attribute field is required when :field is not empty.',
	  required_with_all: 'The :attribute field is required when :fields are not empty.',
	  required_without: 'The :attribute field is required when :field is empty.',
	  required_without_all: 'The :attribute field is required when :fields are empty.',
	  same: 'The :attribute and :same fields must match.',
	  size: {
	    numeric: 'The :attribute must be :size.',
	    string: 'The :attribute must be :size characters.'
	  },
	  string: 'The :attribute must be a string.',
	  url: 'The :attribute format is invalid.',
	  regex: 'The :attribute format is invalid.',
	  attributes: {}
	};

	var Messages = messages$1;
	var require_method = commonjsRequire;
	var container = {
	  messages: {},

	  /**
	   * Set messages for language
	   *
	   * @param {string} lang
	   * @param {object} rawMessages
	   * @return {void}
	   */
	  _set: function (lang, rawMessages) {
	    this.messages[lang] = rawMessages;
	  },

	  /**
	   * Set message for given language's rule.
	   *
	   * @param {string} lang
	   * @param {string} attribute
	   * @param {string|object} message
	   * @return {void}
	   */
	  _setRuleMessage: function (lang, attribute, message) {
	    this._load(lang);

	    if (message === undefined) {
	      message = this.messages[lang].def;
	    }

	    this.messages[lang][attribute] = message;
	  },

	  /**
	   * Load messages (if not already loaded)
	   *
	   * @param  {string} lang
	   * @return {void}
	   */
	  _load: function (lang) {
	    if (!this.messages[lang]) {
	      try {
	        var rawMessages = require_method('./lang/' + lang);

	        this._set(lang, rawMessages);
	      } catch (e) {}
	    }
	  },

	  /**
	   * Get raw messages for language
	   *
	   * @param  {string} lang
	   * @return {object}
	   */
	  _get: function (lang) {
	    this._load(lang);

	    return this.messages[lang];
	  },

	  /**
	   * Make messages for given language
	   *
	   * @param  {string} lang
	   * @return {Messages}
	   */
	  _make: function (lang) {
	    this._load(lang);

	    return new Messages(lang, this.messages[lang]);
	  }
	};
	var lang = container;

	var Errors$1 = function () {
	  this.errors = {};
	};

	Errors$1.prototype = {
	  constructor: Errors$1,

	  /**
	   * Add new error message for given attribute
	   *
	   * @param  {string} attribute
	   * @param  {string} message
	   * @return {void}
	   */
	  add: function (attribute, message) {
	    if (!this.has(attribute)) {
	      this.errors[attribute] = [];
	    }

	    if (this.errors[attribute].indexOf(message) === -1) {
	      this.errors[attribute].push(message);
	    }
	  },

	  /**
	   * Returns an array of error messages for an attribute, or an empty array
	   *
	   * @param  {string} attribute A key in the data object being validated
	   * @return {array} An array of error messages
	   */
	  get: function (attribute) {
	    if (this.has(attribute)) {
	      return this.errors[attribute];
	    }

	    return [];
	  },

	  /**
	   * Returns the first error message for an attribute, false otherwise
	   *
	   * @param  {string} attribute A key in the data object being validated
	   * @return {string|false} First error message or false
	   */
	  first: function (attribute) {
	    if (this.has(attribute)) {
	      return this.errors[attribute][0];
	    }

	    return false;
	  },

	  /**
	   * Get all error messages from all failing attributes
	   *
	   * @return {Object} Failed attribute names for keys and an array of messages for values
	   */
	  all: function () {
	    return this.errors;
	  },

	  /**
	   * Determine if there are any error messages for an attribute
	   *
	   * @param  {string}  attribute A key in the data object being validated
	   * @return {boolean}
	   */
	  has: function (attribute) {
	    if (this.errors.hasOwnProperty(attribute)) {
	      return true;
	    }

	    return false;
	  }
	};
	var errors = Errors$1;

	function AsyncResolvers$1(onFailedOne, onResolvedAll) {
	  this.onResolvedAll = onResolvedAll;
	  this.onFailedOne = onFailedOne;
	  this.resolvers = {};
	  this.resolversCount = 0;
	  this.passed = [];
	  this.failed = [];
	  this.firing = false;
	}

	AsyncResolvers$1.prototype = {
	  /**
	   * Add resolver
	   *
	   * @param {Rule} rule
	   * @return {integer}
	   */
	  add: function (rule) {
	    var index = this.resolversCount;
	    this.resolvers[index] = rule;
	    this.resolversCount++;
	    return index;
	  },

	  /**
	   * Resolve given index
	   *
	   * @param  {integer} index
	   * @return {void}
	   */
	  resolve: function (index) {
	    var rule = this.resolvers[index];

	    if (rule.passes === true) {
	      this.passed.push(rule);
	    } else if (rule.passes === false) {
	      this.failed.push(rule);
	      this.onFailedOne(rule);
	    }

	    this.fire();
	  },

	  /**
	   * Determine if all have been resolved
	   *
	   * @return {boolean}
	   */
	  isAllResolved: function () {
	    return this.passed.length + this.failed.length === this.resolversCount;
	  },

	  /**
	   * Attempt to fire final all resolved callback if completed
	   *
	   * @return {void}
	   */
	  fire: function () {
	    if (!this.firing) {
	      return;
	    }

	    if (this.isAllResolved()) {
	      this.onResolvedAll(this.failed.length === 0);
	    }
	  },

	  /**
	   * Enable firing
	   *
	   * @return {void}
	   */
	  enableFiring: function () {
	    this.firing = true;
	  }
	};
	var async = AsyncResolvers$1;

	var Rules = rules_1;
	var Lang = lang;
	var Errors = errors;
	var Attributes = attributes;
	var AsyncResolvers = async;

	var Validator = function (input, rules, customMessages) {
	  var lang = Validator.getDefaultLang();
	  this.input = input || {};
	  this.messages = Lang._make(lang);

	  this.messages._setCustom(customMessages);

	  this.setAttributeFormatter(Validator.prototype.attributeFormatter);
	  this.errors = new Errors();
	  this.errorCount = 0;
	  this.hasAsync = false;
	  this.rules = this._parseRules(rules);
	};

	Validator.prototype = {
	  constructor: Validator,

	  /**
	   * Default language
	   *
	   * @type {string}
	   */
	  lang: 'en',

	  /**
	   * Numeric based rules
	   *
	   * @type {array}
	   */
	  numericRules: ['integer', 'numeric'],

	  /**
	   * Attribute formatter.
	   *
	   * @type {function}
	   */
	  attributeFormatter: Attributes.formatter,

	  /**
	   * Run validator
	   *
	   * @return {boolean} Whether it passes; true = passes, false = fails
	   */
	  check: function () {

	    for (var attribute in this.rules) {
	      var attributeRules = this.rules[attribute];

	      var inputValue = this._objectPath(this.input, attribute);

	      if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
	        continue;
	      }

	      for (var i = 0, len = attributeRules.length, rule, ruleOptions, rulePassed; i < len; i++) {
	        ruleOptions = attributeRules[i];
	        rule = this.getRule(ruleOptions.name);

	        if (!this._isValidatable(rule, inputValue)) {
	          continue;
	        }

	        rulePassed = rule.validate(inputValue, ruleOptions.value, attribute);

	        if (!rulePassed) {
	          this._addFailure(rule);
	        }

	        if (this._shouldStopValidating(attribute, rulePassed)) {
	          break;
	        }
	      }
	    }

	    return this.errorCount === 0;
	  },

	  /**
	   * Run async validator
	   *
	   * @param {function} passes
	   * @param {function} fails
	   * @return {void}
	   */
	  checkAsync: function (passes, fails) {
	    var _this = this;

	    passes = passes || function () {};

	    fails = fails || function () {};

	    var failsOne = function (rule, message) {
	      _this._addFailure(rule, message);
	    };

	    var resolvedAll = function (allPassed) {
	      if (allPassed) {
	        passes();
	      } else {
	        fails();
	      }
	    };

	    var asyncResolvers = new AsyncResolvers(failsOne, resolvedAll);

	    var validateRule = function (inputValue, ruleOptions, attribute, rule) {
	      return function () {
	        var resolverIndex = asyncResolvers.add(rule);
	        rule.validate(inputValue, ruleOptions.value, attribute, function () {
	          asyncResolvers.resolve(resolverIndex);
	        });
	      };
	    };

	    for (var attribute in this.rules) {
	      var attributeRules = this.rules[attribute];

	      var inputValue = this._objectPath(this.input, attribute);

	      if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
	        continue;
	      }

	      for (var i = 0, len = attributeRules.length, rule, ruleOptions; i < len; i++) {
	        ruleOptions = attributeRules[i];
	        rule = this.getRule(ruleOptions.name);

	        if (!this._isValidatable(rule, inputValue)) {
	          continue;
	        }

	        validateRule(inputValue, ruleOptions, attribute, rule)();
	      }
	    }

	    asyncResolvers.enableFiring();
	    asyncResolvers.fire();
	  },

	  /**
	   * Add failure and error message for given rule
	   *
	   * @param {Rule} rule
	   */
	  _addFailure: function (rule) {
	    var msg = this.messages.render(rule);
	    this.errors.add(rule.attribute, msg);
	    this.errorCount++;
	  },

	  /**
	   * Flatten nested object, normalizing { foo: { bar: 1 } } into: { 'foo.bar': 1 }
	   *
	   * @param  {object} nested object
	   * @return {object} flattened object
	   */
	  _flattenObject: function (obj) {
	    var flattened = {};

	    function recurse(current, property) {
	      if (!property && Object.getOwnPropertyNames(current).length === 0) {
	        return;
	      }

	      if (Object(current) !== current || Array.isArray(current)) {
	        flattened[property] = current;
	      } else {
	        var isEmpty = true;

	        for (var p in current) {
	          isEmpty = false;
	          recurse(current[p], property ? property + '.' + p : p);
	        }

	        if (isEmpty) {
	          flattened[property] = {};
	        }
	      }
	    }

	    if (obj) {
	      recurse(obj);
	    }

	    return flattened;
	  },

	  /**
	   * Extract value from nested object using string path with dot notation
	   *
	   * @param  {object} object to search in
	   * @param  {string} path inside object
	   * @return {any|void} value under the path
	   */
	  _objectPath: function (obj, path) {
	    if (Object.prototype.hasOwnProperty.call(obj, path)) {
	      return obj[path];
	    }

	    var keys = path.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '').split('.');
	    var copy = {};

	    for (var attr in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, attr)) {
	        copy[attr] = obj[attr];
	      }
	    }

	    for (var i = 0, l = keys.length; i < l; i++) {
	      if (typeof copy === 'object' && copy !== null && Object.hasOwnProperty.call(copy, keys[i])) {
	        copy = copy[keys[i]];
	      } else {
	        return;
	      }
	    }

	    return copy;
	  },

	  /**
	   * Parse rules, normalizing format into: { attribute: [{ name: 'age', value: 3 }] }
	   *
	   * @param  {object} rules
	   * @return {object}
	   */
	  _parseRules: function (rules) {
	    var parsedRules = {};
	    rules = this._flattenObject(rules);

	    for (var attribute in rules) {
	      var rulesArray = rules[attribute];

	      this._parseRulesCheck(attribute, rulesArray, parsedRules);
	    }

	    return parsedRules;
	  },
	  _parseRulesCheck: function (attribute, rulesArray, parsedRules, wildCardValues) {
	    if (attribute.indexOf('*') > -1) {
	      this._parsedRulesRecurse(attribute, rulesArray, parsedRules, wildCardValues);
	    } else {
	      this._parseRulesDefault(attribute, rulesArray, parsedRules, wildCardValues);
	    }
	  },
	  _parsedRulesRecurse: function (attribute, rulesArray, parsedRules, wildCardValues) {
	    var parentPath = attribute.substr(0, attribute.indexOf('*') - 1);

	    var propertyValue = this._objectPath(this.input, parentPath);

	    if (propertyValue) {
	      for (var propertyNumber = 0; propertyNumber < propertyValue.length; propertyNumber++) {
	        var workingValues = wildCardValues ? wildCardValues.slice() : [];
	        workingValues.push(propertyNumber);

	        this._parseRulesCheck(attribute.replace('*', propertyNumber), rulesArray, parsedRules, workingValues);
	      }
	    }
	  },
	  _parseRulesDefault: function (attribute, rulesArray, parsedRules, wildCardValues) {
	    var attributeRules = [];

	    if (rulesArray instanceof Array) {
	      rulesArray = this._prepareRulesArray(rulesArray);
	    }

	    if (typeof rulesArray === 'string') {
	      rulesArray = rulesArray.split('|');
	    }

	    for (var i = 0, len = rulesArray.length, rule; i < len; i++) {
	      rule = typeof rulesArray[i] === 'string' ? this._extractRuleAndRuleValue(rulesArray[i]) : rulesArray[i];

	      if (rule.value) {
	        rule.value = this._replaceWildCards(rule.value, wildCardValues);

	        this._replaceWildCardsMessages(wildCardValues);
	      }

	      if (Rules.isAsync(rule.name)) {
	        this.hasAsync = true;
	      }

	      attributeRules.push(rule);
	    }

	    parsedRules[attribute] = attributeRules;
	  },
	  _replaceWildCards: function (path, nums) {
	    if (!nums) {
	      return path;
	    }

	    var path2 = path;
	    nums.forEach(function (value) {
	      if (Array.isArray(path2)) {
	        path2 = path2[0];
	      }

	      const pos = path2.indexOf('*');

	      if (pos === -1) {
	        return path2;
	      }

	      path2 = path2.substr(0, pos) + value + path2.substr(pos + 1);
	    });

	    if (Array.isArray(path)) {
	      path[0] = path2;
	      path2 = path;
	    }

	    return path2;
	  },
	  _replaceWildCardsMessages: function (nums) {
	    var customMessages = this.messages.customMessages;
	    var self = this;
	    Object.keys(customMessages).forEach(function (key) {
	      if (nums) {
	        var newKey = self._replaceWildCards(key, nums);

	        customMessages[newKey] = customMessages[key];
	      }
	    });

	    this.messages._setCustom(customMessages);
	  },

	  /**
	   * Prepare rules if it comes in Array. Check for objects. Need for type validation.
	   *
	   * @param  {array} rulesArray
	   * @return {array}
	   */
	  _prepareRulesArray: function (rulesArray) {
	    var rules = [];

	    for (var i = 0, len = rulesArray.length; i < len; i++) {
	      if (typeof rulesArray[i] === 'object') {
	        for (var rule in rulesArray[i]) {
	          rules.push({
	            name: rule,
	            value: rulesArray[i][rule]
	          });
	        }
	      } else {
	        rules.push(rulesArray[i]);
	      }
	    }

	    return rules;
	  },

	  /**
	   * Determines if the attribute is supplied with the original data object.
	   *
	   * @param  {array} attribute
	   * @return {boolean}
	   */
	  _suppliedWithData: function (attribute) {
	    return this.input.hasOwnProperty(attribute);
	  },

	  /**
	   * Extract a rule and a value from a ruleString (i.e. min:3), rule = min, value = 3
	   *
	   * @param  {string} ruleString min:3
	   * @return {object} object containing the name of the rule and value
	   */
	  _extractRuleAndRuleValue: function (ruleString) {
	    var rule = {},
	        ruleArray;
	    rule.name = ruleString;

	    if (ruleString.indexOf(':') >= 0) {
	      ruleArray = ruleString.split(':');
	      rule.name = ruleArray[0];
	      rule.value = ruleArray.slice(1).join(':');
	    }

	    return rule;
	  },

	  /**
	   * Determine if attribute has any of the given rules
	   *
	   * @param  {string}  attribute
	   * @param  {array}   findRules
	   * @return {boolean}
	   */
	  _hasRule: function (attribute, findRules) {
	    var rules = this.rules[attribute] || [];

	    for (var i = 0, len = rules.length; i < len; i++) {
	      if (findRules.indexOf(rules[i].name) > -1) {
	        return true;
	      }
	    }

	    return false;
	  },

	  /**
	   * Determine if attribute has any numeric-based rules.
	   *
	   * @param  {string}  attribute
	   * @return {Boolean}
	   */
	  _hasNumericRule: function (attribute) {
	    return this._hasRule(attribute, this.numericRules);
	  },

	  /**
	   * Determine if rule is validatable
	   *
	   * @param  {Rule}   rule
	   * @param  {mixed}  value
	   * @return {boolean}
	   */
	  _isValidatable: function (rule, value) {
	    if (Array.isArray(value)) {
	      return true;
	    }

	    if (Rules.isImplicit(rule.name)) {
	      return true;
	    }

	    return this.getRule('required').validate(value);
	  },

	  /**
	   * Determine if we should stop validating.
	   *
	   * @param  {string} attribute
	   * @param  {boolean} rulePassed
	   * @return {boolean}
	   */
	  _shouldStopValidating: function (attribute, rulePassed) {
	    var stopOnAttributes = this.stopOnAttributes;

	    if (typeof stopOnAttributes === 'undefined' || stopOnAttributes === false || rulePassed === true) {
	      return false;
	    }

	    if (stopOnAttributes instanceof Array) {
	      return stopOnAttributes.indexOf(attribute) > -1;
	    }

	    return true;
	  },

	  /**
	   * Set custom attribute names.
	   *
	   * @param {object} attributes
	   * @return {void}
	   */
	  setAttributeNames: function (attributes) {
	    this.messages._setAttributeNames(attributes);
	  },

	  /**
	   * Set the attribute formatter.
	   *
	   * @param {fuction} func
	   * @return {void}
	   */
	  setAttributeFormatter: function (func) {
	    this.messages._setAttributeFormatter(func);
	  },

	  /**
	   * Get validation rule
	   *
	   * @param  {string} name
	   * @return {Rule}
	   */
	  getRule: function (name) {
	    return Rules.make(name, this);
	  },

	  /**
	   * Stop on first error.
	   *
	   * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
	   * @return {void}
	   */
	  stopOnError: function (attributes) {
	    this.stopOnAttributes = attributes;
	  },

	  /**
	   * Determine if validation passes
	   *
	   * @param {function} passes
	   * @return {boolean|undefined}
	   */
	  passes: function (passes) {
	    var async = this._checkAsync('passes', passes);

	    if (async) {
	      return this.checkAsync(passes);
	    }

	    return this.check();
	  },

	  /**
	   * Determine if validation fails
	   *
	   * @param {function} fails
	   * @return {boolean|undefined}
	   */
	  fails: function (fails) {
	    var async = this._checkAsync('fails', fails);

	    if (async) {
	      return this.checkAsync(function () {}, fails);
	    }

	    return !this.check();
	  },

	  /**
	   * Check if validation should be called asynchronously
	   *
	   * @param  {string}   funcName Name of the caller
	   * @param  {function} callback
	   * @return {boolean}
	   */
	  _checkAsync: function (funcName, callback) {
	    var hasCallback = typeof callback === 'function';

	    if (this.hasAsync && !hasCallback) {
	      throw funcName + ' expects a callback when async rules are being tested.';
	    }

	    return this.hasAsync || hasCallback;
	  }
	};
	/**
	 * Set messages for language
	 *
	 * @param {string} lang
	 * @param {object} messages
	 * @return {this}
	 */

	Validator.setMessages = function (lang, messages) {
	  Lang._set(lang, messages);

	  return this;
	};
	/**
	 * Get messages for given language
	 *
	 * @param  {string} lang
	 * @return {Messages}
	 */


	Validator.getMessages = function (lang) {
	  return Lang._get(lang);
	};
	/**
	 * Set default language to use
	 *
	 * @param {string} lang
	 * @return {void}
	 */


	Validator.useLang = function (lang) {
	  this.prototype.lang = lang;
	};
	/**
	 * Get default language
	 *
	 * @return {string}
	 */


	Validator.getDefaultLang = function () {
	  return this.prototype.lang;
	};
	/**
	 * Set the attribute formatter.
	 *
	 * @param {fuction} func
	 * @return {void}
	 */


	Validator.setAttributeFormatter = function (func) {
	  this.prototype.attributeFormatter = func;
	};
	/**
	 * Stop on first error.
	 *
	 * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
	 * @return {void}
	 */


	Validator.stopOnError = function (attributes) {
	  this.prototype.stopOnAttributes = attributes;
	};
	/**
	 * Register custom validation rule
	 *
	 * @param  {string}   name
	 * @param  {function} fn
	 * @param  {string}   message
	 * @return {void}
	 */


	Validator.register = function (name, fn, message, fnReplacement) {
	  var lang = Validator.getDefaultLang();
	  Rules.register(name, fn);

	  Lang._setRuleMessage(lang, name, message);
	};
	/**
	 * Register custom validation rule
	 *
	 * @param  {string}   name
	 * @param  {function} fn
	 * @param  {string}   message
	 * @param  {function} fnReplacement
	 * @return {void}
	 */


	Validator.registerImplicit = function (name, fn, message, fnReplacement) {
	  var lang = Validator.getDefaultLang();
	  Rules.registerImplicit(name, fn);

	  Lang._setRuleMessage(lang, name, message);
	};
	/**
	 * Register asynchronous validation rule
	 *
	 * @param  {string}   name
	 * @param  {function} fn
	 * @param  {string}   message
	 * @return {void}
	 */


	Validator.registerAsync = function (name, fn, message, fnReplacement) {
	  var lang = Validator.getDefaultLang();
	  Rules.registerAsync(name, fn);

	  Lang._setRuleMessage(lang, name, message);
	};
	/**
	 * Register asynchronous validation rule
	 *
	 * @param  {string}   name
	 * @param  {function} fn
	 * @param  {string}   message
	 * @return {void}
	 */


	Validator.registerAsyncImplicit = function (name, fn, message) {
	  var lang = Validator.getDefaultLang();
	  Rules.registerAsyncImplicit(name, fn);

	  Lang._setRuleMessage(lang, name, message);
	};
	/**
	 * Register validator for missed validation rule
	 *
	 * @param  {string}   name
	 * @param  {function} fn
	 * @param  {string}   message
	 * @return {void}
	 */


	Validator.registerMissedRuleValidator = function (fn, message) {
	  Rules.registerMissedRuleValidator(fn, message);
	};

	var validator$2 = Validator;

	// is compiled using rollup. Validatorjs does this internally.
	// When this package is used in conjunction with a rollup compiled package, due to the global nature of
	// a lot of features within validatorjs, this fails!
	// Loading 'en' here, as it is the default language. This is also referenced internally
	// for some methods that are not directly related to validation errors.

	validator$2.setMessages('en', en || {
	  def: 'The :attribute attribute has errors.',
	  attributes: {}
	}); // https://docs.microsoft.com/en-us/office/troubleshoot/excel/determine-a-leap-year

	function leapYear(year) {
	  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	}

	function checkFalsePositiveDates(dateString = '') {
	  if (dateString.length === 10) {
	    // massage input to use yyyy-mm-dd format
	    // we support yyyy/mm/dd or yyyy.mm.dd
	    let normalizedDate = dateString.replace('.', '-').replace('/', '-');
	    let parts = normalizedDate.split('-');

	    if (parts.length === 3) {
	      if (parts[0].length === 4) {
	        // yyyy-mm-dd format
	        let y = parseInt(parts[0]);
	        let m = parseInt(parts[1]);
	        let d = parseInt(parts[2]);

	        if (m === 2) {
	          // return leapYear(y) ? d <= 29 : d <= 28;
	          if (leapYear(y)) {
	            if (d > 29) {
	              return false;
	            }
	          } else {
	            if (d > 28) {
	              return false;
	            }
	          }
	        }

	        if (m === 4 || m === 6 || m === 9 || m === 11) {
	          if (d > 30) {
	            return false;
	          }
	        }
	      }
	    }

	    return true; // we are not in february, proceed
	  }

	  return true; // we are not testing formatted date, proceed to rest of validation
	}

	function isValidDate(dateString) {
	  let testDate;

	  if (typeof dateString === 'number') {
	    testDate = new Date(dateString);

	    if (typeof testDate === 'object') {
	      return true;
	    } else {
	      dateString = `${dateString}`;
	    }
	  } else if (typeof dateString === 'boolean') {
	    return false;
	  } // first convert incoming string to date object and see if it corrects date and format


	  testDate = new Date(dateString);

	  if (typeof testDate === 'object') {
	    if (testDate.toString() === 'Invalid Date') {
	      return false;
	    }
	    /**
	     * Check for false positive dates
	     * perform special check on february as JS `new Date` incorrectly returns valid date
	     * E.g.  let newDate = new Date('2020-02-29')  // returns as March 02, 2020.
	     * E.g.  let newDate = new Date('2019-02-29')  // returns as March 01, 2020.
	     * E.g.  let newDate = new Date('2019-04-31')  // returns as April 30, 2020.
	     */


	    if (!checkFalsePositiveDates(dateString)) {
	      return false;
	    } // valid date object and not a february date


	    return true;
	  } // First check for the pattern


	  const regex_date = /^\d{4}-\d{1,2}-\d{1,2}$/;

	  if (!regex_date.test(dateString)) {
	    return false;
	  } // Parse the date parts to integers


	  const parts = dateString.split('-');
	  const day = parseInt(parts[2], 10);
	  const month = parseInt(parts[1], 10);
	  const year = parseInt(parts[0], 10); // Check the ranges of month and year

	  if (year < 1000 || year > 3000 || month == 0 || month > 12) {
	    return false;
	  }

	  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Adjust for leap years

	  if (year % 400 == 0 || year % 100 != 0 && year % 4 == 0) {
	    monthLength[1] = 29;
	  } // Check the range of the day


	  return day > 0 && day <= monthLength[month - 1];
	}

	function after(val, req) {
	  let val1 = req;

	  if (!isValidDate(val)) {
	    return false;
	  }

	  if (!isValidDate(val1)) {
	    val1 = this.validator.input[val1];

	    if (!isValidDate(val1)) {
	      return false;
	    }
	  }

	  return new Date(val1).getTime() < new Date(val).getTime();
	}

	function after_or_equal(val, req) {
	  let val1 = req;

	  if (!isValidDate(val)) {
	    return false;
	  }

	  if (!isValidDate(val1)) {
	    val1 = this.validator.input[val1];

	    if (!isValidDate(val1)) {
	      return false;
	    }
	  }

	  return new Date(val1).getTime() <= new Date(val).getTime();
	}

	function before(val, req) {
	  let val1 = req;

	  if (!isValidDate(val)) {
	    return false;
	  }

	  if (!isValidDate(val1)) {
	    val1 = this.validator.input[val1];

	    if (!isValidDate(val1)) {
	      return false;
	    }
	  }

	  return new Date(val1).getTime() > new Date(val).getTime();
	}

	function before_or_equal(val, req) {
	  let val1 = req;

	  if (!isValidDate(val)) {
	    return false;
	  }

	  if (!isValidDate(val1)) {
	    val1 = this.validator.input[val1];

	    if (!isValidDate(val1)) {
	      return false;
	    }
	  }

	  return new Date(val1).getTime() >= new Date(val).getTime();
	}

	const messages = validator$2.getMessages(validator$2.getDefaultLang());
	validator$2.register('after', after, messages && typeof messages['after'] === 'string' ? messages['after'] : undefined);
	validator$2.register('after_or_equal', after_or_equal, messages && typeof messages['after_or_equal'] === 'string' ? messages['after_or_equal'] : undefined);
	validator$2.register('before', before, messages && typeof messages['before'] === 'string' ? messages['before'] : undefined);
	validator$2.register('before_or_equal', before_or_equal, messages && typeof messages['before_or_equal'] === 'string' ? messages['before_or_equal'] : undefined);

	/**
	 *  An error that occurred within the SDK. Thrown when no or invalid [ShopConfig](../interfaces/shopconfig.html)
	 *  is provided or when something goes wrong while transforming and exposing data.
	 */
	class ShopError extends Error {
	  /**
	   *  @internal Used to construct ShopErrors
	   */
	  constructor(message) {
	    super(message);
	    /**
	     *  The name of the error.
	     */

	    this.name = 'ShopError'; // Obscure typescript -> es5 transpile fix

	    Object.setPrototypeOf(this, new.target.prototype);
	  }

	}

	function slugError(message, slug, data) {
	  return errorToSlugError(new Error(message), slug, data);
	}
	function errorToSlugError(error, slug, data) {
	  const sluggedError = error;
	  sluggedError.slug = `sdkshop.log.${slug.join('.')}`;

	  if (data) {
	    sluggedError.slugData = data;
	  }

	  return sluggedError;
	}

	/**
	 *  If the metadata applies to a person it should only be asked once per
	 *  person / ticket, if it applies to a product it should be asked for
	 *  every product that’s in the cart *(cartProduct)*.
	 */
	var MetadataAppliesTo;

	(function (MetadataAppliesTo) {
	  MetadataAppliesTo["Person"] = "person";
	  MetadataAppliesTo["Product"] = "product";
	})(MetadataAppliesTo || (MetadataAppliesTo = {}));
	/**
	 *  The type of data the metadata should be answered with. Most are basic data
	 *  types and straightforward, some need a bit of clarification.
	 *
	 *  | Type          | Required input                |
	 *  | :------------ | :---------------------------- |
	 *  | `enumOther`   | Select or manual input        |
	 *  | `values`      | Multiselect                   |
	 *
	 *  The `seatSelect` is used for [Seats](https://www.seats.io/) integration and are
	 *  handled by the API separately, so you can ignore it.
	 */


	var MetadataType;

	(function (MetadataType) {
	  MetadataType["Integer"] = "integer";
	  MetadataType["String"] = "string";
	  MetadataType["Date"] = "date";
	  MetadataType["Enum"] = "enum";
	  MetadataType["EnumOther"] = "enumOther";
	  MetadataType["Boolean"] = "boolean";
	  MetadataType["Values"] = "values";
	  MetadataType["SeatSelect"] = "seatSelect";
	  MetadataType["Phone"] = "phone";
	})(MetadataType || (MetadataType = {}));

	/**
	 *
	 *  Used to add the metadata (as BaseMetadataItem) to the forwarded collection.
	 *
	 *  (i) The default value is null, except for the boolean type to prevent
	 *  weird behaviour of checkboxes.
	 *
	 */

	function addMetadataToCollection(metadata, map, list) {
	  let defaultValue = null;

	  if (metadata.item.type === MetadataType.Boolean && !metadata.item.extra.includes('required')) {
	    defaultValue = false;
	  }

	  const cartMetaData = {
	    item: metadata.item,
	    value: defaultValue,
	    errors: [],
	    index: metadata.index
	  };
	  map[metadata.guid] = cartMetaData;
	  list.push(cartMetaData);
	}
	/**
	 *
	 *  Used to add the metadata of a product to the forwarded collection.
	 *
	 *  @param product The product to add the metadata from to the collection
	 *  @param map The collection to add the product's metadata to
	 *  @param list The list to add the product's metadata to
	 *  @param appliesTo Only the metadatas that holds this applies_to will be added
	 *
	 */

	function addMetadataFromProduct(product, map, list, appliesTo) {
	  forEach$2(product.metadata, metadata => {
	    // Always ignore already added metadata
	    if (metadata.item.applies_to !== appliesTo || Object.prototype.hasOwnProperty.call(map, metadata.guid)) {
	      return;
	    }

	    addMetadataToCollection(metadata, map, list);
	  });
	  list.sort(modelSort);
	}
	/**
	 *  The validator defaults to english, but on language change, the validator should also follow.
	 *  Note however, any already generated errors will nog change. Only new generated errors will be in the new language.
	 */

	function setValidationLang(locale) {
	  // TODO Note: This is a very rudimentary implementation.
	  const langMap = {
	    en: 'en',
	    en_GB: 'en',
	    'en-GB': 'en',
	    en_US: 'en',
	    'en-US': 'en',
	    nl: 'nl',
	    nl_NL: 'nl',
	    'nl-NL': 'nl',
	    fr: 'fr',
	    fr_FR: 'fr',
	    'fr-FR': 'fr',
	    de: 'de',
	    de_DE: 'de',
	    'de-DE': 'de',
	    es: 'es',
	    es_ES: 'es',
	    'es-ES': 'es'
	  };
	  let lang = 'en';

	  if (Object.prototype.hasOwnProperty.call(langMap, locale)) {
	    lang = langMap[locale];
	  }

	  validator$2.useLang(lang);
	}
	/**
	 *  Validate metadata will return an error of error messages if its value does not pass the (extra) rules.
	 *
	 *  By default, when a validation rule fails its error will be added to the errors arrays of the metadata.
	 *
	 *  @param metadata - The metadata instance to validate
	 *  @param mutateErrors - When set to false, any errors will not be written to the metadata errors array
	 */

	function validateMetadata(metadata, mutateErrors = true) {
	  if (!metadata) {
	    throw new ShopError('Failed to validate metadata -> no cart metadata provided');
	  } // noinspection SuspiciousTypeOfGuard


	  if (!metadata.item || !metadata.item.name || typeof metadata.item.name !== 'string') {
	    throw new ShopError('Failed to validate metadata -> invalid metadata item');
	  } // noinspection SuspiciousTypeOfGuard


	  if (!Object.prototype.hasOwnProperty.call(metadata.item, 'extra') || !(Array.isArray(metadata.item.extra) || typeof metadata.item.extra === 'string')) {
	    throw new ShopError('Failed to validate metadata -> invalid metadata rules');
	  } // TODO Once the _rules property is ALWAYS set on the metadata.item, the reliance on the extra string can be completely replaced with the _rules property


	  if (!Object.prototype.hasOwnProperty.call(metadata, 'value')) {
	    throw new ShopError('Failed to validate metadata -> value property not present on cart metadata');
	  }

	  const name = metadata.item.translateName || metadata.item.name;
	  const validator = new validator$2(metadata, {
	    value: metadata.item.extra
	  });
	  validator.setAttributeNames({
	    value: name.toString().toLowerCase()
	  });
	  validator.check();
	  const errors = validator.errors.get('value');

	  if (mutateErrors) {
	    // Empty arrays without breaking references
	    metadata.errors.splice(0, metadata.errors.length); // Add the error objects to the _errors list

	    metadata.errors.push(...errors);
	  }

	  return errors;
	}

	class BaseValidator {
	  /**
	   *  Validate a specific cart metadata.
	   *
	   *  ```ts
	   *  const cartMetadata = {
	   *      item: shop.data.metadata[id],
	   *      value: null,
	   *      errors: [],
	   *  };
	   *
	   *  const validationOk: string[] | undefined = cart.validateMetadata(cartMetadata);
	   *  const validationOk: string[] | undefined = cart.validateMetadata(cartMetadata, false);
	   *  ```
	   *
	   *  When the mutateErrors boolean is not set,
	   *  the errors are returned, but not set on the cart metadata instance.
	   *
	   *  | Error                                    | Reason                              |
	   *  | :--------------------------------------- | :---------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
	   *
	   *  Note: Failed validation will NOT throw an error
	   */
	  metadata(metadata, mutateErrors = true) {
	    const validationErrors = validateMetadata(metadata, mutateErrors);
	    return {
	      valid: !validationErrors.length,
	      message: validationErrors[0] || '',
	      errors: validationErrors
	    };
	  }

	}

	function isHttpClient(client) {
	  // This check is by no means complete, but it will validate the basics!
	  return client && !['delete', 'get', 'head', 'options', 'post', 'put', 'patch'].filter(method => {
	    if (!Object.prototype.hasOwnProperty.call(client, method)) {
	      return true;
	    }

	    const pd = Object.getOwnPropertyDescriptor(client, method);
	    return !pd || typeof pd.value !== 'function';
	  }).length;
	}

	var LogLevel;

	(function (LogLevel) {
	  LogLevel["None"] = "none";
	  LogLevel["Fatal"] = "fatal";
	  LogLevel["Error"] = "error";
	  LogLevel["Warning"] = "warning";
	  LogLevel["Info"] = "info";
	  LogLevel["Debug"] = "debug";
	})(LogLevel || (LogLevel = {}));

	var LogLevelNumber;

	(function (LogLevelNumber) {
	  LogLevelNumber[LogLevelNumber["None"] = 1] = "None";
	  LogLevelNumber[LogLevelNumber["Fatal"] = 2] = "Fatal";
	  LogLevelNumber[LogLevelNumber["Error"] = 3] = "Error";
	  LogLevelNumber[LogLevelNumber["Warning"] = 4] = "Warning";
	  LogLevelNumber[LogLevelNumber["Info"] = 5] = "Info";
	  LogLevelNumber[LogLevelNumber["Debug"] = 6] = "Debug";
	})(LogLevelNumber || (LogLevelNumber = {}));

	({
	  [LogLevelNumber.None]: LogLevel.None,
	  [LogLevelNumber.Fatal]: LogLevel.Fatal,
	  [LogLevelNumber.Error]: LogLevel.Error,
	  [LogLevelNumber.Warning]: LogLevel.Warning,
	  [LogLevelNumber.Info]: LogLevel.Info,
	  [LogLevelNumber.Debug]: LogLevel.Debug
	});
	const logLevelStringToNumber = {
	  [LogLevel.None]: LogLevelNumber.None,
	  [LogLevel.Fatal]: LogLevelNumber.Fatal,
	  [LogLevel.Error]: LogLevelNumber.Error,
	  [LogLevel.Warning]: LogLevelNumber.Warning,
	  [LogLevel.Info]: LogLevelNumber.Info,
	  [LogLevel.Debug]: LogLevelNumber.Debug
	};

	const SIZEOF_SHORT = 2;
	const SIZEOF_INT = 4;
	const FILE_IDENTIFIER_LENGTH = 4;
	const SIZE_PREFIX_LENGTH = 4;

	const int32 = new Int32Array(2);
	const float32 = new Float32Array(int32.buffer);
	const float64 = new Float64Array(int32.buffer);
	const isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;

	class Long {
	  constructor(low, high) {
	    this.low = low | 0;
	    this.high = high | 0;
	  }

	  static create(low, high) {
	    // Special-case zero to avoid GC overhead for default values
	    return low == 0 && high == 0 ? Long.ZERO : new Long(low, high);
	  }

	  toFloat64() {
	    return (this.low >>> 0) + this.high * 0x100000000;
	  }

	  equals(other) {
	    return this.low == other.low && this.high == other.high;
	  }

	}
	Long.ZERO = new Long(0, 0);

	var Encoding;

	(function (Encoding) {
	  Encoding[Encoding["UTF8_BYTES"] = 1] = "UTF8_BYTES";
	  Encoding[Encoding["UTF16_STRING"] = 2] = "UTF16_STRING";
	})(Encoding || (Encoding = {}));

	class ByteBuffer {
	  /**
	   * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
	   */
	  constructor(bytes_) {
	    this.bytes_ = bytes_;
	    this.position_ = 0;
	  }
	  /**
	   * Create and allocate a new ByteBuffer with a given size.
	   */


	  static allocate(byte_size) {
	    return new ByteBuffer(new Uint8Array(byte_size));
	  }

	  clear() {
	    this.position_ = 0;
	  }
	  /**
	   * Get the underlying `Uint8Array`.
	   */


	  bytes() {
	    return this.bytes_;
	  }
	  /**
	   * Get the buffer's position.
	   */


	  position() {
	    return this.position_;
	  }
	  /**
	   * Set the buffer's position.
	   */


	  setPosition(position) {
	    this.position_ = position;
	  }
	  /**
	   * Get the buffer's capacity.
	   */


	  capacity() {
	    return this.bytes_.length;
	  }

	  readInt8(offset) {
	    return this.readUint8(offset) << 24 >> 24;
	  }

	  readUint8(offset) {
	    return this.bytes_[offset];
	  }

	  readInt16(offset) {
	    return this.readUint16(offset) << 16 >> 16;
	  }

	  readUint16(offset) {
	    return this.bytes_[offset] | this.bytes_[offset + 1] << 8;
	  }

	  readInt32(offset) {
	    return this.bytes_[offset] | this.bytes_[offset + 1] << 8 | this.bytes_[offset + 2] << 16 | this.bytes_[offset + 3] << 24;
	  }

	  readUint32(offset) {
	    return this.readInt32(offset) >>> 0;
	  }

	  readInt64(offset) {
	    return new Long(this.readInt32(offset), this.readInt32(offset + 4));
	  }

	  readUint64(offset) {
	    return new Long(this.readUint32(offset), this.readUint32(offset + 4));
	  }

	  readFloat32(offset) {
	    int32[0] = this.readInt32(offset);
	    return float32[0];
	  }

	  readFloat64(offset) {
	    int32[isLittleEndian ? 0 : 1] = this.readInt32(offset);
	    int32[isLittleEndian ? 1 : 0] = this.readInt32(offset + 4);
	    return float64[0];
	  }

	  writeInt8(offset, value) {
	    this.bytes_[offset] = value;
	  }

	  writeUint8(offset, value) {
	    this.bytes_[offset] = value;
	  }

	  writeInt16(offset, value) {
	    this.bytes_[offset] = value;
	    this.bytes_[offset + 1] = value >> 8;
	  }

	  writeUint16(offset, value) {
	    this.bytes_[offset] = value;
	    this.bytes_[offset + 1] = value >> 8;
	  }

	  writeInt32(offset, value) {
	    this.bytes_[offset] = value;
	    this.bytes_[offset + 1] = value >> 8;
	    this.bytes_[offset + 2] = value >> 16;
	    this.bytes_[offset + 3] = value >> 24;
	  }

	  writeUint32(offset, value) {
	    this.bytes_[offset] = value;
	    this.bytes_[offset + 1] = value >> 8;
	    this.bytes_[offset + 2] = value >> 16;
	    this.bytes_[offset + 3] = value >> 24;
	  }

	  writeInt64(offset, value) {
	    this.writeInt32(offset, value.low);
	    this.writeInt32(offset + 4, value.high);
	  }

	  writeUint64(offset, value) {
	    this.writeUint32(offset, value.low);
	    this.writeUint32(offset + 4, value.high);
	  }

	  writeFloat32(offset, value) {
	    float32[0] = value;
	    this.writeInt32(offset, int32[0]);
	  }

	  writeFloat64(offset, value) {
	    float64[0] = value;
	    this.writeInt32(offset, int32[isLittleEndian ? 0 : 1]);
	    this.writeInt32(offset + 4, int32[isLittleEndian ? 1 : 0]);
	  }
	  /**
	   * Return the file identifier.   Behavior is undefined for FlatBuffers whose
	   * schema does not include a file_identifier (likely points at padding or the
	   * start of a the root vtable).
	   */


	  getBufferIdentifier() {
	    if (this.bytes_.length < this.position_ + SIZEOF_INT + FILE_IDENTIFIER_LENGTH) {
	      throw new Error('FlatBuffers: ByteBuffer is too short to contain an identifier.');
	    }

	    let result = "";

	    for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
	      result += String.fromCharCode(this.readInt8(this.position_ + SIZEOF_INT + i));
	    }

	    return result;
	  }
	  /**
	   * Look up a field in the vtable, return an offset into the object, or 0 if the
	   * field is not present.
	   */


	  __offset(bb_pos, vtable_offset) {
	    const vtable = bb_pos - this.readInt32(bb_pos);
	    return vtable_offset < this.readInt16(vtable) ? this.readInt16(vtable + vtable_offset) : 0;
	  }
	  /**
	   * Initialize any Table-derived type to point to the union at the given offset.
	   */


	  __union(t, offset) {
	    t.bb_pos = offset + this.readInt32(offset);
	    t.bb = this;
	    return t;
	  }
	  /**
	   * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
	   * This allocates a new string and converts to wide chars upon each access.
	   *
	   * To avoid the conversion to UTF-16, pass Encoding.UTF8_BYTES as
	   * the "optionalEncoding" argument. This is useful for avoiding conversion to
	   * and from UTF-16 when the data will just be packaged back up in another
	   * FlatBuffer later on.
	   *
	   * @param offset
	   * @param opt_encoding Defaults to UTF16_STRING
	   */


	  __string(offset, opt_encoding) {
	    offset += this.readInt32(offset);
	    const length = this.readInt32(offset);
	    let result = '';
	    let i = 0;
	    offset += SIZEOF_INT;

	    if (opt_encoding === Encoding.UTF8_BYTES) {
	      return this.bytes_.subarray(offset, offset + length);
	    }

	    while (i < length) {
	      let codePoint; // Decode UTF-8

	      const a = this.readUint8(offset + i++);

	      if (a < 0xC0) {
	        codePoint = a;
	      } else {
	        const b = this.readUint8(offset + i++);

	        if (a < 0xE0) {
	          codePoint = (a & 0x1F) << 6 | b & 0x3F;
	        } else {
	          const c = this.readUint8(offset + i++);

	          if (a < 0xF0) {
	            codePoint = (a & 0x0F) << 12 | (b & 0x3F) << 6 | c & 0x3F;
	          } else {
	            const d = this.readUint8(offset + i++);
	            codePoint = (a & 0x07) << 18 | (b & 0x3F) << 12 | (c & 0x3F) << 6 | d & 0x3F;
	          }
	        }
	      } // Encode UTF-16


	      if (codePoint < 0x10000) {
	        result += String.fromCharCode(codePoint);
	      } else {
	        codePoint -= 0x10000;
	        result += String.fromCharCode((codePoint >> 10) + 0xD800, (codePoint & (1 << 10) - 1) + 0xDC00);
	      }
	    }

	    return result;
	  }
	  /**
	   * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
	   * if a string then return a new one
	   *
	   * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
	   * makes the behaviour of __union_with_string different compared to __union
	   */


	  __union_with_string(o, offset) {
	    if (typeof o === 'string') {
	      return this.__string(offset);
	    }

	    return this.__union(o, offset);
	  }
	  /**
	   * Retrieve the relative offset stored at "offset"
	   */


	  __indirect(offset) {
	    return offset + this.readInt32(offset);
	  }
	  /**
	   * Get the start of data of a vector whose offset is stored at "offset" in this object.
	   */


	  __vector(offset) {
	    return offset + this.readInt32(offset) + SIZEOF_INT; // data starts after the length
	  }
	  /**
	   * Get the length of a vector whose offset is stored at "offset" in this object.
	   */


	  __vector_len(offset) {
	    return this.readInt32(offset + this.readInt32(offset));
	  }

	  __has_identifier(ident) {
	    if (ident.length != FILE_IDENTIFIER_LENGTH) {
	      throw new Error('FlatBuffers: file identifier must be length ' + FILE_IDENTIFIER_LENGTH);
	    }

	    for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
	      if (ident.charCodeAt(i) != this.readInt8(this.position() + SIZEOF_INT + i)) {
	        return false;
	      }
	    }

	    return true;
	  }
	  /**
	   * A helper function to avoid generated code depending on this file directly.
	   */


	  createLong(low, high) {
	    return Long.create(low, high);
	  }
	  /**
	   * A helper function for generating list for obj api
	   */


	  createScalarList(listAccessor, listLength) {
	    const ret = [];

	    for (let i = 0; i < listLength; ++i) {
	      if (listAccessor(i) !== null) {
	        ret.push(listAccessor(i));
	      }
	    }

	    return ret;
	  }
	  /**
	   * A helper function for generating list for obj api
	   * @param listAccessor function that accepts an index and return data at that index
	   * @param listLength listLength
	   * @param res result list
	   */


	  createObjList(listAccessor, listLength) {
	    const ret = [];

	    for (let i = 0; i < listLength; ++i) {
	      const val = listAccessor(i);

	      if (val !== null) {
	        ret.push(val.unpack());
	      }
	    }

	    return ret;
	  }

	}

	class Builder {
	  /**
	   * Create a FlatBufferBuilder.
	   */
	  constructor(opt_initial_size) {
	    /** Minimum alignment encountered so far. */
	    this.minalign = 1;
	    /** The vtable for the current table. */

	    this.vtable = null;
	    /** The amount of fields we're actually using. */

	    this.vtable_in_use = 0;
	    /** Whether we are currently serializing a table. */

	    this.isNested = false;
	    /** Starting offset of the current struct/table. */

	    this.object_start = 0;
	    /** List of offsets of all vtables. */

	    this.vtables = [];
	    /** For the current vector being built. */

	    this.vector_num_elems = 0;
	    /** False omits default values from the serialized data */

	    this.force_defaults = false;
	    this.string_maps = null;
	    let initial_size;

	    if (!opt_initial_size) {
	      initial_size = 1024;
	    } else {
	      initial_size = opt_initial_size;
	    }
	    /**
	     * @type {ByteBuffer}
	     * @private
	     */


	    this.bb = ByteBuffer.allocate(initial_size);
	    this.space = initial_size;
	  }

	  clear() {
	    this.bb.clear();
	    this.space = this.bb.capacity();
	    this.minalign = 1;
	    this.vtable = null;
	    this.vtable_in_use = 0;
	    this.isNested = false;
	    this.object_start = 0;
	    this.vtables = [];
	    this.vector_num_elems = 0;
	    this.force_defaults = false;
	    this.string_maps = null;
	  }
	  /**
	   * In order to save space, fields that are set to their default value
	   * don't get serialized into the buffer. Forcing defaults provides a
	   * way to manually disable this optimization.
	   *
	   * @param forceDefaults true always serializes default values
	   */


	  forceDefaults(forceDefaults) {
	    this.force_defaults = forceDefaults;
	  }
	  /**
	   * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
	   * called finish(). The actual data starts at the ByteBuffer's current position,
	   * not necessarily at 0.
	   */


	  dataBuffer() {
	    return this.bb;
	  }
	  /**
	   * Get the bytes representing the FlatBuffer. Only call this after you've
	   * called finish().
	   */


	  asUint8Array() {
	    return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
	  }
	  /**
	   * Prepare to write an element of `size` after `additional_bytes` have been
	   * written, e.g. if you write a string, you need to align such the int length
	   * field is aligned to 4 bytes, and the string data follows it directly. If all
	   * you need to do is alignment, `additional_bytes` will be 0.
	   *
	   * @param size This is the of the new element to write
	   * @param additional_bytes The padding size
	   */


	  prep(size, additional_bytes) {
	    // Track the biggest thing we've ever aligned to.
	    if (size > this.minalign) {
	      this.minalign = size;
	    } // Find the amount of alignment needed such that `size` is properly
	    // aligned after `additional_bytes`


	    const align_size = ~(this.bb.capacity() - this.space + additional_bytes) + 1 & size - 1; // Reallocate the buffer if needed.

	    while (this.space < align_size + size + additional_bytes) {
	      const old_buf_size = this.bb.capacity();
	      this.bb = Builder.growByteBuffer(this.bb);
	      this.space += this.bb.capacity() - old_buf_size;
	    }

	    this.pad(align_size);
	  }

	  pad(byte_size) {
	    for (let i = 0; i < byte_size; i++) {
	      this.bb.writeInt8(--this.space, 0);
	    }
	  }

	  writeInt8(value) {
	    this.bb.writeInt8(this.space -= 1, value);
	  }

	  writeInt16(value) {
	    this.bb.writeInt16(this.space -= 2, value);
	  }

	  writeInt32(value) {
	    this.bb.writeInt32(this.space -= 4, value);
	  }

	  writeInt64(value) {
	    this.bb.writeInt64(this.space -= 8, value);
	  }

	  writeFloat32(value) {
	    this.bb.writeFloat32(this.space -= 4, value);
	  }

	  writeFloat64(value) {
	    this.bb.writeFloat64(this.space -= 8, value);
	  }
	  /**
	   * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
	   * @param value The `int8` to add the the buffer.
	   */


	  addInt8(value) {
	    this.prep(1, 0);
	    this.writeInt8(value);
	  }
	  /**
	   * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
	   * @param value The `int16` to add the the buffer.
	   */


	  addInt16(value) {
	    this.prep(2, 0);
	    this.writeInt16(value);
	  }
	  /**
	   * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
	   * @param value The `int32` to add the the buffer.
	   */


	  addInt32(value) {
	    this.prep(4, 0);
	    this.writeInt32(value);
	  }
	  /**
	   * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
	   * @param value The `int64` to add the the buffer.
	   */


	  addInt64(value) {
	    this.prep(8, 0);
	    this.writeInt64(value);
	  }
	  /**
	   * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
	   * @param value The `float32` to add the the buffer.
	   */


	  addFloat32(value) {
	    this.prep(4, 0);
	    this.writeFloat32(value);
	  }
	  /**
	   * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
	   * @param value The `float64` to add the the buffer.
	   */


	  addFloat64(value) {
	    this.prep(8, 0);
	    this.writeFloat64(value);
	  }

	  addFieldInt8(voffset, value, defaultValue) {
	    if (this.force_defaults || value != defaultValue) {
	      this.addInt8(value);
	      this.slot(voffset);
	    }
	  }

	  addFieldInt16(voffset, value, defaultValue) {
	    if (this.force_defaults || value != defaultValue) {
	      this.addInt16(value);
	      this.slot(voffset);
	    }
	  }

	  addFieldInt32(voffset, value, defaultValue) {
	    if (this.force_defaults || value != defaultValue) {
	      this.addInt32(value);
	      this.slot(voffset);
	    }
	  }

	  addFieldInt64(voffset, value, defaultValue) {
	    if (this.force_defaults || !value.equals(defaultValue)) {
	      this.addInt64(value);
	      this.slot(voffset);
	    }
	  }

	  addFieldFloat32(voffset, value, defaultValue) {
	    if (this.force_defaults || value != defaultValue) {
	      this.addFloat32(value);
	      this.slot(voffset);
	    }
	  }

	  addFieldFloat64(voffset, value, defaultValue) {
	    if (this.force_defaults || value != defaultValue) {
	      this.addFloat64(value);
	      this.slot(voffset);
	    }
	  }

	  addFieldOffset(voffset, value, defaultValue) {
	    if (this.force_defaults || value != defaultValue) {
	      this.addOffset(value);
	      this.slot(voffset);
	    }
	  }
	  /**
	   * Structs are stored inline, so nothing additional is being added. `d` is always 0.
	   */


	  addFieldStruct(voffset, value, defaultValue) {
	    if (value != defaultValue) {
	      this.nested(value);
	      this.slot(voffset);
	    }
	  }
	  /**
	   * Structures are always stored inline, they need to be created right
	   * where they're used.  You'll get this assertion failure if you
	   * created it elsewhere.
	   */


	  nested(obj) {
	    if (obj != this.offset()) {
	      throw new Error('FlatBuffers: struct must be serialized inline.');
	    }
	  }
	  /**
	   * Should not be creating any other object, string or vector
	   * while an object is being constructed
	   */


	  notNested() {
	    if (this.isNested) {
	      throw new Error('FlatBuffers: object serialization must not be nested.');
	    }
	  }
	  /**
	   * Set the current vtable at `voffset` to the current location in the buffer.
	   */


	  slot(voffset) {
	    if (this.vtable !== null) this.vtable[voffset] = this.offset();
	  }
	  /**
	   * @returns Offset relative to the end of the buffer.
	   */


	  offset() {
	    return this.bb.capacity() - this.space;
	  }
	  /**
	   * Doubles the size of the backing ByteBuffer and copies the old data towards
	   * the end of the new buffer (since we build the buffer backwards).
	   *
	   * @param bb The current buffer with the existing data
	   * @returns A new byte buffer with the old data copied
	   * to it. The data is located at the end of the buffer.
	   *
	   * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
	   * it a uint8Array we need to suppress the type check:
	   * @suppress {checkTypes}
	   */


	  static growByteBuffer(bb) {
	    const old_buf_size = bb.capacity(); // Ensure we don't grow beyond what fits in an int.

	    if (old_buf_size & 0xC0000000) {
	      throw new Error('FlatBuffers: cannot grow buffer beyond 2 gigabytes.');
	    }

	    const new_buf_size = old_buf_size << 1;
	    const nbb = ByteBuffer.allocate(new_buf_size);
	    nbb.setPosition(new_buf_size - old_buf_size);
	    nbb.bytes().set(bb.bytes(), new_buf_size - old_buf_size);
	    return nbb;
	  }
	  /**
	   * Adds on offset, relative to where it will be written.
	   *
	   * @param offset The offset to add.
	   */


	  addOffset(offset) {
	    this.prep(SIZEOF_INT, 0); // Ensure alignment is already done.

	    this.writeInt32(this.offset() - offset + SIZEOF_INT);
	  }
	  /**
	   * Start encoding a new object in the buffer.  Users will not usually need to
	   * call this directly. The FlatBuffers compiler will generate helper methods
	   * that call this method internally.
	   */


	  startObject(numfields) {
	    this.notNested();

	    if (this.vtable == null) {
	      this.vtable = [];
	    }

	    this.vtable_in_use = numfields;

	    for (let i = 0; i < numfields; i++) {
	      this.vtable[i] = 0; // This will push additional elements as needed
	    }

	    this.isNested = true;
	    this.object_start = this.offset();
	  }
	  /**
	   * Finish off writing the object that is under construction.
	   *
	   * @returns The offset to the object inside `dataBuffer`
	   */


	  endObject() {
	    if (this.vtable == null || !this.isNested) {
	      throw new Error('FlatBuffers: endObject called without startObject');
	    }

	    this.addInt32(0);
	    const vtableloc = this.offset(); // Trim trailing zeroes.

	    let i = this.vtable_in_use - 1; // eslint-disable-next-line no-empty

	    for (; i >= 0 && this.vtable[i] == 0; i--) {}

	    const trimmed_size = i + 1; // Write out the current vtable.

	    for (; i >= 0; i--) {
	      // Offset relative to the start of the table.
	      this.addInt16(this.vtable[i] != 0 ? vtableloc - this.vtable[i] : 0);
	    }

	    const standard_fields = 2; // The fields below:

	    this.addInt16(vtableloc - this.object_start);
	    const len = (trimmed_size + standard_fields) * SIZEOF_SHORT;
	    this.addInt16(len); // Search for an existing vtable that matches the current one.

	    let existing_vtable = 0;
	    const vt1 = this.space;

	    outer_loop: for (i = 0; i < this.vtables.length; i++) {
	      const vt2 = this.bb.capacity() - this.vtables[i];

	      if (len == this.bb.readInt16(vt2)) {
	        for (let j = SIZEOF_SHORT; j < len; j += SIZEOF_SHORT) {
	          if (this.bb.readInt16(vt1 + j) != this.bb.readInt16(vt2 + j)) {
	            continue outer_loop;
	          }
	        }

	        existing_vtable = this.vtables[i];
	        break;
	      }
	    }

	    if (existing_vtable) {
	      // Found a match:
	      // Remove the current vtable.
	      this.space = this.bb.capacity() - vtableloc; // Point table to existing vtable.

	      this.bb.writeInt32(this.space, existing_vtable - vtableloc);
	    } else {
	      // No match:
	      // Add the location of the current vtable to the list of vtables.
	      this.vtables.push(this.offset()); // Point table to current vtable.

	      this.bb.writeInt32(this.bb.capacity() - vtableloc, this.offset() - vtableloc);
	    }

	    this.isNested = false;
	    return vtableloc;
	  }
	  /**
	   * Finalize a buffer, poiting to the given `root_table`.
	   */


	  finish(root_table, opt_file_identifier, opt_size_prefix) {
	    const size_prefix = opt_size_prefix ? SIZE_PREFIX_LENGTH : 0;

	    if (opt_file_identifier) {
	      const file_identifier = opt_file_identifier;
	      this.prep(this.minalign, SIZEOF_INT + FILE_IDENTIFIER_LENGTH + size_prefix);

	      if (file_identifier.length != FILE_IDENTIFIER_LENGTH) {
	        throw new Error('FlatBuffers: file identifier must be length ' + FILE_IDENTIFIER_LENGTH);
	      }

	      for (let i = FILE_IDENTIFIER_LENGTH - 1; i >= 0; i--) {
	        this.writeInt8(file_identifier.charCodeAt(i));
	      }
	    }

	    this.prep(this.minalign, SIZEOF_INT + size_prefix);
	    this.addOffset(root_table);

	    if (size_prefix) {
	      this.addInt32(this.bb.capacity() - this.space);
	    }

	    this.bb.setPosition(this.space);
	  }
	  /**
	   * Finalize a size prefixed buffer, pointing to the given `root_table`.
	   */


	  finishSizePrefixed(root_table, opt_file_identifier) {
	    this.finish(root_table, opt_file_identifier, true);
	  }
	  /**
	   * This checks a required field has been set in a given table that has
	   * just been constructed.
	   */


	  requiredField(table, field) {
	    const table_start = this.bb.capacity() - table;
	    const vtable_start = table_start - this.bb.readInt32(table_start);
	    const ok = this.bb.readInt16(vtable_start + field) != 0; // If this fails, the caller will show what field needs to be set.

	    if (!ok) {
	      throw new Error('FlatBuffers: field ' + field + ' must be set');
	    }
	  }
	  /**
	   * Start a new array/vector of objects.  Users usually will not call
	   * this directly. The FlatBuffers compiler will create a start/end
	   * method for vector types in generated code.
	   *
	   * @param elem_size The size of each element in the array
	   * @param num_elems The number of elements in the array
	   * @param alignment The alignment of the array
	   */


	  startVector(elem_size, num_elems, alignment) {
	    this.notNested();
	    this.vector_num_elems = num_elems;
	    this.prep(SIZEOF_INT, elem_size * num_elems);
	    this.prep(alignment, elem_size * num_elems); // Just in case alignment > int.
	  }
	  /**
	   * Finish off the creation of an array and all its elements. The array must be
	   * created with `startVector`.
	   *
	   * @returns The offset at which the newly created array
	   * starts.
	   */


	  endVector() {
	    this.writeInt32(this.vector_num_elems);
	    return this.offset();
	  }
	  /**
	   * Encode the string `s` in the buffer using UTF-8. If the string passed has
	   * already been seen, we return the offset of the already written string
	   *
	   * @param s The string to encode
	   * @return The offset in the buffer where the encoded string starts
	   */


	  createSharedString(s) {
	    if (!s) {
	      return 0;
	    }

	    if (!this.string_maps) {
	      this.string_maps = new Map();
	    }

	    if (this.string_maps.has(s)) {
	      return this.string_maps.get(s);
	    }

	    const offset = this.createString(s);
	    this.string_maps.set(s, offset);
	    return offset;
	  }
	  /**
	   * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
	   * instead of a string, it is assumed to contain valid UTF-8 encoded data.
	   *
	   * @param s The string to encode
	   * @return The offset in the buffer where the encoded string starts
	   */


	  createString(s) {
	    if (!s) {
	      return 0;
	    }

	    let utf8;

	    if (s instanceof Uint8Array) {
	      utf8 = s;
	    } else {
	      utf8 = [];
	      let i = 0;

	      while (i < s.length) {
	        let codePoint; // Decode UTF-16

	        const a = s.charCodeAt(i++);

	        if (a < 0xD800 || a >= 0xDC00) {
	          codePoint = a;
	        } else {
	          const b = s.charCodeAt(i++);
	          codePoint = (a << 10) + b + (0x10000 - (0xD800 << 10) - 0xDC00);
	        } // Encode UTF-8


	        if (codePoint < 0x80) {
	          utf8.push(codePoint);
	        } else {
	          if (codePoint < 0x800) {
	            utf8.push(codePoint >> 6 & 0x1F | 0xC0);
	          } else {
	            if (codePoint < 0x10000) {
	              utf8.push(codePoint >> 12 & 0x0F | 0xE0);
	            } else {
	              utf8.push(codePoint >> 18 & 0x07 | 0xF0, codePoint >> 12 & 0x3F | 0x80);
	            }

	            utf8.push(codePoint >> 6 & 0x3F | 0x80);
	          }

	          utf8.push(codePoint & 0x3F | 0x80);
	        }
	      }
	    }

	    this.addInt8(0);
	    this.startVector(1, utf8.length, 1);
	    this.bb.setPosition(this.space -= utf8.length);

	    for (let i = 0, offset = this.space, bytes = this.bb.bytes(); i < utf8.length; i++) {
	      bytes[offset++] = utf8[i];
	    }

	    return this.endVector();
	  }
	  /**
	   * A helper function to avoid generated code depending on this file directly.
	   */


	  createLong(low, high) {
	    return Long.create(low, high);
	  }
	  /**
	   * A helper function to pack an object
	   *
	   * @returns offset of obj
	   */


	  createObjectOffset(obj) {
	    if (obj === null) {
	      return 0;
	    }

	    if (typeof obj === 'string') {
	      return this.createString(obj);
	    } else {
	      return obj.pack(this);
	    }
	  }
	  /**
	   * A helper function to pack a list of object
	   *
	   * @returns list of offsets of each non null object
	   */


	  createObjectOffsetList(list) {
	    const ret = [];

	    for (let i = 0; i < list.length; ++i) {
	      const val = list[i];

	      if (val !== null) {
	        ret.push(this.createObjectOffset(val));
	      } else {
	        throw new Error('FlatBuffers: Argument for createObjectOffsetList cannot contain null.');
	      }
	    }

	    return ret;
	  }

	  createStructOffsetList(list, startFunc) {
	    startFunc(this, list.length);
	    this.createObjectOffsetList(list);
	    return this.endVector();
	  }

	}

	var axios$5 = {exports: {}};

	var bind$5 = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);

	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }

	    return fn.apply(thisArg, args);
	  };
	};

	var bind$4 = bind$5;
	/*global toString:true*/
	// utils is a library of generic helper functions non-specific to axios

	var toString$1 = Object.prototype.toString;
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */

	function isArray$1(val) {
	  return toString$1.call(val) === '[object Array]';
	}
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */


	function isUndefined$1(val) {
	  return typeof val === 'undefined';
	}
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */


	function isBuffer$1(val) {
	  return val !== null && !isUndefined$1(val) && val.constructor !== null && !isUndefined$1(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */


	function isArrayBuffer$1(val) {
	  return toString$1.call(val) === '[object ArrayBuffer]';
	}
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */


	function isFormData$1(val) {
	  return typeof FormData !== 'undefined' && val instanceof FormData;
	}
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */


	function isArrayBufferView$1(val) {
	  var result;

	  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
	  }

	  return result;
	}
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */


	function isString$1(val) {
	  return typeof val === 'string';
	}
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */


	function isNumber$1(val) {
	  return typeof val === 'number';
	}
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */


	function isObject$2(val) {
	  return val !== null && typeof val === 'object';
	}
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */


	function isDate$1(val) {
	  return toString$1.call(val) === '[object Date]';
	}
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */


	function isFile$1(val) {
	  return toString$1.call(val) === '[object File]';
	}
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */


	function isBlob$1(val) {
	  return toString$1.call(val) === '[object Blob]';
	}
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */


	function isFunction$1(val) {
	  return toString$1.call(val) === '[object Function]';
	}
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */


	function isStream$1(val) {
	  return isObject$2(val) && isFunction$1(val.pipe);
	}
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */


	function isURLSearchParams$1(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */


	function trim$1(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */


	function isStandardBrowserEnv$1() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
	    return false;
	  }

	  return typeof window !== 'undefined' && typeof document !== 'undefined';
	}
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */


	function forEach$1(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  } // Force an array if not already something iterable


	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }

	  if (isArray$1(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */


	function
	  /* obj1, obj2, obj3, ... */
	merge$1() {
	  var result = {};

	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge$1(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }

	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach$1(arguments[i], assignValue);
	  }

	  return result;
	}
	/**
	 * Function equal to merge with the difference being that no reference
	 * to original objects is kept.
	 *
	 * @see merge
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */


	function
	  /* obj1, obj2, obj3, ... */
	deepMerge() {
	  var result = {};

	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = deepMerge(result[key], val);
	    } else if (typeof val === 'object') {
	      result[key] = deepMerge({}, val);
	    } else {
	      result[key] = val;
	    }
	  }

	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach$1(arguments[i], assignValue);
	  }

	  return result;
	}
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */


	function extend$1(a, b, thisArg) {
	  forEach$1(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind$4(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}

	var utils$r = {
	  isArray: isArray$1,
	  isArrayBuffer: isArrayBuffer$1,
	  isBuffer: isBuffer$1,
	  isFormData: isFormData$1,
	  isArrayBufferView: isArrayBufferView$1,
	  isString: isString$1,
	  isNumber: isNumber$1,
	  isObject: isObject$2,
	  isUndefined: isUndefined$1,
	  isDate: isDate$1,
	  isFile: isFile$1,
	  isBlob: isBlob$1,
	  isFunction: isFunction$1,
	  isStream: isStream$1,
	  isURLSearchParams: isURLSearchParams$1,
	  isStandardBrowserEnv: isStandardBrowserEnv$1,
	  forEach: forEach$1,
	  merge: merge$1,
	  deepMerge: deepMerge,
	  extend: extend$1,
	  trim: trim$1
	};

	var utils$q = utils$r;

	function encode$1(val) {
	  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
	}
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */


	var buildURL$5 = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }

	  var serializedParams;

	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils$q.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	    utils$q.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }

	      if (utils$q.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }

	      utils$q.forEach(val, function parseValue(v) {
	        if (utils$q.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils$q.isObject(v)) {
	          v = JSON.stringify(v);
	        }

	        parts.push(encode$1(key) + '=' + encode$1(v));
	      });
	    });
	    serializedParams = parts.join('&');
	  }

	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');

	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }

	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }

	  return url;
	};

	var utils$p = utils$r;

	function InterceptorManager$3() {
	  this.handlers = [];
	}
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */


	InterceptorManager$3.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */


	InterceptorManager$3.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */


	InterceptorManager$3.prototype.forEach = function forEach(fn) {
	  utils$p.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};

	var InterceptorManager_1$1 = InterceptorManager$3;

	var utils$o = utils$r;
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */

	var transformData$3 = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils$o.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	  return data;
	};

	var isCancel$3 = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};

	var utils$n = utils$r;

	var normalizeHeaderName$3 = function normalizeHeaderName(headers, normalizedName) {
	  utils$n.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};

	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */


	var enhanceError$4 = function enhanceError(error, config, code, request, response) {
	  error.config = config;

	  if (code) {
	    error.code = code;
	  }

	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;

	  error.toJSON = function () {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };

	  return error;
	};

	var enhanceError$3 = enhanceError$4;
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */

	var createError$5 = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError$3(error, config, code, request, response);
	};

	var createError$4 = createError$5;
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */

	var settle$3 = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;

	  if (!validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError$4('Request failed with status code ' + response.status, response.config, null, response.request, response));
	  }
	};

	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */


	var isAbsoluteURL$3 = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};

	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */


	var combineURLs$3 = function combineURLs(baseURL, relativeURL) {
	  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
	};

	var isAbsoluteURL$2 = isAbsoluteURL$3;
	var combineURLs$2 = combineURLs$3;
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */

	var buildFullPath$3 = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL$2(requestedURL)) {
	    return combineURLs$2(baseURL, requestedURL);
	  }

	  return requestedURL;
	};

	var utils$m = utils$r; // Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers

	var ignoreDuplicateOf$1 = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */

	var parseHeaders$3 = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;

	  if (!headers) {
	    return parsed;
	  }

	  utils$m.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils$m.trim(line.substr(0, i)).toLowerCase();
	    val = utils$m.trim(line.substr(i + 1));

	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf$1.indexOf(key) >= 0) {
	        return;
	      }

	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	  return parsed;
	};

	var utils$l = utils$r;
	var isURLSameOrigin$3 = utils$l.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
	// whether the request URL is of the same origin as current location.
	function standardBrowserEnv() {
	  var msie = /(msie|trident)/i.test(navigator.userAgent);
	  var urlParsingNode = document.createElement('a');
	  var originURL;
	  /**
	  * Parse a URL to discover it's components
	  *
	  * @param {String} url The URL to be parsed
	  * @returns {Object}
	  */

	  function resolveURL(url) {
	    var href = url;

	    if (msie) {
	      // IE needs attribute set twice to normalize properties
	      urlParsingNode.setAttribute('href', href);
	      href = urlParsingNode.href;
	    }

	    urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

	    return {
	      href: urlParsingNode.href,
	      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	      host: urlParsingNode.host,
	      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	      hostname: urlParsingNode.hostname,
	      port: urlParsingNode.port,
	      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
	    };
	  }

	  originURL = resolveURL(window.location.href);
	  /**
	  * Determine if a URL shares the same origin as the current location
	  *
	  * @param {String} requestURL The URL to test
	  * @returns {boolean} True if URL shares the same origin, otherwise false
	  */

	  return function isURLSameOrigin(requestURL) {
	    var parsed = utils$l.isString(requestURL) ? resolveURL(requestURL) : requestURL;
	    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
	  };
	}() : // Non standard browser envs (web workers, react-native) lack needed support.
	function nonStandardBrowserEnv() {
	  return function isURLSameOrigin() {
	    return true;
	  };
	}();

	var utils$k = utils$r;
	var cookies$2 = utils$k.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
	function standardBrowserEnv() {
	  return {
	    write: function write(name, value, expires, path, domain, secure) {
	      var cookie = [];
	      cookie.push(name + '=' + encodeURIComponent(value));

	      if (utils$k.isNumber(expires)) {
	        cookie.push('expires=' + new Date(expires).toGMTString());
	      }

	      if (utils$k.isString(path)) {
	        cookie.push('path=' + path);
	      }

	      if (utils$k.isString(domain)) {
	        cookie.push('domain=' + domain);
	      }

	      if (secure === true) {
	        cookie.push('secure');
	      }

	      document.cookie = cookie.join('; ');
	    },
	    read: function read(name) {
	      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	      return match ? decodeURIComponent(match[3]) : null;
	    },
	    remove: function remove(name) {
	      this.write(name, '', Date.now() - 86400000);
	    }
	  };
	}() : // Non standard browser env (web workers, react-native) lack needed support.
	function nonStandardBrowserEnv() {
	  return {
	    write: function write() {},
	    read: function read() {
	      return null;
	    },
	    remove: function remove() {}
	  };
	}();

	var utils$j = utils$r;
	var settle$2 = settle$3;
	var buildURL$4 = buildURL$5;
	var buildFullPath$2 = buildFullPath$3;
	var parseHeaders$2 = parseHeaders$3;
	var isURLSameOrigin$2 = isURLSameOrigin$3;
	var createError$3 = createError$5;

	var xhr$1 = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;

	    if (utils$j.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }

	    var request = new XMLHttpRequest(); // HTTP basic authentication

	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }

	    var fullPath = buildFullPath$2(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL$4(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

	    request.timeout = config.timeout; // Listen for ready state

	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      } // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request


	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      } // Prepare the response


	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders$2(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	      settle$2(resolve, reject, response); // Clean up request

	      request = null;
	    }; // Handle browser request cancellation (as opposed to a manual cancellation)


	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }

	      reject(createError$3('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

	      request = null;
	    }; // Handle low level network errors


	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError$3('Network Error', config, null, request)); // Clean up request

	      request = null;
	    }; // Handle timeout


	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';

	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }

	      reject(createError$3(timeoutErrorMessage, config, 'ECONNABORTED', request)); // Clean up request

	      request = null;
	    }; // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.


	    if (utils$j.isStandardBrowserEnv()) {
	      var cookies = cookies$2; // Add xsrf header

	      var xsrfValue = (config.withCredentials || isURLSameOrigin$2(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    } // Add headers to the request


	    if ('setRequestHeader' in request) {
	      utils$j.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    } // Add withCredentials to request if needed


	    if (!utils$j.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    } // Add responseType to request if needed


	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    } // Handle progress if needed


	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    } // Not all browsers support upload events


	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }

	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }

	        request.abort();
	        reject(cancel); // Clean up request

	        request = null;
	      });
	    }

	    if (requestData === undefined) {
	      requestData = null;
	    } // Send the request


	    request.send(requestData);
	  });
	};

	var utils$i = utils$r;
	var normalizeHeaderName$2 = normalizeHeaderName$3;
	var DEFAULT_CONTENT_TYPE$1 = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};

	function setContentTypeIfUnset$1(headers, value) {
	  if (!utils$i.isUndefined(headers) && utils$i.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}

	function getDefaultAdapter$1() {
	  var adapter;

	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = xhr$1;
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = xhr$1;
	  }

	  return adapter;
	}

	var defaults$7 = {
	  adapter: getDefaultAdapter$1(),
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName$2(headers, 'Accept');
	    normalizeHeaderName$2(headers, 'Content-Type');

	    if (utils$i.isFormData(data) || utils$i.isArrayBuffer(data) || utils$i.isBuffer(data) || utils$i.isStream(data) || utils$i.isFile(data) || utils$i.isBlob(data)) {
	      return data;
	    }

	    if (utils$i.isArrayBufferView(data)) {
	      return data.buffer;
	    }

	    if (utils$i.isURLSearchParams(data)) {
	      setContentTypeIfUnset$1(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }

	    if (utils$i.isObject(data)) {
	      setContentTypeIfUnset$1(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }

	    return data;
	  }],
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) {
	        /* Ignore */
	      }
	    }

	    return data;
	  }],

	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	  maxContentLength: -1,
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	defaults$7.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	utils$i.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults$7.headers[method] = {};
	});
	utils$i.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults$7.headers[method] = utils$i.merge(DEFAULT_CONTENT_TYPE$1);
	});
	var defaults_1$1 = defaults$7;

	var utils$h = utils$r;
	var transformData$2 = transformData$3;
	var isCancel$2 = isCancel$3;
	var defaults$6 = defaults_1$1;
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */

	function throwIfCancellationRequested$1(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */


	var dispatchRequest$3 = function dispatchRequest(config) {
	  throwIfCancellationRequested$1(config); // Ensure headers exist

	  config.headers = config.headers || {}; // Transform request data

	  config.data = transformData$2(config.data, config.headers, config.transformRequest); // Flatten headers

	  config.headers = utils$h.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
	  utils$h.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
	    delete config.headers[method];
	  });
	  var adapter = config.adapter || defaults$6.adapter;
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested$1(config); // Transform response data

	    response.data = transformData$2(response.data, response.headers, config.transformResponse);
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel$2(reason)) {
	      throwIfCancellationRequested$1(config); // Transform response data

	      if (reason && reason.response) {
	        reason.response.data = transformData$2(reason.response.data, reason.response.headers, config.transformResponse);
	      }
	    }

	    return Promise.reject(reason);
	  });
	};

	var utils$g = utils$r;
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */

	var mergeConfig$5 = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
	  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
	  var defaultToConfig2Keys = ['baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath'];
	  utils$g.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    }
	  });
	  utils$g.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
	    if (utils$g.isObject(config2[prop])) {
	      config[prop] = utils$g.deepMerge(config1[prop], config2[prop]);
	    } else if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (utils$g.isObject(config1[prop])) {
	      config[prop] = utils$g.deepMerge(config1[prop]);
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	  utils$g.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
	  var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
	    return axiosKeys.indexOf(key) === -1;
	  });
	  utils$g.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
	    if (typeof config2[prop] !== 'undefined') {
	      config[prop] = config2[prop];
	    } else if (typeof config1[prop] !== 'undefined') {
	      config[prop] = config1[prop];
	    }
	  });
	  return config;
	};

	var utils$f = utils$r;
	var buildURL$3 = buildURL$5;
	var InterceptorManager$2 = InterceptorManager_1$1;
	var dispatchRequest$2 = dispatchRequest$3;
	var mergeConfig$4 = mergeConfig$5;
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */

	function Axios$3(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager$2(),
	    response: new InterceptorManager$2()
	  };
	}
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */


	Axios$3.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }

	  config = mergeConfig$4(this.defaults, config); // Set config.method

	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  } // Hook up interceptors middleware


	  var chain = [dispatchRequest$2, undefined];
	  var promise = Promise.resolve(config);
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });

	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }

	  return promise;
	};

	Axios$3.prototype.getUri = function getUri(config) {
	  config = mergeConfig$4(this.defaults, config);
	  return buildURL$3(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	}; // Provide aliases for supported request methods


	utils$f.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios$3.prototype[method] = function (url, config) {
	    return this.request(utils$f.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	utils$f.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios$3.prototype[method] = function (url, data, config) {
	    return this.request(utils$f.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	var Axios_1$1 = Axios$3;

	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */


	function Cancel$5(message) {
	  this.message = message;
	}

	Cancel$5.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};

	Cancel$5.prototype.__CANCEL__ = true;
	var Cancel_1$1 = Cancel$5;

	var Cancel$4 = Cancel_1$1;
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */

	function CancelToken$1(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }

	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }

	    token.reason = new Cancel$4(message);
	    resolvePromise(token.reason);
	  });
	}
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */


	CancelToken$1.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */


	CancelToken$1.source = function source() {
	  var cancel;
	  var token = new CancelToken$1(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};

	var CancelToken_1$1 = CancelToken$1;

	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */


	var spread$1 = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};

	var utils$e = utils$r;
	var bind$3 = bind$5;
	var Axios$2 = Axios_1$1;
	var mergeConfig$3 = mergeConfig$5;
	var defaults$5 = defaults_1$1;
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */

	function createInstance$1(defaultConfig) {
	  var context = new Axios$2(defaultConfig);
	  var instance = bind$3(Axios$2.prototype.request, context); // Copy axios.prototype to instance

	  utils$e.extend(instance, Axios$2.prototype, context); // Copy context to instance

	  utils$e.extend(instance, context);
	  return instance;
	} // Create the default instance to be exported


	var axios$4 = createInstance$1(defaults$5); // Expose Axios class to allow class inheritance

	axios$4.Axios = Axios$2; // Factory for creating new instances

	axios$4.create = function create(instanceConfig) {
	  return createInstance$1(mergeConfig$3(axios$4.defaults, instanceConfig));
	}; // Expose Cancel & CancelToken


	axios$4.Cancel = Cancel_1$1;
	axios$4.CancelToken = CancelToken_1$1;
	axios$4.isCancel = isCancel$3; // Expose all/spread

	axios$4.all = function all(promises) {
	  return Promise.all(promises);
	};

	axios$4.spread = spread$1;
	axios$5.exports = axios$4; // Allow use of default import syntax in TypeScript

	axios$5.exports.default = axios$4;

	var axios$3 = axios$5.exports;

	var __awaiter$5 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	/**
	 *  Level constants
	 */

	var Level;

	(function (Level) {
	  Level[Level["Trace"] = 0] = "Trace";
	  Level[Level["Debug"] = 1] = "Debug";
	  Level[Level["Info"] = 2] = "Info";
	  Level[Level["Warn"] = 3] = "Warn";
	  Level[Level["Error"] = 4] = "Error";
	  Level[Level["Fatal"] = 5] = "Fatal";
	  Level[Level["Panic"] = 6] = "Panic";
	})(Level || (Level = {}));

	class ExternalLoggerService {
	  constructor(settings) {
	    this._settings = createSettings(settings);
	    this._url = `${this._settings.proto}://${this._settings.host}`;
	  }
	  /**
	   *  Log a message to the external service.
	   */


	  log(level, slug, data) {
	    const httpClient = this._settings.httpClient;
	    const url = this._url; // Do not block execution flow

	    setTimeout(() => __awaiter$5(this, void 0, void 0, function* () {
	      try {
	        yield httpClient.post(url, Buffer.from(buildFlatBuffer(level, slug, data)));
	      } catch (e) {
	        console.error('Failed to send log to external service', e);
	      }
	    }), 0);
	  }

	}
	/**
	 *  Send data to external url as flat buffer
	 */

	function buildFlatBuffer(level, slug, data) {
	  const builder = new Builder(128);
	  const messageOffset = builder.createString(slug);
	  const fieldsArr = [];

	  for (const [key, value] of Object.entries(data)) {
	    const keyOffset = builder.createString(key);
	    const valueOffset = builder.createString(value);
	    builder.startObject(2);
	    builder.addFieldOffset(0, keyOffset, 0);
	    builder.addFieldOffset(1, valueOffset, 0);
	    fieldsArr.unshift(builder.endObject());
	  }

	  builder.startVector(4, fieldsArr.length, 4);

	  for (const offset of fieldsArr) {
	    builder.addOffset(offset);
	  }

	  const fieldsOffset = builder.endVector();
	  builder.startObject(3);
	  builder.addFieldOffset(0, messageOffset, 0);
	  builder.addFieldInt8(1, level, Level.Trace);
	  builder.addFieldOffset(2, fieldsOffset, 0);
	  builder.finish(builder.endObject());
	  return builder.asUint8Array();
	}
	/**
	 *  Create settings object merged from defaults and partial settings object.
	 *
	 *  @param settings The partial settings for the external logger.
	 */


	function createSettings(settings) {
	  if (!settings.entityId) {
	    throw new Error('Missing entityId in settings');
	  }

	  if (!settings.host) {
	    throw new Error('Missing host in settings');
	  } // Check if the provided httpClient implements the correct interface


	  if (settings.httpClient && !isHttpClient(settings.httpClient)) {
	    throw new Error('No valid HTTP client provided');
	  }

	  return Object.assign(Object.assign({
	    proto: 'https'
	  }, settings), {
	    httpClient: settings.httpClient || axios$3.create()
	  });
	}

	// This is assuming 100.000 ids per hour.
	// src: https://zelark.github.io/nano-id-cc/

	const sessionIdGenerator$1 = customAlphabet$1('346789ABCDEFGHJKLMNPQRTUVWXY', 12);
	let idIncrement = 0;
	/**
	 *  Service to create and process log messages
	 */

	class Logger {
	  constructor(eventBus, config) {
	    /**
	     *  Severity log levels for individual processors
	     */
	    this._logLevelsConfig = {
	      console: LogLevelNumber.Warning,
	      service: LogLevelNumber.None
	    };
	    /**
	     *  Holds all values that will be injected in all log messages
	     */

	    this._staticValues = {};
	    /**
	     *  Holds the INTENDED entity id (e.g. shop guid, order guid, etc.).
	     */

	    this.entityId = '';
	    this._id = config && config.sessionId ? config.sessionId : Logger.generateSessionId();
	    this._eventBus = eventBus; // Relay to the actual event bus

	    this._eventBus.on(['log'], (path, payload) => {
	      let msg; // Handle non OpenTicketError errors

	      if (payload && payload._isOpenTicketLogMessage) {
	        msg = payload;
	      } else {
	        msg = this._buildFromError(payload, path);
	      }

	      this._send(msg);
	    });
	  }

	  static generateSessionId() {
	    return sessionIdGenerator$1();
	  }

	  get id() {
	    return this._id;
	  }
	  /**
	   *  Set the severity log levels
	   *
	   *  Any log message with a level smaller or equal should be processed.
	   *
	   *  @param logLevels Individual log level settings per processor.
	   */


	  setLoggingLevels(logLevels) {
	    if (logLevels && logLevels.console && logLevelStringToNumber[logLevels.console]) {
	      this._logLevelsConfig.console = logLevelStringToNumber[logLevels.console]; // eslint-disable-next-line no-console

	      console.info('Console log level changed', logLevels.console);
	    }

	    if (logLevels && logLevels.service && logLevelStringToNumber[logLevels.service]) {
	      this._logLevelsConfig.service = logLevelStringToNumber[logLevels.service]; // eslint-disable-next-line no-console

	      console.info('Service log level changed', logLevels.service);
	    }
	  }
	  /**
	   *  Set the logging url for the external logging service
	   *
	   *  @param loggingUrl
	   */


	  setLoggingUrl(loggingUrl) {
	    const proto = loggingUrl.startsWith('http://') ? 'http' : 'https';
	    const host = loggingUrl.replace(/^(?:[a-z]+:)?\/\//, '').replace(/\/*$/, '');
	    const settings = {
	      entityId: this.entityId || '',
	      proto,
	      host
	    };

	    if (this._externalService) {
	      // eslint-disable-next-line no-console
	      console.info('Restart external log service', proto, host);
	    } else {
	      // eslint-disable-next-line no-console
	      console.info('Start external log service', proto, host);
	    }

	    this._externalService = new ExternalLoggerService(settings);
	  }
	  /**
	   *  Set the entity ID to be used with the logging service.
	   *
	   *  Note, this should be the INTENDED entity id (e.g. shop id, order id, etc.).
	   *  As the validity is not yet known until after the logger is initialized!
	   *
	   *  @param entityId The intended entity id.
	   */


	  setEntityId(entityId) {
	    this.entityId = entityId;
	    this.addStaticValue('entity_id', entityId);
	  }
	  /**
	   *  Add a static value to all log messages
	   *
	   *  @param key
	   *  @param value
	   */


	  addStaticValue(key, value) {
	    this._staticValues[key] = value;
	  }
	  /**
	   *  Create and emit a log message
	   *
	   *  @param logLevel The log level of the log message
	   *  @param path The event path of the log message. Also used to create the slug.
	   *  @param message Add optional human readable message.
	   *  @param data The extra data for the log message. Also used for translation placeholders.
	   *  @param parent When the log messages is a wrapper for another log message.
	   */


	  create(logLevel, path, data = {}, message = null, parent = null) {
	    if (!path || !path.length) {
	      path = ['unknown'];
	    }

	    path = ['external', ...path];
	    return this._buildAndEmit(logLevel, path, data, message, parent);
	  }
	  /**
	   *  Create and emit a log message
	   *
	   *  @param logLevel The log level of the log message
	   *  @param path The event path of the log message. Also used to create the slug.
	   *  @param message Add optional human readable message.
	   *  @param data The extra data for the log message. Also used for translation placeholders.
	   *  @param parent When the log messages is a wrapper for another log message.
	   *  @param shouldEmit If the message should be processed.
	   */


	  _create(logLevel, path, data = {}, message = null, parent = null, shouldEmit = true) {
	    return this._buildAndEmit(logLevel, path, data, message, parent, shouldEmit);
	  }
	  /**
	   *  Pass-through the parent log message, if it is a log message.
	   *  Create and emit a log message, if not.
	   *
	   *  @param logLevel The log level of the log message
	   *  @param path The event path of the log message. Also used to create the slug.
	   *  @param message Add optional human readable message.
	   *  @param data The extra data for the log message. Also used for translation placeholders.
	   *  @param parent When the log messages is a wrapper for another log message.
	   *  @param shouldEmit If the message should be processed.
	   */


	  _passThroughOrCreate(parent, logLevel, path, data = {}, message = null, shouldEmit = true) {
	    if (parent && parent._isOpenTicketLogMessage) {
	      return parent;
	    }

	    return this._buildAndEmit(logLevel, path, data, message, parent, shouldEmit);
	  }
	  /**
	   *  Send the log message to all processors.
	   *
	   *  If the log level is enough.
	   *
	   *  @param msg
	   */


	  _send(msg) {
	    const at = new Date(msg.at);

	    this._getConsoleForLoggingLevel(msg)(`[${msg.session} | ${msg.id} | ${at.getHours()}:${at.getMinutes()}] ${msg.slug}${msg.parent ? ` (^ ${msg.parent.id})` : ''}`, msg.message, msg.data);

	    this._sendMessageToExternalService(msg);
	  }
	  /**
	   *  Helper to create a new log message object and emit it
	   *
	   *  @param logLevel The log level of the log message
	   *  @param path The event path of the log message. Also used to create the slug for the translatable message
	   *  @param message Add optional human readable message
	   *  @param data The extra data for the error. Also used for translation placeholders
	   *  @param parent When the error is a wrapper for another error
	   *  @param shouldEmit If the message should be processed.
	   */


	  _buildAndEmit(logLevel, path, data = {}, message = null, parent = null, shouldEmit = true) {
	    if (!path || !path.length) {
	      path = ['unknown'];
	    }

	    path = ['log', ...path];

	    const err = this._build(logLevel, path, message, data, parent);

	    if (shouldEmit) {
	      try {
	        // noinspection JSIgnoredPromiseFromCall
	        this._eventBus.emit(path, err);
	      } catch (e) {// Explicitly ignore any failures to emit!
	      }
	    }

	    return err;
	  }
	  /**
	   *  Helper to create a new log message from an error object
	   *
	   *  @param err The Error to transform to a log message object
	   *  @param path Optionally, the error can have been emitted and thus will have a path/slug
	   */


	  _buildFromError(err, path) {
	    let message = null;
	    let data = {};

	    if (err) {
	      data = this._retrieveDataFromError(err);

	      if (err.description && typeof err.description === 'string') {
	        message = err.description;
	      } else if (err.message && typeof err.message === 'string') {
	        message = err.message;
	      } else if (err.name && typeof err.name === 'string') {
	        message = err.name;
	      }
	    }

	    if (!path) {
	      path = ['log', 'unknown'];
	    }

	    return this._build(LogLevel.Error, path, message, data);
	  }
	  /**
	   *  Helper to create a new log message object
	   *
	   *  @param logLevel The severity level of the log message
	   *  @param path The event path of the log message. Also used to create the slug for the translatable message
	   *  @param message Add optional human readable message
	   *  @param data The extra data for the log message. Also used for translation placeholders
	   *  @param parent When the log message is a wrapper for another log message
	   */


	  _build(logLevel, path, message = null, data = {}, parent = null) {
	    let logLevelNumber = logLevelStringToNumber[logLevel] || LogLevel.None;
	    const logMessage = {
	      _isOpenTicketLogMessage: true,
	      session: this._id,
	      id: ++idIncrement,
	      at: Date.now(),
	      slug: `sdkshop.${path.join('.')}`,
	      data: {},
	      exception: null,
	      parent: null,
	      displayLogLevel: logLevel,
	      logLevel: logLevelNumber,
	      message
	    };
	    data = Object.assign(Object.assign({}, data), this._staticValues);

	    try {
	      if (parent && parent._isOpenTicketLogMessage) {
	        logMessage.parent = parent;
	      } else if (parent && parent instanceof Error) {
	        logMessage.exception = parent;
	        data = Object.assign(Object.assign({}, data), {
	          exception: this._retrieveDataFromError(parent)
	        });
	      } else if (parent) {
	        data = Object.assign(Object.assign({}, parent), data);
	      }
	    } catch (_) {// Explicitly ignore any data retrieval!
	    }

	    logMessage.data = data;
	    return logMessage;
	  } // noinspection JSMethodCanBeStatic

	  /**
	   *  Retrieve the data from the given error exception.
	   *
	   *  @param error The error exception
	   */


	  _retrieveDataFromError(error) {
	    if (!error) {
	      return {
	        name: 'Error',
	        message: 'Unknown error'
	      };
	    }

	    const flatError = {
	      name: error.name || 'Error',
	      message: error.message || 'Unknown error',
	      description: error.description,
	      number: error.number,
	      fileName: error.fileName,
	      lineNumber: error.lineNumber,
	      columnNumber: error.columnNumber
	    };

	    if (error.response) {
	      if (typeof error.response.status !== 'undefined' && typeof error.response.statusText !== 'undefined') {
	        flatError.status = error.response.status;
	        flatError.statusText = error.response.statusText;
	      }

	      if (error.response.data) {
	        if (typeof error.response.data.status_code !== 'undefined') {
	          flatError.status_code = error.response.data.status_code;
	        }

	        if (typeof error.response.data.error_description !== 'undefined') {
	          flatError.error_description = error.response.data.error_description;
	        }
	      }
	    }

	    if (error.stack) {
	      flatError.stack = error.stack;
	      const stack = typeof error.stack === 'string' ? error.stack.split('\n') : error.stack;
	      flatError.stackList = stack.map(part => part.trim()).filter(part => part && part.length);
	    }

	    if (error.slug) {
	      flatError.slug = error.slug;

	      if (error.slugData) {
	        return Object.assign(Object.assign({}, error.slugData), flatError);
	      }
	    }

	    return flatError;
	  }
	  /**
	   *  Retrieve the correct console processor.
	   *
	   *  Depends on the console logging level.
	   *
	   *  @param msg
	   */


	  _getConsoleForLoggingLevel(msg) {
	    // If the logging level is higher (e.g.: Less important)
	    // than the set level, return a no-op function
	    if (msg.logLevel > this._logLevelsConfig.console) {
	      return () => {// No-op
	      };
	    }

	    switch (msg.logLevel) {
	      case LogLevelNumber.Debug:
	        // eslint-disable-next-line no-console
	        return console.debug;

	      case LogLevelNumber.Info:
	        // eslint-disable-next-line no-console
	        return console.info;

	      case LogLevelNumber.Warning:
	        return console.warn;

	      case LogLevelNumber.Error:
	      case LogLevelNumber.Fatal:
	      default:
	        return console.error;
	    }
	  }
	  /**
	   *  Send the message to the external logging service.
	   *
	   *  Depends on the service logging level.
	   *
	   *  @param msg
	   */


	  _sendMessageToExternalService(msg) {
	    // If the logging level is higher (e.g.: Less important)
	    // than the set level, abort
	    if (!this._externalService || msg.logLevel > this._logLevelsConfig.service) {
	      return;
	    }

	    let logLevel;

	    switch (msg.logLevel) {
	      case LogLevelNumber.Fatal:
	        logLevel = Level.Fatal;
	        break;

	      case LogLevelNumber.Error:
	        logLevel = Level.Error;
	        break;

	      case LogLevelNumber.Warning:
	        logLevel = Level.Warn;
	        break;

	      case LogLevelNumber.Debug:
	        logLevel = Level.Debug;
	        break;

	      case LogLevelNumber.Info:
	      default:
	        logLevel = Level.Info;
	        break;
	    } // Create raw data json string


	    const rawData = JSON.stringify(msg.data); // Recreate object from json
	    // This ensures any complex objects are filtered out (like functions) and
	    // literal objects are converted to their literal value (like String{})
	    // This allows for every Object to be flattened,
	    // without losing or corrupting data

	    const flatData = flattenObject({
	      data: JSON.parse(rawData)
	    });

	    this._externalService.log(logLevel, msg.slug, Object.assign(Object.assign({}, flatData), {
	      raw_data: rawData,
	      entity_id: this.entityId || '',
	      session: msg.session,
	      id: JSON.stringify(msg.id),
	      at: JSON.stringify(msg.at),
	      parent: msg.parent ? JSON.stringify(msg.parent.id) : '',
	      slug: msg.slug,
	      message: msg.message || ''
	    }));
	  }

	}

	var lib = {};

	var is_scrolled$1 = {};

	Object.defineProperty(is_scrolled$1, '__esModule', {
	  value: true
	});
	/**
	 *  Piece of logic to add the class 'scroll' to the body if the page is
	 *  scrolled. Only imported and used once in the main.ts
	 */

	function addIsScrolledListener() {
	  var el = document.getElementsByTagName('body')[0];

	  window.onscroll = function () {
	    if (window.scrollY >= 5) {
	      if (!el.classList.contains('is-scrolled')) {
	        el.classList.add('is-scrolled');
	      }
	    } else if (window.scrollY < 5) {
	      if (el.classList.contains('is-scrolled')) {
	        el.classList.remove('is-scrolled');
	      }
	    }
	  };
	}

	is_scrolled$1.default = addIsScrolledListener;

	var copy_to_clipboard$1 = {};

	Object.defineProperty(copy_to_clipboard$1, '__esModule', {
	  value: true
	}); // src: https://stackoverflow.com/questions/33855641/copy-output-of-a-javascript-variable-to-the-clipboard

	function copyToClipboard(text) {
	  var dummy = document.createElement('textarea');
	  document.body.appendChild(dummy);
	  dummy.value = text;
	  dummy.select();
	  document.execCommand('copy');
	  document.body.removeChild(dummy);
	}

	copy_to_clipboard$1.default = copyToClipboard;

	var flag$1 = {};

	Object.defineProperty(flag$1, '__esModule', {
	  value: true
	});
	/**
	 * Unicode regional indicators start at 0x1F1E6 (A) to 0x1F1FF (Z).
	 * This value is the start minus the code point for uppercase letter A.
	 *
	 * Therefore, adding this number to an uppercase letter will
	 * result in a regional indicator character.
	 *
	 * @see https://www.unicode.org/Public/UCD/latest/ucd/emoji/emoji-data.txt
	 * @see http://unicode.org/reports/tr51/#def_emoji_flag_sequence
	 */

	var REGIONAL_INDICATOR_CHAR_CODE_OFFSET = 127397;

	function charToRegionalIndicator(char) {
	  return String.fromCodePoint(char.charCodeAt(0) + REGIONAL_INDICATOR_CHAR_CODE_OFFSET);
	}
	/**
	 *  Transform (2 character) country code to regional indicator characters.
	 *  Cast those to a string to form a flag.
	 */


	function countryCodeToFlag(code) {
	  if (!code || code.length !== 2) {
	    return '🏳';
	  }

	  return code.substr(0, 2).toUpperCase().replace(/./g, charToRegionalIndicator);
	}

	flag$1.default = countryCodeToFlag;

	var browser_language$1 = {};

	Object.defineProperty(browser_language$1, '__esModule', {
	  value: true
	});

	function getBrowserLanguage() {
	  var nav = window.navigator;
	  var languages = nav.languages || []; // support for HTML 5.1 "navigator.languages"

	  for (var _i = 0, languages_1 = languages; _i < languages_1.length; _i++) {
	    var language = languages_1[_i];

	    if (language.length) {
	      return language.split('_').join('-');
	    }
	  } // Support for other well known properties in browsers


	  var browserLanguagePropertyKeys = ['language', // eslint-disable-next-line @typescript-eslint/ban-ts-comment
	  // @ts-ignore -- These are not technically according to spec, but... IE...
	  'browserLanguage', 'systemLanguage', 'userLanguage'];

	  for (var _a = 0, browserLanguagePropertyKeys_1 = browserLanguagePropertyKeys; _a < browserLanguagePropertyKeys_1.length; _a++) {
	    var browserLanguagePropertyKey = browserLanguagePropertyKeys_1[_a];
	    var language = nav[browserLanguagePropertyKey];

	    if (language && typeof language === 'string' && language.length) {
	      return language.split('_').join('-');
	    }
	  }

	  return null;
	}

	browser_language$1.default = getBrowserLanguage;

	var has_local_storage$1 = {};

	Object.defineProperty(has_local_storage$1, '__esModule', {
	  value: true
	});
	var TEST_LOCALSTORAGE_KEY = 'TEST_LOCALSTORAGE_KEY_OPENTICKET';

	function hasLocalStorage() {
	  try {
	    if (typeof localStorage !== 'undefined') {
	      localStorage.setItem(TEST_LOCALSTORAGE_KEY, 'yes');

	      if (localStorage.getItem(TEST_LOCALSTORAGE_KEY) === 'yes') {
	        localStorage.removeItem(TEST_LOCALSTORAGE_KEY);
	        return true;
	      }
	    }

	    return false;
	  } catch (e) {
	    return false;
	  }
	}

	has_local_storage$1.default = hasLocalStorage;

	var int_to_duration$1 = {};

	Object.defineProperty(int_to_duration$1, '__esModule', {
	  value: true
	});

	function intToDuration(seconds, highestOnly) {
	  if (highestOnly === void 0) {
	    highestOnly = false;
	  }

	  var duration = [];

	  var add = function (unit, value) {
	    if (value && (!highestOnly || highestOnly && !duration.length)) {
	      if (highestOnly && unit !== 'seconds') {
	        duration.push(value + 1 + " " + unit);
	      } else {
	        duration.push(value + " " + unit);
	      }
	    }
	  };

	  add('years', Math.floor(seconds / 31536000));
	  add('days', Math.floor(seconds % 31536000 / 86400));
	  add('hours', Math.floor(seconds % 31536000 % 86400 / 3600));
	  add('minutes', Math.floor(seconds % 31536000 % 86400 % 3600 / 60));
	  add('seconds', seconds % 31536000 % 86400 % 3600 % 60);
	  var last = duration.pop();

	  if (!last) {
	    return '';
	  }

	  if (duration.length) {
	    return duration.slice(0, -1).join(', ') + " and " + last;
	  }

	  return last;
	}

	function intToDurationObject$1(seconds) {
	  return {
	    days: Math.floor(seconds % 31536000 / 86400),
	    hours: Math.floor(seconds % 31536000 % 86400 / 3600),
	    minutes: Math.floor(seconds % 31536000 % 86400 % 3600 / 60),
	    seconds: Math.floor(seconds % 31536000 % 86400 % 3600 % 60),
	    years: Math.floor(seconds / 31536000)
	  };
	}

	int_to_duration$1.default = intToDuration;

	int_to_duration$1.intToDurationObject = intToDurationObject$1;

	var is_object$2 = {};

	Object.defineProperty(is_object$2, '__esModule', {
	  value: true
	});

	function isObject$1(value) {
	  return value != null && typeof value === 'object' && !Array.isArray(value);
	}

	is_object$2.default = isObject$1;

	var scroll_to$1 = {};

	Object.defineProperty(scroll_to$1, '__esModule', {
	  value: true
	});

	function scrollToTop() {
	  window.scrollTo(0, 0);
	}

	function scrollTo(config) {
	  var elem;

	  if (config.element) {
	    elem = config.element;
	  } else {
	    elem = document.getElementById(config.id);
	  }

	  if (!elem) {
	    return;
	  }

	  setTimeout(function () {
	    elem.scrollIntoView({
	      behavior: 'smooth',
	      block: config.position
	    });
	  }, config.delay || 0);
	}

	scroll_to$1.default = scrollTo;

	scroll_to$1.scrollToTop = scrollToTop;

	var style$1 = {};

	Object.defineProperty(style$1, '__esModule', {
	  value: true
	});
	var is_object$1 = is_object$2;
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */

	function __spreadArray(to, from, pack) {
	  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	    if (ar || !(i in from)) {
	      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	      ar[i] = from[i];
	    }
	  }
	  return to.concat(ar || from);
	}

	function writeToDom(key, val) {
	  document.body.style.setProperty("--" + key, val);
	}

	function setStyle(style, path) {
	  if (path === void 0) {
	    path = [];
	  }

	  for (var styleProp in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, styleProp)) {
	      continue;
	    }

	    var val = style[styleProp];

	    var newPath = __spreadArray(__spreadArray([], path), [styleProp]);

	    if (is_object$1['default'](val)) {
	      setStyle(val, newPath);
	      return;
	    } // noinspection SuspiciousTypeOfGuard


	    if (val && typeof val === 'string') {
	      writeToDom(newPath.join('-'), val);
	    }
	  }
	}

	var Style =
	/** @class */
	function () {
	  function Style() {}

	  Style.applyStyle = function (style) {
	    setStyle(style);
	  };

	  Style.getCustomProperty = function (key) {
	    var styles = window.getComputedStyle(document.body);
	    return styles.getPropertyValue("--" + key);
	  };

	  Style.setFavicon = function () {
	    var link = document.querySelector('link[rel~=\'icon\']');

	    if (!link) {
	      link = document.createElement('link');
	      link.setAttribute('rel', 'icon');
	      document.head.appendChild(link);
	    }

	    var img = document.createElement('img');
	    var faviconUrl = link.href || window.location.origin + "/favicon.ico";

	    var onImageLoaded = function () {
	      var canvas = document.createElement('canvas');
	      canvas.width = 32;
	      canvas.height = 32;
	      var context = canvas.getContext('2d');
	      context.drawImage(img, 0, 0);
	      context.globalCompositeOperation = 'xor';
	      context.fillStyle = Style.getCustomProperty('color-secondary');
	      context.fillRect(0, 0, 32, 32);
	      context.fill();
	      link.type = 'image/x-icon';
	      link.href = canvas.toDataURL();
	    };

	    img.addEventListener('load', onImageLoaded);
	    img.src = faviconUrl;
	  };

	  return Style;
	}();

	style$1.default = Style;

	var dates$1 = {};

	Object.defineProperty(dates$1, '__esModule', {
	  value: true
	});
	var dateformat = {
	  exports: {}
	};

	(function (module, exports) {
	  function _typeof(obj) {
	    "@babel/helpers - typeof";

	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function _typeof(obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function _typeof(obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }

	    return _typeof(obj);
	  }

	  (function (global) {
	    var _arguments = arguments;

	    var dateFormat = function () {
	      var token = /d{1,4}|D{3,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|W{1,2}|[LlopSZN]|"[^"]*"|'[^']*'/g;
	      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
	      var timezoneClip = /[^-+\dA-Z]/g;
	      return function (date, mask, utc, gmt) {
	        if (_arguments.length === 1 && kindOf(date) === "string" && !/\d/.test(date)) {
	          mask = date;
	          date = undefined;
	        }

	        date = date || date === 0 ? date : new Date();

	        if (!(date instanceof Date)) {
	          date = new Date(date);
	        }

	        if (isNaN(date)) {
	          throw TypeError("Invalid date");
	        }

	        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks["default"]);
	        var maskSlice = mask.slice(0, 4);

	        if (maskSlice === "UTC:" || maskSlice === "GMT:") {
	          mask = mask.slice(4);
	          utc = true;

	          if (maskSlice === "GMT:") {
	            gmt = true;
	          }
	        }

	        var _ = function _() {
	          return utc ? "getUTC" : "get";
	        };

	        var _d = function d() {
	          return date[_() + "Date"]();
	        };

	        var D = function D() {
	          return date[_() + "Day"]();
	        };

	        var _m = function m() {
	          return date[_() + "Month"]();
	        };

	        var y = function y() {
	          return date[_() + "FullYear"]();
	        };

	        var _H = function H() {
	          return date[_() + "Hours"]();
	        };

	        var _M = function M() {
	          return date[_() + "Minutes"]();
	        };

	        var _s = function s() {
	          return date[_() + "Seconds"]();
	        };

	        var _L = function L() {
	          return date[_() + "Milliseconds"]();
	        };

	        var _o = function o() {
	          return utc ? 0 : date.getTimezoneOffset();
	        };

	        var _W = function W() {
	          return getWeek(date);
	        };

	        var _N = function N() {
	          return getDayOfWeek(date);
	        };

	        var flags = {
	          d: function d() {
	            return _d();
	          },
	          dd: function dd() {
	            return pad(_d());
	          },
	          ddd: function ddd() {
	            return dateFormat.i18n.dayNames[D()];
	          },
	          DDD: function DDD() {
	            return getDayName({
	              y: y(),
	              m: _m(),
	              d: _d(),
	              _: _(),
	              dayName: dateFormat.i18n.dayNames[D()],
	              short: true
	            });
	          },
	          dddd: function dddd() {
	            return dateFormat.i18n.dayNames[D() + 7];
	          },
	          DDDD: function DDDD() {
	            return getDayName({
	              y: y(),
	              m: _m(),
	              d: _d(),
	              _: _(),
	              dayName: dateFormat.i18n.dayNames[D() + 7]
	            });
	          },
	          m: function m() {
	            return _m() + 1;
	          },
	          mm: function mm() {
	            return pad(_m() + 1);
	          },
	          mmm: function mmm() {
	            return dateFormat.i18n.monthNames[_m()];
	          },
	          mmmm: function mmmm() {
	            return dateFormat.i18n.monthNames[_m() + 12];
	          },
	          yy: function yy() {
	            return String(y()).slice(2);
	          },
	          yyyy: function yyyy() {
	            return pad(y(), 4);
	          },
	          h: function h() {
	            return _H() % 12 || 12;
	          },
	          hh: function hh() {
	            return pad(_H() % 12 || 12);
	          },
	          H: function H() {
	            return _H();
	          },
	          HH: function HH() {
	            return pad(_H());
	          },
	          M: function M() {
	            return _M();
	          },
	          MM: function MM() {
	            return pad(_M());
	          },
	          s: function s() {
	            return _s();
	          },
	          ss: function ss() {
	            return pad(_s());
	          },
	          l: function l() {
	            return pad(_L(), 3);
	          },
	          L: function L() {
	            return pad(Math.floor(_L() / 10));
	          },
	          t: function t() {
	            return _H() < 12 ? dateFormat.i18n.timeNames[0] : dateFormat.i18n.timeNames[1];
	          },
	          tt: function tt() {
	            return _H() < 12 ? dateFormat.i18n.timeNames[2] : dateFormat.i18n.timeNames[3];
	          },
	          T: function T() {
	            return _H() < 12 ? dateFormat.i18n.timeNames[4] : dateFormat.i18n.timeNames[5];
	          },
	          TT: function TT() {
	            return _H() < 12 ? dateFormat.i18n.timeNames[6] : dateFormat.i18n.timeNames[7];
	          },
	          Z: function Z() {
	            return gmt ? "GMT" : utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, "").replace(/GMT\+0000/g, "UTC");
	          },
	          o: function o() {
	            return (_o() > 0 ? "-" : "+") + pad(Math.floor(Math.abs(_o()) / 60) * 100 + Math.abs(_o()) % 60, 4);
	          },
	          p: function p() {
	            return (_o() > 0 ? "-" : "+") + pad(Math.floor(Math.abs(_o()) / 60), 2) + ":" + pad(Math.floor(Math.abs(_o()) % 60), 2);
	          },
	          S: function S() {
	            return ["th", "st", "nd", "rd"][_d() % 10 > 3 ? 0 : (_d() % 100 - _d() % 10 != 10) * _d() % 10];
	          },
	          W: function W() {
	            return _W();
	          },
	          WW: function WW() {
	            return pad(_W());
	          },
	          N: function N() {
	            return _N();
	          }
	        };
	        return mask.replace(token, function (match) {
	          if (match in flags) {
	            return flags[match]();
	          }

	          return match.slice(1, match.length - 1);
	        });
	      };
	    }();

	    dateFormat.masks = {
	      default: "ddd mmm dd yyyy HH:MM:ss",
	      shortDate: "m/d/yy",
	      paddedShortDate: "mm/dd/yyyy",
	      mediumDate: "mmm d, yyyy",
	      longDate: "mmmm d, yyyy",
	      fullDate: "dddd, mmmm d, yyyy",
	      shortTime: "h:MM TT",
	      mediumTime: "h:MM:ss TT",
	      longTime: "h:MM:ss TT Z",
	      isoDate: "yyyy-mm-dd",
	      isoTime: "HH:MM:ss",
	      isoDateTime: "yyyy-mm-dd'T'HH:MM:sso",
	      isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",
	      expiresHeaderFormat: "ddd, dd mmm yyyy HH:MM:ss Z"
	    };
	    dateFormat.i18n = {
	      dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	      monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	      timeNames: ["a", "p", "am", "pm", "A", "P", "AM", "PM"]
	    };

	    var pad = function pad(val, len) {
	      val = String(val);
	      len = len || 2;

	      while (val.length < len) {
	        val = "0" + val;
	      }

	      return val;
	    };

	    var getDayName = function getDayName(_ref) {
	      var y = _ref.y,
	          m = _ref.m,
	          d = _ref.d,
	          _ = _ref._,
	          dayName = _ref.dayName,
	          _ref$short = _ref["short"],
	          _short = _ref$short === void 0 ? false : _ref$short;

	      var today = new Date();
	      var yesterday = new Date();
	      yesterday.setDate(yesterday[_ + "Date"]() - 1);
	      var tomorrow = new Date();
	      tomorrow.setDate(tomorrow[_ + "Date"]() + 1);

	      var today_d = function today_d() {
	        return today[_ + "Date"]();
	      };

	      var today_m = function today_m() {
	        return today[_ + "Month"]();
	      };

	      var today_y = function today_y() {
	        return today[_ + "FullYear"]();
	      };

	      var yesterday_d = function yesterday_d() {
	        return yesterday[_ + "Date"]();
	      };

	      var yesterday_m = function yesterday_m() {
	        return yesterday[_ + "Month"]();
	      };

	      var yesterday_y = function yesterday_y() {
	        return yesterday[_ + "FullYear"]();
	      };

	      var tomorrow_d = function tomorrow_d() {
	        return tomorrow[_ + "Date"]();
	      };

	      var tomorrow_m = function tomorrow_m() {
	        return tomorrow[_ + "Month"]();
	      };

	      var tomorrow_y = function tomorrow_y() {
	        return tomorrow[_ + "FullYear"]();
	      };

	      if (today_y() === y && today_m() === m && today_d() === d) {
	        return _short ? "Tdy" : "Today";
	      } else if (yesterday_y() === y && yesterday_m() === m && yesterday_d() === d) {
	        return _short ? "Ysd" : "Yesterday";
	      } else if (tomorrow_y() === y && tomorrow_m() === m && tomorrow_d() === d) {
	        return _short ? "Tmw" : "Tomorrow";
	      }

	      return dayName;
	    };

	    var getWeek = function getWeek(date) {
	      var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	      targetThursday.setDate(targetThursday.getDate() - (targetThursday.getDay() + 6) % 7 + 3);
	      var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);
	      firstThursday.setDate(firstThursday.getDate() - (firstThursday.getDay() + 6) % 7 + 3);
	      var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
	      targetThursday.setHours(targetThursday.getHours() - ds);
	      var weekDiff = (targetThursday - firstThursday) / (864e5 * 7);
	      return 1 + Math.floor(weekDiff);
	    };

	    var getDayOfWeek = function getDayOfWeek(date) {
	      var dow = date.getDay();

	      if (dow === 0) {
	        dow = 7;
	      }

	      return dow;
	    };

	    var kindOf = function kindOf(val) {
	      if (val === null) {
	        return "null";
	      }

	      if (val === undefined) {
	        return "undefined";
	      }

	      if (_typeof(val) !== "object") {
	        return _typeof(val);
	      }

	      if (Array.isArray(val)) {
	        return "array";
	      }

	      return {}.toString.call(val).slice(8, -1).toLowerCase();
	    };

	    if (_typeof(exports) === "object") {
	      module.exports = dateFormat;
	    } else {
	      global.dateFormat = dateFormat;
	    }
	  })(void 0);
	})(dateformat, dateformat.exports);

	var dateFormat = dateformat.exports;
	var ISO8601_REGEX = /^(\d{4})-(?:(02)-(0[1-9]|[12]\d)|(0[469]|11)-(0[1-9]|[12]\d|30)|(0[13578]|1[02])-(0[1-9]|[12]\d|3[01]))T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\.(\d{1,6}))?(Z|-(?:(?:0[0-9]|1[012]):00|0[39]:30)|\+(?:(?:0\d|1[0-4]):00|(?:0[3-69]|1[0]):30|0[58]:45|12:45))$/;

	function containsDate(dateCollection, date) {
	  var dateParts = dateFormat(date, 'yyyy-mm-dd').split('-');

	  if (dateParts.length < 3) {
	    return false;
	  }

	  var year = dateCollection[dateParts[0]];

	  if (!year) {
	    return false;
	  }

	  var month = year[dateParts[1]];

	  if (!month) {
	    return false;
	  }

	  var day = month[dateParts[2]];
	  return day && day.length > 0;
	}

	function getFirstDateFromNow(dateCollection) {
	  var now = new Date(); // First check if now exists exactly and return it if present.

	  if (containsDate(dateCollection, now)) {
	    now.setHours(0, 0, 0, 0);
	    return now;
	  } // Otherwise return first date after now if present


	  var yearKeys = Object.getOwnPropertyNames(dateCollection).sort();

	  for (var _i = 0, yearKeys_1 = yearKeys; _i < yearKeys_1.length; _i++) {
	    var year = yearKeys_1[_i];
	    var months = dateCollection[year];
	    var monthKeys = Object.getOwnPropertyNames(months).sort();

	    for (var _a = 0, monthKeys_1 = monthKeys; _a < monthKeys_1.length; _a++) {
	      var month = monthKeys_1[_a];
	      var days = months[month];
	      var dayKeys = Object.getOwnPropertyNames(days).sort();

	      for (var _b = 0, dayKeys_1 = dayKeys; _b < dayKeys_1.length; _b++) {
	        var day = dayKeys_1[_b];

	        if (days[day] && days[day].length > 0) {
	          try {
	            return new Date(parseInt(year, 10), parseInt(month, 10), parseInt(day, 10));
	          } catch (e) {// No-op - Ignore date if can't be parsed
	          }
	        }
	      }
	    }
	  } // If non were found


	  return null;
	}
	/**
	 *  Helper to determine if a string is a valid iso8601 datetime string
	 */


	function isValidISO8601String(value) {
	  // noinspection SuspiciousTypeOfGuard
	  if (!value || typeof value !== 'string') {
	    return false;
	  } // Check format


	  if (!ISO8601_REGEX.test(value)) {
	    return false;
	  } // Redundant check for creation


	  var iso8601 = new Date(value);
	  return iso8601.toString() !== 'Invalid Date'; // TODO (Once tests are created, can be moved there and removed here!)
	  // TEST VALUES
	  // VALID BASIC
	  // 2020-01-01T00:00:00+00:00
	  // 2020-01-31T00:00:00+00:00
	  // 2020-01-01T23:59:59+00:00
	  // 2020-04-30T00:00:00+00:00
	  // 2020-07-31T00:00:00+00:00
	  // 2020-08-31T00:00:00+00:00
	  // 2020-09-30T00:00:00+00:00
	  // 2020-12-31T00:00:00+00:00
	  //
	  // VALID WITH MS
	  // 2020-01-01T00:00:00.0+00:00
	  // 2020-01-01T00:00:00.000+00:00
	  // 2020-01-01T00:00:00.000000+00:00
	  // 2020-01-01T23:59:59.999999+00:00
	  // 2020-01-31T00:00:00.000000+00:00
	  // 2020-01-01T23:59:59.000000+00:00
	  // 2020-04-30T00:00:00.000000+00:00
	  // 2020-07-31T00:00:00.000000+00:00
	  // 2020-08-31T00:00:00.000000+00:00
	  // 2020-09-30T00:00:00.000000+00:00
	  // 2020-12-31T00:00:00.000000+00:00
	  //
	  // INVALID YEARS
	  // 20-01-01T00:00:00.000000+00:00
	  //
	  // INVALID MONTHS
	  // 2020-1-01T00:00:00.000000+00:00
	  // 2020-13-01T00:00:00.000000+00:00
	  // 2020-00-01T00:00:00.000000+00:00
	  //
	  // INVALID DAYS
	  // 2020-01-1T00:00:00.000000+00:00
	  // 2020-01-00T00:00:00.000000+00:00
	  // 2020-01-32T00:00:00.000000+00:00
	  // 2020-03-32T00:00:00.000000+00:00
	  // 2020-04-31T00:00:00.000000+00:00
	  // 2020-12-32T00:00:00.000000+00:00
	  // 2020-07-32T00:00:00.000000+00:00
	  //
	  // FEBRUARY
	  // 2020-02-29T00:00:00.000000+00:00
	  // 2020-02-30T00:00:00.000000+00:00
	  //
	  // INVALID TIME
	  // 2020-01-01T1:01:01.000000+00:00
	  // 2020-01-01T01:1:01.000000+00:00
	  // 2020-01-01T01:01:1.000000+00:00
	  // 2020-01-01T24:00:00.000000+00:00
	  // 2020-01-01T23:60:00.000000+00:00
	  // 2020-01-01T23:00:60.000000+00:00
	  // 2020-01-01T-00:00:00.000000+00:00
	  // 2020-01-01T00:-00:00.000000+00:00
	  //
	  // VALID TIMEZONE OFFSETS
	  // 2020-01-01T00:00:00Z
	  // 2020-01-01T00:00:00.000000Z
	  // 2020-01-01T00:00:00.000000-12:00
	  // 2020-01-01T00:00:00.000000-11:00
	  // 2020-01-01T00:00:00.000000-10:00
	  // 2020-01-01T00:00:00.000000-09:30
	  // 2020-01-01T00:00:00.000000-09:00
	  // 2020-01-01T00:00:00.000000-08:00
	  // 2020-01-01T00:00:00.000000-07:00
	  // 2020-01-01T00:00:00.000000-06:00
	  // 2020-01-01T00:00:00.000000-05:00
	  // 2020-01-01T00:00:00.000000-04:00
	  // 2020-01-01T00:00:00.000000-03:30
	  // 2020-01-01T00:00:00.000000-03:00
	  // 2020-01-01T00:00:00.000000-02:00
	  // 2020-01-01T00:00:00.000000-01:00
	  // 2020-01-01T00:00:00.000000-00:00
	  // 2020-01-01T00:00:00.000000+00:00
	  // 2020-01-01T00:00:00.000000+01:00
	  // 2020-01-01T00:00:00.000000+02:00
	  // 2020-01-01T00:00:00.000000+03:00
	  // 2020-01-01T00:00:00.000000+03:30
	  // 2020-01-01T00:00:00.000000+04:00
	  // 2020-01-01T00:00:00.000000+04:30
	  // 2020-01-01T00:00:00.000000+05:00
	  // 2020-01-01T00:00:00.000000+05:30
	  // 2020-01-01T00:00:00.000000+05:45
	  // 2020-01-01T00:00:00.000000+06:00
	  // 2020-01-01T00:00:00.000000+06:30
	  // 2020-01-01T00:00:00.000000+07:00
	  // 2020-01-01T00:00:00.000000+08:00
	  // 2020-01-01T00:00:00.000000+08:45
	  // 2020-01-01T00:00:00.000000+09:00
	  // 2020-01-01T00:00:00.000000+09:30
	  // 2020-01-01T00:00:00.000000+10:00
	  // 2020-01-01T00:00:00.000000+10:30
	  // 2020-01-01T00:00:00.000000+11:00
	  // 2020-01-01T00:00:00.000000+12:00
	  // 2020-01-01T00:00:00.000000+12:45
	  // 2020-01-01T00:00:00.000000+13:00
	  // 2020-01-01T00:00:00.000000+14:00
	  //
	  // INVALID TIMEZONE OFFSETS
	  // 2020-01-01T00:00:00.000000-12:01
	  // 2020-01-01T00:00:00.000000-13:00
	  // 2020-01-01T00:00:00.000000-10:45
	  // 2020-01-01T00:00:00.000000+12:01
	  // 2020-01-01T00:00:00.000000+15:00
	  // 2020-01-01T00:00:00.000000+10:45
	  // 2020-01-01T00:00:00.000000+1:00
	  // 2020-01-01T00:00:00.000000+00:3
	}
	/**
	 *  Verify and cast the value to a Date instance
	 */


	function ensureDateInstance(value) {
	  if (!(value instanceof Date)) {
	    if (!isValidISO8601String(value)) {
	      return null;
	    }

	    return new Date(value);
	  }

	  return value;
	}

	dates$1.containsDate = containsDate;
	dates$1.ensureDateInstance = ensureDateInstance;
	dates$1.getFirstDateFromNow = getFirstDateFromNow;
	dates$1.isValidISO8601String = isValidISO8601String;

	Object.defineProperty(lib, '__esModule', {
	  value: true
	});
	var is_scrolled = is_scrolled$1;
	var copy_to_clipboard = copy_to_clipboard$1;
	var flag = flag$1;
	var browser_language = browser_language$1;
	var has_local_storage = has_local_storage$1;
	var int_to_duration = int_to_duration$1;
	var is_object = is_object$2;
	var scroll_to = scroll_to$1;
	var style = style$1;
	var dates = dates$1;
	lib.addIsScrolledListener = is_scrolled['default'];
	lib.copyToClipboard = copy_to_clipboard['default'];
	lib.countryCodeToFlag = flag['default'];
	lib.getBrowserLanguage = browser_language['default'];
	lib.hasLocalStorage = has_local_storage['default'];
	lib.intToDuration = int_to_duration['default'];
	var intToDurationObject = lib.intToDurationObject = int_to_duration.intToDurationObject;
	lib.isObject = is_object['default'];
	lib.scrollTo = scroll_to['default'];
	lib.scrollToTop = scroll_to.scrollToTop;
	lib.Style = style['default'];
	lib.containsDate = dates.containsDate;
	lib.ensureDateInstance = dates.ensureDateInstance;
	lib.getFirstDateFromNow = dates.getFirstDateFromNow;
	lib.isValidISO8601String = dates.isValidISO8601String;

	/**
	 * This class generates notifications from events. These events
	 * are then received by clients which decide to show a notifcation to the user.
	 */

	class OpenTicketBaseNotifications {
	  constructor(base) {
	    this._shop = base; // Listen for coupon events

	    this._shop._eventBus.on(['cart', 'coupon'], path => {
	      switch (path[2]) {
	        case 'add':
	          this._send({
	            type: 'is-success',
	            message: 'Coupon applied',
	            slug: 'sdkshop.notifications.coupon_applied'
	          });

	          break;

	        case 'remove':
	          this._send({
	            type: 'is-warning',
	            message: 'Coupon removed',
	            slug: 'sdkshop.notifications.coupon_removed'
	          });

	          break;
	      }
	    });

	    let countdownStart = null;
	    let countdownWarningShown = false;
	    let countdownDangerShown = false; // Listen for timer events

	    this._shop.events.on(['timer'], (path, data) => {
	      switch (path[1]) {
	        case 'start':
	          countdownStart = data.secondsRemaining;

	          this._send({
	            type: 'is-info',
	            message: `Reserved for ${intToDurationObject(data.secondsRemaining || 0)['minutes']}`,
	            slug: 'sdkshop.notifications.reservation_started',
	            slugData: intToDurationObject(data.secondsRemaining || 0)
	          });

	          break;

	        case 'tick':
	          if (!countdownWarningShown && countdownStart && data.secondsRemaining && countdownStart < data.secondsRemaining) {
	            countdownWarningShown = true;

	            this._send({
	              type: 'is-warning',
	              message: `Reserved for ${intToDurationObject(data.secondsRemaining || 0)['minutes']}`,
	              slug: 'sdkshop.notifications.reservation_expiration_warning',
	              slugData: intToDurationObject(data.secondsRemaining || 0)
	            });
	          }

	          break;

	        case 'clear':
	          if (!countdownDangerShown) {
	            if (data.timeout) {
	              countdownDangerShown = true;

	              this._send({
	                type: 'is-danger',
	                message: 'Reservation expired',
	                slug: 'sdkshop.notifications.reservation_expired'
	              });
	            } else {
	              this._send({
	                type: 'is-info',
	                message: 'Cart cleared',
	                slug: 'sdkshop.notifications.cart_cleared'
	              });
	            }
	          }

	          break;
	      }
	    });
	  }
	  /**
	   * Send a notification over the notification channel
	   * @param data - Notification configuration
	   */


	  send(data) {
	    this._send(data);
	  }

	  _send(data) {
	    this._shop.events.emit(['notification'], data);
	  }

	}

	var __awaiter$4 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	/**
	 *  Seats.io service
	 */

	class SeatsioService {
	  /**
	   *  Construct the Seats.io service
	   *
	   *  This will lock the config in place for all future use cases.
	   */
	  constructor(config) {
	    this.config = this._ensureConfig(config);
	  }
	  /**
	   *  Ensure the Seats.io chart library is loaded.
	   */


	  ensureLoaded() {
	    return __awaiter$4(this, void 0, void 0, function* () {
	      if (!window.seatsio) {
	        yield loadScript('https://cdn.seatsio.net/chart.js');
	      }

	      if (!window.seatsio) {
	        throw new Error('Seats.io -> Not loaded');
	      }
	    });
	  }
	  /**
	   *  Mount the SeatingChart to the DOM.
	   */


	  mount(options) {
	    return __awaiter$4(this, void 0, void 0, function* () {
	      yield this.ensureLoaded();
	      this.destroy();

	      const config = this._ensureOptions(options); // Save some current callbacks.
	      // These callbacks can now be wrapped by internal functionality.


	      const onChartRendered = config.onChartRendered;
	      const onChartRenderingFailed = config.onChartRenderingFailed;
	      const onHoldTokenExpired = config.onHoldTokenExpired; // Create a promise that will resolve when the chart has been rendered
	      // or reject if it fails rendering.

	      const rendered = new Promise((resolve, reject) => {
	        config.onChartRendered = chart => {
	          this._setHoldToken();

	          onChartRendered && onChartRendered(chart);
	          resolve(this);
	        };

	        config.onChartRenderingFailed = chart => {
	          onChartRenderingFailed && onChartRenderingFailed(chart);
	          this.chart = undefined;
	          chart.destroy();
	          reject();
	        };

	        config.onHoldTokenExpired = () => {
	          this.holdToken = undefined;
	          onHoldTokenExpired && onHoldTokenExpired();

	          if (this.chart) {
	            this.chart.startNewSession(this._setHoldToken.bind(this), () => {
	              throw new Error('Seats.io -> Failed to start new seatsio session');
	            });
	          } else {
	            console.error('Failed to start new seatsio session -> no chart');
	          }
	        };
	      });
	      this.chart = new window.seatsio.SeatingChart(config);
	      this.chart.render();
	      return rendered;
	    });
	  }
	  /**
	   *  Destroy the current seating chart
	   *
	   *  This is a mandatory step. Failing to destroy charts will lead to memory leaks!
	   */


	  destroy() {
	    if (!this.chart) {
	      return;
	    }

	    const chart = this.chart;
	    this.chart = undefined;
	    chart.destroy();
	  }
	  /**
	   *  Validate the config and merge with the current (default) config.
	   */


	  _ensureConfig(config) {
	    const conf = Object.assign(Object.assign({}, this.config), config);

	    if (!conf.workspaceKey) {
	      throw new Error('Seats.io -> Workspace key missing');
	    }

	    return this.config = conf;
	  }
	  /**
	   *  Validate the options (config) and ensure default values are set.
	   */


	  _ensureOptions(options) {
	    if (!options.divId || options.divId.length < 2 || !options.divId.startsWith('#')) {
	      throw new Error('Seats.io -> Invalid divId, expected DOM id selector (starts with #)');
	    }

	    if (!options.events || !options.events.length) {
	      throw new Error('Seats.io -> Expected at least one event key');
	    }

	    if (!options.pricing || !options.pricing.length) {
	      throw new Error('Seats.io -> Invalid pricing, expected at least one pricing option');
	    }

	    const selectionValidators = [];

	    if (!options.allowOrphanSeats) {
	      selectionValidators.push({
	        type: 'noOrphanSeats',
	        mode: 'strict'
	      });
	    }

	    if (options.forceConsecutiveSeats) {
	      selectionValidators.push({
	        type: 'consecutiveSeats'
	      });
	    }

	    return Object.assign({
	      // DOM location
	      divId: options.divId.replace(/^[#]/, ''),
	      // Session values
	      session: this.holdToken ? 'continue' : 'start',
	      // Note: holdOnSelect is not allowed when passing in session
	      // holdOnSelect: true,
	      holdOnSelectForGAs: true,
	      // Chart, event, category, pricing settings
	      events: options.events,
	      pricing: options.pricing,
	      maxSelectedObjects: options.maxSelectedObjects,
	      priceFormatter: options.priceFormatter,
	      objectWithoutPricingSelectable: false,
	      objectWithoutCategorySelectable: false,
	      canGASelectionBeIncreased: undefined,
	      // Explicitly disabled! Could potentially trigger large number of concurrent reservations!
	      multiSelectEnabled: false,
	      availableCategories: undefined,
	      unavailableCategories: undefined,
	      selectedObjects: undefined,
	      // Validators
	      selectionValidators,
	      // Styling
	      showRowLines: true,
	      showLegend: options.showLegend !== false,
	      legend: {
	        hideNonSelectableCategories: true
	      },
	      language: ensureLanguage(options.language),
	      showMinimap: true,
	      loading: options.loading || undefined,
	      colorScheme: options.colorScheme || 'light',
	      colors: {
	        // The color used for certain interactive, selected or highlighted user interface elements.
	        colorSelected: options.colors && options.colors.colorSelected || undefined,
	        //The background color for the whole tooltip.
	        cursorTooltipBackgroundColor: options.colors && options.colors.cursorTooltipBackgroundColor || undefined,
	        // The color of certain tiles, such as in modal dialogs or the Category Filter.
	        colorTitle: options.colors && options.colors.colorTitle || undefined
	      },
	      stylePreset: options.stylePreset || 'balance',
	      style: options.style || undefined,
	      onHoldSucceeded: options.onHoldSucceeded || undefined,
	      onHoldFailed: options.onHoldFailed || undefined,
	      onHoldTokenExpired: options.onHoldTokenExpired || undefined,
	      onReleaseHoldSucceeded: options.onReleaseHoldSucceeded || undefined,
	      onReleaseHoldFailed: options.onReleaseHoldFailed || undefined,
	      onSelectionValid: options.onSelectionValid || undefined,
	      onSelectionInvalid: options.onSelectionInvalid || undefined,
	      // Non-exposed events.
	      // For now the below events are not exposed to any implementor.
	      // Should be added when needed!
	      // onChartRendered
	      // onChartRenderingFailed
	      // onObjectClicked
	      // onObjectSelected
	      // onObjectDeselected
	      // onObjectMouseOver
	      // onObjectMouseOut
	      // onSelectedObjectBooked
	      // onBestAvailableSelected
	      // onBestAvailableSelectionFailed
	      // onFullScreenOpened
	      // onFullScreenClosed
	      // Other
	      unifiedObjectPropertiesInCallbacks: true,
	      extraConfig: undefined
	    }, this.config);
	  }
	  /**
	   *  Set the hold token, this signals the Seats.io class a session is currently active.
	   */


	  _setHoldToken() {
	    if (!this.chart) {
	      console.error('Failed to retrieve hold token -> chart does not exist');
	    } else if (this.chart.holdToken) {
	      this.holdToken = this.chart.holdToken;
	    } else {
	      console.error('Failed to retrieve hold token -> Session not started');
	    }
	  }

	}
	/**
	 *  Process a language or locale to be a supported language string or fallback to the given default.
	 */

	function ensureLanguage(lang, defaultLang = 'en') {
	  if (!lang) {
	    return defaultLang;
	  }

	  if (/^[a-z]{2}_/.test(lang)) {
	    lang = lang.substr(0, 2);
	  } // See: https://support.seats.io/en/articles/2074430-translating-embedded-floor-plans-i18n


	  const languages = {
	    'ar': 'Arabic',
	    'be': 'Belarusian',
	    'bg': 'Bulgarian',
	    'ca': 'Catalan',
	    'cs': 'Czech',
	    'da': 'Danish',
	    'de': 'German',
	    'el': 'Greek',
	    'en': 'English',
	    'es': 'Spanish',
	    'et': 'Estonian',
	    'fa': 'Persian (Farsi)',
	    'fi': 'Finnish',
	    'fr': 'French',
	    'hr': 'Croatian',
	    'he': 'Hebrew',
	    'hu': 'Hungarian',
	    'it': 'Italian',
	    'ja': 'Japanese',
	    'li': 'Lithuanian',
	    'lv': 'Latvian',
	    'no': 'Norwegian',
	    'nl': 'Dutch',
	    'pl': 'Polish',
	    'pt': 'Portuguese',
	    'ro': 'Romanian',
	    'ru': 'Russian',
	    'sk': 'Slovak',
	    'sl': 'Slovenian',
	    'sr': 'Serbian',
	    'sv': 'Swedish',
	    'tr': 'Turkish',
	    'uk': 'Ukrainian',
	    'zh-Hans': 'Simplified Chinese',
	    'zh-Hant': 'Traditional Chinese'
	  };
	  return languages[lang] ? lang : defaultLang;
	}

	class CartValidator extends BaseValidator {
	  constructor(cart, logger) {
	    super();
	    this._cart = cart;
	    this._log = logger;
	  }
	  /**
	   *  Validate all booker cart metadata.
	   *
	   *  This will return true iff all metadata is valid.
	   *  On failure, the errors are set on the cart metadata object
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.bookerMetadata();
	   *  ```
	   *
	   *  | Error                                    | Reason                              |
	   *  | :--------------------------------------- | :---------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
	   *
	   *  Note: Failed validation will NOT throw an error
	   */


	  bookerMetadata(mutateErrors) {
	    return mergeValidation({
	      booker: mergeValidation(Object.assign({}, this._cart.booker), this.metadata.bind(this), mutateErrors),
	      metadata: mergeValidation(this._cart.metadata, this.metadata.bind(this), mutateErrors)
	    }, item => item);
	  }
	  /**
	   *  Validate a given ticket's cart metadata.
	   *
	   *  This will return true iff all metadata is valid.
	   *  On failure, the errors are set on the cart metadata object
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.ticketMetadata(cartTicket);
	   *  ```
	   *
	   *  | Error                                    | Reason                              |
	   *  | :--------------------------------------- | :---------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
	   *
	   *  Note: Failed validation will NOT throw an error
	   */


	  ticketMetadata(cartTicket, mutateErrors) {
	    if (!CartTicket.isCartTicket(cartTicket)) {
	      throw slugError('Failed to validate ticket metadata -> invalid cart ticket', ['validation', 'ticketMetadata', 'error', 'ticket']);
	    }

	    return this._validateCartItemMetadata(cartTicket, mutateErrors);
	  }
	  /**
	   *  Validate all ticket cart metadata.
	   *
	   *  This will return true iff all metadata is valid.
	   *  On failure, the errors are set on the cart metadata object
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.allTicketMetadata();
	   *  ```
	   *
	   *  | Error                                    | Reason                              |
	   *  | :--------------------------------------- | :---------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
	   *
	   *  Note: Failed validation will NOT throw an error
	   */


	  allTicketMetadata(mutateErrors) {
	    return mergeValidation(this._cart.flatItems[CartItemChildType.Tickets], this.ticketMetadata.bind(this), mutateErrors);
	  }
	  /**
	   *  Validate a given product's cart metadata.
	   *
	   *  This will return true iff all metadata is valid.
	   *  On failure, the errors are set on the cart metadata object
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.productMetadata(cartProduct);
	   *  ```
	   *
	   *  | Error                                    | Reason                              |
	   *  | :--------------------------------------- | :---------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
	   *
	   *  Note: Failed validation will NOT throw an error
	   */


	  productMetadata(cartProduct, mutateErrors) {
	    if (!CartProduct.isCartProduct(cartProduct)) {
	      throw slugError('Failed to validate product metadata -> invalid cart product', ['validation', 'productMetadata', 'error', 'product']);
	    }

	    return this._validateCartItemMetadata(cartProduct, mutateErrors);
	  }
	  /**
	   *  Validate all (global) product cart metadata.
	   *
	   *  This will return true iff all metadata is valid.
	   *  On failure, the errors are set on the cart metadata object
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.allProductMetadata();
	   *  ```
	   *
	   *  | Error                                    | Reason                              |
	   *  | :--------------------------------------- | :---------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
	   *
	   *  Note: Failed validation will NOT throw an error
	   */


	  allProductMetadata(mutateErrors) {
	    return mergeValidation(this._cart.flatItems[CartItemChildType.Products], cartProduct => {
	      if (cartProduct.childOf) {
	        return validationResponseFromValidationErrors([]);
	      }

	      return this.productMetadata(cartProduct, mutateErrors);
	    });
	  }
	  /**
	   *  Validate all metadata (booker, ticket & product).
	   *
	   *  This will return true iff all metadata is valid.
	   *  On failure, the errors are set on the cart metadata object
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.allMetadata();
	   *  ```
	   *
	   *  | Error                                    | Reason                              |
	   *  | :--------------------------------------- | :---------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
	   *
	   *  Note: Failed validation will NOT throw an error
	   */


	  allMetadata(mutateErrors) {
	    return mergeValidation({
	      booker: this.bookerMetadata(mutateErrors),
	      ticket: this.allTicketMetadata(mutateErrors),
	      product: this.allProductMetadata(mutateErrors)
	    }, item => item);
	  }
	  /**
	   *  Validate ticket constraints for a ticket
	   *
	   *  E.g.: min/max orderable amount of tickets
	   *
	   *  If the ticket is not ordered, it is NOT invalid,
	   *  even if the min orderable amount is larger than zero.
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.ticket(ticket);
	   *  ```
	   */


	  ticket(ticket, mutateErrors = true) {
	    // If the ticket is not ordered, it is NOT invalid,
	    // even if the min orderable amount is larger than zero.
	    if (!Object.prototype.hasOwnProperty.call(this._cart.items, ticket.event_id) || !Object.prototype.hasOwnProperty.call(this._cart.items[ticket.event_id][CartItemChildType.Tickets].map, ticket.guid)) {
	      return validationResponseFromValidationErrors([]);
	    } // TODO Where should we get these defaults from... ?


	    const min = ticket.min_orderable_amount_per_order || 1;
	    const max = ticket.max_orderable_amount_per_order || 20;
	    const increment = ticket.increment || 1;
	    const cartTicketCount = Object.keys(this._cart.items[ticket.event_id][CartItemChildType.Tickets].map[ticket.guid]).length;
	    const ticketErrors = [];

	    if (cartTicketCount > 0) {
	      // TODO Should we set a errors somewhere ??? (With mutateErrors check)
	      if (cartTicketCount < min) {
	        ticketErrors.push(`invalid minimum orderable amount per order: should contain at least ${ticket.min_orderable_amount_per_order} tickets`);
	      }

	      if (cartTicketCount > max) {
	        ticketErrors.push(`invalid maximum orderable amount per order: should contain at most ${ticket.max_orderable_amount_per_order} tickets`);
	      }

	      if (cartTicketCount % increment !== 0) {
	        ticketErrors.push(`invalid increment: should contain a strict multiple of ${ticket.increment} tickets`);
	      }
	    }

	    return validationResponseFromValidationErrors(ticketErrors, ticketErrors[0]);
	  }
	  /**
	   *  Validate ticket constraints for all tickets
	   *
	   *  E.g.: min/max orderable amount of tickets
	   *
	   *  We can safely check the cart tickets here,
	   *  as we define cart tickets to be valid,
	   *  even when they have not been reserved
	   *  AND the min orderable amount is larger than zero.
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.allTickets();
	   *  ```
	   */


	  allTickets(mutateErrors) {
	    return mergeValidation(this._cart.items, eventItems => {
	      return mergeValidation(eventItems[CartItemChildType.Tickets].map, cartTickets => {
	        const firstCartTicket = Object.values(cartTickets)[0];

	        if (!firstCartTicket) {
	          return validationResponseFromValidationErrors([]);
	        }

	        return this.ticket(firstCartTicket.item, mutateErrors);
	      });
	    });
	  }
	  /**
	   *  Validate (optional) product constraints for a product group of a cart ticket.
	   *
	   *  A product group is considered valid if the count of the ticket's products is within the bounds.
	   *  And the uniqueness is not surpassed for each individual product type.
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.ticketProductGroup(cartTicket, productGroup);
	   *  ```
	   */


	  ticketProductGroup(cartTicket, productGroup, mutateErrors = true) {
	    const productGroupErrors = [];
	    const productErrors = {};
	    let productMessage = '';
	    let totalCartProductCount = 0; // TODO Should we set a errors somewhere ??? (With mutateErrors check)
	    // Test the product group for every product type in the ticket.
	    // The count of these types is used to validate the min and max bounds.
	    // Inside the loop, the uniqueness is checked for every product type.

	    forOwn(cartTicket.products.map, (cartProducts, productGuid) => {
	      const groupProduct = productGroup.products.find(product => product.guid === productGuid); // If the product is not found, this cart product set does not apply to this product group.

	      if (!groupProduct) {
	        return;
	      }

	      const cartProductCount = Object.keys(cartProducts).length;
	      totalCartProductCount += cartProductCount;
	      const uniqueness = groupProduct.uniqueness || productGroup.uniqueness;

	      if (!!uniqueness && cartProductCount > uniqueness) {
	        productErrors[productGuid] = ['product uniqueness invalid'];
	        productMessage = 'product uniqueness invalid';
	      }
	    });

	    if (totalCartProductCount < productGroup.min_bound) {
	      productGroupErrors.push(`invalid min bound: should contain at least ${productGroup.min_bound} products`);
	    } else if (!!productGroup.max_bound && totalCartProductCount > productGroup.max_bound) {
	      productGroupErrors.push(`invalid max bound: should contain at most ${productGroup.max_bound} products`);
	    }

	    return mergeValidation({
	      count: validationResponseFromValidationErrors(productGroupErrors, productGroupErrors[0]),
	      products: validationResponseFromValidationErrors(productErrors, productMessage)
	    }, item => item);
	  }
	  /**
	   *  Validate (optional) product constraints for a cart ticket.
	   *
	   *  This is done using the constraints of product groups.
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.ticketProducts(cartTicket);
	   *  ```
	   */


	  ticketProducts(cartTicket, mutateErrors = true) {
	    // Convert list to map
	    const productGroups = cartTicket.item.groups.reduce((carry, item) => {
	      carry[item.guid] = item;
	      return carry;
	    }, {});
	    const groupErrors = mergeValidation(productGroups, productGroup => this.ticketProductGroup(cartTicket, productGroup, mutateErrors)); // Also ensure all required products not part of a group are validated.
	    // Note: This could result in a product flagged as an error both as required product and as invalid group

	    const productErrors = {};
	    let productMessage = '';
	    forEach$2(cartTicket.item.products.required, product => {
	      // TODO Should we set a errors somewhere ??? (With mutateErrors check)
	      if (!Object.prototype.hasOwnProperty.call(cartTicket.products.map, product.guid)) {
	        productErrors[product.guid] = ['product is required'];
	        productMessage = 'product is required';
	      }
	    });
	    return mergeValidation({
	      groups: groupErrors,
	      requiredProducts: validationResponseFromValidationErrors(productErrors, productMessage)
	    }, item => item);
	  }
	  /**
	   *  Validate (optional) product constraints for all cart tickets.
	   *
	   *  This is done using the constraints of product groups.
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.allTicketProducts();
	   *  ```
	   */


	  allTicketProducts(mutateErrors) {
	    return mergeValidation(this._cart.flatItems[CartItemChildType.Tickets], this.ticketProducts.bind(this), mutateErrors);
	  }
	  /**
	   *  Validate if the cart has items.
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.hasItems();
	   *  ```
	   */


	  hasItems() {
	    let messages = [];

	    if (!this._cart.hasItems()) {
	      messages.push('invalid items: should contain at least 1 item');
	    }

	    return validationResponseFromValidationErrors(messages, messages[0]);
	  }
	  /**
	   *  Validate all validators for the cart.
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.all();
	   *  ```
	   */


	  all() {
	    const result = mergeValidation({
	      // An order should have at least one item
	      items: this.hasItems(),
	      // Ticket constraints should be valid
	      tickets: this.allTickets(),
	      // Product group constraints should be valid
	      ticket_products: this.allTicketProducts(),
	      // All metadata validation should succeed
	      metadata: this.allMetadata(),
	      // All terms should be accepted
	      terms: this.allTerms(),
	      // The chosen payment method should be valid
	      // Note: Most payment methods can ONLY be valid
	      payment_methods: this.paymentMethod(true)
	    }, item => item);

	    if (!result.valid) {
	      this._log._create(LogLevel.Debug, ['cart', 'validation', 'all', 'invalid'], result);
	    }

	    return result;
	  }
	  /**
	   *  Validate if all terms are accepted.
	   *
	   *  This will return true iff all terms are accepted.
	   *
	   *  ```ts
	   *  const validationResponse: ValidationResponse = cart.validator.allTerms();
	   *  ```
	   */


	  allTerms(mutateErrors = true) {
	    const termsErrors = {};
	    let message = '';
	    forOwn(this._cart.terms, (term, key) => {
	      if (!term) {
	        // TODO Should we set a errors somewhere ??? (With mutateErrors check)
	        termsErrors[key] = ['term should be accepted']; // TODO Translate

	        message = 'term should be accepted';
	      }
	    });
	    return validationResponseFromValidationErrors(termsErrors, message);
	  }
	  /**
	   *  Validate the custom properties for the chosen payment method.
	   *
	   *  Note: For the default payment method(s), this is currently irrelevant.
	   *  The default payment methods are always valid.
	   */


	  paymentMethod(checkStripeToken = false, mutateErrors = true) {
	    const result = this._paymentMethod(checkStripeToken, mutateErrors);

	    if (!result.valid) {
	      this._log._create(LogLevel.Debug, ['cart', 'validation', 'paymentMethod', 'invalid'], result);
	    }

	    return result;
	  }

	  _paymentMethod(checkStripeToken = false, mutateErrors = true) {
	    const cartPaymentMethod = this._cart.paymentMethod;

	    if (!cartPaymentMethod) {
	      return validationResponseFromValidationErrors(['Payment method missing'], 'Payment method missing');
	    }

	    if (cartPaymentMethod.is_stripe && this._cart.checkout_details.total_price > 0) {
	      if (!cartPaymentMethod.item.stripe || !cartPaymentMethod.item.stripe.complete) {
	        return validationResponseFromValidationErrors(['Stripe should be completed'], 'Stripe should be completed');
	      }

	      if (cartPaymentMethod.item.stripe.errors.length) {
	        const errors = cartPaymentMethod.item.stripe.errors.map(error => error.message);
	        return validationResponseFromValidationErrors(errors, errors[0]);
	      }

	      if (checkStripeToken && !cartPaymentMethod.stripe_token) {
	        return validationResponseFromValidationErrors(['Stripe token missing'], 'Stripe token missing');
	      }
	    }

	    return validationResponseFromValidationErrors([]);
	  }
	  /**
	   *  Validate the cart metadata collection of a given cart item.
	   *
	   *  This will return true iff all metadata is valid.
	   *  On failure, the errors are set on the cart metadata object
	   *
	   *  ```ts
	   *  const validationOk: boolean = cart._validateCartItemMetadata(cartItem);
	   *  ```
	   *
	   *  Note: this method expects its first argument to be of type CartItem.
	   *  A CartItem type is a generic fixed to a Reservable type. By using `Reservable<any>`
	   *  here, the exact type CartItem implementation can be extended in one (or at least less)
	   *  place(s).
	   *
	   *  | Error                                    | Reason                              |
	   *  | :--------------------------------------- | :---------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid cartMetadata provided |
	   *
	   *  Note: Failed validation will NOT throw an error
	   *
	   *  @internal
	   */


	  _validateCartItemMetadata(cartItem, mutateErrors = true) {
	    const metadataErrors = mergeValidation(cartItem.metadata, this.metadata.bind(this), mutateErrors);
	    const childErrors = mergeValidation(CartItemChildType, childType => {
	      if (!Object.prototype.hasOwnProperty.call(cartItem.children, childType) || !cartItem.children[childType]) {
	        return validationResponseFromValidationErrors({});
	      }

	      return mergeValidation(cartItem.children[childType].map, childItems => {
	        return mergeValidation(childItems, this._validateCartItemMetadata.bind(this), mutateErrors);
	      });
	    });
	    return mergeValidation({
	      metadata: metadataErrors,
	      children: childErrors
	    }, item => item);
	  }

	}
	/**
	 *  Helper method to compile and merge validation errors and state.
	 *
	 *  The info needed for this is gathered by running the same callback on all items in the input.
	 */

	function mergeValidation(items, cb, mutateErrors) {
	  const errors = {};
	  let message = '';
	  forOwn(items, (item, key) => {
	    // Explicitly do not cancel the loop before all metadata are handled!
	    // Even if one fails, we still want to know the errors of the rest.
	    const validationResponse = cb(item, mutateErrors);

	    if (!validationResponse.valid) {
	      errors[key] = validationResponse.errors;
	      message = message || validationResponse.message;
	    }
	  });
	  return validationResponseFromValidationErrors(errors, message);
	}
	/**
	 *  Helper method to created a validation response from validation errors.
	 *
	 *  The validation response is defined to be valid if no errors are given.
	 */


	function validationResponseFromValidationErrors(errors, message) {
	  return {
	    valid: !Object.keys(errors).length,
	    message: message || '',
	    errors
	  };
	}

	/**
	 *  Possible type of a (child) reservation.
	 */
	var ReservationRequestAction;

	(function (ReservationRequestAction) {
	  ReservationRequestAction["Reserve"] = "reserve";
	  ReservationRequestAction["Release"] = "release";
	})(ReservationRequestAction || (ReservationRequestAction = {}));

	var ReservationType;

	(function (ReservationType) {
	  ReservationType["Ticket"] = "Ticket";
	  ReservationType["Product"] = "Product";
	})(ReservationType || (ReservationType = {}));

	/**
	 *  a reservation request holds the data and promise for a reservation request.
	 *  It also exposes the resolve and reject methods of the promise.
	 *
	 *  A reservation request can be created to fetch reservations in bulk for the same type and guid.
	 *  This number of reservations amount could be used to either fetch all reservations for a group ticket (E.g.: 1 click -> 5 tickets).
	 *
	 *  @internal
	 */

	class ReservationRequest {
	  constructor(type, guid, numberOfReservations) {
	    this._resolve = () => {};

	    this._reject = () => {};

	    if (!type || !enumIncludes(ReservationType, type)) {
	      throw slugError('Invalid reservation request -> invalid type', ['reservator', 'request', 'constructor', 'error', 'type']);
	    } // noinspection SuspiciousTypeOfGuard


	    if (!guid || typeof guid !== 'string' || !guid.length) {
	      throw slugError('Invalid reservation request -> invalid guid', ['reservator', 'request', 'constructor', 'error', 'guid']);
	    }

	    if (!numberOfReservations || !Number.isSafeInteger(numberOfReservations) || numberOfReservations < 1) {
	      throw slugError('Invalid reservation request -> invalid number of reservations', ['reservator', 'request', 'constructor', 'error', 'numberofreservations']);
	    }

	    this.action = ReservationRequestAction.Reserve;
	    this.type = type;
	    this.guid = guid;
	    this.numberOfReservations = numberOfReservations;
	    this.childType = undefined;
	    this.childGuid = undefined;
	    /**
	     *  The executor creates the bridge between the promise internals and
	     *  the resolve and reject methods exposed on the reservation request instance.
	     *
	     *  @internal
	     */

	    this._promise = new Promise((resolve, reject) => {
	      this._resolve = resolve;
	      this._reject = reject;
	    });
	  }
	  /**
	   *  For child changes a reservation request to request a child reservation for the already present reservation
	   *  This method can only be called once and can not be called if the reservation request is a release request
	   */


	  forChild(type, guid) {
	    if (!(this instanceof ReservationRequest)) {
	      throw slugError('Invalid reservation request -> for child called on invalid reservation request', ['reservator', 'request', 'forChild', 'error', 'reservationrequest']);
	    }

	    if (this.childType || this.childGuid) {
	      throw slugError('Invalid reservation request -> can not combine child reservation and release', ['reservator', 'request', 'forChild', 'error', 'exclusive']);
	    }

	    if (!type || !enumIncludes(ReservationType, type)) {
	      throw slugError('Invalid reservation request -> invalid child type', ['reservator', 'request', 'forChild', 'error', 'type']);
	    } // noinspection SuspiciousTypeOfGuard


	    if (!guid || typeof guid !== 'string' || !guid.length) {
	      throw slugError('Invalid reservation request -> invalid child guid', ['reservator', 'request', 'forChild', 'error', 'guid']);
	    }

	    this.childType = type;
	    this.childGuid = guid;
	    return this;
	  }
	  /**
	   *  Release changes a reservation request to release the already present reservation
	   *  This method can only be called once and can not be called if the reservation request is a child reservation request
	   */


	  release(reservation) {
	    if (!(this instanceof ReservationRequest)) {
	      throw slugError('Invalid reservation request -> release called on invalid reservation request', ['reservator', 'request', 'release', 'error', 'reservationrequest']);
	    }

	    if (this.childType || this.childGuid) {
	      throw slugError('Invalid reservation request -> can not combine release and child reservation', ['reservator', 'request', 'release', 'error', 'exclusive']);
	    } // noinspection SuspiciousTypeOfGuard


	    if (!reservation || typeof reservation !== 'string' || !reservation.length) {
	      throw slugError('Invalid reservation request -> invalid reservation key', ['reservator', 'request', 'release', 'error', 'reservation']);
	    }

	    this.action = ReservationRequestAction.Release;
	    this.childType = undefined;
	    this.childGuid = reservation;
	    return this;
	  }
	  /**
	   *  Handler to resolve the underlying promise
	   */


	  resolve(value) {
	    this._resolve(value);
	  }
	  /**
	   *  Handler to reject the underlying promise
	   */


	  reject(reason) {
	    this._reject(reason);
	  }

	}

	class ShopConfig {
	  constructor(config) {
	    /**
	     *  If it is a config instance.
	     */
	    this._isConfigInstance = true;
	    this._urlUid = 0;

	    if (!config) {
	      throw slugError('No config provided', ['base', 'config', 'error', 'missing']);
	    }

	    if (config._isConfigInstance) {
	      return config;
	    }

	    this._setReservator(config.reservator);

	    this._setDefaultReservationTime(config.defaultReservationTime);

	    this._setBaseUrl(config.baseUrl);

	    this._setGuid(config.guid);

	    this._setHttpClient(config.httpClient);

	    this._setLogLevels(config.logLevels);

	    this._setLoggerUrl(config.loggerUrl);

	    this.gtmCode = config.gtmCode;
	  }
	  /**
	   *  Set thee reservator settings. Checks if the input is valid and
	   *  chooses sensible defaults if no input is given.
	   */


	  _setReservator(reservator) {
	    if (!reservator) {
	      reservator = {};
	    } // noinspection SuspiciousTypeOfGuard


	    if (reservator.maxPendingReservations && typeof reservator.maxPendingReservations !== 'number') {
	      throw slugError('reservator.maxPendingReservations is not a number', ['shop', 'config', 'error', 'maxPendingReservations']);
	    } // noinspection SuspiciousTypeOfGuard


	    if (reservator.maxConcurrentReservations && typeof reservator.maxConcurrentReservations !== 'number') {
	      throw slugError('reservator.maxConcurrentReservations is not a number', ['shop', 'config', 'error', 'maxConcurrentReservations']);
	    }

	    if (!reservator.maxPendingReservations) {
	      reservator.maxPendingReservations = 20;
	    }

	    if (!reservator.maxConcurrentReservations) {
	      // Max concurrent reservations will default to 1, similar to 'in sync'.
	      reservator.maxConcurrentReservations = 1;
	    }

	    this.reservator = reservator;
	  }
	  /**
	   *  Set the default reservation time, Checks if the input is valid and
	   *  chooses a sensible default if no input is given.
	   */


	  _setDefaultReservationTime(defaultReservationTime) {
	    // noinspection SuspiciousTypeOfGuard
	    if (defaultReservationTime && typeof defaultReservationTime !== 'number') {
	      throw slugError('defaultReservationTime is not a number', ['shop', 'config', 'error', 'defaultReservationTime']);
	    }

	    if (!defaultReservationTime) {
	      defaultReservationTime = 8;
	    }

	    this.defaultReservationTime = defaultReservationTime;
	  }
	  /**
	   *  @internal Function to validate and set the base url.
	   */


	  _setBaseUrl(url) {
	    if (!url) {
	      throw slugError('No base url provided', ['base', 'config', 'baseurl', 'error', 'missing']);
	    } // noinspection SuspiciousTypeOfGuard


	    if (typeof url !== 'string') {
	      throw slugError(`The provided base url must be a string: ${url}`, ['base', 'config', 'baseurl', 'error', 'type']);
	    }

	    url = cleanUrl(url);
	    const includesProtocol = /^[a-z]+:\/\//i.test(url); // Add the https protocol if no protocol is present or throw
	    // an error if another protocol than http(s) is present

	    if (!includesProtocol) {
	      url = `https://${url}`;
	    } else if (!/^https?:\/\//.test(url)) {
	      throw slugError(`The provided url must contain the http(s) protocol: ${url}`, ['base', 'config', 'baseurl', 'error', 'https']);
	    }

	    this.baseUrl = url;
	  }
	  /**
	   *
	   *  Get an absolute path from a relative one
	   *
	   *  @param path - Relative path
	   *  @param filters - The filters to add as GET params
	   *
	   */


	  getUrl(path, filters) {
	    let url = this.baseUrl;

	    if (path) {
	      path = cleanUrl(path);

	      if (path.length) {
	        url += `/${path}`;
	      }
	    } // Append the filter settings as GET params if provided


	    if (filters) {
	      const filterKeys = Object.keys(filters); // The forwarded URL might already contain a GET param

	      url += /\?[\w]/i.test(url) ? '&' : '?';
	      forEach$2(filterKeys, (prop, index) => {
	        url += `${prop}=${filters[prop]}`;

	        if (index < filterKeys.length - 1) {
	          url += '&';
	        }
	      });
	    }

	    return encodeURI(url);
	  }
	  /**
	   *  Get an absolute path from a relative one.
	   *
	   *  A 'nocache' query parameter is added to the data,
	   *  to bust any browser micro-cache.
	   *
	   *  @param path - Relative path
	   *  @param filters - The filters to add as GET params
	   *
	   */


	  getNoCacheUrl(path, filters) {
	    const queryParams = Object.assign({}, filters || {}); // Note: Some browsers (micro)-cache XHR requests... so we make the resource id (URI) unique!
	    // DD-Frontend-2718

	    queryParams.nocache = `${new Date().getTime()}-${(++this._urlUid).toString()}-${Math.floor(Math.random() * 1000000000)}`;
	    return this.getUrl(path, queryParams);
	  }
	  /**
	   *  @internal Function to validate and set the guid of the shop.
	   */


	  _setGuid(guid) {
	    if (!guid) {
	      throw new Error('No guid provided');
	    } // noinspection SuspiciousTypeOfGuard


	    if (typeof guid !== 'string') {
	      throw new Error(`The provided guid must be a string: ${guid}`);
	    }

	    this.guid = guid;
	  }
	  /**
	   *  @internal Internal function to validate and set the http client
	   */


	  _setHttpClient(httpClient) {
	    // Check if the provided httpClient implements the correct interface
	    if (httpClient && !isHttpClient(httpClient)) {
	      throw new Error('No valid HTTP client provided');
	    }

	    this.httpClient = httpClient || axios$3.create();
	  }
	  /**
	   *  @internal Set the config log levels
	   */


	  _setLogLevels(logLevels) {
	    this.logLevels = logLevels;
	  }
	  /**
	   *  @internal Set the config logger url.
	   *
	   *  When undefined, no messages will be logged to the external log service
	   */


	  _setLoggerUrl(loggerUrl) {
	    this.loggerUrl = loggerUrl;
	  }

	}
	/**
	 *  @internal Used to clean the provided url or path
	 *  from leading and trailing slashes.
	 */

	function cleanUrl(urlOrPath) {
	  while (urlOrPath[0] === '/') {
	    urlOrPath = urlOrPath.substr(1, urlOrPath.length);
	  }

	  while (urlOrPath.substr(urlOrPath.length - 1, 1) === '/') {
	    urlOrPath = urlOrPath.substr(0, urlOrPath.length - 1);
	  }

	  return urlOrPath;
	}

	var __awaiter$3 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	/**
	 *  The reservator is a manager for reservation requests.
	 *
	 *  Any limits and request queues are held within a reservator.
	 *
	 *  @internal
	 */

	class Reservator {
	  /**
	   *  The constructor initializes a new reservator instance and checks if all (relevant) values in the settings object are valid
	   *
	   *  @internal
	   */
	  constructor(config) {
	    this._queue = [];
	    this._requestSlots = 0;
	    this._typePendingCount = {};

	    if (!config) {
	      throw slugError('No valid settings provided for the reservator', ['reservator', 'constructor', 'error', 'config']);
	    }

	    this._config = new ShopConfig(config);
	  }
	  /**
	   *  The reserve method will queue a reservation request and ensure it will be send within the limitations set in the settings.
	   *
	   *  These limitations will ensure the server as well as the client are not swamped with requests.
	   *
	   *  Limitations are placed on:
	   *  - Total pending requests ('in the air' + waiting)
	   *  - Total pending requests 'in the air'
	   *
	   *  It is possible to request multiple reservations in bulk by providing the numberOfReservations amount.
	   *  @todo Right now reservation requests are handled individually, another efficiency step here would be to implement bulk reservations.
	   *    These bulk requests would allow higher volumes to be requested by the the user, while keeping request congestion to a minimum.
	   *
	   *  @internal
	   */


	  reserve(type, guid, numberOfReservations = 1) {
	    return __awaiter$3(this, void 0, void 0, function* () {
	      // Check the limit on total pending reservations (both 'in the air' and waiting)
	      if (this._queue.length + this._requestSlots >= this._config.reservator.maxPendingReservations) {
	        throw slugError('Max pending reservations reached', ['reservator', 'reserve', 'error', 'maxpending']);
	      }

	      const reservationRequest = new ReservationRequest(type, guid, numberOfReservations); // The actual requests should only be send when the queue is not (no longer) overfull.

	      this._queue.push(reservationRequest);

	      this._send().then();

	      let reservations;

	      try {
	        // Return only the promise in the reservation request.
	        // The actual reservation request has no purpose living outside the reservator.
	        reservations = yield reservationRequest._promise;
	      } catch (error) {
	        if (error && error.response && error.response.status === 406) {
	          throw errorToSlugError(error, ['reservator', 'reserve', 'error', 'notacceptable']);
	        }

	        throw errorToSlugError(error, ['reservator', 'reserve', 'error', 'failed']);
	      }

	      if (!reservations || !Array.isArray(reservations) || !reservations.length) {
	        throw slugError('Reserve failed -> Reservations missing in response', ['reservator', 'reserve', 'error', 'reservation']);
	      }

	      const filteredReservations = reservations.filter(reservation => {
	        return !!reservation;
	      });

	      if (filteredReservations.length !== numberOfReservations) {
	        throw slugError('Reserve failed -> (Some) reservation(s) missing in response', ['reservator', 'reserve', 'error', 'reservations']);
	      }

	      return filteredReservations;
	    });
	  }
	  /**
	   *  The reserve method will queue a child reservation request and ensure it will be send within the limitations set in the settings.
	   *
	   *  These limitations will ensure the server as well as the client are not swamped with requests.
	   *
	   *  Limitations are placed on:
	   *  - Total pending requests ('in the air' + waiting)
	   *  - Total pending requests 'in the air'
	   *
	   *  It is possible to request multiple reservations in bulk by providing the numberOfReservations amount.
	   *  @todo Right now reservation requests are handled individually, another efficiency step here would be to implement bulk reservations.
	   *    These bulk requests would allow higher volumes to be requested by the the user, while keeping request congestion to a minimum.
	   *
	   *  @internal
	   */


	  reserveChild(type, guid, childType, childGuid, numberOfReservations = 1) {
	    return __awaiter$3(this, void 0, void 0, function* () {
	      // Check the limit on total pending reservations (both 'in the air' and waiting)
	      if (this._queue.length + this._requestSlots >= this._config.reservator.maxPendingReservations) {
	        throw slugError('Max pending reservations reached', ['reservator', 'reserveChild', 'error', 'maxpending']);
	      }

	      const reservationRequest = new ReservationRequest(type, guid, numberOfReservations).forChild(childType, childGuid); // The actual requests should only be send when the queue is not (no longer) overfull.

	      this._queue.push(reservationRequest);

	      this._send().then();

	      let reservations;

	      try {
	        // Return only the promise in the reservation request.
	        // The actual reservation request has no purpose living outside the reservator.
	        reservations = yield reservationRequest._promise;
	      } catch (error) {
	        if (error && error.response && error.response.status === 406) {
	          throw errorToSlugError(error, ['reservator', 'reserveChild', 'error', 'notacceptable']);
	        }

	        throw errorToSlugError(error, ['reservator', 'reserveChild', 'error', 'failed']);
	      }

	      if (!reservations || !reservations.length) {
	        throw slugError('Reserve child failed -> Reservations missing in response', ['reservator', 'reserveChild', 'error', 'reservation']);
	      }

	      const filteredReservations = reservations.filter(reservation => {
	        return !!reservation;
	      });

	      if (filteredReservations.length !== numberOfReservations) {
	        throw slugError('Reserve child failed -> (Some) reservation(s) missing in response', ['reservator', 'reserveChild', 'error', 'reservations']);
	      }

	      return filteredReservations;
	    });
	  }
	  /**
	   *  The release method will queue a release request and ensure it will be send within the limitations set in the settings.
	   *
	   *  @internal
	   */


	  release(type, guid, reservation) {
	    return __awaiter$3(this, void 0, void 0, function* () {
	      const reservationRequest = new ReservationRequest(type, guid, 1).release(reservation);

	      this._queue.push(reservationRequest);

	      this._send().then(); // Ignores any response from the promise


	      yield reservationRequest._promise;
	    });
	  }
	  /**
	   *  The send method will take queued reservation requests as long as there are requests in the queue.
	   *  This will allow any call over the concurrent limit to this method to silently return and
	   *  trust the request it was supposed to handle will still be handled.
	   *
	   *  There is a configurable, limited amount of calls to this method allowed to be running at the same time.
	   *  This protects the client and server from too many consecutive alive requests.
	   *
	   *  If the API returned a reservation response, this will be marshalled into a reservation object and
	   *  used as the promise resolution value.
	   *
	   *  @internal
	   */


	  _send() {
	    return __awaiter$3(this, void 0, void 0, function* () {
	      // There is a configurable maximum of in flight requests.
	      // Exclusively acquire one of the request slots to ensure no more requests than allowed are in the air.
	      if (++this._requestSlots > this._config.reservator.maxConcurrentReservations) {
	        // All available request slots are used by other senders.
	        // Any sender who finishes holds the responsibility to ensure it does not finish until the queue is empty.
	        // This will ensure the current call to _send can safely (and silently) abort and
	        // trust that the intended work will be performed by the other senders already/still running.
	        this._requestSlots--;
	        return;
	      }

	      let job;

	      while (job = this._queue.shift()) {
	        try {
	          if (job.action === ReservationRequestAction.Reserve) {
	            const guid = job.childGuid || job.guid;
	            const numberOfReservations = job.numberOfReservations;
	            const typeCounts = this._typePendingCount[job.childType || job.type] = this._typePendingCount[job.childType || job.type] || {};
	            typeCounts[guid] = typeCounts[guid] || 0;
	            typeCounts[guid] += numberOfReservations;
	            const promises = [];

	            for (let i = 0; i < numberOfReservations; i++) {
	              // TODO: When API can handle `numberOfReservations` -> add this here as well.
	              // Note URL is recompiled for every request, due to unique cache busting param
	              const url = this.compileUrl(job.type, job.guid, job.childType, job.childGuid); // Transforming any rejections into standard responses allows waiting for ALL failures,
	              // instead of only the first one.

	              promises.push(this._config.httpClient.get(url).then(response => Promise.resolve({
	                payload: response.data
	              })).catch(reason => Promise.resolve({
	                error: reason
	              })));
	            }

	            const result = yield Promise.all(promises).then(results => {
	              const failures = results.filter(result => result.error);

	              if (failures.length) {
	                // Only rejecting with first error!
	                return Promise.reject(failures[0].error);
	              }

	              return results.map(result => marshalReservationResponse(result.payload));
	            }).finally(() => {
	              typeCounts[guid] -= numberOfReservations;
	            }); // This is not the place an error should be thrown if the API returns an empty response.
	            // The originating function should check this!

	            job.resolve(result);
	          } else {
	            // Note URL is recompiled here, due to unique cache busting param
	            const url = this.compileUrl(job.type, job.guid, job.childType, job.childGuid);
	            yield this._config.httpClient.delete(url);
	            job.resolve();
	          }
	        } catch (error) {
	          // A rejected promise from the reservation call will be caught here and propagated to the reservation request's promise.
	          // Any other reservation request will still be handled!
	          job.reject(error);
	        }
	      } // There are no longer jobs on the queue. It is ok now to release the request slot
	      // and make it available to a future call to reserve/_send
	      // TODO: There is a race condition here.
	      //  If a job was added to the queue if every sender is between the last call to shift and the release of the request slot.
	      //  There is a chance the sender of that job has already aborted due to this sender still holding the lock.


	      this._requestSlots--;
	      return Promise.resolve();
	    });
	  }
	  /**
	   *  Create the URL for any reservation calls
	   *
	   *  @internal
	   */


	  compileUrl(type, guid, childType, childGuid) {
	    let path = `${this._config.guid}/reserve/${type.toLowerCase()}/${guid}`;

	    if (childType) {
	      path += `/${childType.toLowerCase()}`;
	    }

	    if (childGuid) {
	      path += `/${childGuid}`;
	    }

	    return this._config.getNoCacheUrl(path);
	  }
	  /**
	   *  Alternative release method to facilitate releasing reservation on window unload.
	   *
	   *  Note: This is not a perfect solution, as it is not supported in IE at all.
	   *
	   *  @internal
	   */


	  releaseOnUnload(type, guid, reservation) {
	    // It seems redundant to create a reservation request here.
	    // But it allows for keeping all validation logic in one place
	    const reservationRequest = new ReservationRequest(type, guid, 1).release(reservation);
	    return window.fetch(this.compileUrl(reservationRequest.type, reservationRequest.guid, reservationRequest.childType, reservationRequest.childGuid), {
	      method: 'DELETE',
	      mode: 'cors',
	      cache: 'no-cache',
	      keepalive: true
	    });
	  }
	  /**
	   *  This will return the aggregated pending count for a type and guid.
	   *
	   *  E.g.: The reserve count minus release count
	   *
	   *  @internal
	   */


	  inFlightCount(type, guid) {
	    if (type && guid) {
	      const typed = this._typePendingCount[type] || {};

	      if (guid) {
	        return typed[guid] || 0;
	      }

	      return Object.values(typed).reduce((carry, count = 0) => carry + count, 0);
	    }

	    return Object.values(this._typePendingCount).reduce((carry, typed) => {
	      return carry + Object.values(typed).reduce((subCarry, count = 0) => subCarry + count, 0);
	    }, 0);
	  }

	}
	/**
	 *  Marshals a reservation response to a reservation object.
	 *
	 *  This method is created as a helper, because the action it performs is simple,
	 *  however the implementation is less straight forward / readable.
	 *
	 *  The only difference between a reservation response and a reservation object is that the type of child reservations are different.
	 *  By marshalling the child reservations into a reservation object as well,
	 *  we guarantee the usability within the cart can be equal between cart items instantiated through an explicit user action and
	 *  because the API decided the cart item should have a child.
	 *
	 *  E.g.: If this was not done, there would be a difference between a product (e.g.: a required product) added to a ticket
	 *  through a child reservation and a product (e.g.: an optional product) added through a separate call.
	 */

	function marshalReservationResponse(reservationResponse) {
	  if (!reservationResponse || !reservationResponse.reservation) {
	    return;
	  } // The top level reservation is easy and should always be set.


	  const reservation = {
	    received_at: new Date(Date.now()),
	    reservation: reservationResponse.reservation
	  }; // Child reservations are optional. When they are not present, return early

	  if (!reservationResponse.childReservations) {
	    return reservation;
	  } // Loop over all possible (child) reservation types


	  forOwn(ReservationType, childReservationType => {
	    if (!Object.prototype.hasOwnProperty.call(reservationResponse.childReservations, childReservationType) || !reservationResponse.childReservations[childReservationType]) {
	      // If the child reservation type does not exist in the reservation response,
	      // move on to the next one (iff any)
	      return;
	    }

	    reservation.childReservations = reservation.childReservations || {}; // Loop over every child reservation model. Child reservations are grouped by their type and associated (reservable) model.

	    forOwn(reservationResponse.childReservations[childReservationType], (childReservationIds, childId) => {
	      reservation.childReservations[childReservationType] = reservation.childReservations[childReservationType] || {};
	      reservation.childReservations[childReservationType][childId] = reservation.childReservations[childReservationType][childId] || []; // Loop over every child reservation id for the current type and reservable id and add them to the reservation object.

	      reservation.childReservations[childReservationType][childId].push(...(childReservationIds || []).map(childReservationId => {
	        return {
	          received_at: new Date(Date.now()),
	          reservation: childReservationId
	        };
	      }));
	    });
	  });
	  return reservation;
	}

	var uaParser = {exports: {}};

	(function (module, exports) {
	  /////////////////////////////////////////////////////////////////////////////////

	  /* UAParser.js v0.7.31
	     Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
	     MIT License */

	  /*
	  Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
	  Supports browser & node.js environment. 
	  Demo   : https://faisalman.github.io/ua-parser-js
	  Source : https://github.com/faisalman/ua-parser-js */
	  /////////////////////////////////////////////////////////////////////////////////
	  (function (window, undefined$1) {
	    // Constants
	    /////////////

	    var LIBVERSION = '0.7.31',
	        EMPTY = '',
	        UNKNOWN = '?',
	        FUNC_TYPE = 'function',
	        UNDEF_TYPE = 'undefined',
	        OBJ_TYPE = 'object',
	        STR_TYPE = 'string',
	        MAJOR = 'major',
	        MODEL = 'model',
	        NAME = 'name',
	        TYPE = 'type',
	        VENDOR = 'vendor',
	        VERSION = 'version',
	        ARCHITECTURE = 'architecture',
	        CONSOLE = 'console',
	        MOBILE = 'mobile',
	        TABLET = 'tablet',
	        SMARTTV = 'smarttv',
	        WEARABLE = 'wearable',
	        EMBEDDED = 'embedded',
	        UA_MAX_LENGTH = 255;
	    var AMAZON = 'Amazon',
	        APPLE = 'Apple',
	        ASUS = 'ASUS',
	        BLACKBERRY = 'BlackBerry',
	        BROWSER = 'Browser',
	        CHROME = 'Chrome',
	        EDGE = 'Edge',
	        FIREFOX = 'Firefox',
	        GOOGLE = 'Google',
	        HUAWEI = 'Huawei',
	        LG = 'LG',
	        MICROSOFT = 'Microsoft',
	        MOTOROLA = 'Motorola',
	        OPERA = 'Opera',
	        SAMSUNG = 'Samsung',
	        SONY = 'Sony',
	        XIAOMI = 'Xiaomi',
	        ZEBRA = 'Zebra',
	        FACEBOOK = 'Facebook'; ///////////
	    // Helper
	    //////////

	    var extend = function (regexes, extensions) {
	      var mergedRegexes = {};

	      for (var i in regexes) {
	        if (extensions[i] && extensions[i].length % 2 === 0) {
	          mergedRegexes[i] = extensions[i].concat(regexes[i]);
	        } else {
	          mergedRegexes[i] = regexes[i];
	        }
	      }

	      return mergedRegexes;
	    },
	        enumerize = function (arr) {
	      var enums = {};

	      for (var i = 0; i < arr.length; i++) {
	        enums[arr[i].toUpperCase()] = arr[i];
	      }

	      return enums;
	    },
	        has = function (str1, str2) {
	      return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
	    },
	        lowerize = function (str) {
	      return str.toLowerCase();
	    },
	        majorize = function (version) {
	      return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined$1;
	    },
	        trim = function (str, len) {
	      if (typeof str === STR_TYPE) {
	        str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
	        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
	      }
	    }; ///////////////
	    // Map helper
	    //////////////


	    var rgxMapper = function (ua, arrays) {
	      var i = 0,
	          j,
	          k,
	          p,
	          q,
	          matches,
	          match; // loop through all regexes maps

	      while (i < arrays.length && !matches) {
	        var regex = arrays[i],
	            // even sequence (0,2,4,..)
	        props = arrays[i + 1]; // odd sequence (1,3,5,..)

	        j = k = 0; // try matching uastring with regexes

	        while (j < regex.length && !matches) {
	          matches = regex[j++].exec(ua);

	          if (!!matches) {
	            for (p = 0; p < props.length; p++) {
	              match = matches[++k];
	              q = props[p]; // check if given property is actually array

	              if (typeof q === OBJ_TYPE && q.length > 0) {
	                if (q.length === 2) {
	                  if (typeof q[1] == FUNC_TYPE) {
	                    // assign modified match
	                    this[q[0]] = q[1].call(this, match);
	                  } else {
	                    // assign given value, ignore regex match
	                    this[q[0]] = q[1];
	                  }
	                } else if (q.length === 3) {
	                  // check whether function or regex
	                  if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                    // call function (usually string mapper)
	                    this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
	                  } else {
	                    // sanitize match using given regex
	                    this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
	                  }
	                } else if (q.length === 4) {
	                  this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
	                }
	              } else {
	                this[q] = match ? match : undefined$1;
	              }
	            }
	          }
	        }

	        i += 2;
	      }
	    },
	        strMapper = function (str, map) {
	      for (var i in map) {
	        // check if current value is array
	        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	          for (var j = 0; j < map[i].length; j++) {
	            if (has(map[i][j], str)) {
	              return i === UNKNOWN ? undefined$1 : i;
	            }
	          }
	        } else if (has(map[i], str)) {
	          return i === UNKNOWN ? undefined$1 : i;
	        }
	      }

	      return str;
	    }; ///////////////
	    // String map
	    //////////////
	    // Safari < 3.0


	    var oldSafariMap = {
	      '1.0': '/8',
	      '1.2': '/1',
	      '1.3': '/3',
	      '2.0': '/412',
	      '2.0.2': '/416',
	      '2.0.3': '/417',
	      '2.0.4': '/419',
	      '?': '/'
	    },
	        windowsVersionMap = {
	      'ME': '4.90',
	      'NT 3.11': 'NT3.51',
	      'NT 4.0': 'NT4.0',
	      '2000': 'NT 5.0',
	      'XP': ['NT 5.1', 'NT 5.2'],
	      'Vista': 'NT 6.0',
	      '7': 'NT 6.1',
	      '8': 'NT 6.2',
	      '8.1': 'NT 6.3',
	      '10': ['NT 6.4', 'NT 10.0'],
	      'RT': 'ARM'
	    }; //////////////
	    // Regex map
	    /////////////

	    var regexes = {
	      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
	      ], [VERSION, [NAME, 'Chrome']], [/edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
	      ], [VERSION, [NAME, 'Edge']], [// Presto based
	      /(opera mini)\/([-\w\.]+)/i, // Opera Mini
	      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, // Opera Mobi/Tablet
	      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
	      ], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
	      ], [VERSION, [NAME, OPERA + ' Mini']], [/\bopr\/([\w\.]+)/i // Opera Webkit
	      ], [VERSION, [NAME, OPERA]], [// Mixed
	      /(kindle)\/([\w\.]+)/i, // Kindle
	      /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	      // Trident based
	      /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser
	      /(ba?idubrowser)[\/ ]?([\w\.]+)/i, // Baidu Browser
	      /(?:ms|\()(ie) ([\w\.]+)/i, // Internet Explorer
	      // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
	      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i, // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
	      /(weibo)__([\d\.]+)/i // Weibo
	      ], [NAME, VERSION], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
	      ], [VERSION, [NAME, 'UC' + BROWSER]], [/\bqbcore\/([\w\.]+)/i // WeChat Desktop for Windows Built-in Browser
	      ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [/micromessenger\/([\w\.]+)/i // WeChat
	      ], [VERSION, [NAME, 'WeChat']], [/konqueror\/([\w\.]+)/i // Konqueror
	      ], [VERSION, [NAME, 'Konqueror']], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
	      ], [VERSION, [NAME, 'IE']], [/yabrowser\/([\w\.]+)/i // Yandex
	      ], [VERSION, [NAME, 'Yandex']], [/(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
	      ], [[NAME, /(.+)/, '$1 Secure ' + BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i // Firefox Focus
	      ], [VERSION, [NAME, FIREFOX + ' Focus']], [/\bopt\/([\w\.]+)/i // Opera Touch
	      ], [VERSION, [NAME, OPERA + ' Touch']], [/coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
	      ], [VERSION, [NAME, 'Coc Coc']], [/dolfin\/([\w\.]+)/i // Dolphin
	      ], [VERSION, [NAME, 'Dolphin']], [/coast\/([\w\.]+)/i // Opera Coast
	      ], [VERSION, [NAME, OPERA + ' Coast']], [/miuibrowser\/([\w\.]+)/i // MIUI Browser
	      ], [VERSION, [NAME, 'MIUI ' + BROWSER]], [/fxios\/([-\w\.]+)/i // Firefox for iOS
	      ], [VERSION, [NAME, FIREFOX]], [/\bqihu|(qi?ho?o?|360)browser/i // 360
	      ], [[NAME, '360 ' + BROWSER]], [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i], [[NAME, /(.+)/, '$1 ' + BROWSER], VERSION], [// Oculus/Samsung/Sailfish Browser
	      /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
	      ], [[NAME, /_/g, ' '], VERSION], [/(electron)\/([\w\.]+) safari/i, // Electron-based App
	      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, // Tesla
	      /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
	      ], [NAME, VERSION], [/(metasr)[\/ ]?([\w\.]+)/i, // SouGouBrowser
	      /(lbbrowser)/i // LieBao Browser
	      ], [NAME], [// WebView
	      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
	      ], [[NAME, FACEBOOK], VERSION], [/safari (line)\/([\w\.]+)/i, // Line App for iOS
	      /\b(line)\/([\w\.]+)\/iab/i, // Line App for Android
	      /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
	      ], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
	      ], [VERSION, [NAME, 'GSA']], [/headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
	      ], [VERSION, [NAME, CHROME + ' Headless']], [/ wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
	      ], [[NAME, CHROME + ' WebView'], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
	      ], [VERSION, [NAME, 'Android ' + BROWSER]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
	      ], [NAME, VERSION], [/version\/([\w\.]+) .*mobile\/\w+ (safari)/i // Mobile Safari
	      ], [VERSION, [NAME, 'Mobile Safari']], [/version\/([\w\.]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
	      ], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
	      ], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [// Gecko based
	      /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
	      ], [[NAME, 'Netscape'], VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
	      ], [VERSION, [NAME, FIREFOX + ' Reality']], [/ekiohf.+(flow)\/([\w\.]+)/i, // Flow
	      /(swiftfox)/i, // Swiftfox
	      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
	      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	      /(firefox)\/([\w\.]+)/i, // Other Firefox-based
	      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, // Mozilla
	      // Other
	      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
	      /(links) \(([\w\.]+)/i // Links
	      ], [NAME, VERSION]],
	      cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
	      ], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i // IA32 (quicktime)
	      ], [[ARCHITECTURE, lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32 (x86)
	      ], [[ARCHITECTURE, 'ia32']], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
	      ], [[ARCHITECTURE, 'arm64']], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
	      ], [[ARCHITECTURE, 'armhf']], [// PocketPC mistakenly identified as PowerPC
	      /windows (ce|mobile); ppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
	      ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [/(sun4\w)[;\)]/i // SPARC
	      ], [[ARCHITECTURE, 'sparc']], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	      ], [[ARCHITECTURE, lowerize]]],
	      device: [[//////////////////////////
	      // MOBILES & TABLETS
	      // Ordered by popularity
	      /////////////////////////
	      // Samsung
	      /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [// Apple
	      /\((ip(?:hone|od)[\w ]*);/i // iPod/iPhone
	      ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i, // iPad
	      /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [// Huawei
	      /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [// Xiaomi
	      /\b(poco[\w ]+)(?: bui|\))/i, // Xiaomi POCO
	      /\b; (\w+) build\/hm\1/i, // Xiaomi Hongmi 'numeric' models
	      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, // Xiaomi Hongmi
	      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, // Xiaomi Redmi
	      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
	      ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
	      ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [// OPPO
	      /; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [// Vivo
	      /vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [// Realme
	      /\b(rmx[12]\d{3})(?: bui|;|\))/i], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [// Motorola
	      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [// LG
	      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [// Lenovo
	      /(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [// Nokia
	      /(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [// Google
	      /(pixel c)\b/i // Google Pixel C
	      ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
	      ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [// Sony
	      /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [// OnePlus
	      / (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [// Amazon
	      /(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i, // Kindle Fire without Silk
	      /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
	      ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
	      ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [// BlackBerry
	      /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
	      ], [MODEL, VENDOR, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i // BlackBerry 10
	      ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [// Asus
	      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [// HTC
	      /(nexus 9)/i // HTC Nexus 9
	      ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, // HTC
	      // ZTE
	      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
	      ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [// Acer
	      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [// Meizu
	      /droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [// Sharp
	      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [VENDOR, 'Sharp'], [TYPE, MOBILE]], [// MIXED
	      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i, // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
	      /(hp) ([\w ]+\w)/i, // HP iPAQ
	      /(asus)-?(\w+)/i, // Asus
	      /(microsoft); (lumia[\w ]+)/i, // Microsoft Lumia
	      /(lenovo)[-_ ]?([-\w]+)/i, // Lenovo
	      /(jolla)/i, // Jolla
	      /(oppo) ?([\w ]+) bui/i // OPPO
	      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(archos) (gamepad2?)/i, // Archos
	      /(hp).+(touchpad(?!.+tablet)|tablet)/i, // HP TouchPad
	      /(kindle)\/([\w\.]+)/i, // Kindle
	      /(nook)[\w ]+build\/(\w+)/i, // Nook
	      /(dell) (strea[kpr\d ]*[\dko])/i, // Dell Streak
	      /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, // Le Pan Tablets
	      /(trinity)[- ]*(t\d{3}) bui/i, // Trinity Tablets
	      /(gigaset)[- ]+(q\w{1,9}) bui/i, // Gigaset Tablets
	      /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
	      ], [VENDOR, MODEL, [TYPE, TABLET]], [/(surface duo)/i // Surface Duo
	      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
	      ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [/(u304aa)/i // AT&T
	      ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [/\bsie-(\w*)/i // Siemens
	      ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [/\b(rct\w+) b/i // RCA Tablets
	      ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [/\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
	      ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [/\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
	      ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
	      ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [/\b(tm\d{3}\w+) b/i], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [/\b(k88) b/i // ZTE K Series Tablet
	      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [/\b(nx\d{3}j) b/i // ZTE Nubia
	      ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [/\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
	      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [/\b(zur\d{3}) b/i // Swiss ZUR Tablet
	      ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [/\b((zeki)?tb.*\b) b/i // Zeki Tablets
	      ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
	      ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [/\b(ns-?\w{0,9}) b/i // Insignia Tablets
	      ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [/\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
	      ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
	      ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [/\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
	      ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [/\b(ph-1) /i // Essential PH-1
	      ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [/\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
	      ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [/\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
	      ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [/\btu_(1491) b/i // Rotor Tablets
	      ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [/(shield[\w ]+) b/i // Nvidia Shield Tablets
	      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [/(sprint) (\w+)/i // Sprint Phones
	      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
	      ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
	      ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [///////////////////
	      // CONSOLES
	      ///////////////////
	      /(ouya)/i, // Ouya
	      /(nintendo) ([wids3utch]+)/i // Nintendo
	      ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+; (shield) bui/i // Nvidia
	      ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [/(playstation [345portablevi]+)/i // Playstation
	      ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
	      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [///////////////////
	      // SMARTTVS
	      ///////////////////
	      /smart-tv.+(samsung)/i // Samsung
	      ], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
	      ], [[VENDOR, LG], [TYPE, SMARTTV]], [/(apple) ?tv/i // Apple TV
	      ], [VENDOR, [MODEL, APPLE + ' TV'], [TYPE, SMARTTV]], [/crkey/i // Google Chromecast
	      ], [[MODEL, CHROME + 'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [/droid.+aft(\w)( bui|\))/i // Fire TV
	      ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i // Sharp
	      ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, // Roku
	      /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i // HbbTV devices
	      ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
	      ], [[TYPE, SMARTTV]], [///////////////////
	      // WEARABLES
	      ///////////////////
	      /((pebble))app/i // Pebble
	      ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/droid.+; (glass) \d/i // Google Glass
	      ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [/(quest( 2)?)/i // Oculus Quest
	      ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [///////////////////
	      // EMBEDDED
	      ///////////////////
	      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
	      ], [VENDOR, [TYPE, EMBEDDED]], [////////////////////
	      // MIXED (GENERIC)
	      ///////////////////
	      /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
	      ], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
	      ], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
	      ], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
	      ], [[TYPE, MOBILE]], [/(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
	      ], [MODEL, [VENDOR, 'Generic']]],
	      engine: [[/windows.+ edge\/([\w\.]+)/i // EdgeHTML
	      ], [VERSION, [NAME, EDGE + 'HTML']], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
	      ], [VERSION, [NAME, 'Blink']], [/(presto)\/([\w\.]+)/i, // Presto
	      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
	      /ekioh(flow)\/([\w\.]+)/i, // Flow
	      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, // KHTML/Tasman/Links
	      /(icab)[\/ ]([23]\.[\d\.]+)/i // iCab
	      ], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
	      ], [VERSION, NAME]],
	      os: [[// Windows
	      /microsoft (windows) (vista|xp)/i // Windows (iTunes)
	      ], [NAME, VERSION], [/(windows) nt 6\.2; (arm)/i, // Windows RT
	      /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, // Windows Phone
	      /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [// iOS/macOS
	      /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, // iOS
	      /cfnetwork\/.+darwin/i], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
	      ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [// Mobile OSes
	      /droid ([\w\.]+)\b.+(android[- ]x86)/i // Android-x86
	      ], [VERSION, NAME], [// Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
	      /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, // Blackberry
	      /(tizen|kaios)[\/ ]([\w\.]+)/i, // Tizen/KaiOS
	      /\((series40);/i // Series 40
	      ], [NAME, VERSION], [/\(bb(10);/i // BlackBerry 10
	      ], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
	      ], [VERSION, [NAME, 'Symbian']], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
	      ], [VERSION, [NAME, FIREFOX + ' OS']], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
	      ], [VERSION, [NAME, 'webOS']], [// Google Chromecast
	      /crkey\/([\d\.]+)/i // Google Chromecast
	      ], [VERSION, [NAME, CHROME + 'cast']], [/(cros) [\w]+ ([\w\.]+\w)/i // Chromium OS
	      ], [[NAME, 'Chromium OS'], VERSION], [// Console
	      /(nintendo|playstation) ([wids345portablevuch]+)/i, // Nintendo/Playstation
	      /(xbox); +xbox ([^\);]+)/i, // Microsoft Xbox (360, One, X, S, Series X, Series S)
	      // Other
	      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, // Joli/Palm
	      /(mint)[\/\(\) ]?(\w*)/i, // Mint
	      /(mageia|vectorlinux)[; ]/i, // Mageia/VectorLinux
	      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
	      /(hurd|linux) ?([\w\.]*)/i, // Hurd/Linux
	      /(gnu) ?([\w\.]*)/i, // GNU
	      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
	      /(haiku) (\w+)/i // Haiku
	      ], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i // Solaris
	      ], [[NAME, 'Solaris'], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, // Solaris
	      /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, // AIX
	      /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
	      /(unix) ?([\w\.]*)/i // UNIX
	      ], [NAME, VERSION]]
	    }; /////////////////
	    // Constructor
	    ////////////////

	    var UAParser = function (ua, extensions) {
	      if (typeof ua === OBJ_TYPE) {
	        extensions = ua;
	        ua = undefined$1;
	      }

	      if (!(this instanceof UAParser)) {
	        return new UAParser(ua, extensions).getResult();
	      }

	      var _ua = ua || (typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);

	      var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

	      this.getBrowser = function () {
	        var _browser = {};
	        _browser[NAME] = undefined$1;
	        _browser[VERSION] = undefined$1;
	        rgxMapper.call(_browser, _ua, _rgxmap.browser);
	        _browser.major = majorize(_browser.version);
	        return _browser;
	      };

	      this.getCPU = function () {
	        var _cpu = {};
	        _cpu[ARCHITECTURE] = undefined$1;
	        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
	        return _cpu;
	      };

	      this.getDevice = function () {
	        var _device = {};
	        _device[VENDOR] = undefined$1;
	        _device[MODEL] = undefined$1;
	        _device[TYPE] = undefined$1;
	        rgxMapper.call(_device, _ua, _rgxmap.device);
	        return _device;
	      };

	      this.getEngine = function () {
	        var _engine = {};
	        _engine[NAME] = undefined$1;
	        _engine[VERSION] = undefined$1;
	        rgxMapper.call(_engine, _ua, _rgxmap.engine);
	        return _engine;
	      };

	      this.getOS = function () {
	        var _os = {};
	        _os[NAME] = undefined$1;
	        _os[VERSION] = undefined$1;
	        rgxMapper.call(_os, _ua, _rgxmap.os);
	        return _os;
	      };

	      this.getResult = function () {
	        return {
	          ua: this.getUA(),
	          browser: this.getBrowser(),
	          engine: this.getEngine(),
	          os: this.getOS(),
	          device: this.getDevice(),
	          cpu: this.getCPU()
	        };
	      };

	      this.getUA = function () {
	        return _ua;
	      };

	      this.setUA = function (ua) {
	        _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
	        return this;
	      };

	      this.setUA(_ua);
	      return this;
	    };

	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
	    UAParser.CPU = enumerize([ARCHITECTURE]);
	    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
	    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]); ///////////
	    // Export
	    //////////
	    // check js environment

	    {
	      // nodejs env
	      if (module.exports) {
	        exports = module.exports = UAParser;
	      }

	      exports.UAParser = UAParser;
	    } // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.


	    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);

	    if ($ && !$.ua) {
	      var parser = new UAParser();
	      $.ua = parser.getResult();

	      $.ua.get = function () {
	        return parser.getUA();
	      };

	      $.ua.set = function (ua) {
	        parser.setUA(ua);
	        var result = parser.getResult();

	        for (var prop in result) {
	          $.ua[prop] = result[prop];
	        }
	      };
	    }
	  })(typeof window === 'object' ? window : commonjsGlobal);
	})(uaParser, uaParser.exports);

	var __awaiter$2 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	class Orderbuilder {
	  /**
	   *  Constructing a new orderbuilder,
	   *  The order builder can be used to consolidate order info and send the order request.
	   *
	   *  This can be used for placing orders, but also requesting refunds.
	   *
	   *  ```ts
	   *  const orderbuilder: Orderbuilder = new Orderbuilder(settings);
	   *  ```
	   *
	   *  #### Possible errors
	   *  One type of error could be thrown while initializing an orderbuilder.
	   *
	   *  | Error                                    | Reason                                                                    |
	   *  | :--------------------------------------- | :------------------------------------------------------------------------ |
	   *  | [ShopError](shoperror.html)              | No or invalid settings [ShopData](../interfaces/shopconfig.html) provided |
	   */
	  constructor(config) {
	    if (!config) {
	      throw slugError('No config provided for the orderbuilder', ['orderbuilder', 'constructor', 'error', 'config']);
	    }

	    this._config = new ShopConfig(config);
	  }
	  /**
	   *  Handle the order data given in the orderbuilder options
	   *  This will compile the order and send it to the API.
	   *
	   *  ```ts
	   *  const response: PlaceOrderResponse = orderbuilder.handle(orderbuilderOptions);
	   *  ```
	   *
	   *  #### Possible errors
	   *  One type of error could be thrown while handling an order builder.
	   *
	   *  | Error                                    | Reason                                                                     |
	   *  | :--------------------------------------- | :------------------------------------------------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid options [ShopData](../interfaces/orderbuilder.html) provided |
	   */


	  handle(options) {
	    return __awaiter$2(this, void 0, void 0, function* () {
	      if (!options) {
	        throw slugError('Failed to handle orderbuilder -> No options provided', ['orderbuilder', 'handle', 'error', 'options']);
	      }

	      if (!options.booker || !options.booker.bookerInfo || !options.booker.bookerInfo.email || !options.booker.bookerInfo.firstname || !options.booker.bookerInfo.lastname || !options.booker.locale) {
	        throw slugError('Failed to handle orderbuilder -> No valid booker info provided', ['orderbuilder', 'handle', 'error', 'bookerinfo']);
	      }

	      if (!(options.tickets && options.tickets.length) && !(options.products && options.products.length) && !(options.return && options.return.items && options.return.items.length)) {
	        throw slugError('Failed to handle orderbuilder -> No valid items provided, need either tickets, products or return items', ['orderbuilder', 'handle', 'error', 'items']);
	      }

	      if (options.return && (!(options.return.items && options.return.items.length) || !options.return.order_id || options.return.includes_fees === undefined || options.return.to_voucher === undefined)) {
	        throw slugError('Failed to handle orderbuilder -> No valid return options provided', ['orderbuilder', 'handle', 'error', 'return']);
	      }

	      if (!options.paymentMethod) {
	        throw slugError('Failed to handle orderbuilder -> No valid payment method provided', ['orderbuilder', 'handle', 'error', 'paymentmethods']);
	      }

	      if (options.coupons && options.coupons.length > 1) {
	        throw slugError('Failed to handle orderbuilder -> Multiple coupon not implemented yet', ['orderbuilder', 'handle', 'error', 'coupons']);
	      }

	      const orderData = {
	        receiver: {
	          email: options.booker.bookerInfo.email.value,
	          firstname: options.booker.bookerInfo.firstname.value,
	          lastname: options.booker.bookerInfo.lastname.value,
	          locale: options.booker.locale
	        },
	        tickets: Orderbuilder._processTickets(options.tickets, !!options.seats),
	        products: Orderbuilder._processProducts(options.products),
	        return: Orderbuilder._processReturns(options.return),
	        metaData: Orderbuilder._processMetadata(options.metaData),
	        seatsReservationToken: options.seats ? options.seats.holdToken : undefined,
	        paymentProvider: options.paymentMethod.item.guid,
	        paymentProviderIssuer: options.paymentMethod.issuer ? options.paymentMethod.issuer.id : undefined,
	        currency: options.paymentMethod.currency,
	        stripeToken: Orderbuilder._getStripeOrderData(options.paymentMethod.stripe_token),
	        coupon: options.coupons && options.coupons.length ? options.coupons[0].item.code : undefined,
	        extraMetaData: Object.assign(Object.assign({}, yield Orderbuilder._getTechData(options.cartInitAt, options.seats)), options.extraTechData)
	      };
	      const response = yield this._send(orderData);
	      return response.data;
	    });
	  }
	  /**
	   *  Send the order data to the API
	   *
	   *  ```ts
	   *  const response: Response<PlaceOrderResponse> = this._send(orderData);
	   *  ```
	   *
	   *  #### Possible errors
	   *  Two types of errors could be thrown while sending an order to the API.
	   *
	   *  | Error                                    | Reason                                           |
	   *  | :--------------------------------------- | :----------------------------------------------- |
	   *  | [OrderApiError](orderapierror.html)      | Any of the values provided are not valid for the |
	   *  |                                          | current state of the API                         |
	   *  | [ApiError](apierror.html)                | Something unexpected went wrong                  |
	   */


	  _send(orderData) {
	    return __awaiter$2(this, void 0, void 0, function* () {
	      const url = this._config.getNoCacheUrl(`${this._config.guid}/order`);

	      try {
	        return yield this._config.httpClient.post(url, orderData);
	      } catch (error) {
	        if (error && error.response && error.response.status && error.response.status >= 400 && error.response.status < 500) {
	          throw errorToSlugError(error, ['orderbuilder', 'send', 'error', 'failed']);
	        } else {
	          throw errorToSlugError(error, ['orderbuilder', 'send', 'error', 'fatal']);
	        }
	      }
	    });
	  }
	  /**
	   *  Transform cart tickets into ticket order data
	   *
	   *  Explicitly static as it should never use any state on the order builder
	   */


	  static _processTickets(cartTickets, addSeatInfo = false) {
	    if (!cartTickets || !cartTickets.length) {
	      return [];
	    }

	    return cartTickets.map(cartTicket => {
	      const cartProducts = [];
	      forOwn(cartTicket.products.map, products => {
	        forOwn(products, cartProduct => {
	          cartProducts.push(cartProduct);
	        });
	      });
	      let seatInfo = undefined;

	      if (addSeatInfo && cartTicket.seatsInfo) {
	        seatInfo = {
	          uuid: cartTicket.seatsInfo.objectLabel,
	          eventKeys: cartTicket.seatsInfo.eventKeys
	        };
	      }

	      return {
	        guid: cartTicket.item.guid,
	        reservation: cartTicket.reservation.reservation,
	        products: Orderbuilder._processProducts(cartProducts),
	        metaData: Orderbuilder._processMetadata(cartTicket.metadataList),
	        seatInfo
	      };
	    });
	  }
	  /**
	   *  Transform cart products into product order data
	   *
	   *  Explicitly static as it should never use any state on the order builder
	   */


	  static _processProducts(cartProducts) {
	    if (!cartProducts || !cartProducts.length) {
	      return undefined;
	    }

	    return cartProducts.map(cartProduct => {
	      return {
	        guid: cartProduct.item.guid,
	        reservation: cartProduct.reservation.reservation,
	        metaData: Orderbuilder._processMetadata(cartProduct.metadataList)
	      };
	    });
	  }
	  /**
	   *  Transform return items into return order data
	   *
	   *  Explicitly static as it should never use any state on the order builder
	   */


	  static _processReturns(options) {
	    if (!options || !options.items || !options.items.length) {
	      return undefined;
	    }

	    const returnsOrderData = {
	      order_id: options.order_id,
	      includes_fees: options.includes_fees,
	      to_voucher: options.to_voucher,
	      reason: options.reason,
	      items: options.items
	    };

	    if (options.donate_percentage && options.donate_percentage > 0) {
	      returnsOrderData.arbitrary = {
	        percentage: options.donate_percentage,
	        // A gift is by default 0 vat.
	        // However, this might not be true for all countries!!!
	        // We do not have this notion right now though...
	        vat: 0
	      };
	    }

	    return returnsOrderData;
	  }
	  /**
	   *  Transform cart metadata into metadata order data
	   *
	   *  Explicitly static as it should never use any state on the order builder
	   */


	  static _processMetadata(cartMetadataCollection) {
	    if (!cartMetadataCollection || !cartMetadataCollection.length) {
	      return undefined;
	    }

	    return cartMetadataCollection.filter(cartMetadata => {
	      return cartMetadata.item.extra.includes('required') || cartMetadata.value !== null;
	    }).map(cartMetadata => {
	      return {
	        guid: cartMetadata.item.guid,
	        value: cartMetadata.value
	      };
	    });
	  }
	  /**
	   *  Transform cart payment method's stripe token into stripe order data if present
	   *
	   *  Explicitly static as it should never use any state on the order builder
	   */


	  static _getStripeOrderData(stripeToken) {
	    return stripeToken ? {
	      id: stripeToken.id
	    } : undefined;
	  }
	  /**
	   *  Transform arbitrary data into a techdata object.
	   *
	   *  This data is mainly for understanding order flow and debugging purposes.
	   *
	   *  @param initAt - The exact moment the cart was constructed
	   *  @param seatsio - The seatsio info to be saved with the order for debugging purposes.
	   */


	  static _getTechData(initAt, seatsio) {
	    return __awaiter$2(this, void 0, void 0, function* () {
	      const dppx = +(window ? window.devicePixelRatio : 0);
	      const dpi = dppx * 96;
	      const uaParser$1 = new uaParser.exports.UAParser();
	      const adBlocker = yield adsBlocked();
	      return {
	        timeToBank: Math.ceil((new Date().getTime() - initAt.getTime()) / 1000),
	        screen: {
	          width: window.screen.width,
	          height: window.screen.height,
	          orientation: {
	            angle: window.screen && window.screen.orientation && window.screen.orientation.angle || null,
	            type: window.screen && window.screen.orientation && window.screen.orientation.type || null
	          },
	          dpi: dpi,
	          dpcm: dpi / 2.54,
	          dppx: dppx
	        },
	        userAgent: uaParser$1.getResult(),
	        queryParams: parseQuery(),
	        timezone: guessTimezone() || null,
	        adblock: adBlocker,
	        referrer: document.referrer,
	        doNotTrack: !!navigator.doNotTrack,
	        cookieEnabled: navigator.cookieEnabled,
	        seatsioHoldToken: (seatsio ? seatsio.holdToken : null) || null
	      };
	    });
	  }

	}

	/**
	 *  @internal Type of action to invoke the cart's _action method with
	 *  that sets the pending state of the checkout details and emits them
	 */
	var CartAction;

	(function (CartAction) {
	  /**
	   *  Adds a pending count to the pending actions
	   *  and emits the current checkout details
	   *  with pending set to true.
	   */
	  CartAction["Start"] = "start";
	  /**
	   *  Subtracts a pending count from the pending actions and
	   *  emits the current checkout details, with the pending set
	   *  based on the current pending actions.
	   */

	  CartAction["End"] = "end";
	})(CartAction || (CartAction = {}));
	/**
	 *  Possible type of cart item children.
	 */


	var CartItemChildType;

	(function (CartItemChildType) {
	  CartItemChildType["Tickets"] = "tickets";
	  CartItemChildType["Products"] = "products";
	})(CartItemChildType || (CartItemChildType = {}));
	/**
	 *  Possible type of a cart item.
	 */


	var CartItemType;

	(function (CartItemType) {
	  CartItemType["Ticket"] = "ticket";
	  CartItemType["Product"] = "product";
	})(CartItemType || (CartItemType = {}));
	/**
	 *  Terms actions.
	 *
	 *  The possible actions allowed on terms.
	 */


	var TermsActions;

	(function (TermsActions) {
	  TermsActions["Accept"] = "Accept";
	  TermsActions["Reject"] = "Reject";
	})(TermsActions || (TermsActions = {}));

	var __awaiter$1 = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	/**
	 *  Used to create a new cart instance that holds all the data for the state of the order.
	 *
	 *  In this file, some object order is important. In those cases the below explanation is important!
	 *  Note, according to the ES6 spec Object.getOwnPropertyNames is defined to call the following (abstract) operations in order
	 *   - GetOwnPropertyKeys (does not change order)
	 *   - [[OwnPropertyKeys]]
	 *  Order is therefore defined as:
	 *   1. For each own property key P of O that is an integer index, in ascending numeric index order
	 *   2. For each own property key P of O that is a String but is not an integer index, in property creation order
	 *   3. For each own property key P of O that is a Symbol, in property creation order
	 *  Therefore, this order will be deemed 'good enough'.
	 *  See http://www.ecma-international.org/ecma-262/6.0/#sec-ordinary-object-internal-methods-and-internal-slots-ownpropertykeys
	 */

	class Cart extends lib$1.exports.EventScope {
	  /**
	   *  Constructing a new cart creates an *(empty)* shopping cart instance,
	   *  the cart is immediately ready for use.
	   *
	   *  ```ts
	   *  const cart: Cart = new Cart(shopData, settings);
	   *  ```
	   *
	   *  #### Possible errors
	   *  One type of error could be thrown while initializing a shopping cart.
	   *
	   *  | Error                                    | Reason                                                                    |
	   *  | :--------------------------------------- | :------------------------------------------------------------------------ |
	   *  | [ShopError](shoperror.html)              | No or invalid shop data [ShopData](../interfaces/shopdata.html) provided  |
	   *  |                                          | or no settings provided                                                   |
	   */
	  constructor(shop, config, logger, eventBus) {
	    super(eventBus || new EventBus());
	    this._eventScope = 'cart';
	    /**
	     *  Collection of cart items.
	     *  This holds all reserved tickets and products except orphaned global products.
	     *  The items are grouped per event and per (ticket/product) abstract instance
	     *
	     *  @category Cart
	     */

	    this.items = {};
	    /**
	     *  Collection of cart products.
	     *  This holds all reserved global product not belonging to an event.
	     *
	     *  @category Cart
	     */

	    this.orphanedGlobalProducts = {
	      map: {},
	      collection: []
	    };
	    /**
	     *  Holding the checkout details of the cart, being updated every time the items change.
	     *
	     *  @category Cart
	     */

	    this.checkout_details = {
	      vats: {
	        percentages: {},
	        total: 0
	      },
	      payment_method_fee: 0,
	      subtotal_price: 0,
	      total_price: 0,
	      busy: false
	    };
	    /**
	     *  The locale in which the booker is creating his order.
	     *
	     *  This should be one of the supported languages in the shop.
	     *  This value will also be used by the API to determine
	     *  in which language to render the tickets, etc..
	     */

	    this.locale = 'en_GB';
	    /**
	     *  Map of CartMetadata
	     *
	     *  Metadata wrappers containing values, errors and the original item.
	     *
	     *  @Category Cart
	     */

	    this.metadata = {};
	    this.metadataList = [];
	    /**
	     *  Holding all the applied coupons, including the data of
	     *  the coupon and the number of times it is applied.
	     */

	    this._coupons = {};
	    /**
	     *  The number of current pending actions. Used to block the
	     *  place order call while there are pending actions.
	     */

	    this._pendingActions = 0;
	    /**
	     *  Extra arbitrary data to add to the place order call
	     */

	    this.techData = {};

	    if (!logger) {
	      throw slugError('Failed to create cart, missing logger', ['cart', 'constructor', 'missing', 'logger']);
	    }

	    this.log = logger;

	    if (!shop) {
	      throw this.log._create(LogLevel.Fatal, ['cart', 'constructor', 'error', 'missing', 'shop']);
	    }

	    if (!shop.data) {
	      throw this.log._create(LogLevel.Fatal, ['cart', 'constructor', 'error', 'missing', 'data']);
	    }

	    if (!config) {
	      throw this.log._create(LogLevel.Fatal, ['cart', 'constructor', 'error', 'missing', 'config']);
	    }

	    this._shop = shop;
	    this._data = shop.data;
	    this.booker = factoryBookerCartMetadata(shop.data.email_validation_rule);
	    this._config = new ShopConfig(config);
	    this._reservator = new Reservator(this._config);
	    this._orderbuilder = new Orderbuilder(this._config);
	    this._reservationTime = shop.data.reservation_time ? shop.data.reservation_time : this._config.defaultReservationTime;
	    this.reservationExpiration = {
	      date: null,
	      secondsRemaining: null
	    };
	    this.flatItems = {
	      products: {},
	      tickets: {}
	    }; // Add the default booker metadata to the metadata collection and list

	    forEach$2(this._data.booker_metadata, metadata => {
	      addMetadataToCollection(metadata, this.metadata, this.metadataList);
	    });
	    this.metadataList.sort(modelSort);
	    this.validator = new CartValidator(this, this.log); // Select the first payment method as default.

	    const firstPaymentMethod = this._data.payment_methods[0];

	    if (!firstPaymentMethod) {
	      throw this.log._create(LogLevel.Fatal, ['cart', 'constructor', 'error', 'missing', 'paymentmethods']);
	    }

	    this.paymentMethod = {
	      item: firstPaymentMethod,
	      currency: this._data.currency || 'EUR',
	      is_stripe: !!firstPaymentMethod.stripe
	    }; //  TODO Depending on the data this can become more than one terms checkbox,
	    //  so it is already an object instead of a value.
	    //  Exact implementation spec is still somewhat unfinished, so not doing anything with that (YET!!).

	    this.terms = {
	      default: false
	    };

	    if (this._data.seats_public_key) {
	      this.seatsioInstance = new SeatsioService({
	        workspaceKey: this._data.seats_public_key
	      });
	    }

	    this._priceFormatter = this._resetPriceFormatter();

	    this._registerOnUnload();

	    this._initAt = new Date();
	  }
	  /**
	   *  Determines if any items exist in the cart
	   */


	  hasItems() {
	    return Object.keys(this.flatItems.tickets).length > 0 || Object.keys(this.flatItems.products).length > 0;
	  }
	  /**
	   * Get cart ticket info (total count, total price, cart ticket id's)
	   */


	  getTicketInfo(ticketGuid) {
	    const ticket = this._data.tickets_map[ticketGuid];
	    let cartTickets = [];

	    if (this.items[ticket.event_id]) {
	      cartTickets = Object.values(this.items[ticket.event_id].tickets.map[ticketGuid] || {});
	    }

	    return this._cartEventItemResponse(ticket, cartTickets, CartItemChildType.Tickets);
	  }
	  /**
	   * Get product ticket info (total count, total price, cart product id's)
	   */


	  getProductInfo(productGuid) {
	    const product = this._data.products_map[productGuid];
	    let cartProducts = [];

	    if (this.items[product.event_id]) {
	      cartProducts = Object.values(this.items[product.event_id].products.map[productGuid] || {});
	    }

	    return this._cartEventItemResponse(product, cartProducts, CartItemChildType.Products);
	  }
	  /**
	   * Get cart ticket product info (total count, total price, cart ticket product id's)
	   */


	  getTicketProductInfo(cartTicketId, ticketProductGuid) {
	    const cartTicket = this.flatItems.tickets[cartTicketId];
	    const ticketProduct = this._data.products_map[ticketProductGuid];
	    let cartTicketProducts = [];

	    if (this.flatItems.tickets[cartTicketId]) {
	      cartTicketProducts = Object.values(this.flatItems.tickets[cartTicketId].products.map[ticketProductGuid] || {});
	    }

	    return this._cartEventItemResponse(ticketProduct, cartTicketProducts, CartItemChildType.Products, cartTicket);
	  }
	  /**
	   *
	   *  Used to sync the data of items that are currently in
	   *  the cart with the shop data that got updated.
	   *
	   *  Updates the cart items' pricing objects according
	   *  to their (possibly) updated item and recomputes
	   *  their pricing and checkout details.
	   *
	   *  (i) The Object.assign should be used to remove any saved
	   *  data about applied coupons, because the applied coupons
	   *  get re-applied.
	   *
	   *  (i) Only the pricing is relevant to copy from the
	   *  item, because other data (such as the name) can be
	   *  used directly out of the item's item, where the pricing
	   *  is subject to changes because of coupons.
	   *
	   *  @internal
	   *
	   */


	  _shopDataUpdated() {
	    this._action(CartAction.Start); // Also recompute their optional state as it might have been changed


	    forOwn(this.flatItems.products, cartProduct => {
	      Object.assign(cartProduct.pricing, cartProduct.item.pricing);
	      cartProduct.setOptional();
	    }); // Also update their min_price to make sure pricing computations are correct

	    forOwn(this.flatItems.tickets, cartTicket => {
	      Object.assign(cartTicket.pricing, cartTicket.item.pricing);
	      cartTicket.min_price = cartTicket.item.min_price;
	    }); // Reset and re-apply the applied coupons

	    forOwn(this._coupons, coupon => {
	      this._resetCoupon(coupon);

	      this._couponDiscounts(CouponAction.Add, coupon);
	    }); // Recomputes the cart item pricing and recomputes the checkout details.

	    this._doneUpdatingItems();

	    this._action(CartAction.End);
	  }
	  /**
	   *  Add a ticket to the cart. This will only succeed if a reservation can be retrieved.
	   *
	   *  ```ts
	   *  cart.addTicket(ticket.guid);
	   *  ```
	   *
	   *  @param ticketGuid The guid of the ticket to add
	   *
	   *  | Error                                    | Reason                                                                    |
	   *  | :--------------------------------------- | :------------------------------------------------------------------------ |
	   *  | [ShopError](shoperror.html)              | No or invalid ticket in shop data [ShopData](../interfaces/shopdata.html) |
	   *  | [ApiError](apierror.html)                | The shop API threw an error                                               |
	   */


	  addTicket(ticketGuid) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        // Also ends the action via the _itemsUpdated()
	        const addTicketEvent = yield this._addTicket(ticketGuid); // Ends the action and emits the checkout details

	        this._action(CartAction.End);

	        this.emit(['ticket', ticketGuid, 'add'], addTicketEvent);
	        return addTicketEvent;
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'addTicket', 'error', 'failed'], {
	          ticketGuid
	        });
	      }
	    });
	  }
	  /**
	   *
	   *  Internally used for adding a ticket to the cart.
	   *
	   *  @param ticketGuid The guid of the ticket to add.
	   *  @param seatInfo When a ticket is added through the seats integration, it's place's info can be added here.
	   *
	   */


	  _addTicket(ticketGuid, seatInfo) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      const ticket = this._getShopTicket(ticketGuid);

	      this._ensureTicketAvailable(ticket);

	      const eventCollection = this._getOrCreateEventCollection(ticket.event_id); // Ensure the eventCollection ticket map is set on the cart and retrieve it


	      const cartTicketMap = eventCollection.tickets.map[ticketGuid] = eventCollection.tickets.map[ticketGuid] || {}; // Cart items in the cart are always in stable state.
	      // E.g.: Pending reservations are not yet added to the cart item collections
	      // until the reservation request resolves.
	      // Here the count is calculated to come as close to a realised ticket count,
	      // assuming all pending reservations will successfully resolve.

	      const currentTicketCount = Object.keys(cartTicketMap).length + this._reservator.inFlightCount(ReservationType.Ticket, ticket.guid); // Calculate the amount of tickets to order to the next valid step


	      const numberOfTicketsToReserve = seatInfo ? 1 : calculateTicketDiff(currentTicketCount, ticket.min_orderable_amount_per_order || 1, ticket.increment || 1); // Don't let it exceed the max orderable amount per order

	      if (currentTicketCount + numberOfTicketsToReserve > ticket.max_orderable_amount_per_order) {
	        throw new ShopError('Ticket max orderable amount per order reached');
	      }

	      try {
	        const reservations = yield this._reservator.reserve(ReservationType.Ticket, ticket.guid, numberOfTicketsToReserve);
	        const cartTickets = []; // Process every reservation, create items for each and add to the cart collection(s)

	        forEach$2(reservations, reservation => {
	          // Create the cart ticket
	          const cartTicket = new CartTicket(this._data, ticket, reservation, undefined, seatInfo); // Add the cart ticket to the tickets map and collection of his event

	          cartTicketMap[cartTicket.id] = cartTicket;
	          eventCollection.tickets.collection.push(cartTicket); // Add it to the flat items collection for easy access

	          this.flatItems.tickets[cartTicket.id] = cartTicket; // Add the cart ticket's children (products) to the flat list
	          // (!) Not to the event's products, as those are only for top level products

	          forOwn(cartTicket.products.map, cartProducts => {
	            forOwn(cartProducts, cartProduct => {
	              this.flatItems.products[cartProduct.id] = cartProduct;
	            });
	          });
	          cartTickets.push(cartTicket);
	        });

	        this._itemsUpdated();

	        return this._cartEventItemResponse(ticket, cartTickets, CartItemChildType.Tickets);
	      } catch (e) {
	        if (e && e.slug === 'sdkshop.log.reservator.reserve.error.notacceptable' && e.response && e.response.data) {
	          if (e.response.data.error_description === 'Sold out') {
	            ticket.status = 'sold_out';
	            throw this.log._passThroughOrCreate(e, LogLevel.Warning, ['cart', 'addTicket', 'error', 'sold_out'], {
	              ticketGuid
	            });
	          }

	          if (e.response.data.error_description === 'Everything is reserved') {
	            throw this.log._passThroughOrCreate(e, LogLevel.Warning, ['cart', 'addTicket', 'error', 'all_reserved'], {
	              ticketGuid
	            });
	          }
	        } // TODO: add check for not_sold_right_now


	        throw e;
	      }
	    });
	  }
	  /**
	   *  Remove a ticket from the cart.
	   *
	   *  ```ts
	   *  cart.removeTicket(ticket.guid);
	   *  cart.removeTicket(ticket.guid, cartTicket.id);
	   *  ```
	   *
	   *  @param ticketGuid The guid of the ticket to remove
	   *  @param cartTicketId The id of the cart ticket, when not provided the last cart item will be removed
	   *
	   *  | Error                                    | Reason                                    |
	   *  | :--------------------------------------- | :---------------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid ticket in shop data or cart |
	   *  |                                          | [ShopData](../interfaces/shopdata.html)   |
	   *  | [ApiError](apierror.html)                | The shop API threw an error               |
	   */


	  removeTicket(ticketGuid, cartTicketId) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        // Also ends the action via the _itemsUpdated()
	        const removeTicketEvent = yield this._removeTicket(ticketGuid, cartTicketId); // Ends the action and emits the checkout details

	        this._action(CartAction.End);

	        this.emit(['ticket', ticketGuid, 'remove'], removeTicketEvent);
	        return removeTicketEvent;
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'removeTicket', 'error', 'failed'], {
	          ticketGuid,
	          cartTicketId
	        });
	      }
	    });
	  }
	  /**
	   *
	   *  Internally used to remove a ticket from the cart, including the option to not
	   *  recompute the checkout details after doing so. Used by the removeAllItems
	   *  method to make sure the re-computation of the checkout details only happens
	   *  once after every item has been removed.
	   *
	   *  @param ticketGuid The guid of the ticket to remove
	   *  @param cartTicketId The id of the cart ticket, when not provided the last cart item  will be removed
	   *  @param singleRemove If it's about the removing of a single product (and not removing all products)
	   *
	   */


	  _removeTicket(ticketGuid, cartTicketId, singleRemove = true) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      const ticket = this._getShopTicket(ticketGuid); // Retrieve the cart ticket map and cart ticket collection


	      const [cartTicketCollection, cartTicketMap] = this._getTicketItemCollection(ticket.event_id, ticket.guid); // Any pending counts are not relevant (yet) for removing tickets


	      const cartTicketCount = Object.keys(cartTicketMap).length;
	      const cartTicketIds = [];

	      if (cartTicketId) {
	        // When a specific cart ticket id is provided, only that cart ticket should be removed
	        if (!Object.prototype.hasOwnProperty.call(cartTicketMap, cartTicketId)) {
	          throw this.log._create(LogLevel.Error, ['cart', 'removeTicket', 'error', 'notfound'], {
	            ticketGuid,
	            cartTicketId
	          });
	        }

	        cartTicketIds.push(cartTicketId);
	      } else if (cartTicketCount) {
	        // When no specific cart ticket id is provided, remove the n last added ticket(s)
	        // (i) See top of file comment; sorting of getOwnPropertyNames is good enough
	        const numberOfTickets = calculateTicketDiff(cartTicketCount, ticket.min_orderable_amount_per_order || 1, ticket.increment || 1, -1);
	        cartTicketIds.push(...Object.getOwnPropertyNames(cartTicketMap).slice(-1 * numberOfTickets));
	      } else {
	        throw new ShopError(`Ticket is not in cart's item collection: ${ticket.guid}`);
	      } // Array containing all cart tickets to be released


	      const cartTickets = []; // Process all cart ticket IDs to be removed.

	      forEach$2(cartTicketIds, currentCartTicketId => {
	        // Get the ticket out of the collection to release it in the API and remove it from the event's collection
	        const cartTicket = cartTicketMap[currentCartTicketId];
	        cartTickets.push(cartTicket); // (!) The reservation release request is not awaited!
	        //
	        // Race conditions will become a lot more common
	        // and state is almost guaranteed to fail when waiting for reservation release!
	        //
	        // Note: It is possible a reservation will not be properly released in the API,
	        // but is removed from the cart.
	        // This is accepted behaviour as at some point the API will release the reservation anyway,
	        // when the reservation timeout has been reached.

	        this._reservator.release(ReservationType.Ticket, cartTicket.item.guid, cartTicket.reservation.reservation).catch(() => {}); // Remove the cart ticket from the map


	        delete cartTicketMap[cartTicket.id]; // Remove collection element from array by value

	        lodash.exports.remove(cartTicketCollection, cartTicket); // Remove the cart ticket from the flat items

	        delete this.flatItems[CartItemChildType.Tickets][cartTicket.id]; // Make ticket available if sold_out on release

	        if (cartTicket.item.status === 'sold_out') {
	          cartTicket.item.status = 'available';
	        } // Remove the child items out of the flat items and check if coupons were applied to keep the coupon stats up to date
	        // (i) Product reservations (should) have been released automatically by the API


	        forOwn(cartTicket.products.map, cartProducts => {
	          forOwn(cartProducts, cartProduct => {
	            delete this.flatItems.products[cartProduct.id];

	            this._checkRemovedProductCoupons(cartProduct);
	          });
	        });
	      }); // Any empty elements in the cart structure can/should be removed.
	      // In this case it is not necessary to check the entire structure, only a partial subset.

	      this._cleanUpItemStructure(ticket.event_id, ticket.guid); // Only invoke the items update when it's about a single remove,
	      // otherwise the overlaying action that is removing multiple
	      // is responsible for invoking the items updated


	      if (singleRemove) {
	        this._itemsUpdated();
	      }

	      return this._cartEventItemResponse(ticket, cartTickets, CartItemChildType.Tickets);
	    });
	  }
	  /**
	   *  Add a (global) product to the cart. This will only succeed if a reservation can be retrieved.
	   *
	   *  ```ts
	   *  cart.addProduct(product.guid);
	   *  ```
	   *
	   *  @param productGuid The guid of the (global) product to add
	   *
	   *  | Error                                    | Reason                                                                     |
	   *  | :--------------------------------------- | :------------------------------------------------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid product in shop data [ShopData](../interfaces/shopdata.html) |
	   *  | [ApiError](apierror.html)                | The shop API threw an error                                                |
	   */


	  addProduct(productGuid) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        // Also ends the action via the _itemsUpdated()
	        const addProductEvent = yield this._addProduct(productGuid); // Ends the action and emits the checkout details

	        this._action(CartAction.End);

	        this.emit(['product', productGuid, 'add'], addProductEvent);
	        return addProductEvent;
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'addProduct', 'error', 'failed'], {
	          productGuid
	        });
	      }
	    });
	  }
	  /**
	   *
	   *  Internally used to add a (global) product to the cart.
	   *
	   *  @param productGuid The guid of the (global) product to add
	   *
	   */


	  _addProduct(productGuid) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      const product = this._getShopProduct(productGuid, false); // Global products can belong to an event OR be a child of the shop/cart directly


	      const event = product.event_id ? this._data.events_map[product.event_id] : undefined;
	      const globalProductsCollection = event ? event.global_products : this._data.global_products; // Above the product is retrieved from the root collection.
	      // This contains both ticket products and global products.
	      // Ensure the product is a global product.

	      this._ensureGlobalProduct(globalProductsCollection, product); // Retrieve the relevant global product collection depending on the event.


	      let productCollection;

	      if (event) {
	        productCollection = this._getOrCreateEventCollection(product.event_id)[CartItemChildType.Products];
	      } else {
	        productCollection = this.orphanedGlobalProducts;
	      }

	      const cartProductMap = productCollection.map[product.guid] = productCollection.map[product.guid] || {};
	      const reservations = yield this._reservator.reserve(ReservationType.Product, product.guid);
	      const cartProducts = []; // Process every reservation, create items for each and add to the cart collection(s)

	      forEach$2(reservations, reservation => {
	        // Create the cart product
	        const cartProduct = new CartProduct(this._data, product, reservation); // Add the cart product to the event's product map and collection

	        cartProductMap[cartProduct.id] = cartProduct;
	        productCollection.collection.push(cartProduct); // Add it to the flat items collection for easy access

	        this.flatItems.products[cartProduct.id] = cartProduct;
	        cartProducts.push(cartProduct);
	      }); // Add the product's person meta to the cart's metadata

	      addMetadataFromProduct(product, this.metadata, this.metadataList, MetadataAppliesTo.Person);

	      this._itemsUpdated();

	      return this._cartEventItemResponse(product, cartProducts, CartItemChildType.Products);
	    });
	  }
	  /**
	   *  Remove a (global) product from the cart.
	   *
	   *  ```ts
	   *  cart.removeProduct(product.guid);
	   *  cart.removeProduct(product.guid, cartProduct.id);
	   *  ```
	   *
	   *  @param productGuid The guid of the (global) product to remove
	   *  @param cartProductId The id of the cart product, when not provided the last cart product will be removed
	   *
	   *  | Error                                    | Reason                                    |
	   *  | :--------------------------------------- | :---------------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid ticket in shop data or cart |
	   *  |                                          | [ShopData](../interfaces/shopdata.html)   |
	   *  | [ApiError](apierror.html)                | The shop API threw an error               |
	   */


	  removeProduct(productGuid, cartProductId) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        // Also ends the action via the _itemsUpdated()
	        const removeProductEvent = yield this._removeProduct(productGuid, cartProductId); // Ends the action and emits the checkout details

	        this._action(CartAction.End);

	        this.emit(['product', productGuid, 'remove'], removeProductEvent);
	        return removeProductEvent;
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'removeProduct', 'error', 'failed'], {
	          productGuid,
	          cartProductId
	        });
	      }
	    });
	  }
	  /**
	   *
	   *  Internally used to remove a (global) product from the cart, including the option to
	   *  not recompute the checkout details after doing so. Used by the removeAllItems
	   *  method to make sure the re-computation of the checkout details only happens
	   *  once after every item has been removed.
	   *
	   *  @param productGuid The guid of the (global) product to remove
	   *  @param cartProductId The id of the cart product, when not provided the last (global) cart product will be removed
	   *  @param singleRemove If it's about the removing of a single product (and not removing all products)
	   *
	   */


	  _removeProduct(productGuid, cartProductId, singleRemove = true) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      const product = this._getShopProduct(productGuid, false); // Global products can belong to an event OR be a child of the shop/cart directly


	      const event = product.event_id ? this._data.events_map[product.event_id] : undefined;
	      const globalProductsCollection = event ? event.global_products : this._data.global_products; // Above the product is retrieved from the root collection.
	      // This contains both ticket products and global products.
	      // Ensure the product is a global product.

	      this._ensureGlobalProduct(globalProductsCollection, product); // Retrieve the relevant global product collection depending on the event.


	      const [cartProductCollection, cartProductMap] = this._getProductItemCollection(event ? event.guid : undefined, product.guid);

	      const cartProductCount = Object.keys(cartProductMap).length;
	      const cartProductIds = [];

	      if (cartProductId) {
	        if (!Object.prototype.hasOwnProperty.call(cartProductMap, cartProductId)) {
	          throw new ShopError(`Cart product id not found: ${cartProductId}`);
	        }

	        cartProductIds.push(cartProductId);
	      } else if (cartProductCount) {
	        // Remove the n last added product(s)
	        // (i) See top of file comment; sorting of getOwnPropertyNames is good enough
	        cartProductIds.push(...Object.getOwnPropertyNames(cartProductMap).slice(-1));
	      } else {
	        throw new ShopError(`Product is not in cart's item collection: ${product.guid}`);
	      } // Array containing all cart tickets to be released


	      const cartProducts = [];
	      forEach$2(cartProductIds, currentCartProductId => {
	        // Get the product out of the collection to release it in the API and remove it from the event's collection
	        const cartProduct = cartProductMap[currentCartProductId];
	        cartProducts.push(cartProduct); // (!) The reservation release request is not awaited!
	        //
	        // Race conditions will become a lot more common
	        // and state is almost guaranteed to fail when waiting for reservation release!
	        //
	        // Note: It is possible a reservation will not be properly released in the API,
	        // but is removed from the cart.
	        // This is accepted behaviour as at some point the API will release the reservation anyway,
	        // when the reservation timeout has been reached.

	        this._reservator.release(ReservationType.Product, cartProduct.item.guid, cartProduct.reservation.reservation).catch(() => {}); // Remove the cart ticket from the map


	        delete cartProductMap[cartProduct.id];
	        lodash.exports.remove(cartProductCollection, cartProduct); // Remove the cart product from the flat items

	        delete this.flatItems[CartItemChildType.Products][cartProduct.id]; // Check if the coupons should be updated

	        this._checkRemovedProductCoupons(cartProduct);
	      });

	      this._cleanUpItemStructure(product.event_id, undefined, product.guid); // Remove the metadata to ask out of the cart's metadata


	      this._checkRemovedProductMetadata(product.metadata); // Only invoke the items update when it's about a single remove,
	      // otherwise the overlaying action that is removing multiple
	      // is responsible for invoking the items updated


	      if (singleRemove) {
	        this._itemsUpdated();
	      }

	      return this._cartEventItemResponse(product, cartProducts, CartItemChildType.Products);
	    });
	  }
	  /**
	   *  Add a product to a cart ticket. This will only succeed if a reservation can be retrieved.
	   *
	   *  ```ts
	   *  cart.addProductToTicket(cartTicket.id, product.guid);
	   *  ```
	   *
	   *  @param cartTicketId The id of the cart ticket to add the product to
	   *  @param productGuid The guid of the product to add to the ticket
	   *
	   *  | Error                                    | Reason                                                                     |
	   *  | :--------------------------------------- | :------------------------------------------------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid product in shop data [ShopData](../interfaces/shopdata.html) |
	   *  | [ApiError](apierror.html)                | The shop API threw an error                                                |
	   */


	  addProductToTicket(cartTicketId, productGuid) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        // Also ends the action via the _itemsUpdated()
	        const addProductToTicketEvent = yield this._addProductToTicket(cartTicketId, productGuid); // Ends the action and emits the checkout details

	        this._action(CartAction.End);

	        this.emit(['ticket', cartTicketId, 'product', productGuid, 'add'], addProductToTicketEvent);
	        return addProductToTicketEvent;
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'addProductToTicket', 'error', 'failed'], {
	          cartTicketId,
	          productGuid
	        });
	      }
	    });
	  }
	  /**
	   *
	   *  Internally used to add a product to a cart ticket.
	   *
	   *  @param cartTicketId The id of the cart ticket to add the product to
	   *  @param productGuid The guid of the product to add to the ticket
	   *
	   */


	  _addProductToTicket(cartTicketId, productGuid) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      // Get the ticket to add the product to
	      const cartTicket = this._getCartTicket(cartTicketId); // Number of times the product has been added to the ticket (already)


	      const timesAdded = cartTicket.products.map[productGuid] ? Object.keys(cartTicket.products.map[productGuid]).length : 0;
	      forEach$2(cartTicket.item.groups, productGroup => {
	        let inGroup = false;
	        let totalAdded = 0;
	        forEach$2(productGroup.products, groupProduct => {
	          if (productGuid === groupProduct.guid) {
	            inGroup = true;
	            const uniqueness = groupProduct.uniqueness || productGroup.uniqueness; // Check if the uniqueness restriction will be exceeded
	            // This is either the group's product pivot value, or the product group value

	            if (!!uniqueness && timesAdded >= uniqueness) {
	              throw new ShopError(`Adding product exceeds uniqueness (${uniqueness}) of product group: ${productGroup.guid}`);
	            }
	          } // Count the group's products that are added to the
	          // ticket already, for checking the max bound


	          if (cartTicket.products.map[groupProduct.guid]) {
	            totalAdded += Object.keys(cartTicket.products.map[groupProduct.guid]).length;
	          }
	        }); // When the product is in this group, check if the max_bound will be exceeded

	        if (inGroup && !!productGroup.max_bound && totalAdded >= productGroup.max_bound) {
	          throw new ShopError(`Adding product exceeds max_bound (${productGroup.max_bound}) of product group: ${productGroup.guid}`);
	        }
	      }); // Get the product to add

	      const ticketProduct = this._getProductFromTicket(cartTicket.item, productGuid); // Reserve the product as child of the (cart) ticket


	      const reservations = yield this._reservator.reserveChild(ReservationType.Ticket, cartTicket.item.guid, ReservationType.Product, ticketProduct.item.guid); // Let the ticket process his (child) product reservations

	      const cartProducts = cartTicket._processProductChildReservation(ticketProduct.item.guid, ...reservations); // Add the cart products to the flat items for easy access


	      forEach$2(cartProducts, cartProduct => {
	        this.flatItems.products[cartProduct.id] = cartProduct;
	      }); // Only add the metadata if the ticket's personalization should
	      // not be later, because the buyer doesn't need to enter the
	      // metadata now if it should be personalized later

	      if (!cartTicket.item.late_personalization) {
	        addMetadataFromProduct(ticketProduct.item, cartTicket.metadata, cartTicket.metadataList, MetadataAppliesTo.Person);
	      }

	      this._itemsUpdated(); // Recompute the total prices of the SHOP ticket's container products
	      // based on their container prices (the ticket's)
	      // (i) It's ok if it becomes zero because the ticket price is zero


	      const originalTicketPrice = cartTicket.pricing.self.total_price + cartTicket.pricing.children.own.total_price;
	      forEach$2(cartTicket.item.products.all, shopProduct => {
	        if (shopProduct.item.pricing_method === PricingMethod.Container) {
	          Price.computeProductPricing(shopProduct.pricing, originalTicketPrice);
	        }
	      });
	      return this._cartEventItemResponse(ticketProduct.item, cartProducts, CartItemChildType.Products, cartTicket);
	    });
	  }
	  /**
	   *  Remove a product from a cart ticket. This will only succeed if a reservation can be cancelled.
	   *
	   *  ```ts
	   *  cart.removeProductFromTicket(cartTicket.id, product.guid);
	   *  cart.removeProductFromTicket(cartTicket.id, product.guid, cartProduct.id);
	   *  ```
	   *
	   *  @param cartTicketId The id of the ticket to remove the product from
	   *  @param productGuid The guid of the product to remove
	   *  @param cartProductId The id of the cart ticket, when not provided the last cart ticket will be removed
	   *
	   *  | Error                                    | Reason                                                             |
	   *  | :--------------------------------------- | :----------------------------------------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid cart product [ShopData](../interfaces/shopdata.html) |
	   *  | [ApiError](apierror.html)                | The shop API threw an error                                        |
	   */


	  removeProductFromTicket(cartTicketId, productGuid, cartProductId) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        // Also ends the action via the _itemsUpdated()
	        const removeTicketProductEvent = yield this._removeProductFromTicket(cartTicketId, productGuid, cartProductId); // Ends the action and emits the checkout details

	        this._action(CartAction.End);

	        this.emit(['ticket', cartTicketId, 'product', productGuid, 'remove'], removeTicketProductEvent);
	        return removeTicketProductEvent;
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'removeProductFromTicket', 'error', 'failed'], {
	          cartTicketId,
	          productGuid,
	          cartProductId
	        });
	      }
	    });
	  }
	  /**
	   *
	   *  Internally used to remove a product from a cart ticket.
	   *
	   *  @param cartTicketId The id of the ticket to remove the product from
	   *  @param productGuid The guid of the product to remove
	   *  @param cartProductId The id of the cart ticket, when not provided the last cart ticket will be removed
	   */


	  _removeProductFromTicket(cartTicketId, productGuid, cartProductId) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      const cartTicket = this._getCartTicket(cartTicketId);

	      const ticketProduct = this._getProductFromTicket(cartTicket.item, productGuid); // Retrieve the relevant product collection.


	      const [cartProductCollection, cartProductMap] = this._getChildProductCollection(cartTicket, productGuid);

	      const cartProductCount = Object.keys(cartProductMap).length;
	      const cartProductIds = [];

	      if (cartProductId) {
	        if (!Object.prototype.hasOwnProperty.call(cartProductMap, cartProductId)) {
	          throw new ShopError(`Cart product id not found: ${cartProductId}`);
	        }

	        cartProductIds.push(cartProductId);
	      } else if (cartProductCount) {
	        // Remove the n last added products(s)
	        // (i) See top of file comment; sorting of getOwnPropertyNames is good enough
	        cartProductIds.push(...Object.getOwnPropertyNames(cartProductMap).slice(-1));
	      } else {
	        throw new ShopError(`Product is not in cart ticket's product collection: ${ticketProduct.item.guid}`);
	      } // Array containing all cart products to be released


	      const cartProducts = [];
	      forEach$2(cartProductIds, currentCartProductId => {
	        // Get the product out of the collection to release it in the API and remove it from the cart ticket's collection
	        const cartProduct = cartProductMap[currentCartProductId];
	        cartProducts.push(cartProduct); // (!) The reservation release request is not awaited!
	        //
	        // Race conditions will become a lot more common
	        // and state is almost guaranteed to fail when waiting for reservation release!
	        //
	        // Note: It is possible a reservation will not be properly released in the API,
	        // but is removed from the cart.
	        // This is accepted behaviour as at some point the API will release the reservation anyway,
	        // when the reservation timeout has been reached.

	        this._reservator.release(ReservationType.Product, cartProduct.item.guid, cartProduct.reservation.reservation).catch(() => {}); // Remove the cart product from the map


	        delete cartProductMap[cartProduct.id];
	        lodash.exports.remove(cartProductCollection, cartProduct); // Remove the cart product from the flat items

	        delete this.flatItems[CartItemChildType.Products][cartProduct.id]; // Check if coupons were applied to keep the coupon stats up to date

	        this._checkRemovedProductCoupons(cartProduct);
	      }); // Remove any (optional) parent structure if empty

	      if (!Object.keys(cartTicket.products.map[ticketProduct.item.guid]).length) {
	        delete cartTicket.products.map[ticketProduct.item.guid];
	      } // Only remove the metadata if the product's ticket's personalization
	      // should not be later, because the buyer doesn't need to enter the
	      // metadata now if it should be personalized later.
	      // This is an optimization step, it should never have been added, so no need to remove it.


	      if (!cartTicket.item.late_personalization) {
	        cartTicket._checkRemovedProductMetadata(ticketProduct.item.metadata);
	      }

	      this._itemsUpdated(); // Recompute the total prices of the SHOP ticket's container products
	      // based on their container prices (the ticket's)
	      // (i) It's ok if it becomes zero because the ticket price is zero


	      const originalTicketPrice = cartTicket.pricing.self.total_price + cartTicket.pricing.children.own.total_price;
	      forEach$2(cartTicket.item.products.all, shopProduct => {
	        if (shopProduct.item.pricing_method === PricingMethod.Container) {
	          Price.computeProductPricing(shopProduct.pricing, originalTicketPrice);
	        }
	      });
	      return this._cartEventItemResponse(ticketProduct.item, cartProducts, CartItemChildType.Products, cartTicket);
	    });
	  }
	  /**
	   *  Add (a) ticket(s) through the seats selector
	   *
	   *  Note: The seat selector will be opened for all tickets
	   *  with the same set of seats.io eventKeys as the provided ticket.
	   *
	   *  @param ticketGuid The ticket guid for which to open the seat selector.
	   *  @param divId The id of the DOM element to mount seat selector in.
	   *  @param inputOptions Extra options to forward to the seat selector.
	   */


	  addTicketThroughSeats(ticketGuid, divId, inputOptions) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        this.emit(['seats', 'created'], null, true);
	        yield this._openSeatsFromTicket(ticketGuid, divId, inputOptions);
	        this.emit(['seats', 'mounted'], null, true);
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'addTicketThroughSeats', 'error', 'failed'], {
	          ticketGuid
	        });
	      }
	    });
	  }
	  /**
	   *  Find a cart ticket by it's seats info object label and remove it from the cart.
	   *
	   *  @param label The seats.io seating chart object's label
	   *  @param ticketGuid The ticket guid from the seats.io pricing ticket type
	   */


	  _removeTicketBySeats(label, ticketGuid) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      const cartTicketMap = ticketGuid ? this._getTicketItemCollection(this._getShopTicket(ticketGuid).event_id, ticketGuid)[1] : this.flatItems[CartItemChildType.Tickets];
	      const labeledCartTickets = Object.getOwnPropertyNames(cartTicketMap).map(cartTicketId => cartTicketMap[cartTicketId]).filter(cartTicket => cartTicket.seatsInfo && cartTicket.seatsInfo.objectLabel === label).slice(-1);

	      if (!labeledCartTickets.length) {
	        console.warn('Failed to remove seated ticket -> Could not find ticket: ', label, ticketGuid);
	        return;
	      }

	      return yield this._removeTicket(labeledCartTickets[0].item.guid, labeledCartTickets[0].id);
	    });
	  }
	  /**
	   *  Collect all (nested) event keys from the ticket
	   *
	   *  Note: If any optional products are connected to an event date with a seats_event_key,
	   *  those are ignored (for now...)
	   *  Might want to add those to addProductToTicketThroughSeats once the API supports it.
	   */


	  _getEventKeysFromTicket(ticket, productType) {
	    const eventKeys = {};
	    forEach$2(ticket.products[productType], product => {
	      forEach$2(product.item.event_dates, eventDate => {
	        // By using a map, this ensures the event date collection is unique
	        if (eventDate.seats_event_key) {
	          eventKeys[eventDate.seats_event_key] = eventDate.seats_event_key;
	        }
	      });
	    });
	    return Object.keys(eventKeys);
	  }
	  /**
	   *  Open the seats selector with the intention of adding tickets to the cart
	   *
	   *  Note: The seat selector will be opened for all tickets
	   *  with the same set of seats.io eventKeys as the provided ticket.
	   *
	   *  @param ticketGuid The ticket guid for which to open the seat selector.
	   *  @param divId The id of the DOM element to mount seat selector in.
	   *  @param inputOptions Extra options to forward to the seat selector.
	   */


	  _openSeatsFromTicket(ticketGuid, divId, inputOptions) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      if (!this.seatsioInstance) {
	        throw new ShopError('Ticket is not seated -> Seats.io instance not constructed');
	      }

	      const [tickets, eventKeys] = this._getSeatedTickets(ticketGuid);

	      const pricing = {}; // Filter any tickets that have the exact same combination of event keys
	      // If any other combination can also be selected, a mismatch between the ticket spec,
	      // the seats reservations and the ordered products can occur!!!

	      forEach$2(tickets, otherTicket => {
	        pricing[otherTicket.seats_category_key] = pricing[otherTicket.seats_category_key] || {
	          category: otherTicket.seats_category_key,
	          ticketTypes: []
	        };
	        pricing[otherTicket.seats_category_key].ticketTypes.push({
	          ticketType: otherTicket.guid,
	          price: otherTicket.pricing.total_price,
	          label: otherTicket.name
	        });
	      });
	      const seatsOptions = Object.assign(Object.assign({
	        // Default values from data / cart, can be overwritten by input options!
	        language: this.locale,
	        allowOrphanSeats: this._data.seats_allow_orphan_computed || false,
	        forceConsecutiveSeats: false,
	        colorScheme: 'light',
	        priceFormatter: cents => this._formatPrice(cents)
	      }, inputOptions), {
	        // Always set by the computed values, can never be set through input options
	        divId: divId,
	        events: eventKeys,
	        // This line shows a confirmation dialog even when only one choice.
	        pricing: Object.values(pricing),
	        // The below code block could be used to convert single choice categories to the simple pricing config...
	        // Note however: the callbacks will need to be rewritten.
	        // Without the ticket type info, they can not easily retrieve the associated ticket!!!
	        //
	        // pricing: Object.values(pricing).map((pricingConfig: seatsio.PricingConfig) => {
	        //
	        //     if (pricingConfig.ticketTypes && pricingConfig.ticketTypes.length === 1) {
	        //
	        //         return {
	        //             category: pricingConfig.category,
	        //             price: pricingConfig.ticketTypes[0].price,
	        //         };
	        //
	        //     }
	        //
	        //     return pricingConfig;
	        //
	        // }),
	        onHoldSucceeded: (objects, ticketTypes) => __awaiter$1(this, void 0, void 0, function* () {
	          if (!ticketTypes) {
	            // TODO Retrieve ticket by seats_category_key ???
	            console.error('Invalid hold -> no ticket types', objects);
	            throw new Error('Invalid hold -> no ticket types');
	          }

	          this._action(CartAction.Start);

	          forEach$2(objects, (object, index) => {
	            const ticketType = ticketTypes[index];

	            if (!ticketType.ticketType) {
	              // TODO Retrieve ticket by seats_category_key ???
	              console.error('Invalid hold -> no ticket type', object);
	              return;
	            }

	            const seatInfo = {
	              objectLabel: object.label,
	              eventKeys
	            }; // Note: If the ticket is not available, this will be handled by `_addTicket`

	            this._addTicket(ticketType.ticketType, seatInfo).then(addTicketEvent => {
	              this.emit(['ticket', ticketGuid, 'add'], addTicketEvent);
	              return addTicketEvent;
	            }).catch(reason => {
	              object.deselect();
	              console.error(`Failed to add ticket for seated object ${object.label}`, reason);
	            });
	          }); // Ends the action and emits the checkout details

	          this._action(CartAction.End);
	        }),
	        onHoldFailed: (objects, ticketTypes) => {
	          console.error('onHoldFailed', objects, ticketTypes); // TODO Some error for frontend ???
	        },
	        onHoldTokenExpired: () => {
	          console.error('onHoldTokenExpired');
	          this.emit(['seats', 'error', 'hold-expired'], null, true); // TODO -> release all seated tickets or reselect seated tickets (if possible), or both...
	        },
	        onReleaseHoldSucceeded: (objects, ticketTypes) => __awaiter$1(this, void 0, void 0, function* () {
	          this._action(CartAction.Start);

	          forEach$2(objects, (object, index) => {
	            const ticketType = ticketTypes ? ticketTypes[index] : undefined;

	            this._removeTicketBySeats(object.label, ticketType ? ticketType.ticketType : undefined).then(removeTicketEvent => {
	              if (removeTicketEvent) {
	                this.emit(['ticket', ticketGuid, 'remove'], removeTicketEvent);
	              }

	              return removeTicketEvent;
	            }).catch(reason => {
	              console.error(`Failed to remove ticket for seated object ${object.label}`, reason);
	            });
	          }); // Ends the action and emits the checkout details

	          this._action(CartAction.End);
	        }),
	        onReleaseHoldFailed: (objects, ticketTypes) => __awaiter$1(this, void 0, void 0, function* () {
	          console.error('onReleaseHoldFailed', objects, ticketTypes); // TODO Did only the release hold fail, or also the deselect?
	          //  Or.. is the object deselected -> we should also release it, regardless of hold failure!
	          //  If the object is NOT deselected current behaviour is fine!
	          // TODO Some error for frontend ???
	        }),
	        onSelectionValid: () => {
	          this.emit(['seats', 'validation', 'valid'], {
	            valid: true,
	            violations: []
	          }, true);
	        },
	        onSelectionInvalid: violations => {
	          console.error('onSelectionInvalid', violations);
	          this.emit(['seats', 'validation', 'invalid'], {
	            valid: false,
	            violations: violations
	          }, true);
	        }
	      });
	      yield this.seatsioInstance.mount(seatsOptions);
	    });
	  }
	  /**
	   *  Close the seats io seating chart
	   */


	  closeSeats() {
	    if (!this.seatsioInstance) {
	      throw this.log._create(LogLevel.Warning, ['cart', 'closeSeats', 'error', 'initialized']);
	    }

	    this.seatsioInstance.destroy();

	    this._action(CartAction.End);

	    this.emit(['seats', 'destroy'], null, true);
	  }
	  /**
	   *  Retrieve the seats info for the set of (cart) tickets equal to the given ticket guid.
	   *
	   *  @param ticketGuid The reference ticket's guid
	   */


	  getSeatedTicketInfo(ticketGuid) {
	    const [tickets, eventKeys] = this._getSeatedTickets(ticketGuid);

	    const allCartItems = [];
	    forEach$2(tickets, ticket => {
	      try {
	        allCartItems.push(...Object.values(this._getTicketItemCollection(ticket.event_id, ticket.guid)[1]));
	      } catch (e) {// Ignore...
	      }
	    });
	    return {
	      items: allCartItems.map(cartTicket => {
	        return {
	          ticket_guid: cartTicket.item.guid,
	          name: cartTicket.item.name,
	          id: cartTicket.id,
	          label: cartTicket.seatsInfo ? cartTicket.seatsInfo.objectLabel : '',
	          pricing: cartTicket.pricing
	        };
	      }),
	      eventKeys: eventKeys,
	      count: allCartItems.length,
	      pricing: Price.getCumulativeCartItemPrice(allCartItems)
	    };
	  }
	  /**
	   *  Retrieve all seated tickets with the same set of event keys to the given ticket guid.
	   *
	   *  @param ticketGuid The reference ticket's guid
	   */


	  _getSeatedTickets(ticketGuid) {
	    const ticket = this._getShopTicket(ticketGuid);

	    if (!ticket.seats_category_key) {
	      throw new ShopError('Ticket is not seated -> Seats.io category key not found');
	    }

	    if (!ticket.seated) {
	      throw new ShopError('Ticket is not seated');
	    }

	    const eventKeys = this._getEventKeysFromTicket(ticket, 'required');

	    if (!eventKeys.length) {
	      throw new ShopError('Ticket is not seated -> Seats.io event key(s) not found');
	    } // TODO Note: currently no way to know if the event Keys belong to the same chart...


	    const event = this._getShopEvent(ticket.event_id);

	    const tickets = []; // Filter any tickets that have the exact same combination of event keys
	    // If any other combination can also be selected, a mismatch between the ticket spec,
	    // the seats reservations and the ordered products can occur!!!

	    forEach$2(event.tickets, otherTicket => {
	      if (otherTicket.seats_category_key) {
	        if (!this._ensureTicketAvailable(otherTicket, false)) {
	          return;
	        }

	        const ticketEventKeys = this._getEventKeysFromTicket(otherTicket, 'required');

	        if (ticketEventKeys.length && arraysMatch(eventKeys, ticketEventKeys)) {
	          tickets.push(otherTicket);
	        }
	      }
	    });
	    return [tickets, eventKeys];
	  }
	  /**
	   *  Retrieve a cart ticket from the cart
	   *
	   *  If it does not exist a shop error is thrown
	   */


	  _getCartTicket(cartTicketId) {
	    if (!cartTicketId || !Object.prototype.hasOwnProperty.call(this.flatItems[CartItemChildType.Tickets], cartTicketId)) {
	      throw new ShopError(`No valid cart ticket id provided: ${cartTicketId}`);
	    }

	    return this.flatItems[CartItemChildType.Tickets][cartTicketId];
	  } // noinspection JSMethodCanBeStatic

	  /**
	   *  Retrieve a child cart product collection from the cart ticket
	   *
	   *  If it does not exist a shop error is thrown
	   */


	  _getChildProductCollection(cartTicket, productGuid) {
	    // noinspection SuspiciousTypeOfGuard
	    if (typeof productGuid !== 'string' || !Object.prototype.hasOwnProperty.call(cartTicket.products.map, productGuid)) {
	      throw new ShopError(`Product ${productGuid} not in cart ticket ${cartTicket.id}`);
	    }

	    return [cartTicket.products.collection, cartTicket.products.map[productGuid]];
	  }
	  /**
	   *  Retrieve a ticket from the shop data if it exists.
	   *
	   *  If it does not exist a shop error is thrown
	   */


	  _getShopTicket(ticketGuid) {
	    return this._getShopReservable(this._data.tickets_map, ticketGuid);
	  }
	  /**
	   *  Retrieve a product from the shop data if it exists.
	   *
	   *  If it does not exist a shop error is thrown
	   */


	  _getShopProduct(productGuid, ensureEvent) {
	    return this._getShopReservable(this._data.products_map, productGuid, ensureEvent);
	  }
	  /**
	   *  Retrieve a reservable from the shop data if it exists.
	   *
	   *  If it does not exist a shop error is thrown
	   */


	  _getShopReservable(collection, guid, ensureEvent = true) {
	    // noinspection SuspiciousTypeOfGuard
	    if (!guid || typeof guid !== 'string' || !Object.prototype.hasOwnProperty.call(collection, guid)) {
	      throw new ShopError(`No valid item guid provided: ${guid}`);
	    }

	    const reservable = collection[guid];

	    if (!reservable.guid || guid !== reservable.guid) {
	      throw new ShopError(`Item does not have valid guid: ${reservable.guid}`);
	    }

	    if (ensureEvent && (!reservable.event_id || !Object.prototype.hasOwnProperty.call(this._data.events_map, reservable.event_id))) {
	      throw new ShopError(`Item does not have valid event guid: ${reservable.event_id}`);
	    }

	    return reservable;
	  }
	  /**
	   *  Retrieve a product from the ticket if it exists
	   *
	   *  If it does not exist a shop error is thrown
	   */


	  _getProductFromTicket(ticket, productGuid) {
	    // noinspection SuspiciousTypeOfGuard
	    if (typeof productGuid !== 'string' || !Object.prototype.hasOwnProperty.call(this._data.products_map, productGuid)) {
	      throw new ShopError(`No valid product guid provided: ${productGuid}`);
	    } // Make sure the product is part of the ticket


	    const ticketProduct = ticket.products.all.find(ticketProduct => {
	      return ticketProduct.item.guid === productGuid;
	    });

	    if (!ticketProduct) {
	      throw new ShopError(`Product ${productGuid} not part of ticket ${ticket.guid}`);
	    }

	    return ticketProduct;
	  }
	  /**
	   *  Retrieve an event from the shop data if it exists.
	   *
	   *  If it does not exist a shop error is thrown
	   */


	  _getShopEvent(eventGuid) {
	    // noinspection SuspiciousTypeOfGuard
	    if (!eventGuid || typeof eventGuid !== 'string' || !Object.prototype.hasOwnProperty.call(this._data.events_map, eventGuid)) {
	      throw new ShopError(`Event not found -> No valid event guid provided: ${eventGuid}`);
	    }

	    return this._data.events_map[eventGuid];
	  }
	  /**
	   *  Ensure the given product is part of a global product collection in the shop data
	   *
	   *  Throws an error when not the case
	   */


	  _ensureGlobalProduct(productsCollection, product) {
	    let found = false;
	    forEach$2(productsCollection, globalProduct => {
	      if (product.guid === globalProduct.guid) {
	        found = true;
	      }

	      return !found;
	    });

	    if (found) {
	      return product;
	    }

	    throw new ShopError(`Product not a global product: ${product.guid}`);
	  } // noinspection JSMethodCanBeStatic

	  /**
	   *  Ensure the ticket is available.
	   *
	   *  This checks status and availability range.
	   *
	   *  @param ticket The ticket to ensure availability for.
	   *  @param throwError If set to false, the method returns a boolean instead of throwing an error.
	   */


	  _ensureTicketAvailable(ticket, throwError = true) {
	    let error = undefined;

	    if (ticket.status_overrule === 'sold_out') {
	      error = `Ticket is not available -> status overruled ${ticket.status_overrule}`;
	    } else if (ticket.status !== 'available') {
	      error = `Ticket is not available -> invalid status ${ticket.status}`;
	    } else if (ticket.available_from && ticket.available_from > new Date()) {
	      error = 'Ticket is not available -> Not available yet';
	    } else if (ticket.available_until && ticket.available_until < new Date()) {
	      error = 'Ticket is not available -> Not available any more';
	    }

	    if (error && throwError) {
	      throw new ShopError(error);
	    }

	    return !error;
	  }
	  /**
	   *  Ensure the event's item collection is defined
	   */


	  _getOrCreateEventCollection(eventGuid) {
	    return this.items[eventGuid] = this.items[eventGuid] || {
	      event: this._getShopEvent(eventGuid),
	      tickets: {
	        map: {},
	        collection: []
	      },
	      products: {
	        map: {},
	        collection: []
	      }
	    };
	  }
	  /**
	   *  Retrieve the event's cart ticket collection
	   *
	   *  This includes the complete ticket collection for the given event
	   *  and the ticket map for the specific ticket.
	   *
	   *  If it does not exist a shop error is thrown
	   */


	  _getTicketItemCollection(eventGuid, ticketGuid) {
	    if (!eventGuid || !Object.prototype.hasOwnProperty.call(this.items, eventGuid)) {
	      throw new ShopError(`Event is not in cart: ${eventGuid}`);
	    }

	    const collection = this.items[eventGuid][CartItemChildType.Tickets];

	    if (!ticketGuid || !Object.prototype.hasOwnProperty.call(collection.map, ticketGuid)) {
	      throw new ShopError(`Ticket is not in cart: ${ticketGuid}`);
	    }

	    return [collection.collection, collection.map[ticketGuid]];
	  }
	  /**
	   *  Retrieve the cart product collection from the event or the orphaned global products
	   *
	   *  If it does not exist a shop error is thrown
	   */


	  _getProductItemCollection(eventGuid, productGuid) {
	    if (eventGuid && !Object.prototype.hasOwnProperty.call(this.items, eventGuid)) {
	      throw new ShopError(`Event is not in cart: ${eventGuid}`);
	    }

	    const collection = eventGuid ? this.items[eventGuid][CartItemChildType.Products] : this.orphanedGlobalProducts;

	    if (!productGuid || !Object.prototype.hasOwnProperty.call(collection.map, productGuid)) {
	      throw new ShopError(`Product is not in cart: ${productGuid}`);
	    }

	    return [collection.collection, collection.map[productGuid]];
	  }
	  /**
	   *  Cleanup the cart item's structure
	   *
	   *  When providing an event guid, ticket guid or product guid,
	   *  the method can be focused to those paths.
	   */


	  _cleanUpItemStructure(eventGuid, ticketGuid, productGuid) {
	    // When no eventGuid is provided, recursively call this method for each event in the collection
	    if (!eventGuid) {
	      const eventGuids = Object.keys(this.items);
	      forEach$2(eventGuids, eventGuid => {
	        this._cleanUpItemStructure(eventGuid);
	      });
	      return;
	    }

	    const eventCollection = this.items[eventGuid];

	    if (!eventCollection) {
	      return;
	    }

	    const ticketMap = eventCollection[CartItemChildType.Tickets].map;
	    const productMap = eventCollection[CartItemChildType.Products].map;

	    if (ticketGuid) {
	      if (ticketMap[ticketGuid] && !Object.keys(ticketMap[ticketGuid]).length) {
	        delete ticketMap[ticketGuid];
	      }
	    } else if (productGuid) {
	      if (productMap[productGuid] && !Object.keys(productMap[productGuid]).length) {
	        delete productMap[productGuid];
	      }
	    } else {
	      // When no ticket guid and no product guid are provided, loop over all tickets and products
	      const ticketGuids = Object.keys(eventCollection[CartItemChildType.Tickets].map);
	      forEach$2(ticketGuids, guid => {
	        if (ticketMap[guid] && !Object.keys(ticketMap[guid]).length) {
	          delete ticketMap[guid];
	        }
	      });
	      const productGuids = Object.keys(eventCollection[CartItemChildType.Products].map);
	      forEach$2(productGuids, guid => {
	        if (productMap[guid] && !Object.keys(productMap[guid]).length) {
	          delete productMap[guid];
	        }
	      });
	    } // Finally check if the entire event is now empty, if so, clean it up!


	    if (!Object.keys(eventCollection[CartItemChildType.Tickets].map).length && !Object.keys(eventCollection[CartItemChildType.Products].map).length) {
	      delete this.items[eventGuid];
	    }
	  }
	  /**
	   *  Create the default cart item event object, to always return the same data.
	   *
	   *  @param item      - Reservable item
	   *  @param cartItems - Array of the affected cart items
	   *  @param type      - Type of cart item(s)
	   *  @param parent    - Optional parent object (CartTicket)
	   */


	  _cartEventItemResponse(item, cartItems, type, parent) {
	    let isTicket = false;
	    const event = {
	      guid: item.guid,
	      name: item.name,
	      items: cartItems.map(cartItem => {
	        if (cartItem.getType() === CartItemType.Ticket) {
	          isTicket = true;
	        }

	        return {
	          id: cartItem.id,
	          pricing: cartItem.pricing
	        };
	      }),
	      count: 0,
	      counts: {},
	      pricing: {
	        base_price: 0,
	        total_fees: 0,
	        subtotal_price: 0,
	        total_price: 0
	      }
	    }; // Forward the max orderable amount per order in case of a ticket

	    if (isTicket) {
	      event.max_count = item.max_orderable_amount_per_order;
	    }

	    let allCartItems;

	    if (parent) {
	      if (parent.products.collection.length > 0) {
	        allCartItems = Object.values(parent.products.map[item.guid] || {});
	      }
	    } else if (!isTicket && (!item.event_id || !this._data.events_map[item.event_id])) {
	      allCartItems = Object.values(this.orphanedGlobalProducts.map[item.guid] || {});
	    } else if (this.items[item.event_id] && this.items[item.event_id][type] && this.items[item.event_id][type].map[item.guid]) {
	      allCartItems = Object.values(this.items[item.event_id][type].map[item.guid] || {});
	    }

	    if (!allCartItems) {
	      return event;
	    }

	    forEach$2(allCartItems, cartItem => {
	      event.counts[cartItem.pricing.total_price] = (event.counts[cartItem.pricing.total_price] || 0) + 1;
	    });
	    event.count = allCartItems.length;
	    event.pricing = Price.getCumulativeCartItemPrice(allCartItems);
	    return event;
	  }
	  /**
	   *  Used to create the default coupon response, including the products
	   *  and tickets that got affected by the coupon action.
	   */


	  _cartEventCouponResponse(appliedCoupon, affected = []) {
	    // Create the default coupon event
	    const event = {
	      guid: appliedCoupon ? appliedCoupon.guid : null,
	      coupon: appliedCoupon ? appliedCoupon.item.coupon : null,
	      code: appliedCoupon ? appliedCoupon.item.code : '',
	      spend: appliedCoupon ? appliedCoupon.spend : 0,
	      products: [],
	      tickets: []
	    };

	    if (affected.length) {
	      // Used to make sure a ticket is only added to the affected tickets once,
	      // as the coupon might have affected multiple products in a single ticket
	      const affectedTickets = {};
	      forEach$2(affected, couponApplicable => {
	        event.products.push({
	          id: couponApplicable.product.id,
	          pricing: couponApplicable.product.pricing
	        });
	        const cartTicket = couponApplicable.ticket;

	        if (cartTicket && !affectedTickets[cartTicket.id]) {
	          event.tickets.push({
	            id: cartTicket.id,
	            pricing: cartTicket.pricing
	          });
	          affectedTickets[cartTicket.id] = cartTicket.id;
	        }
	      });
	    }

	    return event;
	  }
	  /**
	   *
	   *  Remove all cart items from the cart
	   *
	   *  Internally release all reservations
	   *
	   *  Resolves with true on success
	   *  Rejects with an array of all errors on failure
	   *
	   *  It waits for all actions to finish before the promise is settled.
	   *  Failures of actions do NOT abort the rest. Every action is waited upon
	   *
	   *  Coupon stats are updated automatically because it uses the internal
	   *  methods for removing tickets and/or products, which make sure to
	   *  update coupon stats accordingly
	   *
	   */


	  removeAllItems() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        // Holding all remove promises
	        const removePromises = []; // Collections of removed tickets and products per guid, so we are
	        // able to create and emit a single event for every ticket and product
	        // that got removed - because it might happen that a specific ticket or
	        // product got added/removed multiple times

	        const removedTickets = {};
	        const removedProducts = {};
	        forOwn(this.flatItems.tickets, cartTicket => {
	          // Ignore item if it is a child, as they will be handled by their parent(s)
	          if (cartTicket.childOf) {
	            return;
	          } // Create the ticket remove promise and save the removed cart ticket for creating the single remove event below


	          const removeTicketPromise = this._removeTicket(cartTicket.item.guid, cartTicket.id, false).then(() => {
	            removedTickets[cartTicket.item.guid] = removedTickets[cartTicket.item.guid] || [];
	            removedTickets[cartTicket.item.guid].push(cartTicket);
	            return true;
	          }, reason => {
	            return Promise.resolve(reason);
	          });

	          removePromises.push(removeTicketPromise);
	        });
	        forOwn(this.flatItems.products, cartProduct => {
	          // Ignore item if it is a child, as they will be handled by their parent(s)
	          if (cartProduct.childOf) {
	            return;
	          } // Create the product remove promise and save the removed cart product for creating the single remove event below


	          const removeProductPromise = this._removeProduct(cartProduct.item.guid, cartProduct.id, false).then(() => {
	            removedProducts[cartProduct.item.guid] = removedProducts[cartProduct.item.guid] || [];
	            removedProducts[cartProduct.item.guid].push(cartProduct);
	            return true;
	          }, reason => {
	            return Promise.resolve(reason);
	          });

	          removePromises.push(removeProductPromise);
	        });
	        const result = yield Promise.all(removePromises).then(results => {
	          // Make sure to recompute everything after all remove promises are settled
	          this._itemsUpdated(); // Ends the action and emits the checkout details


	          this._action(CartAction.End); // Create and emit a single remove event per ticket


	          forOwn(removedTickets, (removedTickets, ticketGuid) => {
	            const removedTicketsEvent = this._cartEventItemResponse(removedTickets[0].item, // The actual item of the ticket that got removed
	            removedTickets, CartItemChildType.Tickets);

	            this.emit(['ticket', ticketGuid, 'remove'], removedTicketsEvent);
	          }); // Create and emit a single remove event per ticket

	          forOwn(removedProducts, (removedProducts, productGuid) => {
	            const removedProductsEvent = this._cartEventItemResponse(removedProducts[0].item, // The actual item of the product that got removed
	            removedProducts, CartItemChildType.Products);

	            this.emit(['product', productGuid, 'remove'], removedProductsEvent);
	          }); // Check if one of the removes failed

	          const failures = results.filter(result => result !== true);

	          if (failures.length) {
	            console.error(failures);
	            return Promise.reject(failures);
	          }

	          return true;
	        });
	        this.emit(['empty'], null);
	        return result;
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'removeAllItems', 'error', 'failed']);
	      }
	    });
	  } // noinspection JSMethodCanBeStatic

	  /**
	   * Sanitize a coupon code by removing all whitespace
	   */


	  _sanitizeCouponCode(code) {
	    return code.replace(/\s/g, '');
	  }
	  /**
	   *  Used to apply a coupon. It makes sure to get the data of the coupon
	   *  based on his code and apply the corresponding discount(s), but only
	   *  when the coupon, or any other coupon, is not already applied.
	   */


	  addCoupon(code) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        const addedCouponEvent = yield this._addCoupon(code); // Only invoke the items updated method,
	        // when products actually got affected.
	        // This will also re-computes the checkout details.

	        if (addedCouponEvent.products.length > 0) {
	          this._doneUpdatingItems();
	        }

	        this._action(CartAction.End);

	        this.emit(['coupon', 'add', addedCouponEvent.code], addedCouponEvent);
	        const tickets = {};
	        forEach$2(addedCouponEvent.tickets, item => {
	          const cartTicket = this.flatItems.tickets[item.id];
	          tickets[cartTicket.item.guid] = tickets[cartTicket.item.guid] || {
	            ticket: cartTicket.item,
	            items: []
	          };
	          tickets[cartTicket.item.guid].items.push(cartTicket);
	        });
	        forOwn(tickets, cartTickets => {
	          this.emit(['ticket', cartTickets.ticket.guid, 'update'], this._cartEventItemResponse(cartTickets.ticket, cartTickets.items, CartItemChildType.Tickets));
	        });
	        const products = {};
	        forEach$2(addedCouponEvent.products, item => {
	          const cartProduct = this.flatItems.products[item.id];
	          products[cartProduct.item.guid] = products[cartProduct.item.guid] || {
	            product: cartProduct.item,
	            items: []
	          };
	          products[cartProduct.item.guid].items.push(cartProduct);
	        });
	        forOwn(products, cartProducts => {
	          this.emit(['product', cartProducts.product.guid, 'update'], this._cartEventItemResponse(cartProducts.product, cartProducts.items, CartItemChildType.Products));
	        });
	        return addedCouponEvent;
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'addCoupon', 'error', 'failed'], {
	          code
	        });
	      }
	    });
	  }
	  /**
	   *  Internally used to apply a coupon. It makes sure to get the data of the coupon
	   *  based on his code and apply the corresponding discount(s), but only
	   *  when the coupon, or any other coupon, is not already applied.
	   */


	  _addCoupon(code) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      // noinspection SuspiciousTypeOfGuard
	      if (typeof code !== 'string' || !code.length) {
	        throw new ShopError(`Cannot add coupon -> The provided code is invalid: ${code}`);
	      }

	      code = this._sanitizeCouponCode(code);
	      const appliedCoupons = Object.keys(this._coupons);

	      if (appliedCoupons.length) {
	        const appliedCoupon = this.getAppliedCoupon(code); // Just return the data of the coupon if it has already been applied
	        // with the number of affected items as zero - because no items
	        // got affected because it was already applied

	        if (appliedCoupon) {
	          return this._cartEventCouponResponse(appliedCoupon);
	        } // The current setup only supports the applying of a single coupon
	        // (!) Remove when multiple coupons are supported


	        throw this.log._create(LogLevel.Error, ['cart', 'addCoupon', 'error', 'multiple'], {
	          code,
	          existing_code: this._coupons[appliedCoupons[0]].item.code
	        });
	      }

	      let res;

	      try {
	        const url = this._config.getNoCacheUrl(`${this._config.guid}/coupon/${code}`);

	        res = yield this._config.httpClient.get(url);
	      } catch (error) {
	        if (error && error.response) {
	          if (error.response.status === 404) {
	            throw this.log._create(LogLevel.Warning, ['cart', 'addCoupon', 'error', 'notfound'], {
	              code
	            }, null, error, false);
	          } else if (error.response.status === 406) {
	            throw this.log._create(LogLevel.Warning, ['cart', 'addCoupon', 'error', 'notacceptable'], {
	              code
	            }, null, error, false);
	          }
	        }

	        throw this.log._create(LogLevel.Warning, ['cart', 'addCoupon', 'error', 'failed'], {
	          code
	        }, null, error);
	      }

	      const coupon = res.data; // Add the guid to it's inner data, because only the inner data is
	      // returned that will be returned in the event

	      coupon.coupon.guid = coupon.guid; // Create the applied coupon object for the added coupon

	      const appliedCoupon = {
	        guid: coupon.guid,
	        item: coupon,
	        appliedCount: 0,
	        appliedCounts: {},
	        appliesTo: {
	          cart: this._getCouponApplicableItems(coupon),
	          shop: []
	        },
	        spend: 0
	      }; // Add the coupon discounts, which returns the applicable items that actually got affected

	      const affectedItems = this._couponDiscounts(CouponAction.Add, appliedCoupon); // Also update the coupon discounts in the shop


	      this._shop._updateCouponDiscounts(CouponAction.Add, appliedCoupon); // Save it to the cart's coupons by guid, because a code
	      // is unique but might also contain special chars


	      this._coupons[coupon.guid] = appliedCoupon; // Return the data of the just added coupon and the number of items
	      // that got affected, which is equal to the applied count at this point

	      return this._cartEventCouponResponse(appliedCoupon, affectedItems);
	    });
	  }
	  /**
	   *  Used to add multiple coupons, based on an Array of coupon codes.
	   */


	  addCoupons(codes) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        const addCouponEvents = yield this._addCoupons(codes); // Ends the action and emits the checkout details

	        this._action(CartAction.End);

	        return addCouponEvents;
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'addCoupons', 'error', 'failed'], {
	          codes
	        });
	      }
	    });
	  }
	  /**
	   *  Used to add multiple coupons, based on an Array of coupon codes.
	   */


	  _addCoupons(codes) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      if (!Array.isArray(codes)) {
	        throw new ShopError(`Cannot add coupons -> The provided codes is not an Array: ${codes}`);
	      }

	      if (!codes.length) {
	        throw new ShopError('Cannot add coupons -> The provided codes Array is empty');
	      }

	      codes = codes.map(code => this._sanitizeCouponCode(code)); // Save every event for adding coupons

	      const addCouponEvents = []; // Check if any items got affected by the coupons

	      let affectedItems = false; // Add every coupon code

	      for (const code of codes) {
	        const addedCouponEvent = yield this._addCoupon(code);
	        this.emit(['coupon', 'add', code], addedCouponEvent);

	        if (addedCouponEvent.products.length > 0) {
	          affectedItems = true;
	        }

	        addCouponEvents.push(addedCouponEvent);
	      } // Only invoke the items updated method - which re-computes
	      // the checkout details - when items actually got
	      // affected, otherwise just end the action


	      if (affectedItems) {
	        this._itemsUpdated();
	      }

	      return addCouponEvents;
	    });
	  }
	  /**
	   *
	   *  Used to remove the coupon that belongs to the forwarded code.
	   *
	   *  @return remove coupon events that holds the data of the coupon
	   *  that got removed or null if no coupon was applied for the code
	   *
	   */


	  removeCoupon(code) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        const removeCouponEvent = yield this._removeCoupon(code); // Only invoke the items updated method,
	        // when products actually got affected.
	        // This will also re-computes the checkout details.

	        if (removeCouponEvent.products.length > 0) {
	          this._doneUpdatingItems();
	        }

	        this._action(CartAction.End);

	        this.emit(['coupon', 'remove', removeCouponEvent.code], removeCouponEvent);
	        const tickets = {};
	        forEach$2(removeCouponEvent.tickets, item => {
	          const cartTicket = this.flatItems.tickets[item.id];
	          tickets[cartTicket.item.guid] = tickets[cartTicket.item.guid] || {
	            ticket: cartTicket.item,
	            items: []
	          };
	          tickets[cartTicket.item.guid].items.push(cartTicket);
	        });
	        forOwn(tickets, cartTickets => {
	          this.emit(['ticket', cartTickets.ticket.guid, 'update'], this._cartEventItemResponse(cartTickets.ticket, cartTickets.items, CartItemChildType.Tickets));
	        });
	        const products = {};
	        forEach$2(removeCouponEvent.products, item => {
	          const cartProduct = this.flatItems.products[item.id];
	          products[cartProduct.item.guid] = products[cartProduct.item.guid] || {
	            product: cartProduct.item,
	            items: []
	          };
	          products[cartProduct.item.guid].items.push(cartProduct);
	        });
	        forOwn(products, cartProducts => {
	          this.emit(['product', cartProducts.product.guid, 'update'], this._cartEventItemResponse(cartProducts.product, cartProducts.items, CartItemChildType.Products));
	        });
	        return removeCouponEvent;
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'removeCoupon', 'error', 'failed'], {
	          code
	        });
	      }
	    });
	  }
	  /**
	   *  Internally used to remove the coupon that belongs to the forwarded code.
	   */


	  _removeCoupon(code) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      // noinspection SuspiciousTypeOfGuard
	      if (typeof code !== 'string' || !code.length) {
	        throw new ShopError(`Cannot remove coupon -> The provided code is invalid: ${code}`);
	      }

	      code = this._sanitizeCouponCode(code);
	      let appliedCoupon = this.getAppliedCoupon(code);

	      if (!appliedCoupon) {
	        return this._cartEventCouponResponse(null);
	      } // Remove the coupon discounts, which returns the applicable items that actually got affected


	      const affectedItems = this._couponDiscounts(CouponAction.Remove, appliedCoupon); // Delete the coupon after the discounts have been removed IN THE CART.
	      // The shop data is updated after removing the coupon,
	      // as otherwise recalculations (i.e. hidden values) are not handled properly.


	      delete this._coupons[appliedCoupon.item.guid]; // Also update the coupon discounts in the shop

	      this._shop._updateCouponDiscounts(CouponAction.Remove, appliedCoupon); // Return the event with the affected items


	      return this._cartEventCouponResponse(appliedCoupon, affectedItems);
	    });
	  }
	  /**
	   *  Used to remove multiple coupons, based on an Array of coupon codes.
	   */


	  removeCoupons(codes) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        const removeCouponEvents = yield this._removeCoupons(codes);

	        this._action(CartAction.End);

	        return removeCouponEvents;
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'removeCoupons', 'error', 'failed'], {
	          codes
	        });
	      }
	    });
	  }
	  /**
	   *  Used to remove multiple coupons, based on an Array of coupon codes.
	   */


	  _removeCoupons(codes) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      if (!Array.isArray(codes)) {
	        throw new ShopError(`Cannot remove coupons -> The provided codes is not an Array: ${codes}`);
	      }

	      if (!codes.length) {
	        throw new ShopError('Cannot remove coupons -> The provided codes Array is empty');
	      }

	      codes = codes.map(code => this._sanitizeCouponCode(code)); // Save every event for removing coupons

	      const removeCouponEvents = []; // Check if any items got affected by the coupons

	      let affectedItems = false; // Remove every coupon code

	      for (const code of codes) {
	        const removeCouponEvent = yield this._removeCoupon(code);
	        this.emit(['coupon', 'remove', code], removeCouponEvent);

	        if (removeCouponEvent.products.length > 0) {
	          affectedItems = true;
	        }

	        removeCouponEvents.push(removeCouponEvent);
	      } // Only invoke the items updated method - which ends the action including
	      // a re-computation of the checkout details - when items actually got
	      // affected, otherwise just end the action


	      if (affectedItems) {
	        this._itemsUpdated();
	      }

	      return removeCouponEvents;
	    });
	  }
	  /**
	   *  Used to get the data of an applied coupon, based on his code.
	   */


	  getAppliedCoupon(code) {
	    let appliedCoupon = undefined;
	    forOwn(this._coupons, ac => {
	      if (ac.item.code === code) {
	        appliedCoupon = ac;
	      }

	      return !appliedCoupon;
	    });
	    return appliedCoupon;
	  }
	  /**
	   *  Used to get the data of all applied coupons.
	   */


	  getAppliedCoupons() {
	    return this._coupons;
	  }
	  /**
	   *  Set the payment method for this order.
	   *
	   *  Optionally an issuer id can be provided to immediately set an issuer.
	   *
	   *  If the payment method is already set and equals the provided guid,
	   *  the item within the cart payment method is replaced,
	   *  but the cart payment method object is NOT replaced.
	   *  Because of this, this method can also be used to only update the issuer.
	   *
	   *  ```ts
	   *  const cartPaymentMethod: CartPaymentMethod = cart.setPaymentMethod(paymentMethod.guid);
	   *  const cartPaymentMethod: CartPaymentMethod = cart.setPaymentMethod(paymentMethod.guid, paymentMethod.issuers[0].id);
	   *  ```
	   *
	   *  | Error                                    | Reason                                                                                 |
	   *  | :--------------------------------------- | :------------------------------------------------------------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid payment method guid in shop data [ShopData](../interfaces/shopdata.html) |
	   *  |                                          | No or invalid issuer id in payment method [ShopData](../interfaces/shopdata.html)      |
	   */


	  setPaymentMethod(paymentMethodGuid, issuerId) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      this._action(CartAction.Start);

	      try {
	        const setPaymentMethodEvent = yield this._setPaymentMethod(paymentMethodGuid, issuerId);

	        this._action(CartAction.End);

	        this.emit(['payment_method', 'set', setPaymentMethodEvent.guid], setPaymentMethodEvent);
	        return setPaymentMethodEvent;
	      } catch (error) {
	        this._action(CartAction.End);

	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'setPaymentMethod', 'error', 'failed'], {
	          paymentMethodGuid,
	          issuerId
	        });
	      }
	    });
	  }
	  /**
	   *
	   *  Internally used for setting the payment method for this order.
	   *
	   *  @param paymentMethodGuid The guid of the payment method to set.
	   *  @param issuerId When a payment method has issuers, this is where to set them.
	   *
	   */


	  _setPaymentMethod(paymentMethodGuid, issuerId) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      // noinspection SuspiciousTypeOfGuard
	      if (typeof paymentMethodGuid !== 'string' || !Object.prototype.hasOwnProperty.call(this._data.payment_methods_map, paymentMethodGuid)) {
	        throw new ShopError(`Cannot set payment method -> No valid payment method guid provided: ${paymentMethodGuid}`);
	      }

	      const paymentMethod = this._data.payment_methods_map[paymentMethodGuid];

	      if (!paymentMethod.guid || paymentMethodGuid !== paymentMethod.guid) {
	        throw new ShopError(`Cannot set payment method -> Payment method does not have valid guid: ${paymentMethod.guid}`);
	      }

	      let issuer;

	      if (issuerId) {
	        issuer = paymentMethod.issuers.find(issuer => {
	          return issuer.id === issuerId;
	        });

	        if (!issuer) {
	          throw new ShopError(`Cannot set payment method -> Issuer ${issuerId} not part of payment method ${paymentMethod.guid}`);
	        }
	      } else if (this.paymentMethod && this.paymentMethod.item.guid === paymentMethod.guid) {
	        // This is to ensure we don't remove the issuer when the payment method is the same as the previous
	        issuer = this.paymentMethod.issuer;
	      } // The CartPaymentMethod itself is NOT overwritten.
	      // Only the values change, this is to support remembering settings for previously selected payment methods.
	      // Be carefull here! If any values are used in validation,
	      // make sure they will NOT FAIL validation after switching to another payment method!


	      this.paymentMethod.item = paymentMethod;
	      this.paymentMethod.issuer = issuer;
	      this.paymentMethod.is_stripe = !!paymentMethod.stripe;

	      this._computeCheckoutDetails();

	      return {
	        guid: paymentMethod.guid,
	        name: paymentMethod.name,
	        issuer: issuer,
	        pricing: paymentMethod.pricing
	      };
	    });
	  }
	  /**
	   *  Mount the stripe payment method elements.
	   *
	   *  Optionally card options can be provided.
	   *  These options are primarily used to style the input elements.
	   *
	   *  If the stripe card is already set,
	   *  the card is mounted (again), but the card object is NOT replaced.
	   *
	   *  | Error                                    | Reason                          |
	   *  | :--------------------------------------- | :------------------------------ |
	   *  | [ShopError](shoperror.html)              | Invalid payment method selected |
	   */


	  mountStripePaymentMethod(selector, options) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      if (!this.paymentMethod.item.stripe || !this.paymentMethod.item.stripe.stripe) {
	        throw this.log._create(LogLevel.Error, ['cart', 'mountStripePaymentMethod', 'error', 'initialized']);
	      }

	      const paymentMethod = this.paymentMethod;
	      const stripe = this.paymentMethod.item.stripe;

	      if (!stripe.card) {
	        // Create an instance of Elements.
	        const elements = stripe.stripe.elements(); // Create an instance of the card Element.

	        stripe.card = elements.create('card', options);
	        stripe.card.on('change', event => {
	          stripe.errors.splice(0, stripe.errors.length);
	          stripe.complete = false;

	          if (event.complete) {
	            // enable payment button
	            stripe.complete = true;
	            this.emit(['payment_method', 'change', paymentMethod.item.guid, 'stripe', 'complete'], true);
	          } else if (event.error) {
	            // show validation to customer
	            stripe.errors.push(event.error);
	            this.emit(['payment_method', 'change', paymentMethod.item.guid, 'stripe', 'error'], event.error);
	          }
	        });
	      }

	      return new Promise((resolve, reject) => {
	        const timeout = window.setTimeout(reject, 15000);
	        stripe.card.on('ready', () => {
	          this.emit(['payment_method', 'change', paymentMethod.item.guid, 'stripe', 'ready'], true);
	          window.clearTimeout(timeout);
	          resolve();
	        });
	        stripe.card.mount(selector);
	      });
	    });
	  }
	  /**
	   *  Finalize the payment method if applicable
	   *
	   *  | Error                                    | Reason                                      |
	   *  | :--------------------------------------- | :------------------------------------------ |
	   *  | [ShopError](shoperror.html)              | Invalid payment method. E.g.: Stripe failed |
	   */


	  finalizePaymentMethod() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      if (this.checkout_details.total_price === 0) {
	        this.log._create(LogLevel.Debug, ['cart', 'finalizePaymentMethod', 'free']);

	        return;
	      }

	      try {
	        yield this._finalizePaymentMethodStripe();
	      } catch (error) {
	        throw this.log._passThroughOrCreate(error, LogLevel.Error, ['cart', 'finalizePaymentMethod', 'error', 'stripe', 'error']);
	      }
	    });
	  }

	  _finalizePaymentMethodStripe() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      if (this.paymentMethod.item.stripe && this.paymentMethod.item.stripe.stripe && this.paymentMethod.item.stripe.card) {
	        delete this.paymentMethod.errors;
	        const stripeTokenResponse = yield this.paymentMethod.item.stripe.stripe.createToken(this.paymentMethod.item.stripe.card);

	        if (stripeTokenResponse.error) {
	          this.paymentMethod.errors = [stripeTokenResponse.error];
	          throw this.log._create(LogLevel.Error, ['cart', 'finalizePaymentMethod', 'error', 'stripe', 'error'], stripeTokenResponse.error);
	        } else if (!stripeTokenResponse.token) {
	          throw this.log._create(LogLevel.Error, ['cart', 'finalizePaymentMethod', 'error', 'stripe', 'token']);
	        }

	        this.paymentMethod.stripe_token = stripeTokenResponse.token;
	      }
	    });
	  }
	  /**
	   *  Agree to a specific or default terms.
	   *
	   *  Rejecting terms is only possible for named terms with the second argument
	   *
	   *  ```ts
	   *  const terms: { [key: string]: boolean } = cart.agreeToTerms();
	   *  const terms: { [key: string]: boolean } = cart.agreeToTerms('default');
	   *  const terms: { [key: string]: boolean } = cart.agreeToTerms('default', true);
	   *  const terms: { [key: string]: boolean } = cart.agreeToTerms('default', false);
	   *  ```
	   *
	   *  | Error                                    | Reason                                                                  |
	   *  | :--------------------------------------- | :---------------------------------------------------------------------- |
	   *  | [ShopError](shoperror.html)              | No or invalid terms id provided [ShopData](../interfaces/shopdata.html) |
	   */


	  agreeToTerms(termId = 'default', agree = true) {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      // noinspection SuspiciousTypeOfGuard
	      if (typeof termId !== 'string' || !Object.prototype.hasOwnProperty.call(this.terms, termId)) {
	        throw this.log._create(LogLevel.Error, ['cart', 'agreeToTerms', 'error', 'terms'], {
	          termId,
	          agree
	        });
	      }

	      this.terms[termId] = [true, 1, '1', 'true'].indexOf(agree) > -1;
	      const action = agree ? TermsActions.Accept : TermsActions.Reject;
	      this.emit(['terms', action, termId], this.terms);
	      return this.terms;
	    });
	  }
	  /**
	   *  Set the locale for the order.
	   *
	   *  This value will be send to the API.
	   *  E.g.: tickets can be rendered using the correct locale.
	   *
	   *  ```ts
	   *  cart.setLocale('en_GB');
	   *  ```
	   */


	  setLocale(locale) {
	    this.locale = locale;
	    setValidationLang(locale);

	    this._resetPriceFormatter();

	    this.emit(['locale'], locale);
	  }
	  /**
	   *  Update the price formatter
	   *
	   *  This method can be called when i.e. the locale changes
	   */


	  _resetPriceFormatter() {
	    const tryLocales = [this.locale, this.locale.replace('_', '-'), this.locale.substr(0, 2), 'en-GB'];
	    const localeStructures = Intl.NumberFormat.supportedLocalesOf(tryLocales.filter(locale => {
	      try {
	        Intl.NumberFormat.supportedLocalesOf(locale);
	        return true;
	      } catch (e) {
	        return false;
	      }
	    }));
	    return this._priceFormatter = new Intl.NumberFormat(localeStructures, {
	      style: 'currency',
	      currency: this._data.currency || 'EUR'
	    });
	  }
	  /**
	   *  Set extra arbitrary data to add to the place order call
	   */


	  setTechData(techData) {
	    this.techData = Object.assign(Object.assign({}, techData), this.techData);
	  }
	  /**
	   * Set the booker information and metadata from the outside
	   * @param data - the booker information
	   */


	  setBookerInformation(data) {
	    // TS does not allow for using a loop here, as the properties are not part
	    // of a map definition
	    if (data.firstname) {
	      this.booker.firstname.value = data.firstname;
	    }

	    if (data.lastname) {
	      this.booker.lastname.value = data.lastname;
	    }

	    if (data.email) {
	      this.booker.email.value = data.email;
	    } // Also set the dynamic metadata values, if provided


	    forEach$2(this.metadataList, cartMetadata => {
	      const value = data[cartMetadata.item.name] || data[cartMetadata.item.auto_fill_facebook];

	      if (value !== undefined && value !== null) {
	        cartMetadata.value = value;
	      }
	    });
	  }
	  /**
	   *  Send the order to the API.
	   *
	   *  Before the request will be attempted, the cart structure and values will be validated.
	   *  If validation fails, a ShopError will be thrown.
	   *
	   *  The cart content will then be formatted to the data format the API expects,
	   *  before sending the order to the API.
	   *
	   *  ```ts
	   *  const orderResponse: PlaceOrderResponse = await cart.placeOrder();
	   *  ```
	   *
	   *  | Error                                    | Reason                                                          |
	   *  | :--------------------------------------- | :-------------------------------------------------------------- |
	   *  | [ShopError](shoperror.html)              | A validation failure is encountered                             |
	   *  | [OrderApiError](orderapierror.html)      | The API rejects the data, some precondition or validation fails |
	   *  | [ApiError](apierror.html)                | The API encountered an unexpected error                         |
	   */


	  placeOrder() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      try {
	        const response = yield this._placeOrder();
	        this.emit(['order', 'placed'], response); // TODO @Rik decide on path/payload
	        // TODO @Rik Should we transform the response here?

	        return response;
	      } catch (error) {
	        throw this.log._passThroughOrCreate(error, LogLevel.Fatal, ['cart', 'placeOrder', 'error', 'failed']);
	      }
	    });
	  }

	  _placeOrder() {
	    return __awaiter$1(this, void 0, void 0, function* () {
	      if (this.checkout_details.busy) {
	        throw this.log._create(LogLevel.Debug, ['cart', 'placeOrder', 'error', 'busy']);
	      }

	      const validation = this.validator.all();

	      if (!validation.valid) {
	        throw this.log._create(LogLevel.Warning, ['cart', 'placeOrder', 'error', 'validation'], {
	          errors: validation.errors
	        });
	      }

	      const seatsOptions = this.seatsioInstance && this.seatsioInstance.holdToken ? {
	        holdToken: this.seatsioInstance.holdToken
	      } : undefined;
	      const ticketOptions = Object.values(this.flatItems[CartItemChildType.Tickets]);
	      const productOptions = Object.values(this.flatItems[CartItemChildType.Products]).filter(cartProduct => !cartProduct.childOf);
	      const couponOptions = Object.values(this._coupons);
	      const orderbuilderOptions = {
	        // Required, static booker info
	        booker: {
	          bookerInfo: this.booker,
	          locale: this.locale
	        },
	        // The tickets and global products
	        // Tickets have nested products
	        // Tickets and (global) products have nested metadata
	        tickets: ticketOptions,
	        products: productOptions,
	        // Dynamic booker info / shop level metadata
	        metaData: this.metadataList,
	        // Shop level seats info (like hold token, used to verify/book the seats from the API)
	        seats: seatsOptions,
	        // Chosen payment method and needed info
	        paymentMethod: this.paymentMethod,
	        // Applied coupon(s), note: currently only one coupon supported.
	        coupons: couponOptions,
	        cartInitAt: this._initAt,
	        extraTechData: this.techData
	      };
	      return yield this._orderbuilder.handle(orderbuilderOptions);
	    });
	  } // noinspection JSUnusedGlobalSymbols

	  /**
	   *  Listener for changes on the checkout details
	   */


	  onCheckoutDetails(cb) {
	    // TODO @Rik Is this method actually used??
	    //  It seems a bit useless as the other events do not have a quick access like this?
	    //  Maybe add something like this to the event emitter constructor??
	    //  `this.on.prototype.checkoutDetails = (cb: EventCallback) => eventEmitter.on.call(eventEmitter, [ 'checkout' ], cb);`
	    //  That way we could call `cart.on.checkoutDetails(() => {})`, without bloating the cart ??
	    this.on(['checkout'], cb);
	  }
	  /**
	   *  Remove any metadata no longer used by the global products in the cart.
	   */


	  _checkRemovedProductMetadata(metadataCollection) {
	    const metadataRemove = {};
	    forEach$2(metadataCollection, metadata => {
	      if (metadata.item.applies_to !== 'person') {
	        return;
	      }

	      metadataRemove[metadata.guid] = metadata;
	    }); // If there are multiple (active) roads to Rome, Rome should not be destroyed.
	    // In this case, the shop-metadata pivot

	    forEach$2(this._data.booker_metadata, metadata => {
	      delete metadataRemove[metadata.guid];
	    }); // In this case other products.

	    forOwn(this.flatItems[CartItemChildType.Products], cartProduct => {
	      // Ignore ticket products
	      if (cartProduct.childOf) {
	        return;
	      }

	      forEach$2(cartProduct.item.metadata, metadata => {
	        // Ignore product metadata
	        if (metadata.item.applies_to !== 'person') {
	          return;
	        }

	        delete metadataRemove[metadata.guid];
	      });
	    }); // Actually remove the metadata from the cart

	    forOwn(metadataRemove, (metadata, metadataId) => {
	      delete this.metadata[metadataId];
	      const listIndex = this.metadataList.findIndex(cartMetadata => cartMetadata.item.guid === metadata.guid);

	      if (listIndex > -1) {
	        this.metadataList.splice(listIndex, 1);
	      }
	    }); // TODO Emit ???
	  }
	  /**
	   *  Update the reservation interval
	   *
	   *  This creates an interval if one does not exist yet and there are items in the cart.
	   *  This clears the interval if one already exists and there are no items in the cart (anymore).
	   *
	   *  This method can be called with a cart item id that will be ignored (e.g. an item that will be removed).
	   *  However note that right now this does not ignore it's child items.
	   *
	   *  When setting a new interval,
	   *  the expiration date is set and the interval is started to update every 100ms.
	   *  The interval updates depending on the current time,
	   *  so it won't fluctuate depending on interval trigger rates of the client.
	   *  The interval is therefore triggered every 100 milliseconds to ensure the reservation time is not jittery.
	   */


	  _updateReservationTimer(removingCartItemId) {
	    const hasTickets = 0 < Object.keys(this.flatItems.tickets).filter(cartItemId => cartItemId !== removingCartItemId).length;
	    const hasProducts = 0 < Object.keys(this.flatItems.products).filter(cartItemId => cartItemId !== removingCartItemId).length;
	    const hasItems = hasTickets || hasProducts;
	    const reservationTickerHandle = this._reservationTicker;
	    const reservationTimeMs = this._reservationTime * 60000;

	    if (hasItems && this._reservationTime && !reservationTickerHandle) {
	      this.reservationExpiration.date = new Date(Date.now() + reservationTimeMs);

	      this._updateRelativeReservationExpirationValues();

	      this._reservationTicker = window.setInterval(this._updateRelativeReservationExpirationValues.bind(this), 100);
	      window.clearInterval(reservationTickerHandle);
	      this.emit(['timer', 'start'], this.reservationExpiration, true);
	    } else if (reservationTickerHandle && !hasItems) {
	      // noinspection SuspiciousTypeOfGuard
	      const isTimeout = typeof this.reservationExpiration.secondsRemaining === 'number' && this.reservationExpiration.secondsRemaining <= 0;
	      this.reservationExpiration.date = null;
	      this.reservationExpiration.secondsRemaining = null;
	      this._reservationTicker = undefined;
	      window.clearInterval(reservationTickerHandle);
	      this.emit(['timer', 'clear'], Object.assign(Object.assign({}, this.reservationExpiration), {
	        timeout: isTimeout
	      }), true);
	    }
	  }
	  /**
	   *  Update the relative reservation expiration value
	   *
	   *  This is mostly called by the reservation interval (every 100 milliseconds)
	   *
	   *  The seconds remaining value is updates depending on the current time,
	   *  so it won't fluctuate depending on interval trigger rates of the client.
	   *  When the seconds remaining value hits zero, the interval (if it exists) is cleared,
	   *  the values reset and all cart items removed (reservations released).
	   */


	  _updateRelativeReservationExpirationValues() {
	    if (!this.reservationExpiration.date) {
	      throw slugError('Invalid reservation expiration date value', ['cart', '_updateRelativeReservationExpirationValues', 'error', 'date']);
	    }

	    this.reservationExpiration.secondsRemaining = Math.max(0, Math.floor((this.reservationExpiration.date.getTime() - Date.now()) / 1000));
	    this.emit(['timer', 'tick'], this.reservationExpiration, true);

	    if (this.reservationExpiration.secondsRemaining < 1) {
	      // noinspection JSIgnoredPromiseFromCall
	      this.removeAllItems();

	      this._updateReservationTimer();
	    }
	  }
	  /**
	   *  Used to get the cart items to which a specific forwarded coupon
	   *  applies, making use of the coupon logic.
	   *
	   *  @return a sorted Array of items on which the forwarded coupon
	   *  applies, descending from the most expensive
	   */


	  _getCouponApplicableItems(coupon) {
	    /**
	     *  Used to get the cart ticket of the cart product to which the coupon
	     *  applies, as used by the Coupon.getApplicableItems method.
	     *
	     *  (i) It doesn't have a ticket when it's about a global product
	     */
	    const getTicketOfCartProduct = cartProduct => {
	      return cartProduct.childOf ? this.flatItems.tickets[cartProduct.childOf] : undefined;
	    };

	    return Coupon.getApplicableItems(coupon, this.flatItems.products, getTicketOfCartProduct);
	  }
	  /**
	   *
	   *  Used for adding or removing the discount of a coupon on all applicable
	   *  items, taking the applies_to_count and amount_override into account.
	   *
	   *  @return The affected coupon applicable items.
	   *
	   */


	  _couponDiscounts(action, coupon) {
	    const affectedApplicableItems = [];

	    if (!coupon) {
	      return [];
	    }

	    if (!enumIncludes(CouponType, coupon.item.coupon.type)) {
	      throw new ShopError(`Cannot ${action} coupon -> Unknown coupon type: ${coupon.item.coupon.type}`);
	    }

	    if (!coupon.appliesTo.cart.length) {
	      return [];
	    } // Do not start applying the discounts when the max has been reached, or do
	    // not start removing discounts when it was not applied to any products


	    if (action === CouponAction.Add && coupon.appliedCount === coupon.item.applies_to_count || action === CouponAction.Update && coupon.appliedCount === coupon.item.applies_to_count || action === CouponAction.Remove && coupon.appliedCount === 0) {
	      return [];
	    }

	    forEach$2(coupon.appliesTo.cart, couponApplicable => {
	      Coupon.applyDiscount(coupon, action, couponApplicable);
	      affectedApplicableItems.push(couponApplicable); // Break the adding of discounts when the max has been reached, or break
	      // the removing of discounts if all applied discounts were removed

	      return action === CouponAction.Remove ? !(coupon.appliedCount === 0) : !(coupon.appliedCount === coupon.item.applies_to_count);
	    });
	    return affectedApplicableItems;
	  }
	  /**
	   *  Used to check if a coupon was applied on a product that got removed,
	   *  making sure to lower the applied count and the spend amount of the
	   *  coupon if so - keeping the stats of an applied coupon up to date.
	   */


	  _checkRemovedProductCoupons(cartProduct) {
	    forOwn(cartProduct.pricing.coupons, (delta, guid) => {
	      this._coupons[guid].appliedCount--;
	      this._coupons[guid].appliedCounts[cartProduct.item.pricing.base_price] = this._coupons[guid].appliedCounts[cartProduct.item.pricing.base_price] || 0;
	      this._coupons[guid].appliedCounts[cartProduct.item.pricing.base_price]--;
	      this._coupons[guid].spend -= delta;
	    });
	  }
	  /**
	   *
	   *  Used to make sure the discount of a coupon has been distributed correctly
	   *  among the coupon applicable products, making sure it's still correct
	   *  when a product got added or removed.
	   *
	   *  (!) The re-computation of the prices is invoked in the _itemsUpdated()
	   *  method, because it should have invoked this method for every applied
	   *  coupon before recomputing the prices.
	   *
	   *  It returns the updated models,
	   *  so the _itemsUpdated() method can emit events AFTER recomputing prices.
	   *
	   */


	  _checkCouponDiscounts(coupon) {
	    // Because the method for getting the coupon applicable items sorts them,
	    // the products on which it should be applied first are on top
	    coupon.appliesTo.cart = this._getCouponApplicableItems(coupon.item);
	    const cartItemsUpdated = {
	      tickets: {},
	      products: {}
	    };

	    const collectUpdatedItems = couponApplicable => {
	      if (couponApplicable.ticket) {
	        cartItemsUpdated.tickets[couponApplicable.ticket.item.guid] = couponApplicable.ticket.item;
	      } else {
	        cartItemsUpdated.products[couponApplicable.product.item.guid] = couponApplicable.product.item;
	      }
	    };

	    forEach$2(coupon.appliesTo.cart, (couponApplicable, index) => {
	      const applicable = index + 1 <= coupon.item.applies_to_count;
	      const applied = typeof couponApplicable.product.pricing.coupons[coupon.item.guid] === 'number';

	      if (applicable) {
	        if (!applied) {
	          Coupon.applyDiscount(coupon, CouponAction.Add, couponApplicable);
	          collectUpdatedItems(couponApplicable);
	        }
	      } else if (applied) {
	        Coupon.applyDiscount(coupon, CouponAction.Remove, couponApplicable);
	        collectUpdatedItems(couponApplicable);
	      }
	    });

	    this._shop._updateCouponDiscounts(CouponAction.Update, coupon);

	    this.emit(['coupon', CouponAction.Update, coupon.item.code], this._cartEventCouponResponse(coupon));
	    return cartItemsUpdated;
	  }
	  /**
	   *  Used to reset an applied coupon; resetting his applied count and
	   *  amount spend and recomputing the applicable items for the cart.
	   */


	  _resetCoupon(coupon) {
	    coupon.appliedCount = 0;
	    coupon.appliedCounts = {};
	    coupon.spend = 0;
	    coupon.appliesTo.cart = this._getCouponApplicableItems(coupon.item);
	  }
	  /**
	   *  Used to notify the cart if an action (adding a ticket, adding a product) started or ended,
	   *  so the checkout details / cart can become pending while actions are pending and we
	   *  can block the place order call if actions are pending.
	   */


	  _action(action) {
	    // Update the count of pending actions accordingly
	    this._pendingActions += action === CartAction.Start ? 1 : -1; // There might be multiple actions pending

	    this.checkout_details.busy = this._pendingActions > 0; // Always emit the checkout details when an action is triggered

	    this._emitCheckoutDetails();
	  }
	  /**
	   *  Invoked every time the items in the cart updated. It
	   *  updates the reservation timer accordingly, checks the
	   *  coupons, recomputes the pricing of all items in the cart
	   *  and builds and emits the checkout details.
	   */


	  _itemsUpdated() {
	    /**
	     *  The reservation time should not change when removing child reservations
	     *  [_addProductToTicket() and _removeProductFromTicket()]. However, in case
	     *  this ever changes in the future, the update method is called here anyway.
	     */
	    this._updateReservationTimer();

	    const updatedCartItems = {
	      tickets: {},
	      products: {}
	    }; // Check the coupon discounts

	    forOwn(this._coupons, coupon => {
	      const {
	        tickets,
	        products
	      } = this._checkCouponDiscounts(coupon);

	      updatedCartItems.tickets = Object.assign(Object.assign({}, updatedCartItems.tickets), tickets);
	      updatedCartItems.products = Object.assign(Object.assign({}, updatedCartItems.products), products);
	    }); // Recomputes the cart item pricing and
	    // recomputes and emit the checkout details

	    const {
	      tickets,
	      products
	    } = this._doneUpdatingItems();

	    updatedCartItems.tickets = Object.assign(Object.assign({}, updatedCartItems.tickets), tickets);
	    updatedCartItems.products = Object.assign(Object.assign({}, updatedCartItems.products), products); // Emit updates for changed tickets

	    forOwn(updatedCartItems.tickets, (ticket, guid) => {
	      if (!this.items[ticket.event_id] || !this.items[ticket.event_id][CartItemChildType.Tickets].map[guid]) {
	        return;
	      }

	      this.emit(['ticket', guid, 'update'], this._cartEventItemResponse(ticket, Object.values(this.items[ticket.event_id][CartItemChildType.Tickets].map[guid]), CartItemChildType.Tickets));
	    }); // Emit updates for changed products

	    forOwn(updatedCartItems.products, (product, guid) => {
	      const collection = this.items[product.event_id] ? this.items[product.event_id][CartItemChildType.Products] : this.orphanedGlobalProducts;

	      if (!collection.map[guid]) {
	        return;
	      }

	      this.emit(['product', guid, 'update'], this._cartEventItemResponse(product, Object.values(collection.map[guid]), CartItemChildType.Products));
	    });
	  }
	  /**
	   *  Used to compute the actual (new) pricing of products and tickets in the cart when
	   *  the updating of items is done taking any applied coupons into account, as discounts
	   *  are applied to the pricing object of the item immediately.
	   */


	  _doneUpdatingItems() {
	    // Used by the Price's computeItemsPricing method to collect the
	    // products of the ticket for which it is computing the pricing
	    const getProductsOfTicket = cartTicket => {
	      return cartTicket.products.collection;
	    };

	    const updated = Price.computeItemsPricing(this.flatItems.products, this.flatItems.tickets, getProductsOfTicket);

	    this._computeCheckoutDetails();

	    const cartItemsUpdated = {
	      tickets: {},
	      products: {}
	    };
	    forEach$2(updated.tickets, ticket => {
	      cartItemsUpdated.tickets[ticket.item.guid] = ticket.item;
	    });
	    forEach$2(updated.products, product => {
	      cartItemsUpdated.products[product.item.guid] = product.item;
	    });
	    return cartItemsUpdated;
	  }
	  /**
	   *  Used to compute the checkout details of the cart based
	   *  on his current items, taking tickets and both regular
	   *  as container products into account.
	   */


	  _computeCheckoutDetails() {
	    // Always compute the checkout details from zero
	    const checkoutDetails = {
	      vats: {
	        percentages: {},
	        total: 0
	      },
	      subtotal_price: 0,
	      payment_method_fee: 0,
	      total_price: 0,
	      // Actual pending is being set below to prevent race conditions
	      busy: true
	    }; // Save global container products for adding their pricing
	    // last, as they apply on the order in its entirety

	    const containerProducts = []; // Add the numbers of every ticket that currently is in the cart

	    forOwn(this.flatItems.tickets, cartTicket => {
	      checkoutDetails.total_price += cartTicket.pricing.total_price;
	      checkoutDetails.subtotal_price += cartTicket.pricing.subtotal_price;
	      forOwn(cartTicket.pricing.including_vats.percentages, (amount, percentage) => {
	        Price.updateVATCollection(VATUpdateAction.Add, checkoutDetails.vats, percentage, amount);
	      });
	    }); // Add the numbers of every global product that currently is in the cart

	    forOwn(this.flatItems.products, cartProduct => {
	      // A global product does not have a parent
	      if (cartProduct.childOf !== undefined) {
	        return;
	      } // Save the (global) container products for adding last


	      if (cartProduct.item.pricing_method === PricingMethod.Container) {
	        containerProducts.push(cartProduct);
	        return;
	      }

	      checkoutDetails.total_price += cartProduct.pricing.total_price;
	      checkoutDetails.subtotal_price += cartProduct.pricing.subtotal_price;
	      Price.updateVATCollection(VATUpdateAction.Add, checkoutDetails.vats, cartProduct.pricing.vat.percentage, cartProduct.pricing.vat.amount);
	    }); // Add the container products, of which the pricing applies to the total order price

	    if (containerProducts.length) {
	      const originalOrderPrice = checkoutDetails.total_price;
	      forEach$2(containerProducts, cartProduct => {
	        // Recompute the total prices of the product based on his container price (the order)
	        // (i) It's ok if it becomes zero because the order price is zero
	        Price.computeProductPricing(cartProduct.pricing, originalOrderPrice); // Add his newly computed pricing to the checkout details

	        checkoutDetails.total_price += cartProduct.pricing.total_price;
	        checkoutDetails.subtotal_price += cartProduct.pricing.subtotal_price;
	        Price.updateVATCollection(VATUpdateAction.Add, checkoutDetails.vats, cartProduct.pricing.vat.percentage, cartProduct.pricing.vat.amount);
	      });
	    } // Always (re)compute the payment method fees, as it will
	    // also reset them to zero if the cart became empty


	    this._computePaymentMethodFees(checkoutDetails); // Add the fees of a payment method if there is something to pay
	    // for in the cart and a payment method has been set


	    if (checkoutDetails.total_price > 0 && this.paymentMethod) {
	      checkoutDetails.payment_method_fee = this.paymentMethod.item.pricing.total_fees;
	      checkoutDetails.total_price += checkoutDetails.payment_method_fee;
	    } // Expose and emit the computed values


	    this.checkout_details.vats.percentages = checkoutDetails.vats.percentages;
	    this.checkout_details.vats.total = checkoutDetails.vats.total;
	    this.checkout_details.payment_method_fee = checkoutDetails.payment_method_fee;
	    this.checkout_details.subtotal_price = checkoutDetails.subtotal_price;
	    this.checkout_details.total_price = checkoutDetails.total_price;
	    this.checkout_details.busy = this._pendingActions > 0;
	  }
	  /**
	   *  Computes the total fees, based on the current total price
	   *  of the order, for every available payment method fee.
	   */


	  _computePaymentMethodFees(checkoutDetails) {
	    for (const paymentMethod of this._data.payment_methods) {
	      paymentMethod.pricing.total_fees = 0; // Fees only apply if there is something to pay for in the cart

	      if (checkoutDetails.total_price === 0) {
	        continue;
	      }

	      paymentMethod.pricing.total_fees += paymentMethod.pricing.fees.fixed;
	      paymentMethod.pricing.total_fees += Math.ceil(checkoutDetails.total_price * paymentMethod.pricing.fees.percentage / 100);
	    }
	  }
	  /**
	   *  Emit the checkout details
	   *  (i) Emit the value instead of the ref to prevent race conditions
	   */


	  _emitCheckoutDetails() {
	    this.emit('checkout', JSON.parse(JSON.stringify(this.checkout_details)));
	  }
	  /**
	   *  Format a price in cents to the correct currency format
	   */


	  _formatPrice(cents) {
	    if (typeof cents !== 'number') {
	      cents = Number.parseFloat(cents);
	    }

	    if (Number.isNaN(cents)) {
	      return '???';
	    }

	    return this._priceFormatter.format(cents / 100);
	  }
	  /**
	   *  Register the on unload event handlers, so reservations CAN be released on window close.
	   */


	  _registerOnUnload() {
	    window.addEventListener('unload', this._unloadHandler.bind(this));
	  }
	  /**
	   *  Handler method factory for onunload event. The returned handler will try to release any reservations when closing the window.
	   *
	   *  Note: There is no fail-proof way to do this, as browser implementations
	   *  do not always allow processes to finish after DOM unload.
	   *  However, the this method uses the FETCH API with keepalive,
	   *  which SHOULD in theory allow the request to exist without its parent
	   *  or anything waiting for its response.
	   */


	  _unloadHandler() {
	    // IE (and some other ancient browsers) do not implement the Fetch API.
	    // For those browsers we will silently fail, as this is accepted behaviour.
	    if (!window.fetch) {
	      return;
	    }

	    const releaseCbFactory = type => {
	      return cartItem => {
	        if (cartItem.childOf) {
	          // Ignore children, as they will be released with the parent anyway, no need to waste cycles.
	          return true;
	        } // noinspection JSIgnoredPromiseFromCall


	        this._reservator.releaseOnUnload(type, cartItem.item.guid, cartItem.reservation.reservation);
	      };
	    };

	    forOwn(this.flatItems.tickets, releaseCbFactory(ReservationType.Ticket));
	    forOwn(this.flatItems.products, releaseCbFactory(ReservationType.Product));
	  }

	}
	/**
	 *  This function will create the default booker info collection.
	 *
	 *  A booker info collection is a collection of metadata like objects
	 *  that are used for fixed/forced order data that require
	 *  input from the user and should be validated.
	 *  The booker info interface is designed so it can be used easily
	 *  with the same methods used for regular metadata.
	 */

	function factoryBookerCartMetadata(emailValidationRule) {
	  // TODO Figure out real translatable name -> this property should hold already translated name ??
	  // TODO Add _slug for translation slug -> so translations can be done on the fly (for both shopdata metadata & 'fake metadata')
	  const emailValidationRules = ['required', 'email'];

	  if (emailValidationRule) {
	    emailValidationRules.push(emailValidationRule);
	  }

	  return {
	    firstname: {
	      item: {
	        name: 'first_name',
	        extra: ['required'],
	        type: MetadataType.String,
	        auto_fill_facebook: 'first_name',
	        translateName: 'shop.common.metaData.first_name',
	        translatable: true
	      },
	      value: null,
	      errors: [],
	      index: -3
	    },
	    lastname: {
	      item: {
	        name: 'last_name',
	        extra: ['required'],
	        type: MetadataType.String,
	        auto_fill_facebook: 'last_name',
	        translateName: 'shop.common.metaData.last_name',
	        translatable: true
	      },
	      value: null,
	      errors: [],
	      index: -2
	    },
	    email: {
	      item: {
	        name: 'email',
	        extra: emailValidationRules,
	        type: MetadataType.String,
	        auto_fill_facebook: 'email',
	        translateName: 'shop.common.metaData.email',
	        translatable: true
	      },
	      value: null,
	      errors: [],
	      index: -1
	    }
	  };
	}
	/**
	 *  Calculate the difference to the next valid count for a ticket,
	 *  from the given current ticket count.
	 *
	 *  This method is needed due to the constraints on tickets.
	 *  These constraints should be adhered to even when reserving/releasing ticket reservations.
	 *
	 *  Any diff returned will result in both constraints being valid:
	 *  1) (currentTicketCount + d) % increment === 0
	 *  2) (currentTicketCount + d) === 0 || (currentTicketCount + d) > min
	 *
	 *  Depending on the sign of direction, this can either be a positive or negative diff.
	 */

	function calculateTicketDiff(currentTicketCount, min, increment, direction = 1) {
	  let diffToNext;

	  if (direction > 0) {
	    // When direction is positive:
	    // First calculate closest multiple of increment bigger than current
	    const quotient = Math.floor(currentTicketCount / increment);
	    const next = (quotient + 1) * increment;
	    diffToNext = next - currentTicketCount;

	    if (next < min) {
	      const tooLow = min - next;
	      const tooLowQuotient = Math.ceil(tooLow / increment);
	      diffToNext += tooLowQuotient * increment;
	    }
	  } else {
	    // When direction is negative
	    // First calculate closest multiple of increment smaller than current
	    const quotient = Math.ceil(currentTicketCount / increment);
	    diffToNext = currentTicketCount - (quotient - 1) * increment;

	    if (currentTicketCount - diffToNext < min) {
	      // When next ticket count is less than minimum,
	      // The next step should be zero.
	      diffToNext = currentTicketCount;
	    }
	  }

	  return diffToNext;
	}

	/**
	 *  Used to extend to and create a new typed cart item instance that holds all shared data for the state of the cart item.
	 */

	class CartItem {
	  /**
	   *  Constructing a new cart item creates the basic cart item instance,
	   *  this should (and can) only be used by calling `super()` in an inherited constructor
	   *
	   *  #### Possible errors
	   *  One type of error could be thrown while initializing a cart item.
	   *
	   *  | Error                                    | Reason                                                                          |
	   *  | :--------------------------------------- | :------------------------------------------------------------------------------ |
	   *  | [ShopError](shoperror.html)              | A (child) reservation is not recognized [Reservation](../interfaces/cart.html)  |
	   */
	  constructor(data, item, reservation, childOf, seatInfo) {
	    /**
	     *  Optional parent id
	     *
	     *  @category Cart
	     */
	    this.childOf = undefined;
	    /**
	     *  Optional parent item id
	     *
	     *  @category Cart
	     */

	    this.childOfItemId = undefined;
	    /**
	     *  The children of the cart item.
	     *  E.g.: (Optional) products in a ticket
	     *
	     *  @category Cart
	     */

	    this.children = {};
	    /**
	     *  The metadata (answers) for the current level of cart item(s)
	     *
	     *  @category Cart
	     */

	    this.metadata = {};
	    this.metadataList = [];
	    this.data = data;
	    this.item = item;
	    this.reservation = reservation;

	    if (childOf) {
	      this.childOf = childOf.id;
	      this.childOfItemId = childOf.item.guid;
	    }

	    if (seatInfo) {
	      this.seatsInfo = seatInfo;
	    }

	    this.id = this._setId(); // Ensure the children collection exists for holding his
	    // child reservations (products) in case of a cart ticket

	    if (CartTicket.isCartTicket(this)) {
	      this.children[CartItemChildType.Products] = {
	        map: {},
	        collection: []
	      };
	    } // Process any child reservations if present


	    this._processChildReservations(reservation.childReservations);
	  }
	  /**
	   *  Recompute the unique (temporary) identifier for the cart item
	   */


	  _setId() {
	    return this.id = `${this.item.guid}-${this.reservation.reservation}`;
	  }
	  /**
	   *  Determine if the given object is a cart item.
	   *  Optionally a (specific) type can be specified
	   */


	  static isCartItem(cartItem, type) {
	    if (!cartItem || typeof cartItem.getType !== 'function') {
	      return false;
	    }

	    if (type) {
	      return cartItem.getType() === type;
	    }

	    return enumIncludes(CartItemType, cartItem.getType());
	  }
	  /**
	   *  Process any child reservations
	   *
	   *  Child reservations are nested reservation in a reservation response.
	   *  E.g.: When reserving a ticket, the API might decide that required products should also be returned.
	   *  These products then don't have to be reserved separately (which they would have to be, as they are required).
	   *  This also holds for (soft required) product groups.
	   *  When a product group has a minimum, returning a 'best guess' child reservation
	   *  will (on average) limit the reservation calls.
	   *
	   *  #### Possible errors
	   *  One type of error could be thrown while processing product child reservations.
	   *
	   *  | Error                                    | Reason                                                                         |
	   *  | :--------------------------------------- | :----------------------------------------------------------------------------- |
	   *  | [ShopError](shoperror.html)              | A (child) reservation is not recognized [Reservation](../interfaces/cart.html) |
	   */


	  _processChildReservations(childReservations) {
	    if (!childReservations) {
	      return {};
	    } // Only products are currently processed, even though the structure supports other child-cart-items.
	    // (i) Once others are added to the backend it should be fairly easy to implement here as well


	    const productChildReservations = childReservations[ReservationType.Product] || {};
	    forOwn(productChildReservations, (reservations, childId) => {
	      this._processProductChildReservation(childId, ...reservations);
	    }); // When the child reservation response holds any unsupported reservation types,
	    // an error is logged to the console to mitigate hard to debug behaviour

	    forEach$2(Object.keys(childReservations), reservationType => {
	      // Currently only products are supported, use the following check if also tickets are supported
	      // !enumIncludes<string>(ReservationType, reservationType)
	      if (reservationType !== ReservationType.Product && Object.prototype.hasOwnProperty.call(childReservations, reservationType)) {
	        // TODO: Should we log this some other way, instead / in addition ??
	        // eslint-disable-next-line no-console
	        console.error(`Child reservation of type ${reservationType} ignored`);
	      }
	    });
	    return this.children;
	  }
	  /**
	   *  Add the product cart items for the given id and (child) reservations
	   *
	   *  #### Possible errors
	   *  One type of error could be thrown while processing product child reservations.
	   *
	   *  | Error                                    | Reason                                                                         |
	   *  | :--------------------------------------- | :----------------------------------------------------------------------------- |
	   *  | [ShopError](shoperror.html)              | A (child) reservation is not recognized [Reservation](../interfaces/cart.html) |
	   */


	  _processProductChildReservation(childId, ...reservations) {
	    // When the childId is invalid, the (child) reservations can not be added.
	    if (!Object.prototype.hasOwnProperty.call(this.data.products_map, childId)) {
	      throw new ShopError(`Unrecognized child reservation, invalid guid ${childId}`);
	    }

	    const product = this.data.products_map[childId]; // Because we are processing child reservations here we need to ensure there is a collection for them

	    const childCollection = this.children[CartItemChildType.Products] = this.children[CartItemChildType.Products] || {
	      map: {},
	      collection: []
	    }; // Also save the added cart products in an Array to return, so
	    // we only return the now created/added child products

	    const addedChildren = []; // Ensure the (reserved) product's map exist in the children
	    // collection to be able to add it to the map below

	    childCollection.map[childId] = childCollection.map[childId] || {}; // Create a cart product for every child (reservation) and add it to the children collection(s)

	    forEach$2(reservations, reservation => {
	      const cartItem = new CartProduct(this.data, product, reservation, this); // Add the item to both the map and the collection

	      childCollection.map[childId][cartItem.id] = cartItem;
	      childCollection.collection.push(cartItem);
	      addedChildren.push(cartItem);
	    });
	    return addedChildren;
	  }

	}
	/**
	 *  Used to create a new ticket cart item instance that holds all data for the state of the ticket cart item.
	 */


	class CartTicket extends CartItem {
	  /**
	   *  Constructing a new ticket cart item creates the cart item instance.
	   *
	   *  When product child reservations are included, these products can contain
	   *  metadata that should be applied on the ticket.
	   *  Those (cart) metadata are added to the ticket iff they are not present yet.
	   *  If the metadata is already present (e.g.: because multiple products add the same metadata),
	   *  it will be ignored. The alternative would be overwriting existing metadata,
	   *  which could result in losing already filled in values.
	   *
	   *  #### Possible errors
	   *  One type of error could be thrown while initializing a ticket cart item.
	   *
	   *  | Error                                    | Reason                                                                          |
	   *  | :--------------------------------------- | :------------------------------------------------------------------------------ |
	   *  | [ShopError](shoperror.html)              | A (child) reservation is not recognized [Reservation](../interfaces/cart.html)  |
	   */
	  constructor(data, ticket, reservation, childOf, seatInfo) {
	    super(data, ticket, reservation, childOf, seatInfo); // Work with a copy of the original pricing in the cart to not alter the
	    // item's original pricing, as coupons get applied on this pricing object

	    this.pricing = JSON.parse(JSON.stringify(Object.assign(Object.assign({}, ticket.pricing), {
	      coupons: {},
	      coupons_count: {}
	    }))); // Create a shortcut to the cart ticket's products (which are
	    // his children), which have been created/set in his super

	    this.products = this.children[CartItemChildType.Products]; // Save his original min price as it's needed for recomputing his pricing

	    this.min_price = this.item.min_price; // Only add the metadata if the ticket's personalization should
	    // not be later, because the buyer doesn't need to enter the
	    // metadata now if it should be personalized later

	    if (!ticket.late_personalization) {
	      forOwn(this.products.map, products => {
	        forOwn(products, product => {
	          addMetadataFromProduct(product.item, this.metadata, this.metadataList, MetadataAppliesTo.Person);
	        });
	      });
	    }
	  }
	  /**
	   *  Retrieve the cart item type
	   */


	  getType() {
	    return CartItemType.Ticket;
	  }
	  /**
	   *  Determine if the given object is a cart ticket
	   */


	  static isCartTicket(cartItem) {
	    return CartItem.isCartItem(cartItem, CartItemType.Ticket);
	  }
	  /**
	   *  Remove any metadata no longer used by the global products in the cart.
	   */


	  _checkRemovedProductMetadata(metadataCollection) {
	    const metadataRemove = {};
	    forEach$2(metadataCollection, metadata => {
	      if (metadata.item.applies_to !== MetadataAppliesTo.Person) {
	        return;
	      }

	      metadataRemove[metadata.guid] = metadata;
	    }); // If there are multiple (active) roads to Rome, Rome should not be destroyed.
	    // In this case other products.

	    forOwn(this.products.map, cartProducts => {
	      forOwn(cartProducts, cartProduct => {
	        forEach$2(cartProduct.item.metadata, metadata => {
	          // Ignore product metadata
	          if (metadata.item.applies_to !== MetadataAppliesTo.Person) {
	            return;
	          }

	          delete metadataRemove[metadata.guid];
	        });
	      });
	    }); // Actually remove the metadata from the cart

	    forOwn(metadataRemove, (metadata, metadataId) => {
	      delete this.metadata[metadataId];
	      const listIndex = this.metadataList.findIndex(cartMetadata => cartMetadata.item.guid === metadata.guid);

	      if (listIndex > -1) {
	        this.metadataList.splice(listIndex, 1);
	      }
	    }); // TODO Emit ???
	  }

	}
	/**
	 *  Used to create a new product cart item instance that holds all data for the state of the product cart item.
	 */


	class CartProduct extends CartItem {
	  /**
	   *  Constructing a new product cart item creates the cart item instance,
	   *
	   *  A product can have metadata that is applied to the product itself
	   *  or on the parent (e.g.: ticket).
	   *  Here only the metadata applied to the product is processed.
	   *  Any metadata applied to the parent will be handled by the parent
	   *  when adding this cart product to the parent.
	   *
	   *  #### Possible errors
	   *  One type of error could be thrown while initializing a product cart item.
	   *
	   *  | Error                                    | Reason                                                                          |
	   *  | :--------------------------------------- | :------------------------------------------------------------------------------ |
	   *  | [ShopError](shoperror.html)              | A (child) reservation is not recognized [Reservation](../interfaces/cart.html)  |
	   */
	  constructor(data, product, reservation, childOf) {
	    super(data, product, reservation, childOf); // If the product is optional for the ticket to which it's added,
	    // which defaults to true if it doesn't belong to a ticket

	    this.is_optional = true; // Work with a copy of the original pricing in the cart to not alter the
	    // item's original pricing, as coupons get applied on this pricing object

	    this.pricing = JSON.parse(JSON.stringify(product.pricing)); // Set the optional state of the product

	    this.setOptional(); // Only add the metadata if it's about a global product or
	    // if the product's ticket should not be personalized later

	    const addMetadata = !childOf || CartTicket.isCartTicket(childOf) && !childOf.item.late_personalization;

	    if (addMetadata) {
	      addMetadataFromProduct(product, this.metadata, this.metadataList, MetadataAppliesTo.Product);
	    }
	  }
	  /**
	   *  Used to compute the optional state of a cart product. It is always optional
	   *  by default, but becomes required if the product is part of a ticket and it's
	   *  located in the tickets' required products collection.
	   */


	  setOptional() {
	    this.is_optional = true;

	    if (!this.childOfItemId) {
	      return;
	    }

	    const ticket = this.data.tickets_map[this.childOfItemId];

	    if (!ticket) {
	      return;
	    }

	    forEach$2(ticket.products.required, ticketProduct => {
	      if (ticketProduct.item.guid === this.item.guid) {
	        return this.is_optional = false;
	      }
	    });
	  }
	  /**
	   *  Retrieve the cart item type
	   */


	  getType() {
	    return CartItemType.Product;
	  }
	  /**
	   *  Determine if the given object is a cart product
	   */


	  static isCartProduct(cartItem) {
	    return CartItem.isCartItem(cartItem, CartItemType.Product);
	  }

	}

	/**
	 *  Logic that is used to cast the needed data in a specific model.
	 */
	/**
	 *  Used for casting a value to a valid date. The method returns the original
	 *  value if it could not be casted to a valid date object.
	 */

	function castDate(value) {
	  if (!value || value instanceof Date) {
	    return value;
	  }

	  const parsed = Date.parse(value);
	  return !isNaN(parsed) ? new Date(value) : value;
	}

	function event(event) {
	  event.status_until = castDate(event.status_until);
	  event.start = castDate(event.start);
	  event.end = castDate(event.end);
	}
	function eventDate(eventDate) {
	  eventDate.start = castDate(eventDate.start);
	  eventDate.end = castDate(eventDate.end);
	}
	function ticket(ticket) {
	  ticket.available_from = castDate(ticket.available_from);
	  ticket.available_until = castDate(ticket.available_until);
	}
	/**
	 *  Used for casting a collection of models.
	 */

	function castMultiple(models, method) {
	  forOwn(models, method);
	}

	function events(events) {
	  castMultiple(events, event);
	}
	function eventDates(eventDates) {
	  castMultiple(eventDates, eventDate);
	}
	function tickets(tickets) {
	  castMultiple(tickets, ticket);
	}

	/**
	 *  Model related logic, including the getting of a model out of a collection, adding
	 *  it to a collection (once) and casting all it's date properties.
	 */
	/**
	 *  Consts which can be provided as fourth param to the getFrom method
	 *  for getting the value of a model or a ref to the model.
	 */

	const GET_BY_VALUE = true;
	const GET_BY_REF = false;
	/**
	 *  Const which can be provided as fifth param to the getFrom method
	 *  for not throwing an error when a model could not be found.
	 */

	const IGNORE_UNDEFINED = true;
	var Model = {
	  /**
	   *
	   *  Used to get the reference or value of a model out of the provided data object.
	   *
	   *  @param data Object that holds all the data out of which the model should be get
	   *  @param key The key of the collection within the data out of which the model should be get
	   *  @param guid The guid of the model to get
	   *  @param value If the value of the model should be get, instead of a reference
	   *  @param ignoreUndefined If the method should throw an error if the model could not be found
	   *
	   */
	  getFrom(data, key, guid, value = false, ignoreUndefined = false) {
	    if (!data[key]) {
	      throw slugError(`The provided data does not contain the key ${key}`, ['model', 'getFrom', 'error', 'invalid'], {
	        key
	      });
	    }

	    let _models = [];

	    let _model; // Create a local Array with model references, as the data to get
	    // the model out of can be provided as an Array or Object


	    if (Array.isArray(data[key])) {
	      _models = data[key];
	    } else {
	      forOwn(data[key], model => {
	        _models.push(model);
	      });
	    }

	    forEach$2(_models, model => {
	      if (model.guid === guid) {
	        _model = model;
	      }

	      return !_model;
	    });

	    if (!_model) {
	      // Do not throw an error when undefined models should be ignored
	      if (ignoreUndefined) {
	        return undefined;
	      }

	      throw slugError(`No model in ${key} with guid: ${guid}`, ['model', 'getFrom', 'error', 'notfound'], {
	        key,
	        guid
	      });
	    } // Return the value if requested
	    // noinspection PointlessBooleanExpressionJS


	    return value === true ? JSON.parse(JSON.stringify(_model)) : _model;
	  },

	  /**
	   *
	   *  Used to add a model reference to a collection (once); because it may happen that a specific
	   *  model is returned out of the API more than once.
	   *
	   *  @param collection An Array of the models or a guid map Object of the models
	   *  @param model Any type of model, **must include a guid to check his uniqueness**
	   *
	   */
	  addTo(collection, model) {
	    if (!model.guid) {
	      throw new ShopError(`The model to add to a collection must have a guid: ${model}`);
	    }

	    if (Array.isArray(collection)) {
	      if (!collection.length) {
	        collection.push(model);
	        return;
	      }

	      let alreadyAdded = false;
	      forEach$2(collection, collectionModel => {
	        if (collectionModel.guid === model.guid) {
	          alreadyAdded = true;
	          return false;
	        }
	      });

	      if (!alreadyAdded) {
	        collection.push(model);
	      }

	      return;
	    }

	    if (typeof collection === 'object') {
	      // Currently Object.assign is used to make sure only top level values are
	      // overwritten and underlaying refs are broken, because it's behaviour we
	      // want at this moment: every linked model in a model is added to the
	      // updated model again after it's updated in the collection
	      collection[model.guid] = collection[model.guid] ? Object.assign(collection[model.guid], model) : model;
	      return;
	    }

	    throw new ShopError(`The collection to add a model to should be an Array or Object: ${collection}`);
	  },

	  /**
	   *  Simplied interface for casting the needed data in a
	   *  single or collection of a specific model.
	   */
	  castData: {
	    ofEvent: event,
	    ofEvents: events,
	    ofEventDate: eventDate,
	    ofEventDates: eventDates,
	    ofTicket: ticket,
	    ofTickets: tickets
	  }
	};

	/**
	 *  @internal Provide this constant as 4th param to the
	 *  computeTicketBasePrice method to ignore optional.
	 */
	const IGNORE_OPTIONAL = true;
	/**
	 *  @internal Action to use to update an applied VAT amount in a VAT collection.
	 */

	var VATUpdateAction;

	(function (VATUpdateAction) {
	  VATUpdateAction["Add"] = "add";
	  VATUpdateAction["Subtract"] = "subtract";
	})(VATUpdateAction || (VATUpdateAction = {}));

	/**
	 *  Possible type of an event.
	 */
	var EventType;

	(function (EventType) {
	  EventType[EventType["Once"] = 0] = "Once";
	  EventType[EventType["Repeating"] = 1] = "Repeating";
	})(EventType || (EventType = {}));
	/**
	 *  Possible status of an event.
	 */


	var EventStatus;

	(function (EventStatus) {
	  EventStatus["Unavailable"] = "unavailable";
	  EventStatus["Available"] = "available";
	  EventStatus["Sold_out"] = "sold_out";
	  EventStatus["Refunding"] = "refunding";
	  EventStatus["Moving"] = "moving";
	})(EventStatus || (EventStatus = {}));
	/**
	 *  The possible types of a product.
	 */


	var ProductType;

	(function (ProductType) {
	  ProductType[ProductType["Normal"] = 0] = "Normal";
	  ProductType[ProductType["Varying"] = 1] = "Varying";
	})(ProductType || (ProductType = {}));
	/**
	 *  The possible methods of a product.
	 */


	var ProductMethod;

	(function (ProductMethod) {
	  ProductMethod["BookingProtect"] = "bookingProtect";
	})(ProductMethod || (ProductMethod = {}));
	/**
	 *  The possible pricing methods of a product.
	 */


	var PricingMethod;

	(function (PricingMethod) {
	  PricingMethod["Own"] = "own";
	  PricingMethod["Container"] = "container";
	})(PricingMethod || (PricingMethod = {}));
	/**
	 *  Type of the product group. This value translates
	 *  to the type of input that shops will render for
	 *  selecting the products in this group.
	 */


	var ProductGroupType;

	(function (ProductGroupType) {
	  ProductGroupType["Required"] = "required";
	  ProductGroupType["Optional"] = "optional";
	  ProductGroupType["Select"] = "select";
	  ProductGroupType["Radio"] = "radio";
	  ProductGroupType["Multiselect"] = "multiselect";
	  ProductGroupType["Checkbox"] = "checkbox";
	})(ProductGroupType || (ProductGroupType = {}));
	/**
	 *  The possible types of event selection.
	 */


	var EventSelection;

	(function (EventSelection) {
	  EventSelection["Auto"] = "auto";
	  EventSelection["Enabled"] = "enabled";
	  EventSelection["Disabled"] = "disabled";
	})(EventSelection || (EventSelection = {}));
	/**
	 *  Status values of the OpenTicketBase class
	 */


	var State;

	(function (State) {
	  State["Start"] = "start";
	  State["Initializing"] = "initializing";
	  State["Waiting"] = "waiting";
	  State["Loading"] = "loading";
	  State["Ready"] = "ready";
	  State["Error"] = "error";
	})(State || (State = {}));

	/**
	 *  @internal Provide this constant as 4th param to
	 *  the createPricingDetails method to add a single
	 *  VAT object instead of a collection to the
	 *  pricing details.
	 */

	const SINGLE_VAT = false;
	/**
	 *  @internal The default pricing properties in a
	 *  pricing details object. Used to loop in the
	 *  code below.
	 */

	const PRICING_DETAILS_DATA = ['base_price', 'total_fees', 'subtotal_price', 'total_price'];
	/**
	 *  All pricing logic. (!) Used for both the shop and the cart.
	 */

	var Price = {
	  /**
	   *  Used to create a pricing details object. A (global)
	   *  product has one (self), but a ticket is built up by
	   *  three: self, children own and children container.
	   *
	   *  (i) Details can either contain data of a single VAT
	   *  (only applicable for the self) or a VAT collection,
	   *  holding every applied VAT in it.
	   */
	  createPricingDetails(basePrice = 0, vatPercentage = 0, VATCollection = true) {
	    // Both type of details hold the default pricing details
	    const details = {
	      base_price: basePrice,
	      total_fees: 0,
	      subtotal_price: basePrice,
	      total_price: basePrice
	    };

	    if (VATCollection) {
	      details.including_vats = {
	        percentages: {},
	        total: 0
	      };
	    } else {
	      details.vat = {
	        percentage: vatPercentage,
	        amount: 0
	      };
	    }

	    return details;
	  },

	  /**
	   *  Used to create a default pricing object.
	   *  (i) Used for (global) products and as base for tickets
	   */
	  createPricing(basePrice, fees, vatPercentage = 0) {
	    const pricing = this.createPricingDetails(basePrice, vatPercentage, SINGLE_VAT);
	    return Object.assign(Object.assign({
	      fees
	    }, pricing), {
	      coupons: {}
	    });
	  },

	  /**
	   *  Used to create a ticket's pricing object, which contains more
	   *  than a product's pricing because the pricing of a ticket is
	   *  computed based on multiple pricing details.
	   */
	  createTicketPricing(basePrice, fees, vatPercentage = 0) {
	    // Start with a default pricing object
	    const pricing = this.createPricing(basePrice, fees, vatPercentage);
	    /**
	     *  Extend the pricing with a self which holds the pricing details of himself,
	     *  because the total computed pricing details are saved top level. Also extend
	     *  it with a collection for the including VATS and the coupon counts and an
	     *  object that holds the pricing details of his children.
	     */

	    pricing.self = this.createPricingDetails(basePrice, vatPercentage, SINGLE_VAT);
	    pricing.including_vats = {
	      percentages: {},
	      total: 0
	    };
	    pricing.coupons_count = {};
	    pricing.children = {
	      own: this.createPricingDetails(),
	      container: this.createPricingDetails()
	    };
	    return pricing;
	  },

	  /**
	   *
	   *  Used to compute the pricing of a ticket. Based on required and/or
	   *  optional products and taking his min price and applied coupons into
	   *  account. Also builds the VAT collection based on the products that
	   *  are used for the ticket and setting the highest VAT amount of his
	   *  most expensive required product (if is has a value) as his own.
	   *
	   *  (!) The VAT amounts of the (ticket) products of a ticket must be
	   *  computed before executing this method, as the fees and VATs of
	   *  products are used for computation.
	   *
	   *  Returns true if the pricing has changed!
	   *
	   */
	  computeTicketPricing(ticketPricing, ticketMinPrice, products, ignoreOptional = false) {
	    const hash = () => [ticketPricing.base_price, ticketPricing.total_fees, ticketPricing.subtotal_price, ticketPricing.total_price].toString();

	    const beforeHash = hash(); // Reset the pricing to always build up the pricing from zeros

	    this.resetTicketPricing(ticketPricing); // Subdivide all the products of the ticket in optional
	    // and required for more easy further processing

	    let ticketProducts = {
	      all: products,
	      optional: [],
	      required: []
	    };
	    forEach$2(products, product => {
	      ticketProducts[product.is_optional ? 'optional' : 'required'].push(product);
	    }); // Use the min price of the ticket if provided

	    ticketPricing.self.base_price = ticketMinPrice || 0; // Save container products for adding their pricing last, as
	    // they apply on the ticket's base price in its entirety

	    const containerProducts = []; // Fn for adding a (ticket) product to the pricing of the ticket

	    const addProductToPricing = product => {
	      const productPricing = product.pricing;
	      /**
	       *  The pricing and the fees of optional products are
	       *  added to the children's pricing because they are
	       *  separate from the ticket, as where required products
	       *  actually become the ticket pricing
	       */

	      if (product.is_optional) {
	        ticketPricing.children.own.base_price += productPricing.base_price;
	        ticketPricing.children.own.total_fees += productPricing.total_fees;
	        ticketPricing.children.own.subtotal_price += productPricing.subtotal_price;
	        ticketPricing.children.own.total_price += productPricing.total_price;
	        this.updateVATCollection(VATUpdateAction.Add, ticketPricing.children.own.including_vats, productPricing.vat.percentage, productPricing.vat.amount);
	        return;
	      } // Required product


	      if (productPricing.base_price > 0) {
	        // The sum of the base and sub prices of required
	        // products become the prices of the ticket itself
	        ticketPricing.self.base_price += productPricing.base_price; // The ticket's VAT percentage becomes equal to the VAT percentage
	        // of his most expensive required product (that has a value)

	        ticketPricing.self.vat.percentage = Math.max(ticketPricing.self.vat.percentage, productPricing.vat.percentage);
	      }
	    };
	    /**
	     *  The base price of a ticket should only be computed based on his
	     *  required products if the API did not send back a min price.
	     *
	     *  Coupons are applied on product level, so to also let coupons apply
	     *  on tickets with a min price returned by the API we should subtract
	     *  the coupon discounts of the ticket's min price.
	     */


	    if (typeof ticketMinPrice !== 'number') {
	      // The ticket's VAT percentage becomes equal to the VAT percentage
	      // of his most expensive required product (that has a value) in
	      // the addProductToPricing method above
	      ticketPricing.self.vat.percentage = 0;
	      forEach$2(ticketProducts.required, ticketProduct => {
	        if (ticketProduct.item.pricing_method === PricingMethod.Container) {
	          containerProducts.push(ticketProduct);
	          return;
	        }

	        addProductToPricing(ticketProduct);
	      });
	    } else if (ticketPricing.self.base_price > 0) {
	      forEach$2(ticketProducts.required, product => {
	        forOwn(product.pricing.coupons, couponDelta => {
	          ticketPricing.self.base_price -= couponDelta;
	          return ticketPricing.self.base_price > 0;
	        });
	        return ticketPricing.self.base_price > 0;
	      });
	      ticketPricing.self.base_price = Math.max(0, ticketPricing.self.base_price);
	    }
	    /**
	     *  Compute the total fees based on the computed base price at this point
	     *  or reset to zero because fees do not apply on free tickets.
	     */


	    if (ticketPricing.self.base_price > 0) {
	      ticketPricing.self.total_fees += ticketPricing.fees.fixed;
	      ticketPricing.self.total_fees += Math.ceil(ticketPricing.self.base_price * ticketPricing.fees.percentage / 100);
	    } else {
	      ticketPricing.self.total_fees = 0;
	    }
	    /**
	     *  Compute the total price, VAT amount and subtotal at this point, because
	     *  the VAT amount should be computed based on either his out of the API
	     *  returned min_price plus fees, or his computed min price (based on
	     *  his required products) plus fees.
	     */


	    ticketPricing.self.total_price = ticketPricing.self.base_price + ticketPricing.self.total_fees;
	    ticketPricing.self.vat.amount = Math.ceil(ticketPricing.self.vat.percentage * ticketPricing.self.total_price / (100 + ticketPricing.self.vat.percentage));
	    ticketPricing.self.subtotal_price = ticketPricing.self.total_price - ticketPricing.self.vat.amount;
	    forEach$2(ticketProducts.optional, product => {
	      if (product.item.pricing_method === PricingMethod.Container) {
	        containerProducts.push(product);
	        return;
	      } // The price of the optional products is only added when not ignored


	      if (!ignoreOptional) {
	        addProductToPricing(product);
	      }
	    }); // Add the container products details last, because their pricing applies to the total ticket price

	    if (containerProducts.length) {
	      // Recompute the total prices of the product based on his container
	      // price (the ticket) before adding his fees and VAT to the ticket
	      // (i) It's ok if it becomes zero because the ticket price is zero
	      const originalTicketPrice = ticketPricing.self.total_price + ticketPricing.children.own.total_price;
	      forEach$2(containerProducts, product => {
	        this.computeProductPricing(product.pricing, originalTicketPrice);

	        if (ignoreOptional && product.is_optional) {
	          return;
	        } // Only use the recomputed total fees, subtotal and total price of the product
	        // (!) The base price is ignored for container products


	        ticketPricing.children.container.total_fees += product.pricing.total_fees;
	        ticketPricing.children.container.subtotal_price += product.pricing.subtotal_price;
	        ticketPricing.children.container.total_price += product.pricing.total_price;
	        this.updateVATCollection(VATUpdateAction.Add, ticketPricing.children.container.including_vats, product.pricing.vat.percentage, product.pricing.vat.amount);
	      });
	    } // Compute his totals based on the computed details


	    this.computeTicketTotal(ticketPricing);
	    return beforeHash !== hash();
	  },

	  /**
	   *  Used for resetting the pricing of a ticket, happening every time
	   *  the pricing of a ticket should be computed to make sure the
	   *  values are being computed from zero.
	   */
	  resetTicketPricing(ticketPricing) {
	    forEach$2(PRICING_DETAILS_DATA, dataProp => {
	      ticketPricing[dataProp] = 0;
	    });
	    ticketPricing.including_vats = {
	      percentages: {},
	      total: 0
	    };
	    ticketPricing.self = this.createPricingDetails(ticketPricing.self.base_price, ticketPricing.self.vat.percentage, SINGLE_VAT);
	    ticketPricing.children.own = this.createPricingDetails();
	    ticketPricing.children.container = this.createPricingDetails();
	  },

	  /**
	   *  Compute a ticket's total pricing by summing every pricing
	   *  details (self, own and container children) of the ticket.
	   */
	  computeTicketTotal(ticketPricing) {
	    const details = [ticketPricing.children.own, ticketPricing.children.container]; // Add the details of himself to the ticket's totals

	    forEach$2(PRICING_DETAILS_DATA, dataProp => {
	      ticketPricing[dataProp] += ticketPricing.self[dataProp];
	    });
	    this.updateVATCollection(VATUpdateAction.Add, ticketPricing.including_vats, ticketPricing.self.vat.percentage, ticketPricing.self.vat.amount); // Add the details of the children to the ticket's totals

	    forEach$2(details, detail => {
	      forEach$2(PRICING_DETAILS_DATA, dataProp => {
	        ticketPricing[dataProp] += detail[dataProp];
	      });
	      forOwn(detail.including_vats.percentages, (amount, percentage) => {
	        this.updateVATCollection(VATUpdateAction.Add, ticketPricing.including_vats, percentage, amount);
	      });
	    });
	  },

	  /**
	   *  Used to compute the total prices of a product's pricing object.
	   *
	   *  Returns true if the pricing was changed.
	   */
	  computeProductPricing(pricing, containerPrice) {
	    const hash = () => [pricing.vat.amount, pricing.base_price, pricing.subtotal_price, pricing.total_fees, pricing.total_price].toString();

	    const beforeHash = hash(); // Use the container price for computation if forwarded

	    const price = typeof containerPrice === 'number' ? containerPrice : pricing.base_price;

	    if (typeof containerPrice === 'number') {
	      // Force price to 0 when container pricing method is used see DD-API-271B
	      pricing.base_price = 0;
	    } // Ignore fees and reset totals to zero when the price is zero
	    // (i) The VAT and fees do not apply on a free ticket, product or container item


	    if (price === 0) {
	      pricing.vat.amount = 0;
	      pricing.subtotal_price = 0;
	      pricing.total_fees = 0;
	      pricing.total_price = 0;
	      return beforeHash !== hash();
	    } // Compute the total fees


	    pricing.total_fees = pricing.fees.fixed;
	    pricing.total_fees += Math.ceil(price * pricing.fees.percentage / 100); // The VAT is already included in the base price

	    pricing.total_price = pricing.base_price + pricing.total_fees; // The VAT amount should be subtracted out of the fees in case of a
	    // container pricing and out of the total price by default

	    const amountThatIncludesVAT = pricing[containerPrice ? 'total_fees' : 'total_price'];
	    pricing.vat.amount = Math.ceil(pricing.vat.percentage * amountThatIncludesVAT / (100 + pricing.vat.percentage)); // Compute the subtotal price

	    pricing.subtotal_price = pricing.total_price - pricing.vat.amount;
	    return beforeHash !== hash();
	  },

	  /**
	   *
	   *  Used to compute the pricing of the forwarded products and tickets, as
	   *  used for both regular products and tickets from the shop and cart product
	   *  and cart tickets from the cart.
	   *
	   *  (i) As the location of the products of a ticket differs per type
	   *  of ticket, a method for retrieving them must be forwarded.
	   *
	   */
	  computeItemsPricing(products, tickets, getProductsOfTicket, ignoreOptional = false) {
	    const cartItemsUpdated = {
	      tickets: [],
	      products: []
	    };
	    forOwn(products, product => {
	      if (this.computeProductPricing(product.pricing)) {
	        cartItemsUpdated.products.push(product);
	      }
	    });
	    forOwn(tickets, ticket => {
	      if (this.computeTicketPricing(ticket.pricing, ticket.min_price, getProductsOfTicket(ticket), ignoreOptional)) {
	        cartItemsUpdated.tickets.push(ticket);
	      }
	    });
	    return cartItemsUpdated;
	  },

	  /**
	   *  Calculate the cumulative pricing object for an array of cart items.
	   */
	  getCumulativeCartItemPrice(items) {
	    const pricing = items.map(item => item.pricing);
	    return {
	      base_price: lodash.exports.sumBy(pricing, 'base_price'),
	      total_fees: lodash.exports.sumBy(pricing, 'total_fees'),
	      subtotal_price: lodash.exports.sumBy(pricing, 'subtotal_price'),
	      total_price: lodash.exports.sumBy(pricing, 'total_price')
	    };
	  },

	  /**
	   *  Used to update the amount of a specific VAT percentage in a collection
	   *  of VAT amounts. Meaning it simply adds or subtracts the forwarded amount
	   *  to/from the right percentage key in the forwarded collection and
	   *  adds/subtracts the amount of the total.
	   */
	  updateVATCollection(action, collection, percentage, amount) {
	    const percentageKey = String(percentage);
	    collection.percentages[percentageKey] = typeof collection.percentages[percentageKey] === 'number' ? collection.percentages[percentageKey] : 0; // Revert the amount if it's about subtracting

	    amount = action === VATUpdateAction.Add ? amount : -amount; // Update the collection

	    collection.percentages[percentageKey] += amount;
	    collection.total += amount; // Remove the prop when there is no amount of VAT
	    // applied for this percentage (anymore)

	    if (collection.percentages[percentageKey] === 0) {
	      delete collection.percentages[percentageKey];
	    }
	  }

	};

	/**
	 *  @internal Keys that are used for the pivot maps
	 */
	const PIVOTS_KEY_EVENTS_TICKETS = 'events-tickets';
	const PIVOTS_KEY_PRODUCTS_METADATA = 'products-metadata';
	const PIVOTS_KEY_PRODUCTS_TICKETS = 'products-tickets';
	const PIVOTS_KEY_PRODUCTS_EVENT_DATES = 'products-eventDates';
	const PIVOTS_KEY_SHOPS_COLLAPSES = 'shops-collapses';
	const PIVOTS_KEY_SHOPS_METADATA = 'shops-metadata';
	const PIVOTS_KEY_SHOPS_PRODUCTS = 'shops-products'; // Global products

	const PIVOTS_KEY_SHOPS_TICKETS = 'shops-tickets';
	const PIVOTS_KEY_SHOPS_PAYMENT_METHODS = 'shops-paymentmethods';
	const PIVOTS_KEY_TICKETS_GROUPS = 'tickets-groups';
	const PIVOTS_KEY_GROUPS_PRODUCTS = 'groups-products';
	/**
	 *  @internal Type of sorting of pivots.
	 */

	var OrderType;

	(function (OrderType) {
	  OrderType["Incremental"] = "incremental";
	  OrderType["LinkedList"] = "linkedlist";
	  OrderType["SternBrocot"] = "sternbrocot";
	})(OrderType || (OrderType = {}));

	let visitedGuids = {};
	/**
	 *  Used to set an incremental index if either the preceding or
	 *  computed index sequence seems to be broken / incorrect.
	 */

	function setIncrementalIndexes(items) {
	  let index = 0;

	  const setIndex = item => {
	    item.index = index++;
	  }; // Set the index of every item in the collection


	  if (Array.isArray(items)) {
	    forEach$2(items, setIndex);
	  } else {
	    forOwn(items, setIndex);
	  }
	}
	/**
	 *  Filter the original pivots to remove all pivots
	 *  which have the key from key name present in the new pivots.
	 *
	 *  @param originalPivots
	 *  @param newPivots
	 *  @param keyName
	 */


	function filterFromOneSide(originalPivots, newPivots, keyName) {
	  if (!newPivots) {
	    return originalPivots || [];
	  }

	  const newPivotsArray = Object.values(newPivots);

	  if (!originalPivots) {
	    return newPivotsArray;
	  }

	  const newGroupedPivots = {};
	  forEach$2(newPivotsArray, pivot => {
	    newGroupedPivots[pivot[keyName]] = true;
	  });
	  const filteredList = originalPivots.filter(pivot => {
	    return !newGroupedPivots[pivot[keyName]];
	  });
	  filteredList.push(...newPivotsArray);
	  return filteredList;
	}
	/**
	 *  All pivot logic.
	 */


	class Pivot {
	  constructor() {
	    // Holder of a reference to the original shop data pivots
	    this._pivots = {};
	  }
	  /**
	   *  Used to set a reference to the original shop data's pivots,
	   *  so the pivot methods can easily access it.
	   */


	  setPivots(newPivots) {
	    if (!newPivots) {
	      throw new ShopError('The provided pivots are undefined');
	    } // Ensure objects are converted to arrays
	    // and only tuples with parent guids from the new pivot tuples are replaced.


	    this._pivots[PIVOTS_KEY_EVENTS_TICKETS] = filterFromOneSide(this._pivots[PIVOTS_KEY_EVENTS_TICKETS], newPivots[PIVOTS_KEY_EVENTS_TICKETS], 'event_guid');
	    this._pivots[PIVOTS_KEY_PRODUCTS_METADATA] = filterFromOneSide(this._pivots[PIVOTS_KEY_PRODUCTS_METADATA], newPivots[PIVOTS_KEY_PRODUCTS_METADATA], 'product_guid');
	    this._pivots[PIVOTS_KEY_PRODUCTS_TICKETS] = filterFromOneSide(this._pivots[PIVOTS_KEY_PRODUCTS_TICKETS], newPivots[PIVOTS_KEY_PRODUCTS_TICKETS], 'ticket_guid');
	    this._pivots[PIVOTS_KEY_PRODUCTS_EVENT_DATES] = filterFromOneSide(this._pivots[PIVOTS_KEY_PRODUCTS_EVENT_DATES], newPivots[PIVOTS_KEY_PRODUCTS_EVENT_DATES], 'event_date_guid');
	    this._pivots[PIVOTS_KEY_SHOPS_COLLAPSES] = filterFromOneSide(this._pivots[PIVOTS_KEY_SHOPS_COLLAPSES], newPivots[PIVOTS_KEY_SHOPS_COLLAPSES], 'collapse_guid');
	    this._pivots[PIVOTS_KEY_SHOPS_METADATA] = filterFromOneSide(this._pivots[PIVOTS_KEY_SHOPS_METADATA], newPivots[PIVOTS_KEY_SHOPS_METADATA], 'metadata_guid');
	    this._pivots[PIVOTS_KEY_SHOPS_PRODUCTS] = filterFromOneSide(this._pivots[PIVOTS_KEY_SHOPS_PRODUCTS], newPivots[PIVOTS_KEY_SHOPS_PRODUCTS], 'product_guid');
	    this._pivots[PIVOTS_KEY_SHOPS_TICKETS] = filterFromOneSide(this._pivots[PIVOTS_KEY_SHOPS_TICKETS], newPivots[PIVOTS_KEY_SHOPS_TICKETS], 'ticket_guid');
	    this._pivots[PIVOTS_KEY_SHOPS_PAYMENT_METHODS] = Object.values(newPivots[PIVOTS_KEY_SHOPS_PAYMENT_METHODS] || []);
	    this._pivots[PIVOTS_KEY_TICKETS_GROUPS] = filterFromOneSide(this._pivots[PIVOTS_KEY_TICKETS_GROUPS], newPivots[PIVOTS_KEY_TICKETS_GROUPS], 'ticket_guid');
	    this._pivots[PIVOTS_KEY_GROUPS_PRODUCTS] = filterFromOneSide(this._pivots[PIVOTS_KEY_GROUPS_PRODUCTS], newPivots[PIVOTS_KEY_GROUPS_PRODUCTS], 'group_id'); // Check if any pivots in the data are missing from the above code!
	    // If it is, add it without any filtering

	    forOwn(newPivots, (newPivot, key) => {
	      if (!this._pivots[key]) {
	        console.error('Pivot key not recognized', key);
	        this._pivots[key] = Object.values(newPivot || []);
	      }
	    });
	  }
	  /**
	   *  Used to get a specific pivot(s) out of the forwarded pivots data, with
	   *  the ability to only get pivots that contain a specific guid by
	   *  forwarding filter settings.
	   */


	  get(settings) {
	    let pivots = this._pivots[settings.key];

	    if (!pivots) {
	      throw new ShopError(`No pivots available for: ${settings.key}`);
	    } // Return all the pivots if no specific item is requested


	    if (!settings.item) {
	      return pivots;
	    }

	    pivots = pivots.filter(pivot => {
	      if (!settings.item) {
	        return;
	      }

	      let found = pivot[settings.item.guid_key] === settings.item.guid; // Make sue it also belongs to a specific
	      // guid when the belongs to filter is set

	      if (found && settings.belongs_to) {
	        found = pivot[settings.belongs_to.guid_key] === settings.belongs_to.guid;
	      }

	      return found;
	    });
	    return pivots;
	  }
	  /**
	   *
	   *  Used for determining the index of an item.
	   *
	   *  Either based on a stern-brocot sequence, or a linked list.
	   *
	   *  In case of stern-brocot, the fraction is returned as is,
	   *  in case of a linked list, the index of an item is
	   *  recursively computed based on the pivots,
	   *  by iterating over all of them and counting
	   *  how much steps it takes to reach the item that does not
	   *  have a preceding item.
	   *
	   *  (i) If the preceding sequence is broken - because the preceding
	   *  pivot is undefined or multiple pivots refer to each other - it
	   *  will give every item an index based on his returned order,
	   *  break the iteration and return -1
	   *
	   */


	  computeIndex(items, settings, index = -1) {
	    // An item is needed to find the item in the pivots
	    if (!settings.item) {
	      setIncrementalIndexes(items);
	      return [-1, OrderType.Incremental];
	    } // Get the pivot of the item


	    const pivot = this.get(settings)[0]; // Add a random index if the requested pivot is not found,
	    // as that means the preceding sequence is broken

	    if (!pivot) {
	      setIncrementalIndexes(items);
	      return [-1, OrderType.Incremental];
	    }

	    if (Number.isInteger(pivot.numerator) && Number.isInteger(pivot.denominator)) {
	      return [pivot.numerator / pivot.denominator, OrderType.SternBrocot];
	    }

	    return this.computeIndexForLinkedList(items, settings, pivot, index);
	  }
	  /**
	   *
	   *  Used for recursively computing the index of an item based
	   *  on the pivots, by iterating over all of them and counting
	   *  how much steps it takes to reach the item that does not
	   *  have a preceding item (linked list).
	   *
	   *  (i) If the preceding sequence is broken - because the preceding
	   *  pivot is undefined or multiple pivots refer to each other - it
	   *  will give every item an index based on his returned order,
	   *  break the iteration and return -1
	   *
	   */


	  computeIndexForLinkedList(items, settings, pivot, index = -1) {
	    // An item is needed to find the item in the pivots
	    if (!settings.item) {
	      setIncrementalIndexes(items);
	      return [-1, OrderType.Incremental];
	    } // Return the current index if there is no preceding item guid,
	    // as that means the most highest pivot item has been found


	    if (!pivot.preceded_by) {
	      return [++index, OrderType.LinkedList];
	    } // Reset the visited guids string when it's about the first iteration


	    if (index === -1) {
	      visitedGuids = {};
	    } // Keep track of the guids that were visited


	    visitedGuids[pivot[settings.item.guid_key]] = pivot[settings.item.guid_key]; // Add a random index if the preceding pivot was already visited
	    // before, as that means the preceding sequence is broken and
	    // it is about to get in an infinite loop

	    if (visitedGuids[pivot.preceded_by]) {
	      setIncrementalIndexes(items);
	      return [-1, OrderType.Incremental];
	    } // Set the guid of the preceding item as filter; so we can return
	    // the current index if it doesn't have one (reached the end) or
	    // keep on iterating over his preceding items if it does


	    settings.item.guid = pivot.preceded_by; // TODO: Make sure this doesn't break because of max recursion depth

	    return this.computeIndex(items, settings, ++index);
	  }
	  /**
	   *
	   *  Used to sort the forwarded items based on pivot-based indexes,
	   *  making use of the pivot's compute index method.
	   *
	   *  (!) Also makes sure to give every item an index based on their
	   *  returned order when all the items got index zero - which happens
	   *  when all their preceding_by's are `null`
	   *
	   */


	  computeIndexes(items, settings) {
	    // Don't do anything if the provided items collection is empty
	    const numberOfItems = Array.isArray(items) ? items.length : Object.keys(items).length;

	    if (!numberOfItems) {
	      return OrderType.Incremental;
	    } // Keep track of the computed indexes to check if the computed index sequence is correct


	    const indexes = []; // If the preceding by sequence is correct

	    let validSequence = true;
	    let lastOrderType = OrderType.Incremental; // Fn for invoking the computation of an item's index

	    const computeIndex = item => {
	      // Construct the right pivot settings for computing the item's
	      // index based on the forwarded settings and the guid of the
	      // item for which the index is currently being computed
	      const pivotSettings = settings; // An item is needed to find the index in the pivots

	      if (!pivotSettings.item) {
	        return;
	      }

	      pivotSettings.item.guid = item.guid; // Compute the index of the item

	      const [index, orderType] = this.computeIndex(items, pivotSettings);
	      lastOrderType = orderType; // If the method returned -1 it means the pivots preceding sequence
	      // is broken and it gave the items an index based on their
	      // random returned order - so the iteration can stop

	      switch (orderType) {
	        case OrderType.SternBrocot:
	          item.index = index;
	          break;

	        case OrderType.LinkedList:
	          item.index = index;
	          indexes.push(index);
	          break;

	        case OrderType.Incremental:
	        default:
	          return validSequence = false;
	      }
	    }; // Used to validate the computed index sequence


	    const validIndexSequence = () => {
	      let valid = true;
	      let index = 0; // Should now be index 0 to ...

	      indexes.sort((indexOne, indexTwo) => {
	        return indexOne === indexTwo ? 0 : indexOne - indexTwo;
	      }); // So loop through the indexes to make sure
	      // the computed sequence is ok

	      forEach$2(indexes, itemIndex => {
	        if (itemIndex !== index) {
	          valid = false;
	        } else {
	          index++;
	        }

	        return valid;
	      });
	      return valid;
	    }; // Compute the indexes for each item


	    if (Array.isArray(items)) {
	      forEach$2(items, computeIndex);
	    } else {
	      forOwn(items, computeIndex);
	    } // Make sure to set an incremental index when the preceding sequence seems
	    // correct but the computed index sequence is not, which happens when multiple
	    // item pivots have a preceding_by of `null` (resulting in index 0)
	    // There is no index sequence when all indexes are valid stern-brocot sequences.
	    // No sequence is considered valid!


	    if (validSequence && !validIndexSequence()) {
	      setIncrementalIndexes(items);
	      return OrderType.Incremental;
	    }

	    return lastOrderType;
	  }

	}

	/**
	 *  All coupon logic. (!) Used for both the shop and the cart.
	 */

	var Coupon = {
	  /**
	   *
	   *  Used to get the items to which a specific forwarded coupon applies.
	   *  If the coupon does not specify any products (an empty product prop)
	   *  it means it should be applied on all the forwarded products.
	   *
	   *  (i) As the location of the ticket of a product differs per type of
	   *  product, a method for retrieving their ticket should be forwarded.
	   *
	   *  @return a sorted Array of items on which the forwarded coupon
	   *  applies, descending from the most expensive
	   *
	   */
	  getApplicableItems(coupon, products, getTicketOfProduct) {
	    const appliesTo = [];
	    /**
	     *  Used to add the product to the Array of items on which the
	     *  coupon applies. Also save the pivot if forwarded to enable the
	     *  method for applying the discount to take the amount_override
	     *  into account.
	     */

	    const appliesToProduct = (product, pivot) => {
	      appliesTo.push({
	        product,
	        ticket: getTicketOfProduct(product),
	        pivot,
	        product_original_pricing: product.item.pricing
	      });
	    }; // The coupon applies to all the forwarded products if the
	    // returned coupon data does not specify any products


	    if (!coupon.coupon.products.length) {
	      forOwn(products, product => {
	        appliesToProduct(product);
	      });
	    } else {
	      forEach$2(coupon.coupon.products, couponProduct => {
	        forOwn(products, product => {
	          if (product.item.guid === couponProduct.guid) {
	            appliesToProduct(product, couponProduct.pivot);
	          }
	        });
	      });
	    } // Start applying or removing the discount descending from the most expensive product


	    appliesTo.sort((caA, caB) => {
	      // (!) Use the original price to make sure the sorting keeps
	      // working as expected after a coupon has been applied
	      // The pricing of the product that should be used is located in a
	      // product's item prop when it's about a cart item
	      const pricingA = caA.product_original_pricing;
	      const pricingB = caB.product_original_pricing;
	      return pricingA.base_price === pricingB.base_price ? 0 : pricingA.base_price > pricingB.base_price ? -1 : 1;
	    });
	    return appliesTo;
	  },

	  /**
	   *  Used to get the amount of discount of a coupon, taking the amount_override
	   *  for a specific product (based on the pivot) and the already spend amount
	   *  into account in case of a cheque.
	   */
	  getAmount(coupon, couponApplicable) {
	    let amount = coupon.item.coupon.amount;

	    if (coupon.item.coupon.type === CouponType.Cheque) {
	      amount = Math.max(0, amount - coupon.spend);
	    } else if (couponApplicable.pivot && typeof couponApplicable.pivot.amount_override === 'number') {
	      amount = couponApplicable.pivot.amount_override;
	    }

	    return amount;
	  },

	  /**
	   *
	   *  Method for applying a coupon discount; either adding or removing it.
	   *
	   *  (!) Applied on the pricing object to the cart item (product) itself, which is a copy of the
	   *  original item's item pricing object, so the original product pricing remains unchanged.
	   *
	   *  @return When it's about adding the amount of used is returned because it might have used just
	   *  a part of the total computed delta (if the delta is bigger than the current price), and the
	   *  negative delta should be returned if it's about removing because the delta got removed. Doing
	   *  it like this allows users of the method to always plus the returned delta.
	   *
	   *  @todo How to handle an applied new-price coupon? Is it always leading?
	   *
	   */
	  applyDiscount(coupon, action, couponApplicable) {
	    // Discount is always applied to the pricing object of the product, as it's
	    // both in a ticket product and cart product the object that's used for
	    // reflecting the current pricing, including any discounts
	    const productPricing = couponApplicable.product.pricing; // The coupon's applied delta is saved if it was applied to the product

	    let delta = productPricing.coupons[coupon.item.guid]; // Do not add an already applied coupon or remove a coupon that is not applied

	    const applied = !!delta;

	    if (action === CouponAction.Add && applied || action === CouponAction.Update && applied || action === CouponAction.Remove && !applied) {
	      return 0;
	    } // Compute the discount delta for the product if it was not already
	    // computed - the computation happens when adding a coupon


	    if (delta === undefined) {
	      const amount = this.getAmount(coupon, couponApplicable);

	      switch (coupon.item.coupon.type) {
	        // The remaining amount of a cheque is returned by the _getAmount() method
	        case CouponType.Cheque:
	        case CouponType.Fixed:
	          delta = amount;
	          break;

	        case CouponType.Percentage:
	          // (!) Use original price
	          delta = amount / 100 * couponApplicable.product_original_pricing.base_price;
	          break;

	        case CouponType.NewPrice:
	          // (!) Use original price
	          delta = couponApplicable.product_original_pricing.base_price - amount;
	          break;

	        default:
	          throw new ShopError(`Cannot ${action} coupon code -> Unknown coupon type: ${coupon.item.coupon.type}`);
	      } // Always apply discounts in full cents


	      delta = Math.ceil(delta); // Do not apply the discount if the delta is zero, to keep the appliedCount
	      // correct and let the discount apply on any following products

	      if (delta === 0) {
	        return 0;
	      }
	    }

	    let newBase = 0;
	    let used = 0;

	    switch (action) {
	      case CouponAction.Add:
	      case CouponAction.Update:
	        newBase = Math.max(0, productPricing.base_price - delta);
	        used = productPricing.base_price < delta ? productPricing.base_price : productPricing.base_price - newBase; // The count and spend does not apply for regular products, as this
	        // gets used to take the applies_to_count into account it only
	        // applies for the cart products

	        if (CartProduct.isCartProduct(couponApplicable.product)) {
	          coupon.appliedCount++;
	          const originalBasePrice = couponApplicable.product_original_pricing.base_price;
	          coupon.appliedCounts[originalBasePrice] = coupon.appliedCounts[originalBasePrice] || 0;
	          coupon.appliedCounts[originalBasePrice]++;
	          coupon.spend += used;
	        }

	        productPricing.coupons[coupon.item.guid] = used;
	        break;

	      case CouponAction.Remove:
	        newBase = productPricing.base_price + delta;

	        if (CartProduct.isCartProduct(couponApplicable.product)) {
	          coupon.appliedCount--;
	          const originalBasePrice = couponApplicable.product_original_pricing.base_price;
	          coupon.appliedCounts[originalBasePrice] = coupon.appliedCounts[originalBasePrice] || 0;
	          coupon.appliedCounts[originalBasePrice]--;
	          coupon.spend -= delta;
	        }

	        delete productPricing.coupons[coupon.item.guid];
	        break;
	    }

	    productPricing.base_price = newBase;
	    return action === CouponAction.Remove ? -delta : used;
	  }

	};

	/**
	 *  @internal The possible types of coupons.
	 */
	var CouponType;

	(function (CouponType) {
	  CouponType["Cheque"] = "cheque";
	  CouponType["Fixed"] = "fixed-discount";
	  CouponType["Percentage"] = "percentage-discount";
	  CouponType["NewPrice"] = "new-price";
	})(CouponType || (CouponType = {}));
	/**
	 *  @internal The possible actions regarding a coupon.
	 */


	var CouponAction;

	(function (CouponAction) {
	  CouponAction["Add"] = "add";
	  CouponAction["Remove"] = "remove";
	  CouponAction["Update"] = "update";
	})(CouponAction || (CouponAction = {}));

	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};
	/**
	 *  The OpenTicket shop.
	 */

	class OpenTicketShop extends lib$1.exports.EventScope {
	  /**
	   *  Constructing a new instance creates an uninitialized *(empty)* instance
	   */
	  constructor(config) {
	    super(new EventBus());
	    /**
	     * Used by EventScope to determine event bus prefix
	     */

	    this._eventScope = 'shop';
	    /**
	     *  Boolean that reflects the initialized state of the class.
	     *  @category State
	     */

	    this.is_initialized = false;
	    /**
	     *  Boolean that refrects the initializing state of the class
	     *  @category State
	     */

	    this.state = State.Start;
	    /**
	     *  Boolean that reflects the loading state of the class. It
	     *  is loading while setting data, both on initialization as
	     *  on overwriting or updating data
	     *  @category State
	     */

	    this.loading = true;
	    /**
	     *  Contains the errors or missing data after initialization
	     */

	    this.initErrors = [];
	    /**
	     *  Containing all the data of the shop, based on the [ShopData](../interfaces/shopdata.html) interface.
	     *  @category Data
	     */

	    this.data = {
	      guid: '',
	      name: '',
	      description: null,
	      event_selection: null,
	      google_tag: null,
	      email_validation_rule: null,
	      email_must_be_unique: null,
	      company_terms: null,
	      css: null,
	      facebook_auto_attend: null,
	      facebook_page_url: null,
	      seats_allow_orphan: null,
	      greedy_date_selection: null,
	      seats_public_key: null,
	      reservation_time: null,
	      currency: null,
	      global_terms: null,
	      seats_allow_orphan_computed: null,
	      shop_options: {
	        validate: null,
	        report: null,
	        pdf: null,
	        reservations: null,
	        payment: null,
	        callback: null,
	        insert: null,
	        return: null,
	        receipt: null,
	        allow_user_return: null,
	        arbitrary: null,
	        allow_order_return: null,
	        to_zero: null,
	        skip_metadata_validation: null,
	        send_email: null,
	        late_personalization: null
	      },
	      // The applied filter for the data
	      filters: {},
	      // Transformed model maps
	      collapses_map: {},
	      events_map: {},
	      event_dates_map: {},
	      groups_map: {},
	      metadata_map: {},
	      payment_methods_map: {},
	      products_map: {},
	      tickets_map: {},
	      // Sorted model representation collections, holding
	      // sorted refs to their maps collection
	      collapses: [],
	      events: [],
	      event_dates: [],
	      groups: [],
	      payment_methods: [],
	      tickets: [],
	      // Global data
	      booker_metadata: [],
	      global_products: [],
	      // Dates
	      available_future_dates: [],
	      available_future_dates_nested: {},
	      // Branding
	      branding: {
	        dashboard_terms: null,
	        guid: null,
	        locale: null,
	        name: null,
	        shop_privacy_policy: null,
	        shop_terms: null,
	        website: null
	      },
	      // Company
	      company: {
	        country: null,
	        guid: null,
	        locale: null,
	        name: null,
	        coc_name: null,
	        seats_allow_orphan: null,
	        seats_public_key: null,
	        timezone: null,
	        website: null
	      }
	    };
	    /**
	     *  The shop can be put in debug mode.
	     *
	     *  This will result in less human friendly error messages.
	     */

	    this._debugMode = false;
	    /**
	     *  Pivots from the shop data
	     */

	    this._pivots = new Pivot();
	    /**
	     *  Holding the original shop data that should be loaded while setting data.
	     */

	    this._shopDataToLoad = {};
	    /**
	     *  All model collections, used to build model collection Arrays when loading data.
	     */

	    this._modelCollections = ['collapses', 'events', 'event_dates', 'groups', 'payment_methods', 'tickets'];
	    /**
	     *  Contains the errors or missing data after initialization
	     */

	    this._initErrors = {
	      payment_methods: false,
	      items: false
	    };
	    this.log = new Logger(this._eventBus, config);
	    this.notifications = new OpenTicketBaseNotifications(this);
	    this.initialized = new Promise((resolve, reject) => {
	      this._resolveInit = resolve;
	      this._rejectInit = reject;
	    });
	  }

	  get events() {
	    return this._eventBus;
	  }
	  /**
	   *
	   *  Async method to initialize an OpenTicketShop instance.
	   *  It gets the data of the shop based on the provided shop guid,
	   *  transforms it and exposes the data by binding the result to his public properties.
	   *
	   *  ```ts
	   *  const shop: OpenTicketShop = new OpenTicketShop();
	   *
	   *  const config: ShopConfig = {
	   *      baseUrl: 'https://api.myticketshop.nl',
	   *      guid: '36a8e380-d09b-11e9-be79-49649df1d206',
	   *  };
	   *
	   *  try {
	   *
	   *      await shop.init(config);
	   *
	   *      console.info('Initialized shop:', shop);
	   *
	   *  } catch (error) {
	   *
	   *      console.warn('An error occured:', error);
	   *
	   *  }
	   *  ```
	   *
	   *  A filter can be added to limit the amount of shop data.
	   *  E.g. for timeslot shops.
	   *
	   *  Alternatively the shopdata can be forwarded.
	   *
	   *  Note: filters and forwarded shopdata can not be used consecutively!
	   *
	   *  #### Possible errors
	   *  Two different types of errors could be thrown while initializing a shop.
	   *
	   *  | Error                         | Reason                                                      |
	   *  | :------------------------ --- | :---------------------------------------------------------- |
	   *  | [ShopError](shoperror.html)   | No or invalid [ShopConfig](../interfaces/shopconfig.html)   |
	   *  |                               | provided or the API returned invalid data                   |
	   *  | [ApiError](apierror.html)     | The used API threw an error                                 |
	   *
	   *  @param config The [config](../interfaces/shopconfig.html) to use for the shop
	   *  @param filter The [filter](../globals.html#shopfilter) to use for getting the shop data at
	   *  initialisation (not the filter that got applied for retrieving the provided shop data)
	   *  @param shopData The original shop data. Initializes the shop with this data instead
	   *  of retrieving it out of the API.
	   *
	   */


	  init(config, filter, shopData) {
	    return __awaiter(this, void 0, void 0, function* () {
	      // Ensure init can only be called once
	      if (this.state === State.Ready) {
	        throw this.log._create(LogLevel.Error, ['shop', 'init', 'error', 'initialized'], {
	          state: this.state,
	          errors: this.initErrors
	        });
	      } else if (this.state !== State.Start) {
	        throw this.log._create(LogLevel.Error, ['shop', 'init', 'error', 'loading'], {
	          state: this.state,
	          errors: this.initErrors
	        });
	      }

	      this.state = State.Initializing; // Set the logger entity ID

	      this.log.setEntityId(config ? config.guid : '');

	      if (config && config.guid) {
	        this.log.addStaticValue('shop_id', config.guid);
	      }

	      try {
	        // Ensure the config is complete and valid
	        this._config = new ShopConfig(config); // Set the log levels

	        if (this._config.logLevels) {
	          this.log.setLoggingLevels(this._config.logLevels);
	        }

	        if (this._config.loggerUrl) {
	          this.log.setLoggingUrl(this._config.loggerUrl);
	        } else {
	          this.log._create(LogLevel.Info, ['shop', 'init', 'logging', 'no-external']);
	        }

	        this.log.addStaticValue('shop_id', this._config.guid);
	        this.log.addStaticValue('base_url', this._config.baseUrl);

	        this._ensureFilterOrShopData(filter, shopData); // Get the data of the provided shop guid if the data is not provided


	        if (!shopData) {
	          shopData = yield this._getShopData();
	        } // Transform and expose the data


	        yield this._setData(shopData); // Check if this window is embedded and setup messaging if so

	        if (window.self !== window.top) {
	          this.messaging = new CrossWindowShop(window.parent, this);
	        }

	        const state = this._determineDataIntegrity();

	        if (state === State.Ready) {
	          yield this._finishInit();
	        } else {
	          this.state = State.Waiting;
	        }
	      } catch (error) {
	        this.state = State.Error;

	        const initError = this.log._create(LogLevel.Fatal, ['shop', 'init', 'error', 'fatal'], {
	          state: this.state,
	          errors: this.initErrors
	        }, null, error);

	        this._rejectInit(initError);

	        this.loading = false;
	        return this.initialized;
	      }

	      if (this.state === State.Waiting) {
	        const initError = this.log._create(LogLevel.Warning, ['shop', 'init', 'error', 'waiting'], {
	          state: this.state,
	          errors: this.initErrors
	        });

	        return Promise.reject(initError);
	      }

	      this.log._create(LogLevel.Info, ['shop', 'init', 'done'], {
	        state: this.state,
	        errors: this.initErrors
	      });

	      return this.initialized;
	    });
	  }
	  /**
	   *  Listen to log events by providing a path and a callback to the `on` function
	   *
	   *  @param path - Path to listen to
	   *  @param cb - Will be called when an error event occurs
	   */


	  onLog(path, cb) {
	    if (typeof path === 'string') {
	      path = [path];
	    }

	    return this.on(['log', ...path], cb, true);
	  }
	  /**
	   * Returns true if the sdk is loaded within an iframe and is connected to an OpenTicket CrossWindowClient
	   */


	  get isFramed() {
	    return window.top !== window.self && this.messaging.isConnected;
	  }
	  /**
	   * Send a notification to cross window client
	   * @param notification
	   */


	  sendClientNotification(notification) {
	    this.emit(['client-notification'], Object.assign({
	      _isOpenticket: true,
	      action: 'client-notification'
	    }, notification), true);
	  }
	  /**
	   *  Used to overwrite the exposed shop data. Makes sure to cast the data in
	   *  the models as it should be exposed, that the cart is being re-created
	   *  and to set the original shop data to undefined.
	   */


	  overwriteData(shopData) {
	    return __awaiter(this, void 0, void 0, function* () {
	      // Nothing to overwrite without data!
	      if (!shopData) {
	        throw this.log._create(LogLevel.Error, ['shop', 'overwriteData', 'error', 'data'], {
	          state: this.state,
	          errors: this.initErrors
	        });
	      } // The shop was never initialized, cannot overwrite.


	      if (this.state === State.Start) {
	        throw this.log._create(LogLevel.Error, ['shop', 'overwriteData', 'error', 'initialized'], {
	          state: this.state,
	          errors: this.initErrors
	        });
	      }

	      if (this.state !== State.Waiting) {
	        // Prevent race conditions by throwing an error if the shop is loading
	        if (this.loading) {
	          throw this.log._create(LogLevel.Error, ['shop', 'overwriteData', 'error', 'loading'], {
	            state: this.state,
	            errors: this.initErrors
	          });
	        } // Shop is in an invalid state, cannot guarantee anything!


	        if (this.state !== State.Ready) {
	          throw this.log._create(LogLevel.Error, ['shop', 'overwriteData', 'error', 'state'], {
	            state: this.state,
	            errors: this.initErrors
	          });
	        }
	      }

	      try {
	        this.loading = true;
	        this.state = this.state === State.Waiting ? State.Initializing : State.Loading;
	        this.data = OpenTicketShop._castData(shopData); // Release all the current items in the cart and create
	        // a new cart, as we can't guarantee the validity of the
	        // items in the cart after an overwrite

	        yield this.cart.removeAllItems();
	        this.cart = new Cart(this, this._config, this.log, this._eventBus); // Rebuild the collection representation Arrays

	        forEach$2(this._modelCollections, name => {
	          this._setRepresentationCollection(name);
	        });

	        const state = this._determineDataIntegrity();

	        if (this.state === State.Initializing && state === State.Ready) {
	          yield this._finishInit();
	        } else {
	          // Set the state depending on data completeness.
	          this.state = state;
	        }
	      } catch (error) {
	        this.state = State.Error;

	        const overwriteDataError = this.log._create(LogLevel.Fatal, ['shop', 'overwriteData', 'error', 'fatal'], {
	          state: this.state,
	          errors: this.initErrors
	        }, null, error);

	        this.loading = false;
	        throw overwriteDataError;
	      }

	      if (this.state === State.Waiting) {
	        this.log._create(LogLevel.Warning, ['shop', 'overwriteData', 'error', 'waiting'], {
	          state: this.state,
	          errors: this.initErrors
	        });

	        return;
	      }

	      this.log._create(LogLevel.Info, ['shop', 'overwriteData', 'done'], {
	        state: this.state,
	        errors: this.initErrors
	      });

	      this.loading = this.state !== State.Ready;
	    });
	  }
	  /**
	   *  Used to update the data based on a provided filter.
	   */


	  updateData(filters) {
	    return __awaiter(this, void 0, void 0, function* () {
	      // Prevent race conditions by throwing an error if the shop is not initialized yet
	      if (!this.is_initialized) {
	        throw this.log._create(LogLevel.Error, ['shop', 'updateData', 'error', 'initialized'], {
	          state: this.state,
	          errors: this.initErrors
	        });
	      }

	      if (!filters) {
	        throw this.log._create(LogLevel.Error, ['shop', 'updateData', 'error', 'filters'], {
	          state: this.state,
	          errors: this.initErrors
	        });
	      }

	      if (this.loading) {
	        throw this.log._create(LogLevel.Error, ['shop', 'updateData', 'error', 'loading'], {
	          state: this.state,
	          errors: this.initErrors
	        });
	      }

	      let data; // Recoverable error(s)

	      try {
	        this.loading = true; // Lets the getShopData use the provided filter

	        this.data.filters = Object.assign({}, filters);
	        data = yield this._getShopData();
	      } catch (error) {
	        // Recoverable error(s)
	        const updateDataError = this.log._create(LogLevel.Fatal, ['shop', 'updateData', 'error', 'api'], {
	          state: this.state,
	          errors: this.initErrors
	        }, null, error);

	        this.loading = false;
	        throw updateDataError;
	      } // Unrecoverable error(s)


	      try {
	        yield this._setData(data); // Lets the cart update the data of his added
	        // items according to the just updated data

	        this.cart._shopDataUpdated(); // Update discounts / hidden states for already present coupons


	        forOwn(this.cart.getAppliedCoupons(), coupon => {
	          this._updateCouponDiscounts(CouponAction.Update, coupon);
	        });
	      } catch (error) {
	        // Unrecoverable error(s)
	        this.state = State.Error;

	        const overwriteDataError = this.log._create(LogLevel.Fatal, ['shop', 'overwriteData', 'error', 'fatal'], {
	          state: this.state,
	          errors: this.initErrors
	        }, null, error);

	        this.loading = false;
	        throw overwriteDataError;
	      } // Emit the shop/update event with the name of
	      // the loaded shop and the applied filter


	      this.emit(['update'], {
	        name: this.data.name,
	        filters: filters || null
	      });

	      this.log._create(LogLevel.Info, ['shop', 'updateData', 'done'], {
	        state: this.state,
	        errors: this.initErrors
	      });

	      this.loading = false;
	      return true;
	    });
	  }
	  /**
	   *  Used to invoke a refresh of the data: getting the newest data out of the API.
	   */


	  refreshData() {
	    return __awaiter(this, void 0, void 0, function* () {
	      return this.updateData(this.data.filters);
	    });
	  }
	  /**
	   *  Used to update the coupon discounts when the coupons change in
	   *  the cart. Invoked by the cart event listener that got initialised
	   *  in the init method.
	   *
	   *  @internal: Is and should only be used by the cart to update
	   *  the discounts of applied coupons AND on update of the data of the shop.
	   */


	  _updateCouponDiscounts(action, coupon) {
	    coupon.appliesTo.shop = this._calculateCouponApplicableItems(coupon); // Collect all events which should have their items check hidden values.
	    // This is an Object to enforce uniqueness

	    const eventsToCheckForHidden = {}; // Apply the discounts to the applicable items in the shop

	    forEach$2(coupon.appliesTo.shop, couponApplicable => {
	      // Always apply the discount when it's about a global product
	      if (!couponApplicable.ticket) {
	        // Do not start applying when the maximum of applying discounts has already been reached
	        if (coupon.appliedCount >= coupon.item.applies_to_count) {
	          return;
	        }

	        const delta = Coupon.applyDiscount(coupon, action, couponApplicable);

	        if (delta !== 0) {
	          this.emit(['product', couponApplicable.product.guid, 'update'], {});
	        }

	        return;
	      } // If the ticket is not hidden by the coupon,
	      // no need to check it and its event!


	      if (couponApplicable.ticket.hide_without_coupon) {
	        couponApplicable.ticket.hidden = this._determineTicketHidden(couponApplicable.ticket, action === CouponAction.Remove ? undefined : couponApplicable);
	        eventsToCheckForHidden[couponApplicable.ticket.event_id] = null;
	      } // Get the pricing of the ticket to update his pricing's coupon stats


	      const ticketPricing = couponApplicable.ticket.pricing; // Make sure the stats of the coupon in question are defined in the ticket's pricing

	      ticketPricing.coupons[coupon.item.guid] = ticketPricing.coupons[coupon.item.guid] || 0;
	      ticketPricing.coupons_count[coupon.item.guid] = ticketPricing.coupons_count[coupon.item.guid] || 0;
	      const actions = action === CouponAction.Update ? [CouponAction.Remove, CouponAction.Add] : [action];
	      const beforeBasePrice = couponApplicable.product.pricing.base_price;

	      for (const couponAction of actions) {
	        // Get the count of how many times the coupon was applied on a product in the ticket
	        const appliedInTicketCount = ticketPricing.coupons_count[coupon.item.guid];
	        let openSlotsCount = coupon.item.applies_to_count; // Remove any applied cart products from the open slots count,
	        // IFF they are at least the same price.
	        // Any shop product will show the discounted price,
	        // IFF it would get the discounted price on the next addition to the cart.
	        // If the current shop product is cheaper than the already applied cart products,
	        // it will not be discounted.

	        for (const cents in coupon.appliedCounts) {
	          try {
	            if (Number.parseInt(cents) >= couponApplicable.product_original_pricing.base_price) {
	              openSlotsCount -= coupon.appliedCounts[cents] || 0;
	            }
	          } catch (e) {
	            /* No-op */
	          }
	        } // The 'applies_to_count' becomes relative to the ticket in the shop, so it may not be applied
	        // to more products in a ticket than the 'applies_to_count' prescribes


	        if (couponAction === CouponAction.Add && appliedInTicketCount >= openSlotsCount || couponAction === CouponAction.Remove && !appliedInTicketCount) {
	          continue;
	        } // Apply the discount and save the applied delta to update the ticket's coupon stats below


	        const delta = Coupon.applyDiscount(coupon, couponAction, couponApplicable); // Update the stats of the coupon within the ticket

	        ticketPricing.coupons[coupon.item.guid] += delta; // Only count when a delta got applied (zero delta means no delta applied)

	        ticketPricing.coupons_count[coupon.item.guid] += delta === 0 ? 0 : couponAction === CouponAction.Remove ? -1 : 1;
	      }

	      if (beforeBasePrice !== couponApplicable.product.pricing.base_price) {
	        // Emit triggers on next tick, emitting it now is ok, because it does not contain any data.
	        this.emit(['ticket', couponApplicable.ticket.guid, 'update'], {});
	      } // And remove the collection if there's nothing left after removing


	      if (action === CouponAction.Remove) {
	        if (ticketPricing.coupons[coupon.item.guid] === 0) {
	          delete ticketPricing.coupons[coupon.item.guid];
	        }

	        if (ticketPricing.coupons_count[coupon.item.guid] === 0) {
	          delete ticketPricing.coupons_count[coupon.item.guid];
	        }
	      }
	    }); // Check hidden values for the collected events.

	    forEach$2(Object.getOwnPropertyNames(eventsToCheckForHidden), eventId => {
	      const event = this.data.events_map[eventId];
	      event.hidden = this._determineEventHidden(event, true);
	    }); // Used by the `computeItemsPricing` method for getting the products of a ticket

	    const getProductsOfTicket = ticket => {
	      return ticket.products.all;
	    }; // Recompute the pricing of the products and tickets
	    // (!) It should only take the required products into account in this situation


	    Price.computeItemsPricing(this.data.products_map, this.data.tickets_map, getProductsOfTicket, IGNORE_OPTIONAL);
	  }
	  /**
	   *  Set the shop to debug mode.
	   *
	   *  Errors will now be more clear and less user friendly!
	   *
	   *  @param value Whether or not to set the shop to debug mode
	   */


	  setDebugMode(value) {
	    this._debugMode = value;
	  }
	  /**
	   *  Filters and forwarded shopdata can not be used together.
	   *  The filter is used for retrieving filtered shop data,
	   *  When shop data is forwarded in the init call,
	   *  this should already contain the filter used.
	   *
	   *  @param filters The [filter](../globals.html#shopfilter) to use for getting the shop data at
	   *  initialisation (not the filter that got applied for retrieving the provided shop data)
	   *  @param shopData The original shop data. Initializes the shop with this data instead
	   *  of retrieving it out of the API.
	   */


	  _ensureFilterOrShopData(filters, shopData) {
	    if (filters && shopData) {
	      throw this.log._create(LogLevel.Fatal, ['shop', 'data', 'error', 'exclusive', 'filterdata']);
	    } // Save the filter to the data so it gets used in the
	    // getShopData method and so the developer knows which
	    // filter got used for loading the data


	    if (filters) {
	      this.data.filters = Object.assign({}, filters);
	    } else {
	      this.data.filters = Object.assign({}, shopData ? shopData.filters || {} : {});
	    }
	  }
	  /**
	   *  The init process' final steps.
	   *
	   *  This method is separated from the init call,
	   *  because the init process can be suspended,
	   *  if data is incomplete.
	   */


	  _finishInit() {
	    return __awaiter(this, void 0, void 0, function* () {
	      // Handle any third party payment methods.
	      // E.g.: Loading stripe instances, to enable fraud detection early!
	      // TODO: Should a failure here be be a permanent failure for the shop????
	      yield this._initPaymentMethods(); // Initialize a new cart with the shop, config and event bus

	      this.cart = new Cart(this, this._config, this.log, this._eventBus); // Resolve the initialized states of the shop

	      this.is_initialized = true;
	      this.state = State.Ready;

	      this._resolveInit(true);

	      this.loading = false; // Emit the shop/init event with the name of the
	      // loaded shop and the possibly applied filter

	      this.emit(['init'], {
	        name: this.data.name,
	        filters: this.data.filters || null
	      });
	    });
	  }
	  /**
	   *  Used to cast the needed data of the models in the forwarded data.
	   */


	  static _castData(shopData) {
	    Model.castData.ofEvents(shopData.events_map);
	    Model.castData.ofEventDates(shopData.event_dates_map);
	    Model.castData.ofTickets(shopData.tickets_map);
	    return shopData;
	  }
	  /**
	   *  Used for getting the data of the shop via the configured HTTP client.
	   */


	  _getShopData() {
	    return __awaiter(this, void 0, void 0, function* () {
	      const url = this._config.getNoCacheUrl(`${this._config.guid}/data`, this.data.filters);

	      try {
	        const shop = yield this._config.httpClient.get(url);

	        if (!shop.data.filters) {
	          shop.data.filters = Object.assign({}, this.data.filters || {});
	        }

	        return shop.data;
	      } catch (error) {
	        if (error && error.response && error.response.status === 404) {
	          throw this.log._create(LogLevel.Fatal, ['shop', 'data', 'error', 'notfound'], {}, null, error);
	        }

	        throw this.log._create(LogLevel.Fatal, ['shop', 'data', 'error', 'retrieval', 'failed'], {}, null, error);
	      }
	    });
	  }
	  /**
	   *
	   *  Used for setting original data and transforming that
	   *  data to something we want to expose to the client.
	   *
	   *  (i) Which is exposed by binding it to this instance
	   *
	   */


	  _setData(shopData) {
	    return __awaiter(this, void 0, void 0, function* () {
	      if (!Object.keys(shopData).length) {
	        throw this.log._create(LogLevel.Fatal, ['shop', 'data', 'error', 'missing', 'data']);
	      }

	      if (!shopData.shops || !shopData.shops.length) {
	        throw this.log._create(LogLevel.Fatal, ['shop', 'data', 'error', 'missing', 'shop']);
	      } // Set the shopdata to load in the original shop data property,
	      // so every method that sets the data has access to the data
	      // that should currently be loaded


	      this._shopDataToLoad = shopData; // Set filter data

	      this.data.filters = Object.assign({}, shopData.filters); // Set a ref to the original shop data pivots so the pivot logic can easily access it

	      this._pivots.setPivots(shopData.pivots); // TODO: add parameters and return values to the methods below
	      // to indicate what data they access
	      // Compute all the model maps
	      // (!) Order of execution of the maps is important because of the refs


	      this._setEventDatesMap();

	      this._setMetadataMap();

	      this._setProductsMap();

	      this._setGroupsMap();

	      this._setTicketsMap();

	      this._setCollapsesMap();

	      this._setEventsMap();

	      this._setPaymentMethodsMap(); // Set all the model representation collections, which contain
	      // sorted references to their corresponding model maps


	      forEach$2(this._modelCollections, name => {
	        this._setRepresentationCollection(name);
	      }); // Currently the loaded data can only contain a single shop, so
	      // forward this shop to set his global data

	      const shop = shopData.shops[0];
	      const branding = shopData.brandings[0];
	      const company = shopData.companies[0];

	      this._setGlobalData(shop, branding, company); // Add possible dates for timeslot


	      if (this.data.greedy_date_selection) {
	        this.data.available_future_dates = Array.from(shopData.available_future_dates);
	        this.data.available_future_dates_nested = Object.assign({}, shopData.available_future_dates_nested);
	      } // Clear the shop data to load, as we don't need it
	      // anymore once it is transformed and exposed


	      this._shopDataToLoad = {};
	      return true;
	    });
	  }
	  /**
	   *  Determine if the shop data is ready for full initialization of the shop.
	   */


	  _determineDataIntegrity() {
	    this._initErrors.payment_methods = !this.data.payment_methods.length;
	    this._initErrors.items = !this.data.tickets.length && !this.data.global_products.length;
	    this.initErrors = [];

	    if (this._initErrors.payment_methods) {
	      this.initErrors.push({
	        type: 'payment_methods',
	        message: 'Missing payment methods'
	      });
	    }

	    if (this._initErrors.items) {
	      this.initErrors.push({
	        type: 'items',
	        message: 'Missing tickets or products'
	      });
	    }

	    if (this.initErrors.length) {
	      return State.Waiting;
	    }

	    return State.Ready;
	  }
	  /**
	   *  Used to initialize any payment method 3rd party scripts.
	   */


	  _initPaymentMethods() {
	    return __awaiter(this, void 0, void 0, function* () {
	      if (!this.data || !this.data.payment_methods) {
	        throw this.log._create(LogLevel.Error, ['shop', 'data', 'error', 'loading', 'paymentmethods']);
	      }

	      const promises = [];
	      forEach$2(this.data.payment_methods, paymentMethod => {
	        if (paymentMethod.stripe) {
	          const promise = pure.loadStripe(paymentMethod.stripe.stripe_public_key).then(stripe => {
	            if (!stripe || !paymentMethod.stripe) {
	              // TODO should this be a permanent failure for the shop????
	              throw this.log._create(LogLevel.Error, ['shop', 'data', 'error', 'loading', 'stripe']);
	            }

	            paymentMethod.stripe.stripe = stripe;
	          });
	          promises.push(promise);
	        }
	      });
	      yield Promise.all(promises);
	    });
	  }
	  /**
	   *  Used to set and expose all the event dates of the shop
	   *  as guid map, making sure they are being transformed
	   *  before doing so.
	   */


	  _setEventDatesMap() {
	    if (!Array.isArray(this._shopDataToLoad.eventDates)) {
	      throw this.log._create(LogLevel.Warning, ['shop', 'data', 'error', 'missing', 'eventdates']);
	    }

	    forEach$2(this._shopDataToLoad.eventDates, eventDate => {
	      Model.addTo(this.data.event_dates_map, this._getTransformedEventDate(eventDate.guid));
	    });
	  }
	  /**
	   *  Used to set and expose all the metadata of the shop, making
	   *  sure they are being transformed before doing so.
	   */


	  _setMetadataMap() {
	    if (!Array.isArray(this._shopDataToLoad.metaData)) {
	      throw this.log._create(LogLevel.Warning, ['shop', 'data', 'error', 'missing', 'metadata']);
	    }

	    forEach$2(this._shopDataToLoad.metaData, metadata => {
	      Model.addTo(this.data.metadata_map, this._getTransformedMetadata(metadata.guid));
	    });
	  }
	  /**
	   *  Used to set and expose all the events of the shop as
	   *  guid map, making sure they are being transformed
	   *  before doing so.
	   */


	  _setEventsMap() {
	    if (!Array.isArray(this._shopDataToLoad.events)) {
	      throw this.log._create(LogLevel.Warning, ['shop', 'data', 'error', 'missing', 'events']);
	    }
	    /**
	     *  Keep track of the events that are being added to the events map
	     *  for the current dataset to load, so we know for which events we
	     *  should invoke an update of the attached models based on the pivots,
	     *  because the pivots might have been changed in the new dataset.
	     */


	    const addedEvents = {};
	    forEach$2(this._shopDataToLoad.events, event => {
	      addedEvents[event.guid] = event.guid; // Create the map with the transformed events

	      Model.addTo(this.data.events_map, this._getTransformedEvent(event.guid));
	    }); // Invoke an update of the events' pivots models to make sure
	    // they are in sync with the current data to load

	    forEach$2(Object.keys(this.data.events_map), guid => {
	      if (!addedEvents[guid]) {
	        this._enrichEvent(this.data.events_map[guid]);
	      }
	    });
	  }
	  /**
	   *  Used to set and expose all the collapses of the shop as
	   *  guid map, making sure they are being transformed
	   *  before doing so.
	   */


	  _setCollapsesMap() {
	    if (!Array.isArray(this._shopDataToLoad.collapses)) {
	      throw this.log._create(LogLevel.Warning, ['shop', 'data', 'error', 'missing', 'collapses']);
	    } // It is not mandatory to have collapses


	    if (!this._shopDataToLoad.collapses.length) {
	      return;
	    } // Expose all transformed collapses


	    forEach$2(this._shopDataToLoad.collapses, collapse => {
	      Model.addTo(this.data.collapses_map, this._getTransformedCollapse(collapse.guid));
	    }); // Compute an index based on the pivots so they can easily be sorted

	    const pivotSettings = {
	      key: PIVOTS_KEY_SHOPS_COLLAPSES,
	      item: {
	        guid: '',
	        guid_key: 'collapse_guid'
	      }
	    };

	    this._pivots.computeIndexes(this.data.collapses_map, pivotSettings); // Always add the number of the tickets it contains to each collapse so
	    // they're always at the bottom of the sorted collection


	    const numberOfTickets = Object.keys(this.data.tickets_map).length;
	    forOwn(this.data.collapses_map, collapse => {
	      collapse.index += numberOfTickets; // But overwrite the index with the top ticket's index if
	      // present to make sure it will be sorted at the right
	      // position in the event items collection

	      collapse.index = collapse.tickets[0] ? collapse.tickets[0].index : collapse.index;
	    });
	  }
	  /**
	   *  Used to transform and expose the general data of the shop, including
	   *  the general shop data, booker metadata and payment methods.
	   */


	  _setGlobalData(shop, branding, company) {
	    // Directly expose every primitive value
	    forOwn(shop, (value, key) => {
	      if (value !== Object(value)) {
	        // @ts-ignore: we know it's there
	        this.data[key] = value;
	      }
	    }); // Directly expose the shop options

	    this.data.shop_options = shop.shop_options; // The remaining data to expose

	    this._setBookerInformation(shop.guid);

	    this._setGlobalProducts(shop.guid);

	    forOwn(branding, (value, key) => {
	      if (value !== Object(value)) {
	        // @ts-ignore: we know it's there
	        this.data.branding[key] = value;
	      }
	    });
	    forOwn(company, (value, key) => {
	      if (value !== Object(value)) {
	        // @ts-ignore: we know it's there
	        this.data.company[key] = value;
	      }
	    });
	  }
	  /**
	   *  Used to collect and expose the booker metadata, which basically is
	   *  the metadata that applies for the whole shop.
	   */


	  _setBookerInformation(shopGuid) {
	    const metadataPivots = this._pivots.get({
	      key: PIVOTS_KEY_SHOPS_METADATA,
	      item: {
	        guid: shopGuid,
	        guid_key: 'shop_guid'
	      }
	    });

	    forEach$2(metadataPivots, pivot => {
	      const metadata = Model.getFrom(this.data, 'metadata_map', pivot.metadata_guid);
	      const shopMetadata = {
	        index: 0,
	        guid: metadata.guid,
	        item: metadata
	      }; // Add reference to transformed metadata

	      Model.addTo(this.data.booker_metadata, shopMetadata);
	    }); // Add indexes to the metadata based on the
	    // pivots, so they can easily be sorted

	    const pivotSettings = {
	      key: PIVOTS_KEY_SHOPS_METADATA,
	      item: {
	        guid: '',
	        guid_key: 'metadata_guid'
	      }
	    };

	    this._pivots.computeIndexes(this.data.booker_metadata, pivotSettings); // Sort the model collection


	    this.data.booker_metadata.sort(modelSort);
	  }
	  /**
	   *
	   *  Used to expose the global products, which basically are products
	   *  that could be purchased on shop level. Exposing them out
	   *  of both the global_products as pivots data.
	   *
	   *  (!) They are first added to the general products collection in the
	   *  _setProductsMap() method, before their references are added to the
	   *  event's global products or global global_products collection.
	   *
	   */


	  _setGlobalProducts(shopGuid) {
	    /**
	     *
	     *  Fn for adding the global product as ShopProduct to either the
	     *  collection of his event or the global products collection.
	     *
	     *  @param productGuid The guid of the global product
	     *  @param index currently random, as there's no
	     *  solid way to compute their correct indexes.
	     *
	     */
	    const setGlobalProduct = (productGuid, index) => {
	      const product = Model.getFrom(this.data, 'products_map', productGuid);
	      const collection = !product.event_id || !this.data.events_map[product.event_id] ? this.data.global_products : this.data.events_map[product.event_id].global_products;
	      const shopProduct = {
	        index,
	        guid: product.guid,
	        item: product,
	        pricing: JSON.parse(JSON.stringify(product.pricing))
	      }; // The original product model does not hold coupons, because coupons
	      // are being applied to the ShopProduct wrapper instead

	      shopProduct.pricing.coupons = {};
	      Model.addTo(collection, shopProduct);
	    }; // Expose returned global products


	    if (this._shopDataToLoad.global_products && this._shopDataToLoad.global_products.constructor === Object) {
	      forEach$2(Object.keys(this._shopDataToLoad.global_products), setGlobalProduct);
	    } // Also expose returned global products based on the pivots, which can be found in the products map


	    const shopProductPivots = this._shopDataToLoad.pivots[PIVOTS_KEY_SHOPS_PRODUCTS];

	    if (Array.isArray(shopProductPivots) && shopProductPivots.length) {
	      const globalProductPivots = this._pivots.get({
	        key: PIVOTS_KEY_SHOPS_PRODUCTS,
	        item: {
	          guid: shopGuid,
	          guid_key: 'shop_guid'
	        }
	      });

	      forEach$2(globalProductPivots, (pivot, index) => {
	        setGlobalProduct(pivot.product_guid, index);
	      });
	    }

	    this.data.global_products.sort(modelSort);
	    forEach$2(this.data.events, event => {
	      event.global_products.sort(modelSort);
	    });
	  }
	  /**
	   *  Used to set and expose all the payment methods of the shop,
	   *  making sure they are being transformed before doing so.
	   */


	  _setPaymentMethodsMap() {
	    if (!Array.isArray(this._shopDataToLoad.paymentmethods)) {
	      throw this.log._create(LogLevel.Warning, ['shop', 'data', 'error', 'missing', 'paymentmethods']);
	    }

	    forEach$2(this._shopDataToLoad.paymentmethods, paymentMethod => {
	      Model.addTo(this.data.payment_methods_map, this._getTransformedPaymentMethod(paymentMethod.guid));
	    }); // Add indexes to the payment methods groups based on
	    // the pivots so they can easily be sorted

	    const pivotSettings = {
	      key: PIVOTS_KEY_SHOPS_PAYMENT_METHODS,
	      item: {
	        guid: '',
	        guid_key: 'payment_method_id'
	      }
	    };

	    this._pivots.computeIndexes(this.data.payment_methods_map, pivotSettings);
	  }
	  /**
	   *  Used to set and expose all the products of the shop, both the regular products
	   *  as global products; making sure they are being transformed before doing so.
	   */


	  _setProductsMap() {
	    if (!this._shopDataToLoad.products) {
	      throw this.log._create(LogLevel.Warning, ['shop', 'data', 'error', 'missing', 'products']);
	    }
	    /**
	     *  Keep track of the products that are being added to the products map
	     *  for the current dataset to load, so we know for which products we
	     *  should invoke an update of the attached models based on the pivots,
	     *  because the pivots might have been changed in the new dataset.
	     */


	    const addedProducts = {};
	    forEach$2(Object.keys(this._shopDataToLoad.products), guid => {
	      addedProducts[guid] = guid;
	      Model.addTo(this.data.products_map, this._getTransformedProduct(guid));
	    }); // Also add returned global products to the exposed products collection

	    if (this._shopDataToLoad.global_products && this._shopDataToLoad.global_products.constructor === Object) {
	      forEach$2(Object.keys(this._shopDataToLoad.global_products), guid => {
	        addedProducts[guid] = guid;
	        Model.addTo(this.data.products_map, this._getTransformedProduct(guid));
	      });
	    } // Invoke an update of the products' pivots models to make sure
	    // they are in sync with the current data to load


	    forEach$2(Object.keys(this.data.products_map), guid => {
	      if (!addedProducts[guid]) {
	        this._enrichProduct(this.data.products_map[guid]);
	      }
	    });
	  }
	  /**
	   *  Used to set and expose all the groups of the shop as
	   *  guid map, making sure they are being transformed
	   *  before doing so.
	   */


	  _setGroupsMap() {
	    if (!Array.isArray(this._shopDataToLoad.groups)) {
	      throw this.log._create(LogLevel.Warning, ['shop', 'data', 'error', 'missing', 'groups']);
	    }
	    /**
	     *  Keep track of the groups that are being added to the groups map
	     *  for the current dataset to load, so we know for which groups we
	     *  should invoke an update of the attached models based on the pivots,
	     *  because the pivots might have been changed in the new dataset.
	     */


	    const addedGroups = {}; // Expose all transformed groups

	    forEach$2(this._shopDataToLoad.groups, group => {
	      addedGroups[group.guid] = group.guid;
	      Model.addTo(this.data.groups_map, this._getTransformedProductGroup(group.guid));
	    }); // Invoke an update of the group's pivots models to make sure
	    // they are in sync with the current data to load

	    forOwn(this.data.groups_map, (group, guid) => {
	      if (!addedGroups[guid]) {
	        this._enrichGroup(group);
	      }
	    }); // Add indexes to the product groups based on
	    // the pivots so they can easily be sorted

	    const pivotSettings = {
	      key: PIVOTS_KEY_TICKETS_GROUPS,
	      item: {
	        guid: '',
	        guid_key: 'group_guid'
	      }
	    };

	    this._pivots.computeIndexes(this.data.groups_map, pivotSettings);
	  }
	  /**
	   *  Used to set and expose all the tickets of the shop as
	   *  guid map, making sure they are being transformed
	   *  before doing so.
	   */


	  _setTicketsMap() {
	    if (!this._shopDataToLoad.tickets) {
	      throw this.log._create(LogLevel.Warning, ['shop', 'data', 'error', 'missing', 'tickets']);
	    }
	    /**
	     *  Keep track of the tickets that are being added to the tickets map
	     *  for the current dataset to load, so we know for which tickets we
	     *  should invoke an update of the attached models based on the pivots,
	     *  because the pivots might have been changed in the new dataset.
	     */


	    const addedTickets = {}; // Expose all transformed tickets

	    forOwn(this._shopDataToLoad.tickets, ticket => {
	      addedTickets[ticket.guid] = ticket.guid;
	      Model.addTo(this.data.tickets_map, this._getTransformedTicket(ticket.guid));
	    }); // Invoke an update of the ticket' pivots models to make sure
	    // they are in sync with the current data to load

	    forOwn(this.data.tickets_map, (ticket, guid) => {
	      if (!addedTickets[guid]) {
	        this._enrichTicket(ticket);
	      }
	    }); // Add indexes to the ticket based on the
	    // pivots so they can easily be sorted

	    const pivotSettings = {
	      key: PIVOTS_KEY_SHOPS_TICKETS,
	      item: {
	        guid: '',
	        guid_key: 'ticket_guid'
	      }
	    };

	    this._pivots.computeIndexes(this.data.tickets_map, pivotSettings);
	  }
	  /**
	   *
	   *  Used to expose all the models as a representation Array,
	   *  containing sorted refs to the original model objects in
	   *  the model's guid map.
	   *
	   *  @param name The name of the collection to set the representation collection of
	   *
	   */


	  _setRepresentationCollection(name) {
	    // Get refs to the representation collection and his models map
	    const collection = this.data[name];
	    const map = this.data[`${name}_map`]; // Throw an error when the collection or map could not be found

	    if (!collection || !map) {
	      throw slugError(`The ${!collection ? 'collection' : 'map'} of ${name} is undefined`, ['shop', 'data', 'error', 'representation'], {
	        name
	      });
	    } // Always clean the collection before filling


	    collection.splice(0, collection.length);
	    /**
	     *  Add refs to every model in the map if no filters were applied or if the shop data to
	     *  load is unknown (meaning the shop data got set via the overwrite data method), or
	     *  only add models that got loaded according to the current set original shop data.
	     *
	     *  (i) Adding all models should happen when rebuilding the collections
	     *  based on set/overwritten maps in the overwriteData() method.
	     */

	    if (!Object.keys(this._shopDataToLoad).length || !Object.keys(this.data.filters).length) {
	      forOwn(map, model => {
	        Model.addTo(collection, model);
	      });
	    } else {
	      // Some data that is exposed under a specific property
	      // might be returned in another property name
	      const dataKeyMap = {
	        event_dates: 'eventDates',
	        payment_methods: 'paymentmethods'
	      };
	      const dataKey = dataKeyMap[name] || name; // Get the loaded data, so we can loop over the models that are currently
	      // loaded according to the current set original shop data and we can only
	      // add (refs to) them in the representation collection
	      // (!) As the map always contains every loaded model

	      const loadedData = this._shopDataToLoad[dataKey]; // Fn to add a reference to the transformed model in the map,
	      // based on a model that should currently be added to the
	      // collection according to the loaded original data

	      const addModelToCollection = model => {
	        Model.addTo(collection, map[model.guid]);
	      };

	      if (Array.isArray(loadedData)) {
	        forEach$2(loadedData, addModelToCollection);
	      } else {
	        forOwn(loadedData, addModelToCollection);
	      }
	    } // Sort the model collection


	    collection.sort(modelSort);
	  }
	  /**
	   *  Used to get a transformed copy of an event date
	   *  out of the original data; casting the dates.
	   */


	  _getTransformedEventDate(guid) {
	    const eventDate = Model.getFrom(this._shopDataToLoad, 'eventDates', guid, GET_BY_VALUE);
	    Model.castData.ofEventDate(eventDate);
	    return eventDate;
	  }
	  /**
	   *  Used to get a transformed copy of a metadata
	   *  out of the original data; casting the dates.
	   */


	  _getTransformedMetadata(guid) {
	    const metadata = Model.getFrom(this._shopDataToLoad, 'metaData', guid, GET_BY_VALUE); // @ts-ignore: Always expose the rules as Array
	    // noinspection SuspiciousTypeOfGuard

	    metadata.extra = typeof metadata.extra === 'string' ? metadata.extra.split('|') : metadata.extra || []; // Used for enum values

	    metadata.options = []; // Filter out empty rules and split the enum values if there are rules

	    if (!metadata.extra) {
	      return metadata;
	    }

	    metadata.extra = metadata.extra.filter(rule => {
	      if (!rule.length) {
	        return false;
	      }

	      if (/^in:/.test(rule)) {
	        const values = rule.split(':')[1].split(',');
	        forEach$2(values, value => {
	          if (!value.length) {
	            return;
	          }

	          metadata.options.push(value);
	        });
	      }

	      return true;
	    });
	    return metadata;
	  }
	  /**
	   *  Used to get a transformed copy of an event out of the original
	   *  data; adding a holder for his global products, his tickets, event
	   *  dates, computing his start and end based on the corresponding
	   *  event dates and adding his sorted items list.
	   */


	  _getTransformedEvent(guid) {
	    const event = Model.getFrom(this._shopDataToLoad, 'events', guid, GET_BY_VALUE);
	    Model.castData.ofEvent(event);

	    this._enrichEvent(event);

	    return event;
	  }
	  /**
	   *  Used to get a transformed copy of an event out of the original data;
	   *  adding the corresponding tickets based on his ticket_guid prop
	   *  and casting the dates.
	   */


	  _getTransformedCollapse(guid) {
	    const collapse = Model.getFrom(this._shopDataToLoad, 'collapses', guid, GET_BY_VALUE);
	    collapse.tickets = [];
	    forEach$2(collapse.ticket_guids, ticketGuid => {
	      // Try to get the ticket out of the tickets map
	      const ticket = Model.getFrom(this.data, 'tickets_map', ticketGuid, GET_BY_REF, IGNORE_UNDEFINED); // Only try to add his reference if it's present
	      // (i) It might not be present because it got deleted in
	      // the shop but not directly in the collapse

	      if (ticket) {
	        Model.addTo(collapse.tickets, ticket);
	      }
	    }); // Sort the tickets based on their pivot-based computed index

	    collapse.tickets.sort(modelSort);
	    return collapse;
	  }
	  /**
	   *  Used to get a transformed copy of a payment method out of the original
	   *  data; adding a pricing object and moving the fees to that object.
	   */


	  _getTransformedPaymentMethod(guid) {
	    const paymentMethod = Model.getFrom(this._shopDataToLoad, 'paymentmethods', guid, GET_BY_VALUE); // @ts-ignore: moving the fees to the pricing object

	    const fees = this._transformFees(paymentMethod.fees); // @ts-ignore: moving the stripe public key to the stripe object


	    const stripePublicKey = paymentMethod.stripe_public_key; // @ts-ignore

	    delete paymentMethod.fees; // @ts-ignore

	    delete paymentMethod.stripe_public_key; // Enrich the payment method with a pricing object, including the fees

	    const pricing = {
	      fees,
	      vat: {
	        percentage: 0,
	        amount: 0
	      },
	      total_fees: 0
	    }; // Enrich the payment method with a stripe object

	    const stripe = stripePublicKey ? {
	      stripe_public_key: stripePublicKey,
	      complete: false,
	      errors: []
	    } : undefined;
	    return Object.assign(Object.assign({}, paymentMethod), {
	      pricing,
	      stripe
	    });
	  }
	  /**
	   *  Used to get a transformed copy of a product group out of the original data;
	   *  adding the corresponding products based on his members prop.
	   */


	  _getTransformedProductGroup(guid) {
	    const productGroup = Model.getFrom(this._shopDataToLoad, 'groups', guid, GET_BY_VALUE);
	    delete productGroup.members; // Always clean the products, as the dataset to load always
	    // contains all the pivots a group should contain

	    productGroup.products = [];

	    this._enrichGroup(productGroup); // If all products need to be selected to comply with
	    // the constraints, the group as a whole is 'required'


	    if (productGroup.min_bound === productGroup.max_bound && productGroup.max_bound === productGroup.products.length && productGroup.uniqueness === 1) {
	      productGroup.type = ProductGroupType.Required; // If only one of each can be selected, it will get a type
	      // that resolves to a custom input in the shop
	    } else if (productGroup.uniqueness === 1) {
	      // If there is only one option available and it's
	      // optional, the type is 'checkbox'
	      if (productGroup.max_bound === 1 && productGroup.min_bound === 0 && productGroup.products.length === 1) {
	        productGroup.type = ProductGroupType.Checkbox;
	      } else if (productGroup.max_bound === 1) {
	        // If only on item can be selected of all products in
	        // the group, the type will be 'select' or 'radio', as
	        // these are the input methods that fit the constraint
	        // If the length is larger than 3, the type - and therefore
	        // the input shown in the UI - should change
	        productGroup.type = productGroup.products.length > 3 ? ProductGroupType.Select : ProductGroupType.Radio; // If all items can be selected, but all at most once, the
	        // group will get the 'multiselect' or 'checkbox' type
	      } else {
	        // If the length is larger than 3, the type - and therefore
	        // the input shown in the UI -  should change
	        productGroup.type = productGroup.products.length > 3 ? ProductGroupType.Multiselect : ProductGroupType.Checkbox;
	      } // If the previous statements are not true, all products
	      // can be selected as long as they are in stock.
	      // (i) Optional is the default type for optional products

	    } else {
	      productGroup.type = ProductGroupType.Optional;
	    }

	    return productGroup;
	  }
	  /**
	   *  Used to get a transformed copy of a product out of the original data;
	   *  adding the corresponding metadata and event dates and adding
	   *  original and regular pricing object.
	   */


	  _getTransformedProduct(guid) {
	    // Only applies for regular products
	    if (!this._shopDataToLoad.products) {
	      throw new ShopError('The loaded shop data does not contain products');
	    } // First try to get the product out of the default products, otherwise
	    // out of the global products - but always throw the original error to
	    // keep consistent errors


	    let product = null;
	    let error = null;

	    try {
	      product = Model.getFrom(this._shopDataToLoad, 'products', guid, GET_BY_VALUE);
	    } catch (originalError) {
	      error = originalError;
	    }

	    if (!product) {
	      try {
	        product = Model.getFrom(this._shopDataToLoad, 'global_products', guid, GET_BY_VALUE);
	      } catch (e) {
	        throw error;
	      }
	    } // @ts-ignore Enrich the product with an original pricing object


	    const pricing = Price.createPricing(product.price, this._transformFees(product.fees), product.vat_percentage); // @ts-ignore: The following props get exposed via the pricing object

	    delete product.price; // @ts-ignore

	    delete product.fees;
	    product = Object.assign(Object.assign({}, product), {
	      pricing
	    }); // Enrich the product with his event dates and metadata

	    this._enrichProduct(product); // Compute the product pricing


	    Price.computeProductPricing(product.pricing); // @ts-ignore: The following props get exposed via the pricing object

	    delete product.price; // @ts-ignore

	    delete product.fees;
	    return product;
	  }
	  /**
	   *  Used to get a transformed copy of a ticket out of the original data;
	   *  adding the corresponding groups and products, original and regular
	   *  pricing objects and casting the dates.
	   */


	  _getTransformedTicket(guid) {
	    if (!this._shopDataToLoad.tickets) {
	      throw new ShopError('The loaded shop data does not contain tickets');
	    }

	    let ticket = Model.getFrom(this._shopDataToLoad, 'tickets', guid, GET_BY_VALUE); // Cast the data of the ticket

	    Model.castData.ofTicket(ticket); // @ts-ignore: Enrich the ticket with a ticket pricing object

	    const pricing = Price.createTicketPricing(0, this._transformFees(ticket.fees), ticket.vat_percentage); // @ts-ignore: Exposed via the pricing object

	    delete ticket.fees; // Enriching the ticket with his groups and products based on the pivots

	    this._enrichTicket(ticket); // Compute the ticket's pricing


	    Price.computeTicketPricing(pricing, ticket.min_price, ticket.products.all, IGNORE_OPTIONAL);
	    ticket = Object.assign(Object.assign({}, ticket), {
	      pricing,
	      available_from_margin: ticket.availability_margin && ticket.available_from ? new Date(ticket.available_from.getTime() - ticket.availability_margin * 60000) : null,
	      available_until_margin: ticket.availability_margin && ticket.available_until ? new Date(ticket.available_until.getTime() + ticket.availability_margin * 60000) : null
	    });
	    ticket.hidden = this._determineTicketHidden(ticket);

	    this._setTicketHiddenTimeout(ticket); // Create a copy of the original pricing to not alter the original pricing after applying coupons
	    // (i) Meaning the pricing should always be used to show correct numbers of the ticket


	    ticket.original_pricing = JSON.parse(JSON.stringify(ticket.pricing));
	    return ticket;
	  }
	  /**
	   *  Used to enrich the productGroup with his products models, based on the pivots.
	   */


	  _enrichGroup(group) {
	    const groupProducts = []; // First get all the products of the group based on the pivots

	    const productPivots = this._pivots.get({
	      key: PIVOTS_KEY_GROUPS_PRODUCTS,
	      item: {
	        guid: group.guid,
	        guid_key: 'group_id'
	      }
	    });

	    forEach$2(productPivots, pivot => {
	      const product = Model.getFrom(this.data, 'products_map', pivot.product_id);
	      Model.addTo(groupProducts, {
	        guid: product.guid,
	        group_guid: group.guid,
	        item: product,
	        index: -1,
	        uniqueness: pivot.uniqueness || null
	      });
	    }); // Compute the indexes of the products based on the pivots so they can easily be sorted

	    const pivotSettings = {
	      key: PIVOTS_KEY_GROUPS_PRODUCTS,
	      item: {
	        guid: '',
	        guid_key: 'product_id'
	      },
	      belongs_to: {
	        guid: group.guid,
	        guid_key: 'group_id'
	      }
	    };

	    this._pivots.computeIndexes(groupProducts, pivotSettings); // Make sure the order is correct based on the computed indexes


	    groupProducts.sort(modelSort);
	    group.products = groupProducts;
	  }
	  /**
	   *  Used to enrich the product with his event dates
	   *  and metadata models, based on the pivots.
	   */


	  _enrichProduct(product) {
	    // Always clean the event dates and metadata, as the dataset to
	    // load always contains all the pivots a product should contain
	    product.event_dates = [];
	    product.metadata = []; // The default pivot settings for getting the pivots of this product
	    // (!) The key is overwritten per pivot type below

	    const pivotSettings = {
	      key: '',
	      item: {
	        guid: product.guid,
	        guid_key: 'product_guid'
	      }
	    }; // Enrich the product with his event dates

	    const eventDatePivots = this._pivots.get(Object.assign(Object.assign({}, pivotSettings), {
	      key: PIVOTS_KEY_PRODUCTS_EVENT_DATES
	    }));

	    forEach$2(eventDatePivots, pivot => {
	      // Add reference to transformed event date
	      Model.addTo(product.event_dates, Model.getFrom(this.data, 'event_dates_map', pivot.event_date_guid));
	    }); // Enrich the product with its metadata

	    const metadataPivots = this._pivots.get(Object.assign(Object.assign({}, pivotSettings), {
	      key: PIVOTS_KEY_PRODUCTS_METADATA
	    }));

	    forEach$2(metadataPivots, pivot => {
	      const metadata = Model.getFrom(this.data, 'metadata_map', pivot.metadata_guid);
	      const shopMetadata = {
	        index: 0,
	        guid: metadata.guid,
	        item: metadata,
	        productId: product.guid
	      }; // Add reference to transformed metadata

	      Model.addTo(product.metadata, shopMetadata);
	    }); // Compute their indexes based on the pivots

	    this._pivots.computeIndexes(product.metadata, {
	      key: PIVOTS_KEY_PRODUCTS_METADATA,
	      item: {
	        guid: '',
	        guid_key: 'metadata_guid'
	      }
	    }); // Sort the metadata based on their pivot-based computed index,


	    product.metadata.sort(modelSort);
	  }
	  /**
	   *  Used to enrich the forwarded ticket with his product
	   *  group and product models, based on the pivots.
	   */


	  _enrichTicket(ticket) {
	    // Always clean the groups, as the dataset to load always
	    // contains all the pivots a ticket should contain
	    ticket.groups = []; // Add his product groups based on the pivots

	    let pivotSettings = {
	      key: PIVOTS_KEY_TICKETS_GROUPS,
	      item: {
	        guid: ticket.guid,
	        guid_key: 'ticket_guid'
	      }
	    };

	    const groupPivots = this._pivots.get(pivotSettings);

	    forEach$2(groupPivots, pivot => {
	      // Add reference to transformed product group
	      Model.addTo(ticket.groups, Model.getFrom(this.data, 'groups_map', pivot.group_guid));
	    }); // Compute their indexes based on the pivots

	    pivotSettings = {
	      key: PIVOTS_KEY_TICKETS_GROUPS,
	      item: {
	        guid: '',
	        guid_key: 'group_guid'
	      }
	    };

	    this._pivots.computeIndexes(ticket.groups, pivotSettings); // Sort the groups based on their pivot-based computed index,
	    // which was added while setting the groups


	    ticket.groups.sort(modelSort); // Get the products of the ticket, divided in all, required and optional

	    ticket.products = this._getTicketProducts(ticket.guid, ticket.groups);
	  }
	  /**
	   *  Used to enrich the forwarded event with a holder
	   *  for his global products (which are set in the
	   *  _setGlobalProducts method), his ticket and event
	   *  date models, his start and end date based on his
	   *  attached event dates and the sorted items list.
	   */


	  _enrichEvent(event) {
	    // Create an Array for holding his global products, which
	    // is filled in the _setGlobalProducts method
	    event.global_products = []; // Add tickets based on the pivots

	    event.tickets = [];

	    const eventTicketPivots = this._pivots.get({
	      key: PIVOTS_KEY_EVENTS_TICKETS,
	      item: {
	        guid: event.guid,
	        guid_key: 'event_guid'
	      }
	    });

	    forEach$2(eventTicketPivots, pivot => {
	      // Add reference to transformed ticket
	      Model.addTo(event.tickets, Model.getFrom(this.data, 'tickets_map', pivot.ticket_guid));
	    }); // Sort the tickets based on their pivot-based computed index

	    event.tickets.sort(modelSort); // Compute the start and end date based on the nearest and
	    // furthest event dates that are part of the event

	    const eventDates = []; // Make sure to use the transformed event dates for more
	    // easily computing the event's start and end date

	    forOwn(this.data.event_dates_map, eventDate => {
	      if (eventDate.event_id === event.guid) {
	        eventDates.push(eventDate);
	      }
	    }); // Compute the start and end based on his event dates

	    event.start = null;
	    event.end = null;

	    if (eventDates.length) {
	      let nearest;
	      let furthest;

	      if (eventDates.length === 1) {
	        event.start = eventDates[0].start;
	        event.end = eventDates[0].end;
	      } else {
	        // The model sort sorts on start by default
	        nearest = eventDates.slice().sort(modelSort)[0]; // The furthest should however be sorted based on his end date

	        furthest = eventDates.slice().sort((eventDateA, eventDateB) => {
	          const timeA = eventDateA.end.getTime();
	          const timeB = eventDateB.end.getTime();
	          return timeA === timeB ? 0 : timeA > timeB ? -1 : 1;
	        })[0];
	        event.start = nearest.start;
	        event.end = furthest.end;
	      }
	    } // Add the sorted items


	    this._addEventSortedItems(event);

	    event.hidden = this._determineEventHidden(event, true);
	  }
	  /**
	   *  A ticket can be hidden by coupons or by availability
	   *
	   *  If the ticket is not yet / no longer available,
	   *  the ticket should be hidden if it is outside the availability margin.
	   *
	   *  If the ticket should be hidden without coupon,
	   *  All coupons should be checked for the ticket to be visible.
	   *
	   *  @param ticket Ticket to determine hidden property for
	   *  @param addedCouponItem When a coupon is added, the CouponApplicable item can be given to save looping over all coupon items.
	   */


	  _determineTicketHidden(ticket, addedCouponItem) {
	    // Hide if now is before available from (taking margin into account).
	    if (ticket.available_from_margin && Date.now() < ticket.available_from_margin.getTime()) {
	      return true;
	    } // Hide if now is after available until (taking margin into account).


	    if (ticket.available_until_margin && Date.now() > ticket.available_until_margin.getTime()) {
	      return true;
	    } // Show if not hide without coupon.


	    if (!ticket.hide_without_coupon) {
	      return false;
	    } // Determine Show/Hide directly if a coupon was added.


	    if (addedCouponItem && addedCouponItem.ticket && addedCouponItem.ticket.guid === ticket.guid) {
	      // Show if the coupon is for the current ticket
	      return false;
	    } // When this is run BEFORE the cart is initialized,
	    // coupons can not be added yet anyway.
	    // The ticket should be hidden.


	    if (!this.cart) {
	      return true;
	    } // Determine Show/Hide for all coupons if no applicable coupon given.


	    let hideTicket = true;
	    forOwn(this.cart.getAppliedCoupons(), appliedCoupon => {
	      forEach$2(appliedCoupon.appliesTo.shop, applicableCoupon => {
	        if (applicableCoupon.ticket && applicableCoupon.ticket.guid === ticket.guid) {
	          hideTicket = false;
	        }
	      });
	    });
	    return hideTicket;
	  } // noinspection JSMethodCanBeStatic

	  /**
	   *  An event item can be hidden when none of its tickets are visible
	   */


	  _determineEventItemHidden(item) {
	    if (!item.tickets.length) {
	      return true;
	    }

	    return !item.tickets.some(ticket => !ticket.hidden);
	  }
	  /**
	   *  Determine if an event has no visible items.
	   *
	   *  @param event The event to check the hidden value for
	   *  @param checkAndUpdateItems Update the event items with their hidden values
	   */


	  _determineEventHidden(event, checkAndUpdateItems = false) {
	    if (!event.items.length) {
	      return true;
	    }

	    if (checkAndUpdateItems) {
	      forEach$2(event.items, item => {
	        item.hidden = this._determineEventItemHidden(item);
	      });
	    }

	    return !event.items.some(item => !item.hidden);
	  }
	  /**
	   *  Register the timeouts for ticket availability.
	   *
	   *  E.g.: Show and hide depending on the availability window.
	   */


	  _setTicketHiddenTimeout(ticket) {
	    // Let's take 1 ms to ensure the fluctuation in Date and comparisons will never
	    // result in the wrong hidden value.
	    const margin = 1;

	    if (ticket.available_from_margin && (!ticket.available_until_margin || ticket.available_from_margin < ticket.available_until_margin)) {
	      const msToVisible = ticket.available_from_margin.getTime() - Date.now();

	      if (msToVisible > 0) {
	        setLargeTimeout(() => {
	          ticket.hidden = this._determineTicketHidden(ticket);
	          const event = this.data.events_map[ticket.event_id];
	          event.hidden = this._determineEventHidden(event, true);
	        }, Math.max(0, msToVisible) + margin);
	      }
	    }

	    if (ticket.available_until_margin) {
	      const msToHidden = ticket.available_until_margin.getTime() - Date.now();

	      if (msToHidden > 0) {
	        setLargeTimeout(() => {
	          ticket.hidden = this._determineTicketHidden(ticket);
	          const event = this.data.events_map[ticket.event_id];
	          event.hidden = this._determineEventHidden(event, true);
	        }, Math.max(0, msToHidden) + margin);
	      }
	    }

	    if (ticket.available_from && (!ticket.available_until || ticket.available_from < ticket.available_until)) {
	      const msToAvailable = ticket.available_from.getTime() - Date.now();

	      if (msToAvailable > 0) {
	        setLargeTimeout(() => {
	          if (ticket.available_from && ticket.available_from.getTime() - Date.now() < 0 && ticket.status === 'not_sold_right_now') {
	            ticket.status = 'available';
	          }
	        }, Math.max(0, msToAvailable) + margin);
	      }
	    }

	    if (ticket.available_until) {
	      const msToNotAvailable = ticket.available_until.getTime() - Date.now();

	      if (msToNotAvailable > 0) {
	        setLargeTimeout(() => {
	          if (ticket.available_until && ticket.available_until.getTime() - Date.now() < 0 && ticket.status === 'available') {
	            ticket.status = 'not_sold_right_now';
	          }
	        }, Math.max(0, msToNotAvailable) + margin);
	      }
	    }
	  }
	  /**
	   *  Used to compute and add the sorted items Array of
	   *  an event. It includes a mixed up sorted collection
	   *  of collapses and tickets that belong to the event.
	   */


	  _addEventSortedItems(event) {
	    event.items = []; // Keep track of the guids that are already added to the items
	    // to make sure collapses are not being added twice

	    const addedItemGuids = {}; // Method for finding the corresponding collapse of a ticket

	    const correspondingCollapse = ticketGuid => {
	      let ticketCollapse = undefined;
	      forOwn(this.data.collapses_map, collapse => {
	        if (collapse.ticket_guids.indexOf(ticketGuid) > -1) {
	          ticketCollapse = collapse;
	        }

	        return !ticketCollapse;
	      });
	      return ticketCollapse;
	    }; // Tickets are already sorted in the above method


	    forEach$2(event.tickets, ticket => {
	      const collapse = correspondingCollapse(ticket.guid);
	      const item = collapse || ticket;
	      const eventItem = {
	        index: item.index,
	        type: collapse ? 'collapse' : 'ticket',
	        item,
	        tickets: [],
	        hidden: false
	      };

	      if (!addedItemGuids[item.guid]) {
	        // Collect refs to tickets in the collapse that belong to this event
	        if (collapse) {
	          forEach$2(collapse.tickets, ticket => {
	            if (ticket.event_id === event.guid) {
	              eventItem.tickets.push(ticket);
	            }
	          }); // When no tickets are present for the current event in this collapse,
	          // continue to the next ticket.
	          // This can happen if the shop data does not follow the event-ticket relation
	          // via the ticket.event_id, but through event dates.

	          if (!eventItem.tickets.length) {
	            return;
	          } // The default index of a collapse has been set to the index of his
	          // top ticket, but it might happen that the initial top ticket does
	          // not belong to this event. So we need to make sure it gets the
	          // index of the top ticket that belong to this event


	          eventItem.index = eventItem.tickets[0].index;
	        } else {
	          // Or only add a ref to the single ticket, so it's always exposed in an uniform way
	          eventItem.tickets = [ticket];
	        }

	        eventItem.hidden = this._determineEventItemHidden(eventItem);
	        event.items.push(eventItem); // Make sure this item is only added once

	        addedItemGuids[item.guid] = item.guid;
	      }
	    }); // Sort the items based on their computed index, which is working correctly
	    // because every (event) collapse gets the index of his top ticket assigned

	    event.items.sort(modelSort);
	  }
	  /**
	   *  Used to get a sorted product collection of a ticket, which includes a
	   *  collection of; all products (including optional and required),
	   *  optional products and required products - all sorted.
	   */


	  _getTicketProducts(guid, groups) {
	    const products = [];
	    const ticketProducts = {
	      all: [],
	      optional: [],
	      required: []
	    }; // First get all the products of the ticket based on the pivots

	    const productPivots = this._pivots.get({
	      key: PIVOTS_KEY_PRODUCTS_TICKETS,
	      item: {
	        guid,
	        guid_key: 'ticket_guid'
	      }
	    });

	    forEach$2(productPivots, pivot => {
	      // Add reference to transformed product
	      Model.addTo(products, Model.getFrom(this.data, 'products_map', pivot.product_guid));
	    });
	    /**
	     *  Used to define if the forwarded product is required, based on
	     *  the fact if it's ungrouped or in a required group.
	     */

	    const isRequired = productToCheck => {
	      // Every product that is not in a group is required
	      let unGrouped = true;
	      forEach$2(groups, group => {
	        forEach$2(group.products, groupProduct => {
	          if (groupProduct.guid === productToCheck.guid) {
	            return unGrouped = false;
	          }
	        });
	        return unGrouped;
	      });

	      if (unGrouped) {
	        return true;
	      } // Every product that is in a required group is required


	      let required = false;
	      forEach$2(groups, group => {
	        if (group.type === ProductGroupType.Required) {
	          forEach$2(group.products, groupProduct => {
	            if (groupProduct.guid === productToCheck.guid) {
	              required = true;
	            }

	            return !required;
	          });
	          return !required;
	        }
	      });
	      return required;
	    };
	    /**
	     *
	     *  Create a ticket product for every product, holding its index, is_optional
	     *  and pricing relative to (t)his ticket and a ref to the original product,
	     *  as the index, is_optional and pricing are relative to the ticket.
	     *
	     *  (!) It should first create the collection before it can compute
	     *  the indexes because the full collection is needed when the preceding
	     *  sequence breaks and it sets the indexes based on provided order
	     *
	     */


	    forEach$2(products, product => {
	      const shopProduct = {
	        index: -1,
	        guid: product.guid,
	        ticket_guid: guid,
	        item: product,
	        is_optional: !isRequired(product),
	        pricing: JSON.parse(JSON.stringify(product.pricing))
	      }; // The original product model does not hold coupons, because coupons
	      // are being applied to the ShopProduct wrapper instead

	      shopProduct.pricing.coupons = {};
	      ticketProducts.all.push(shopProduct);
	    }); // Compute the indexes of the products based on the pivots so they can easily be sorted

	    const pivotSettings = {
	      key: PIVOTS_KEY_PRODUCTS_TICKETS,
	      item: {
	        guid: '',
	        guid_key: 'product_guid'
	      },
	      belongs_to: {
	        guid,
	        guid_key: 'ticket_guid'
	      }
	    };

	    this._pivots.computeIndexes(ticketProducts.all, pivotSettings); // Make sure the order is correct based on the computed indexes


	    ticketProducts.all.sort(modelSort); // All products are required if no groups are present

	    if (!groups.length) {
	      ticketProducts.required = ticketProducts.all;
	    } else {
	      // Divide the product refs over optional and required
	      forEach$2(ticketProducts.all, ticketProduct => {
	        ticketProducts[ticketProduct.is_optional ? 'optional' : 'required'].push(ticketProduct);
	      }); // Sort the ticket products again in their own Array to make sure their
	      // order is correct after dividing them in the two collections

	      ticketProducts.optional.sort(modelSort);
	      ticketProducts.required.sort(modelSort);
	    }

	    return ticketProducts;
	  } // noinspection JSMethodCanBeStatic

	  /**
	   *  Used to transform a fees object; summing up the fixed and percentage
	   *  fees (removing the distinction of the self and other) and removing
	   *  the returned total.
	   */


	  _transformFees(fees) {
	    // @ts-ignore
	    fees.fixed = fees.self.fixed + fees.other.fixed; // @ts-ignore

	    fees.percentage = fees.self.percentages + fees.other.percentages; // @ts-ignore

	    delete fees.self; // @ts-ignore

	    delete fees.other; // @ts-ignore

	    delete fees.total;
	    return fees;
	  }

	  _calculateCouponApplicableItems(coupon) {
	    /**
	     *  A collection that holds all the global products of the shop, including the
	     *  ones who are part of an event and the ones who aren't.
	     */
	    const allGlobalProducts = {}; // Collect all global products that are part of an event

	    forEach$2(this.data.events, event => {
	      forEach$2(event.global_products, globalProduct => {
	        allGlobalProducts[globalProduct.guid] = globalProduct;
	      });
	    }); // Collect all remaining global products that are not part of an event

	    forEach$2(this.data.global_products, globalProduct => {
	      allGlobalProducts[globalProduct.guid] = globalProduct;
	    });
	    /**
	     *  A collection that holds all the required products in the shop, as the coupon
	     *  should be applied to each of them as their pricing is loose from the original
	     *  product and relative to the ticket he's in.
	     *
	     *  (i) Separate because this single level collection should be forwarded to the
	     *  coupon's method for computing the applicable items
	     */

	    const allRequiredTicketProducts = {};
	    /**
	     *  A collection that holds a ref to the ticket of a specific ticket product,
	     *  for easily getting it for adding it to the collection of applicable items.
	     */

	    const productTicket = {}; // Fn to create a unique ticket/product id for saving refs in the above collections

	    const constructTicketProductId = ticketProduct => {
	      return `${ticketProduct.ticket_guid}-${ticketProduct.guid}`;
	    }; // Fill the above collections based on every ticket in the shop


	    forEach$2(this.data.tickets, ticket => {
	      forEach$2(ticket.products.required, ticketProduct => {
	        // Because the coupon should be applied once on every ticket/product combination in the shop
	        const ticketProductGuid = constructTicketProductId(ticketProduct);
	        allRequiredTicketProducts[ticketProductGuid] = ticketProduct;
	        productTicket[ticketProductGuid] = ticket;
	      });
	    });
	    /**
	     *  Used by the getApplicableItems() method to get the ticket of
	     *  the product to which the coupon applies.
	     *
	     *  (i) It doesn't have a ticket when it's about a global product
	     */

	    const getTicketOfProduct = ticketProduct => {
	      if (!ticketProduct.ticket_guid) {
	        return undefined;
	      }

	      return productTicket[constructTicketProductId(ticketProduct)];
	    }; // Collect every ticket product and his ticket that is applicable for the coupon


	    return Coupon.getApplicableItems(coupon.item, Object.assign(Object.assign({}, allGlobalProducts), allRequiredTicketProducts), getTicketOfProduct);
	  }

	}

	undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	  function adopt(value) {
	    return value instanceof P ? value : new P(function (resolve) {
	      resolve(value);
	    });
	  }

	  return new (P || (P = Promise))(function (resolve, reject) {
	    function fulfilled(value) {
	      try {
	        step(generator.next(value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function rejected(value) {
	      try {
	        step(generator["throw"](value));
	      } catch (e) {
	        reject(e);
	      }
	    }

	    function step(result) {
	      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
	    }

	    step((generator = generator.apply(thisArg, _arguments || [])).next());
	  });
	};

	// @ts-ignore
	if (!global._babelPolyfill) {
	  require('babel-polyfill');
	}
	window.OpenTicket = Object.assign(window.OpenTicket || {}, {
	  createShop() {
	    return new OpenTicketShop();
	  }

	});

	var axios$2 = {exports: {}};

	var bind$2 = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);

	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }

	    return fn.apply(thisArg, args);
	  };
	};

	var bind$1 = bind$2; // utils is a library of generic helper functions non-specific to axios

	var toString = Object.prototype.toString;
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */

	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */


	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */


	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */


	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */


	function isFormData(val) {
	  return typeof FormData !== 'undefined' && val instanceof FormData;
	}
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */


	function isArrayBufferView(val) {
	  var result;

	  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
	  }

	  return result;
	}
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */


	function isString(val) {
	  return typeof val === 'string';
	}
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */


	function isNumber(val) {
	  return typeof val === 'number';
	}
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */


	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */


	function isPlainObject(val) {
	  if (toString.call(val) !== '[object Object]') {
	    return false;
	  }

	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */


	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */


	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */


	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */


	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */


	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */


	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */


	function trim(str) {
	  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */


	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
	    return false;
	  }

	  return typeof window !== 'undefined' && typeof document !== 'undefined';
	}
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */


	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  } // Force an array if not already something iterable


	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }

	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */


	function
	  /* obj1, obj2, obj3, ... */
	merge() {
	  var result = {};

	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }

	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }

	  return result;
	}
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */


	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind$1(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */


	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }

	  return content;
	}

	var utils$d = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM
	};

	var utils$c = utils$d;

	function encode(val) {
	  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
	}
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */


	var buildURL$2 = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }

	  var serializedParams;

	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils$c.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	    utils$c.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }

	      if (utils$c.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }

	      utils$c.forEach(val, function parseValue(v) {
	        if (utils$c.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils$c.isObject(v)) {
	          v = JSON.stringify(v);
	        }

	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	    serializedParams = parts.join('&');
	  }

	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');

	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }

	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }

	  return url;
	};

	var utils$b = utils$d;

	function InterceptorManager$1() {
	  this.handlers = [];
	}
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */


	InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected,
	    synchronous: options ? options.synchronous : false,
	    runWhen: options ? options.runWhen : null
	  });
	  return this.handlers.length - 1;
	};
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */


	InterceptorManager$1.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */


	InterceptorManager$1.prototype.forEach = function forEach(fn) {
	  utils$b.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};

	var InterceptorManager_1 = InterceptorManager$1;

	var utils$a = utils$d;

	var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
	  utils$a.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};

	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */


	var enhanceError$2 = function enhanceError(error, config, code, request, response) {
	  error.config = config;

	  if (code) {
	    error.code = code;
	  }

	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;

	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code,
	      status: this.response && this.response.status ? this.response.status : null
	    };
	  };

	  return error;
	};

	var enhanceError$1 = enhanceError$2;
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */

	var createError$2 = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError$1(error, config, code, request, response);
	};

	var createError$1 = createError$2;
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */

	var settle$1 = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;

	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError$1('Request failed with status code ' + response.status, response.config, null, response.request, response));
	  }
	};

	var utils$9 = utils$d;
	var cookies$1 = utils$9.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
	function standardBrowserEnv() {
	  return {
	    write: function write(name, value, expires, path, domain, secure) {
	      var cookie = [];
	      cookie.push(name + '=' + encodeURIComponent(value));

	      if (utils$9.isNumber(expires)) {
	        cookie.push('expires=' + new Date(expires).toGMTString());
	      }

	      if (utils$9.isString(path)) {
	        cookie.push('path=' + path);
	      }

	      if (utils$9.isString(domain)) {
	        cookie.push('domain=' + domain);
	      }

	      if (secure === true) {
	        cookie.push('secure');
	      }

	      document.cookie = cookie.join('; ');
	    },
	    read: function read(name) {
	      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	      return match ? decodeURIComponent(match[3]) : null;
	    },
	    remove: function remove(name) {
	      this.write(name, '', Date.now() - 86400000);
	    }
	  };
	}() : // Non standard browser env (web workers, react-native) lack needed support.
	function nonStandardBrowserEnv() {
	  return {
	    write: function write() {},
	    read: function read() {
	      return null;
	    },
	    remove: function remove() {}
	  };
	}();

	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */


	var isAbsoluteURL$1 = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};

	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */


	var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
	  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
	};

	var isAbsoluteURL = isAbsoluteURL$1;
	var combineURLs = combineURLs$1;
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */

	var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }

	  return requestedURL;
	};

	var utils$8 = utils$d; // Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers

	var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */

	var parseHeaders$1 = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;

	  if (!headers) {
	    return parsed;
	  }

	  utils$8.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils$8.trim(line.substr(0, i)).toLowerCase();
	    val = utils$8.trim(line.substr(i + 1));

	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }

	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	  return parsed;
	};

	var utils$7 = utils$d;
	var isURLSameOrigin$1 = utils$7.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
	// whether the request URL is of the same origin as current location.
	function standardBrowserEnv() {
	  var msie = /(msie|trident)/i.test(navigator.userAgent);
	  var urlParsingNode = document.createElement('a');
	  var originURL;
	  /**
	  * Parse a URL to discover it's components
	  *
	  * @param {String} url The URL to be parsed
	  * @returns {Object}
	  */

	  function resolveURL(url) {
	    var href = url;

	    if (msie) {
	      // IE needs attribute set twice to normalize properties
	      urlParsingNode.setAttribute('href', href);
	      href = urlParsingNode.href;
	    }

	    urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

	    return {
	      href: urlParsingNode.href,
	      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	      host: urlParsingNode.host,
	      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	      hostname: urlParsingNode.hostname,
	      port: urlParsingNode.port,
	      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
	    };
	  }

	  originURL = resolveURL(window.location.href);
	  /**
	  * Determine if a URL shares the same origin as the current location
	  *
	  * @param {String} requestURL The URL to test
	  * @returns {boolean} True if URL shares the same origin, otherwise false
	  */

	  return function isURLSameOrigin(requestURL) {
	    var parsed = utils$7.isString(requestURL) ? resolveURL(requestURL) : requestURL;
	    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
	  };
	}() : // Non standard browser envs (web workers, react-native) lack needed support.
	function nonStandardBrowserEnv() {
	  return function isURLSameOrigin() {
	    return true;
	  };
	}();

	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */


	function Cancel$3(message) {
	  this.message = message;
	}

	Cancel$3.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};

	Cancel$3.prototype.__CANCEL__ = true;
	var Cancel_1 = Cancel$3;

	var utils$6 = utils$d;
	var settle = settle$1;
	var cookies = cookies$1;
	var buildURL$1 = buildURL$2;
	var buildFullPath = buildFullPath$1;
	var parseHeaders = parseHeaders$1;
	var isURLSameOrigin = isURLSameOrigin$1;
	var createError = createError$2;
	var defaults$4 = defaults_1;
	var Cancel$2 = Cancel_1;

	var xhr = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;
	    var onCanceled;

	    function done() {
	      if (config.cancelToken) {
	        config.cancelToken.unsubscribe(onCanceled);
	      }

	      if (config.signal) {
	        config.signal.removeEventListener('abort', onCanceled);
	      }
	    }

	    if (utils$6.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }

	    var request = new XMLHttpRequest(); // HTTP basic authentication

	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }

	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

	    request.timeout = config.timeout;

	    function onloadend() {
	      if (!request) {
	        return;
	      } // Prepare the response


	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	      settle(function _resolve(value) {
	        resolve(value);
	        done();
	      }, function _reject(err) {
	        reject(err);
	        done();
	      }, response); // Clean up request

	      request = null;
	    }

	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        } // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request


	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        } // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'


	        setTimeout(onloadend);
	      };
	    } // Handle browser request cancellation (as opposed to a manual cancellation)


	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }

	      reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

	      request = null;
	    }; // Handle low level network errors


	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request)); // Clean up request

	      request = null;
	    }; // Handle timeout


	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
	      var transitional = config.transitional || defaults$4.transitional;

	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }

	      reject(createError(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request)); // Clean up request

	      request = null;
	    }; // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.


	    if (utils$6.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    } // Add headers to the request


	    if ('setRequestHeader' in request) {
	      utils$6.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    } // Add withCredentials to request if needed


	    if (!utils$6.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    } // Add responseType to request if needed


	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    } // Handle progress if needed


	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    } // Not all browsers support upload events


	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }

	    if (config.cancelToken || config.signal) {
	      // Handle cancellation
	      // eslint-disable-next-line func-names
	      onCanceled = function (cancel) {
	        if (!request) {
	          return;
	        }

	        reject(!cancel || cancel && cancel.type ? new Cancel$2('canceled') : cancel);
	        request.abort();
	        request = null;
	      };

	      config.cancelToken && config.cancelToken.subscribe(onCanceled);

	      if (config.signal) {
	        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
	      }
	    }

	    if (!requestData) {
	      requestData = null;
	    } // Send the request


	    request.send(requestData);
	  });
	};

	var utils$5 = utils$d;
	var normalizeHeaderName = normalizeHeaderName$1;
	var enhanceError = enhanceError$2;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};

	function setContentTypeIfUnset(headers, value) {
	  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}

	function getDefaultAdapter() {
	  var adapter;

	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = xhr;
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = xhr;
	  }

	  return adapter;
	}

	function stringifySafely(rawValue, parser, encoder) {
	  if (utils$5.isString(rawValue)) {
	    try {
	      (parser || JSON.parse)(rawValue);
	      return utils$5.trim(rawValue);
	    } catch (e) {
	      if (e.name !== 'SyntaxError') {
	        throw e;
	      }
	    }
	  }

	  return (encoder || JSON.stringify)(rawValue);
	}

	var defaults$3 = {
	  transitional: {
	    silentJSONParsing: true,
	    forcedJSONParsing: true,
	    clarifyTimeoutError: false
	  },
	  adapter: getDefaultAdapter(),
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');

	    if (utils$5.isFormData(data) || utils$5.isArrayBuffer(data) || utils$5.isBuffer(data) || utils$5.isStream(data) || utils$5.isFile(data) || utils$5.isBlob(data)) {
	      return data;
	    }

	    if (utils$5.isArrayBufferView(data)) {
	      return data.buffer;
	    }

	    if (utils$5.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }

	    if (utils$5.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
	      setContentTypeIfUnset(headers, 'application/json');
	      return stringifySafely(data);
	    }

	    return data;
	  }],
	  transformResponse: [function transformResponse(data) {
	    var transitional = this.transitional || defaults$3.transitional;
	    var silentJSONParsing = transitional && transitional.silentJSONParsing;
	    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

	    if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data) && data.length) {
	      try {
	        return JSON.parse(data);
	      } catch (e) {
	        if (strictJSONParsing) {
	          if (e.name === 'SyntaxError') {
	            throw enhanceError(e, this, 'E_JSON_PARSE');
	          }

	          throw e;
	        }
	      }
	    }

	    return data;
	  }],

	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	  maxContentLength: -1,
	  maxBodyLength: -1,
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  },
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    }
	  }
	};
	utils$5.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults$3.headers[method] = {};
	});
	utils$5.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
	});
	var defaults_1 = defaults$3;

	var utils$4 = utils$d;
	var defaults$2 = defaults_1;
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */

	var transformData$1 = function transformData(data, headers, fns) {
	  var context = this || defaults$2;
	  /*eslint no-param-reassign:0*/

	  utils$4.forEach(fns, function transform(fn) {
	    data = fn.call(context, data, headers);
	  });
	  return data;
	};

	var isCancel$1 = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};

	var utils$3 = utils$d;
	var transformData = transformData$1;
	var isCancel = isCancel$1;
	var defaults$1 = defaults_1;
	var Cancel$1 = Cancel_1;
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */

	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }

	  if (config.signal && config.signal.aborted) {
	    throw new Cancel$1('canceled');
	  }
	}
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */


	var dispatchRequest$1 = function dispatchRequest(config) {
	  throwIfCancellationRequested(config); // Ensure headers exist

	  config.headers = config.headers || {}; // Transform request data

	  config.data = transformData.call(config, config.data, config.headers, config.transformRequest); // Flatten headers

	  config.headers = utils$3.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
	  utils$3.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
	    delete config.headers[method];
	  });
	  var adapter = config.adapter || defaults$1.adapter;
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config); // Transform response data

	    response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config); // Transform response data

	      if (reason && reason.response) {
	        reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
	      }
	    }

	    return Promise.reject(reason);
	  });
	};

	var utils$2 = utils$d;
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */

	var mergeConfig$2 = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};

	  function getMergedValue(target, source) {
	    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
	      return utils$2.merge(target, source);
	    } else if (utils$2.isPlainObject(source)) {
	      return utils$2.merge({}, source);
	    } else if (utils$2.isArray(source)) {
	      return source.slice();
	    }

	    return source;
	  } // eslint-disable-next-line consistent-return


	  function mergeDeepProperties(prop) {
	    if (!utils$2.isUndefined(config2[prop])) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils$2.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  } // eslint-disable-next-line consistent-return


	  function valueFromConfig2(prop) {
	    if (!utils$2.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    }
	  } // eslint-disable-next-line consistent-return


	  function defaultToConfig2(prop) {
	    if (!utils$2.isUndefined(config2[prop])) {
	      return getMergedValue(undefined, config2[prop]);
	    } else if (!utils$2.isUndefined(config1[prop])) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  } // eslint-disable-next-line consistent-return


	  function mergeDirectKeys(prop) {
	    if (prop in config2) {
	      return getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      return getMergedValue(undefined, config1[prop]);
	    }
	  }

	  var mergeMap = {
	    'url': valueFromConfig2,
	    'method': valueFromConfig2,
	    'data': valueFromConfig2,
	    'baseURL': defaultToConfig2,
	    'transformRequest': defaultToConfig2,
	    'transformResponse': defaultToConfig2,
	    'paramsSerializer': defaultToConfig2,
	    'timeout': defaultToConfig2,
	    'timeoutMessage': defaultToConfig2,
	    'withCredentials': defaultToConfig2,
	    'adapter': defaultToConfig2,
	    'responseType': defaultToConfig2,
	    'xsrfCookieName': defaultToConfig2,
	    'xsrfHeaderName': defaultToConfig2,
	    'onUploadProgress': defaultToConfig2,
	    'onDownloadProgress': defaultToConfig2,
	    'decompress': defaultToConfig2,
	    'maxContentLength': defaultToConfig2,
	    'maxBodyLength': defaultToConfig2,
	    'transport': defaultToConfig2,
	    'httpAgent': defaultToConfig2,
	    'httpsAgent': defaultToConfig2,
	    'cancelToken': defaultToConfig2,
	    'socketPath': defaultToConfig2,
	    'responseEncoding': defaultToConfig2,
	    'validateStatus': mergeDirectKeys
	  };
	  utils$2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
	    var merge = mergeMap[prop] || mergeDeepProperties;
	    var configValue = merge(prop);
	    utils$2.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
	  });
	  return config;
	};

	var data = {
	  "version": "0.24.0"
	};

	var VERSION = data.version;
	var validators$1 = {}; // eslint-disable-next-line func-names

	['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
	  validators$1[type] = function validator(thing) {
	    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	  };
	});
	var deprecatedWarnings = {};
	/**
	 * Transitional option validator
	 * @param {function|boolean?} validator - set to false if the transitional option has been removed
	 * @param {string?} version - deprecated version / removed since version
	 * @param {string?} message - some message with additional info
	 * @returns {function}
	 */

	validators$1.transitional = function transitional(validator, version, message) {
	  function formatMessage(opt, desc) {
	    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	  } // eslint-disable-next-line func-names


	  return function (value, opt, opts) {
	    if (validator === false) {
	      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
	    }

	    if (version && !deprecatedWarnings[opt]) {
	      deprecatedWarnings[opt] = true; // eslint-disable-next-line no-console

	      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
	    }

	    return validator ? validator(value, opt, opts) : true;
	  };
	};
	/**
	 * Assert object's properties type
	 * @param {object} options
	 * @param {object} schema
	 * @param {boolean?} allowUnknown
	 */


	function assertOptions(options, schema, allowUnknown) {
	  if (typeof options !== 'object') {
	    throw new TypeError('options must be an object');
	  }

	  var keys = Object.keys(options);
	  var i = keys.length;

	  while (i-- > 0) {
	    var opt = keys[i];
	    var validator = schema[opt];

	    if (validator) {
	      var value = options[opt];
	      var result = value === undefined || validator(value, opt, options);

	      if (result !== true) {
	        throw new TypeError('option ' + opt + ' must be ' + result);
	      }

	      continue;
	    }

	    if (allowUnknown !== true) {
	      throw Error('Unknown option ' + opt);
	    }
	  }
	}

	var validator$1 = {
	  assertOptions: assertOptions,
	  validators: validators$1
	};

	var utils$1 = utils$d;
	var buildURL = buildURL$2;
	var InterceptorManager = InterceptorManager_1;
	var dispatchRequest = dispatchRequest$1;
	var mergeConfig$1 = mergeConfig$2;
	var validator = validator$1;
	var validators = validator.validators;
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */

	function Axios$1(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */


	Axios$1.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }

	  config = mergeConfig$1(this.defaults, config); // Set config.method

	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }

	  var transitional = config.transitional;

	  if (transitional !== undefined) {
	    validator.assertOptions(transitional, {
	      silentJSONParsing: validators.transitional(validators.boolean),
	      forcedJSONParsing: validators.transitional(validators.boolean),
	      clarifyTimeoutError: validators.transitional(validators.boolean)
	    }, false);
	  } // filter out skipped interceptors


	  var requestInterceptorChain = [];
	  var synchronousRequestInterceptors = true;
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	      return;
	    }

	    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	  var responseInterceptorChain = [];
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	  var promise;

	  if (!synchronousRequestInterceptors) {
	    var chain = [dispatchRequest, undefined];
	    Array.prototype.unshift.apply(chain, requestInterceptorChain);
	    chain = chain.concat(responseInterceptorChain);
	    promise = Promise.resolve(config);

	    while (chain.length) {
	      promise = promise.then(chain.shift(), chain.shift());
	    }

	    return promise;
	  }

	  var newConfig = config;

	  while (requestInterceptorChain.length) {
	    var onFulfilled = requestInterceptorChain.shift();
	    var onRejected = requestInterceptorChain.shift();

	    try {
	      newConfig = onFulfilled(newConfig);
	    } catch (error) {
	      onRejected(error);
	      break;
	    }
	  }

	  try {
	    promise = dispatchRequest(newConfig);
	  } catch (error) {
	    return Promise.reject(error);
	  }

	  while (responseInterceptorChain.length) {
	    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	  }

	  return promise;
	};

	Axios$1.prototype.getUri = function getUri(config) {
	  config = mergeConfig$1(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	}; // Provide aliases for supported request methods


	utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios$1.prototype[method] = function (url, config) {
	    return this.request(mergeConfig$1(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios$1.prototype[method] = function (url, data, config) {
	    return this.request(mergeConfig$1(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	var Axios_1 = Axios$1;

	var Cancel = Cancel_1;
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */

	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }

	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	  var token = this; // eslint-disable-next-line func-names

	  this.promise.then(function (cancel) {
	    if (!token._listeners) return;
	    var i;
	    var l = token._listeners.length;

	    for (i = 0; i < l; i++) {
	      token._listeners[i](cancel);
	    }

	    token._listeners = null;
	  }); // eslint-disable-next-line func-names

	  this.promise.then = function (onfulfilled) {
	    var _resolve; // eslint-disable-next-line func-names


	    var promise = new Promise(function (resolve) {
	      token.subscribe(resolve);
	      _resolve = resolve;
	    }).then(onfulfilled);

	    promise.cancel = function reject() {
	      token.unsubscribe(_resolve);
	    };

	    return promise;
	  };

	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }

	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */


	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	/**
	 * Subscribe to the cancel signal
	 */


	CancelToken.prototype.subscribe = function subscribe(listener) {
	  if (this.reason) {
	    listener(this.reason);
	    return;
	  }

	  if (this._listeners) {
	    this._listeners.push(listener);
	  } else {
	    this._listeners = [listener];
	  }
	};
	/**
	 * Unsubscribe from the cancel signal
	 */


	CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
	  if (!this._listeners) {
	    return;
	  }

	  var index = this._listeners.indexOf(listener);

	  if (index !== -1) {
	    this._listeners.splice(index, 1);
	  }
	};
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */


	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};

	var CancelToken_1 = CancelToken;

	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */


	var spread = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};

	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */


	var isAxiosError = function isAxiosError(payload) {
	  return typeof payload === 'object' && payload.isAxiosError === true;
	};

	var utils = utils$d;
	var bind = bind$2;
	var Axios = Axios_1;
	var mergeConfig = mergeConfig$2;
	var defaults = defaults_1;
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */

	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context); // Copy axios.prototype to instance

	  utils.extend(instance, Axios.prototype, context); // Copy context to instance

	  utils.extend(instance, context); // Factory for creating new instances

	  instance.create = function create(instanceConfig) {
	    return createInstance(mergeConfig(defaultConfig, instanceConfig));
	  };

	  return instance;
	} // Create the default instance to be exported


	var axios$1 = createInstance(defaults); // Expose Axios class to allow class inheritance

	axios$1.Axios = Axios; // Expose Cancel & CancelToken

	axios$1.Cancel = Cancel_1;
	axios$1.CancelToken = CancelToken_1;
	axios$1.isCancel = isCancel$1;
	axios$1.VERSION = data.version; // Expose all/spread

	axios$1.all = function all(promises) {
	  return Promise.all(promises);
	};

	axios$1.spread = spread; // Expose isAxiosError

	axios$1.isAxiosError = isAxiosError;
	axios$2.exports = axios$1; // Allow use of default import syntax in TypeScript

	axios$2.exports.default = axios$1;

	var axios = axios$2.exports;

	var urlJoin = {exports: {}};

	(function (module) {
	  (function (name, context, definition) {
	    if (module.exports) module.exports = definition();else context[name] = definition();
	  })('urljoin', commonjsGlobal, function () {
	    function normalize(strArray) {
	      var resultArray = [];

	      if (strArray.length === 0) {
	        return '';
	      }

	      if (typeof strArray[0] !== 'string') {
	        throw new TypeError('Url must be a string. Received ' + strArray[0]);
	      } // If the first part is a plain protocol, we combine it with the next part.


	      if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
	        var first = strArray.shift();
	        strArray[0] = first + strArray[0];
	      } // There must be two or three slashes in the file protocol, two slashes in anything else.


	      if (strArray[0].match(/^file:\/\/\//)) {
	        strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1:///');
	      } else {
	        strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1://');
	      }

	      for (var i = 0; i < strArray.length; i++) {
	        var component = strArray[i];

	        if (typeof component !== 'string') {
	          throw new TypeError('Url must be a string. Received ' + component);
	        }

	        if (component === '') {
	          continue;
	        }

	        if (i > 0) {
	          // Removing the starting slashes for each component but the first.
	          component = component.replace(/^[\/]+/, '');
	        }

	        if (i < strArray.length - 1) {
	          // Removing the ending slashes for each component but the last.
	          component = component.replace(/[\/]+$/, '');
	        } else {
	          // For the last component we will combine multiple slashes to a single one.
	          component = component.replace(/[\/]+$/, '/');
	        }

	        resultArray.push(component);
	      }

	      var str = resultArray.join('/'); // Each input component is now separated by a single slash except the possible first plain protocol part.
	      // remove trailing slash before parameters or hash

	      str = str.replace(/\/(\?|&|#[^!])/g, '$1'); // replace ? in parameters with &

	      var parts = str.split('?');
	      str = parts.shift() + (parts.length > 0 ? '?' : '') + parts.join('&');
	      return str;
	    }

	    return function () {
	      var input;

	      if (typeof arguments[0] === 'object') {
	        input = arguments[0];
	      } else {
	        input = [].slice.call(arguments);
	      }

	      return normalize(input);
	    };
	  });
	})(urlJoin);

	var urljoin = urlJoin.exports;

	var helpers = {exports: {}};

	(function (module, exports) {
	  (function (global, factory) {
	    factory(exports) ;
	  })(commonjsGlobal, function (exports) {

	    class BaseError extends Error {
	      // TODO Determine how to do this ??
	      // public get level(): LevelNumber {
	      //
	      //     return this._level;
	      //
	      // }
	      constructor(data) {
	        super();
	        this._at = new Date();
	        this._url = window && window.location && window.location.href || '';
	        this._data = data; // this._level = LevelNumber.Debug; // TODO??

	        this.message = this.toString();
	      } // TODO Determine how to do this ??
	      // protected _level: LevelNumber;


	      get at() {
	        return new Date(this._at.valueOf());
	      }

	      get data() {
	        return this._data;
	      }

	      get isOpenTicketError() {
	        return true;
	      }

	      toFlatData() {
	        const slug = this.toSlug();
	        let serializedSlugData = '';

	        try {
	          serializedSlugData = JSON.stringify(slug.data) || '';
	        } catch (_) {
	          /* No-op */
	        }

	        return { ...this.additionalFlatData(),
	          at: this.at.toISOString(),
	          // level: levelNumberToLevel[this.level], // TODO ??
	          message: this.toString(),
	          slug: this.toSlug().key,
	          slugData: serializedSlugData,
	          url: this._url
	        };
	      }

	      additionalFlatData() {
	        return {};
	      }

	    }

	    function isStringError(e) {
	      return e && e._isStringError;
	    }

	    class StringError extends BaseError {
	      constructor(slug, message) {
	        if (!slug || !slug.length) {
	          throw new Error('Expected first argument to be a non empty string.');
	        }

	        super(slug);
	        this._message = message;
	        this._isStringError = true;
	      }

	      toSlug() {
	        return {
	          key: this.data
	        };
	      }

	      toString() {
	        return this._message || this.data;
	      }

	    }

	    class UnexpectedError extends BaseError {
	      toSlug() {
	        return {
	          key: 'sdkhelpers.errors.unexpected'
	        };
	      }

	      toString() {
	        const str = 'Unexpected error';

	        if (this.data) {
	          if (this.data instanceof Error) {
	            return `${str} [${this.data.name}]: ${this.data.message}`;
	          }

	          try {
	            return `${str}: ${JSON.stringify(this.data)}`;
	          } catch (e) {
	            /* No-op */
	          }
	        }

	        return str;
	      }

	    }

	    function isFormValidationError(e) {
	      return e && e._isFormValidationError;
	    }
	    /**
	     * This error class can be used for all errors that implement the
	     * CRUD validation error interface.
	     */


	    class FormValidationError extends BaseError {
	      constructor() {
	        super(...arguments);
	        this._isFormValidationError = true;
	      }

	      toSlug() {
	        return {
	          key: this.data.slug,
	          data: this.data.data
	        }; // // This key can optionally be used to show a more specific
	        // // error message to the user. We only pass the first error
	        // // because of the translation interface requires fixed
	        // // length data. The getFieldErrors method can be used
	        // // to retrieve a complete set of errors per form field.
	        // const firstError: { key: string; error: string } | undefined = this._getFirstErrorFromFirstField();
	        //
	        // if (!firstError) {
	        //
	        //     return {
	        //         key: 'sdkhelpers.form.errors.generic_validation_error',
	        //     };
	        //
	        // }
	        //
	        // return {
	        //     key: 'sdkhelpers.form.errors.validation_error',
	        //     data: firstError,
	        // };
	      }

	      getFieldErrors(key) {
	        return FormValidationError.getFieldErrors(this.data.messages, key);
	      }

	      toString() {
	        const firstError = this._getFirstErrorFromFirstField();

	        if (!firstError) {
	          return 'Validation error';
	        }

	        return `First validation error ${firstError.key}: ${firstError.error}`;
	      }

	      additionalFlatData() {
	        const errors = {};

	        for (const key in this.data.messages) {
	          if (Object.prototype.hasOwnProperty.call(this.data, key)) {
	            continue;
	          }

	          const localErrors = this.data.messages[key];

	          if (localErrors) {
	            errors[key] = Array.isArray(localErrors) ? localErrors.join(', ') : localErrors;
	          }
	        }

	        return errors;
	      }

	      static getFieldErrors(messages, key) {
	        const errorOrErrors = messages[key];

	        if (!errorOrErrors) {
	          return undefined;
	        }

	        const errors = Array.isArray(errorOrErrors) ? errorOrErrors : [errorOrErrors];
	        return errors.map(error => ({
	          key: 'sdkhelpers.form.errors.validation_error_field',
	          data: {
	            key,
	            error
	          }
	        }));
	      }

	      _getFirstErrorFromFirstField() {
	        for (const key in this.data.messages) {
	          if (!Object.prototype.hasOwnProperty.call(this.data, key)) {
	            continue;
	          }

	          const errorOrErrors = this.data.messages[key];

	          if (!errorOrErrors) {
	            continue;
	          }

	          if (Array.isArray(errorOrErrors)) {
	            return {
	              key,
	              error: errorOrErrors[0]
	            };
	          }

	          return {
	            key,
	            error: errorOrErrors
	          };
	        }

	        return undefined;
	      }

	    }

	    class Form {
	      constructor(config) {
	        this.props = this._buildProps(config.data);
	        this.original = { ...config.data
	        };
	        this.config = config;
	      }

	      validate(mutate = false) {
	        return this._internalValidate(mutate);
	      }

	      validateProp(key, mutate = false) {
	        return this._internalValidate(mutate, key);
	      }

	      async submit() {
	        const validation = await this.validate(true);

	        if (!validation.valid) {
	          throw new FormValidationError(validation.result);
	        }

	        try {
	          const data = this.serialize();
	          const response = await this.config.submit(data, this.original);

	          this._resetErrors();

	          this._applyChanges({ ...data,
	            ...response
	          });
	        } catch (e) {
	          if (isFormValidationError(e)) {
	            // Note:
	            // Only props with data present in the error are mutated.
	            // All other prop errors are left as is.
	            this._mutateErrors(e.data.messages);

	            throw e;
	          } else if (isStringError(e)) {
	            throw e;
	          }

	          throw new UnexpectedError(e); // TODO Add possible usages of unexpected error instance to doc.
	        }
	      }

	      undo(key) {
	        this.props[key].value = this.original[key];
	      }

	      undoAll() {
	        for (const key in this.props) {
	          if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
	            continue;
	          }

	          this.props[key].value = this.original[key];
	        }
	      }

	      hasLocalChanges() {
	        for (const key in this.props) {
	          if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
	            continue;
	          }

	          if (this.props[key].value !== this.original[key]) {
	            return true;
	          }
	        }

	        return false;
	      }

	      serialize(key) {
	        const data = {};

	        if (key) {
	          if (this.original[key] !== this.props[key].value) {
	            data[key] = this.props[key].value;
	          }

	          return data;
	        }

	        for (const propKey in this.props) {
	          if (!Object.prototype.hasOwnProperty.call(this.props, propKey)) {
	            continue;
	          }

	          data[propKey] = this.props[propKey].value;
	        }

	        return data;
	      }
	      /**
	       * Run validation and return results.
	       *
	       * A prop will only be validated if it is dirty.
	       *
	       * When a key is given, only that prop is checked if it is dirty.
	       * Without a key, all dirty props are checked.
	       *
	       * When mutate is true, prop errors are mutated for all checked props.
	       *
	       * @private
	       */


	      async _internalValidate(mutate = false, key) {
	        if (!this.config.validate) {
	          return {
	            valid: true
	          };
	        }

	        const data = this.serialize(key);
	        const result = await this.config.validate(data);

	        if (!result.valid && mutate) {
	          this._mutateErrors(result.result.messages, !key);
	        }

	        return result;
	      }
	      /**
	       * Mutates all given prop errors in keys.
	       *
	       * If no error is present in the validation data,
	       * it is set to an empty array.
	       *
	       * @private
	       */


	      _mutateErrors(validationData, clearAll = true) {
	        for (const key in this.props) {
	          if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
	            continue;
	          }

	          if (validationData[key]) {
	            const sluggedErrors = FormValidationError.getFieldErrors(validationData, key);
	            this.props[key].errors = sluggedErrors || [];
	          } else if (clearAll && this.props[key].errors.length) {
	            this.props[key].errors = [];
	          }
	        }
	      }
	      /**
	       * Removes all errors from  props
	       *
	       * @private
	       */


	      _resetErrors() {
	        this._mutateErrors({});
	      }

	      _applyChanges(data) {
	        for (const key in data) {
	          const value = data[key];
	          this.original[key] = value;
	          this.props[key].value = value;
	        }
	      }

	      _buildProps(props) {
	        const map = {};

	        for (const key in props) {
	          if (!Object.prototype.hasOwnProperty.call(props, key)) {
	            continue;
	          }

	          map[key] = {
	            errors: [],
	            rules: [],
	            value: props[key]
	          };
	        }

	        return map;
	      }

	    }

	    var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};

	    function commonjsRequire(path) {
	      throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
	    }

	    function leapYear$1(year) {
	      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	    }

	    function checkFalsePositiveDates$1(dateString = '') {
	      if (dateString.length === 10) {
	        // massage input to use yyyy-mm-dd format
	        // we support yyyy/mm/dd or yyyy.mm.dd
	        let normalizedDate = dateString.replace('.', '-').replace('/', '-');
	        let parts = normalizedDate.split('-');

	        if (parts.length === 3) {
	          if (parts[0].length === 4) {
	            // yyyy-mm-dd format
	            let y = parseInt(parts[0]);
	            let m = parseInt(parts[1]);
	            let d = parseInt(parts[2]);

	            if (m === 2) {
	              // return leapYear(y) ? d <= 29 : d <= 28;
	              if (leapYear$1(y)) {
	                if (d > 29) {
	                  return false;
	                }
	              } else {
	                if (d > 28) {
	                  return false;
	                }
	              }
	            }

	            if (m === 4 || m === 6 || m === 9 || m === 11) {
	              if (d > 30) {
	                return false;
	              }
	            }
	          }
	        }

	        return true; // we are not in feburary, proceed
	      }

	      return true; // we are not testing formatted date, proceed to rest of validation
	    }

	    function isValidDate$1(dateString) {
	      let testDate;

	      if (typeof dateString === 'number') {
	        testDate = new Date(dateString);

	        if (typeof testDate === 'object') {
	          return true;
	        }
	      } // first convert incoming string to date object and see if it correct date and format


	      testDate = new Date(dateString);

	      if (typeof testDate === 'object') {
	        if (testDate.toString() === 'Invalid Date') {
	          return false;
	        }
	        /**
	         * Check for false positive dates
	         * perform special check on february as JS `new Date` incorrectly returns valid date
	         * Eg.  let newDate = new Date('2020-02-29')  // returns as March 02 2020
	         * Eg.  let newDate = new Date('2019-02-29')  // returns as March 01 2020
	         * Eg.  let newDate = new Date('2019-04-31')  // returns as April 30 2020
	         */


	        if (!checkFalsePositiveDates$1(dateString)) {
	          return false;
	        } // valid date object and not a february date


	        return true;
	      } // First check for the pattern


	      var regex_date = /^\d{4}\-\d{1,2}\-\d{1,2}$/;

	      if (!regex_date.test(dateString)) {
	        return false;
	      } // Parse the date parts to integers


	      var parts = dateString.split("-");
	      var day = parseInt(parts[2], 10);
	      var month = parseInt(parts[1], 10);
	      var year = parseInt(parts[0], 10); // Check the ranges of month and year

	      if (year < 1000 || year > 3000 || month == 0 || month > 12) {
	        return false;
	      }

	      var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Adjust for leap years

	      if (year % 400 == 0 || year % 100 != 0 && year % 4 == 0) {
	        monthLength[1] = 29;
	      } // Check the range of the day


	      return day > 0 && day <= monthLength[month - 1];
	    }

	    var rules = {
	      required: function (val) {
	        var str;

	        if (val === undefined || val === null) {
	          return false;
	        }

	        str = String(val).replace(/\s/g, "");
	        return str.length > 0 ? true : false;
	      },
	      required_if: function (val, req, attribute) {
	        req = this.getParameters();

	        if (this.validator._objectPath(this.validator.input, req[0]) === req[1]) {
	          return this.validator.getRule("required").validate(val);
	        }

	        return true;
	      },
	      required_unless: function (val, req, attribute) {
	        req = this.getParameters();

	        if (this.validator._objectPath(this.validator.input, req[0]) !== req[1]) {
	          return this.validator.getRule("required").validate(val);
	        }

	        return true;
	      },
	      required_with: function (val, req, attribute) {
	        if (this.validator._objectPath(this.validator.input, req)) {
	          return this.validator.getRule("required").validate(val);
	        }

	        return true;
	      },
	      required_with_all: function (val, req, attribute) {
	        req = this.getParameters();

	        for (var i = 0; i < req.length; i++) {
	          if (!this.validator._objectPath(this.validator.input, req[i])) {
	            return true;
	          }
	        }

	        return this.validator.getRule("required").validate(val);
	      },
	      required_without: function (val, req, attribute) {
	        if (this.validator._objectPath(this.validator.input, req)) {
	          return true;
	        }

	        return this.validator.getRule("required").validate(val);
	      },
	      required_without_all: function (val, req, attribute) {
	        req = this.getParameters();

	        for (var i = 0; i < req.length; i++) {
	          if (this.validator._objectPath(this.validator.input, req[i])) {
	            return true;
	          }
	        }

	        return this.validator.getRule("required").validate(val);
	      },
	      boolean: function (val) {
	        return val === true || val === false || val === 0 || val === 1 || val === "0" || val === "1" || val === "true" || val === "false";
	      },
	      // compares the size of strings
	      // with numbers, compares the value
	      size: function (val, req, attribute) {
	        if (val) {
	          req = parseFloat(req);
	          var size = this.getSize();
	          return size === req;
	        }

	        return true;
	      },
	      string: function (val, req, attribute) {
	        return typeof val === "string";
	      },
	      sometimes: function (val) {
	        return true;
	      },

	      /**
	       * Compares the size of strings or the value of numbers if there is a truthy value
	       */
	      min: function (val, req, attribute) {
	        var size = this.getSize();
	        return size >= req;
	      },

	      /**
	       * Compares the size of strings or the value of numbers if there is a truthy value
	       */
	      max: function (val, req, attribute) {
	        var size = this.getSize();
	        return size <= req;
	      },
	      between: function (val, req, attribute) {
	        req = this.getParameters();
	        var size = this.getSize();
	        var min = parseFloat(req[0], 10);
	        var max = parseFloat(req[1], 10);
	        return size >= min && size <= max;
	      },
	      email: function (val) {
	        // Added umlaut support https://github.com/skaterdav85/validatorjs/issues/308
	        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	        if (!re.test(val)) {
	          // added support domain 3-n level https://github.com/skaterdav85/validatorjs/issues/384
	          re = /^((?:[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]|[^\u0000-\u007F])+@(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?(?:\.(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?)+)*$/;
	        }

	        return re.test(val);
	      },
	      numeric: function (val) {
	        var num;
	        num = Number(val); // tries to convert value to a number. useful if value is coming from form element

	        if (typeof num === "number" && !isNaN(num) && typeof val !== "boolean") {
	          return true;
	        } else {
	          return false;
	        }
	      },
	      array: function (val) {
	        return val instanceof Array;
	      },
	      url: function (url) {
	        return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&/=]*)/i.test(url);
	      },
	      alpha: function (val) {
	        return /^[a-zA-Z]+$/.test(val);
	      },
	      alpha_dash: function (val) {
	        return /^[a-zA-Z0-9_\-]+$/.test(val);
	      },
	      alpha_num: function (val) {
	        return /^[a-zA-Z0-9]+$/.test(val);
	      },
	      same: function (val, req) {
	        var val1 = this.validator._flattenObject(this.validator.input)[req];

	        var val2 = val;

	        if (val1 === val2) {
	          return true;
	        }

	        return false;
	      },
	      different: function (val, req) {
	        var val1 = this.validator._flattenObject(this.validator.input)[req];

	        var val2 = val;

	        if (val1 !== val2) {
	          return true;
	        }

	        return false;
	      },
	      in: function (val, req) {
	        var list, i;

	        if (val) {
	          list = this.getParameters();
	        }

	        if (val && !(val instanceof Array)) {
	          var localValue = val;

	          for (i = 0; i < list.length; i++) {
	            if (typeof list[i] === "string") {
	              localValue = String(val);
	            }

	            if (localValue === list[i]) {
	              return true;
	            }
	          }

	          return false;
	        }

	        if (val && val instanceof Array) {
	          for (i = 0; i < val.length; i++) {
	            if (list.indexOf(val[i]) < 0) {
	              return false;
	            }
	          }
	        }

	        return true;
	      },
	      not_in: function (val, req) {
	        var list = this.getParameters();
	        var len = list.length;
	        var returnVal = true;

	        for (var i = 0; i < len; i++) {
	          var localValue = val;

	          if (typeof list[i] === "string") {
	            localValue = String(val);
	          }

	          if (localValue === list[i]) {
	            returnVal = false;
	            break;
	          }
	        }

	        return returnVal;
	      },
	      accepted: function (val) {
	        if (val === "on" || val === "yes" || val === 1 || val === "1" || val === true) {
	          return true;
	        }

	        return false;
	      },
	      confirmed: function (val, req, key) {
	        var confirmedKey = key + "_confirmation";

	        if (this.validator.input[confirmedKey] === val) {
	          return true;
	        }

	        return false;
	      },
	      integer: function (val) {
	        return String(parseInt(val, 10)) === String(val);
	      },
	      digits: function (val, req) {
	        var numericRule = this.validator.getRule('numeric');

	        if (numericRule.validate(val) && String(val.trim()).length === parseInt(req)) {
	          return true;
	        }

	        return false;
	      },
	      digits_between: function (val) {
	        var numericRule = this.validator.getRule("numeric");
	        var req = this.getParameters();
	        var valueDigitsCount = String(val).length;
	        var min = parseFloat(req[0], 10);
	        var max = parseFloat(req[1], 10);

	        if (numericRule.validate(val) && valueDigitsCount >= min && valueDigitsCount <= max) {
	          return true;
	        }

	        return false;
	      },
	      regex: function (val, req) {
	        var mod = /[g|i|m]{1,3}$/;
	        var flag = req.match(mod);
	        flag = flag ? flag[0] : "";
	        req = req.replace(mod, "").slice(1, -1);
	        req = new RegExp(req, flag);
	        return !!req.test(val);
	      },
	      date: function (val, format) {
	        return isValidDate$1(val);
	      },
	      present: function (val) {
	        return typeof val !== "undefined";
	      },
	      after: function (val, req) {
	        var val1 = this.validator.input[req];
	        var val2 = val;

	        if (!isValidDate$1(val1)) {
	          return false;
	        }

	        if (!isValidDate$1(val2)) {
	          return false;
	        }

	        if (new Date(val1).getTime() < new Date(val2).getTime()) {
	          return true;
	        }

	        return false;
	      },
	      after_or_equal: function (val, req) {
	        var val1 = this.validator.input[req];
	        var val2 = val;

	        if (!isValidDate$1(val1)) {
	          return false;
	        }

	        if (!isValidDate$1(val2)) {
	          return false;
	        }

	        if (new Date(val1).getTime() <= new Date(val2).getTime()) {
	          return true;
	        }

	        return false;
	      },
	      before: function (val, req) {
	        var val1 = this.validator.input[req];
	        var val2 = val;

	        if (!isValidDate$1(val1)) {
	          return false;
	        }

	        if (!isValidDate$1(val2)) {
	          return false;
	        }

	        if (new Date(val1).getTime() > new Date(val2).getTime()) {
	          return true;
	        }

	        return false;
	      },
	      before_or_equal: function (val, req) {
	        var val1 = this.validator.input[req];
	        var val2 = val;

	        if (!isValidDate$1(val1)) {
	          return false;
	        }

	        if (!isValidDate$1(val2)) {
	          return false;
	        }

	        if (new Date(val1).getTime() >= new Date(val2).getTime()) {
	          return true;
	        }

	        return false;
	      },
	      hex: function (val) {
	        return /^[0-9a-f]+$/i.test(val);
	      },
	      ipv4: function (val, req, attribute) {
	        if (typeof val != 'string') return false; // regex to check that each octet is valid

	        var er = /^[0-9]+$/; // ipv4 octets are delimited by dot

	        octets = val.split('.'); // check 1: ipv4 address should contains 4 octets

	        if (octets.length != 4) return false;

	        for (let i = 0; i < octets.length; i++) {
	          const element = octets[i]; // check 2: each octet should be integer bigger than 0

	          if (!er.test(element)) return false; // check 3: each octet value should be less than 256

	          var octetValue = parseInt(element);
	          if (octetValue >= 256) return false;
	        } // if all checks passed, we know it's valid IPv4 address!


	        return true;
	      },
	      ipv6: function (val, req, attribute) {
	        if (typeof val != 'string') return false; // regex to check that each hextet is valid

	        var er = /^[0-9a-f]+$/; // ipv6 hextets are delimited by colon

	        hextets = val.split(':'); // check 1: ipv6 should contain only one consecutive colons

	        colons = val.match(/::/);
	        if (colons != null && val.match(/::/g).length > 1) return false; // check 2: ipv6 should not be ending or starting with colon
	        //          edge case: not with consecutive colons

	        if (val[0] == ':' && (colons == null || colons != null && colons.index != 0)) return false;
	        if (val[val.length - 1] == ':' && (colons == null || colons != null && colons.index != val.length - 2)) return false; // check 3: ipv6 should contain no less than 3 sector
	        //         minimum ipv6 addres - ::1

	        if (3 > hextets.length) return false; // check 4: ipv6 should contain no more than 8 sectors
	        //         only 1 edge case: when first or last sector is ommited

	        var isEdgeCase = hextets.length == 9 && colons != null && (colons.index == 0 || colons.index == val.length - 2);
	        if (hextets.length > 8 && !isEdgeCase) return false; // check 5: ipv6 should contain exactly one consecutive colons if it has less than 8 sectors

	        if (hextets.length != 8 && colons == null) return false;

	        for (let i = 0; i < hextets.length; i++) {
	          const element = hextets[i];
	          if (element.length == 0) continue; // check 6: all of hextets should contain numbers from 0 to f (in hexadecimal)

	          if (!er.test(element)) return false; // check 7: all of hextet values should be less then ffff (in hexadeimal)
	          //          checking using length of hextet. lowest invalid value's length is 5.
	          //          so all valid hextets are length of 4 or less

	          if (element.length > 4) return false;
	        }

	        return true;
	      },
	      ip: function (val, req, attribute) {
	        return rules['ipv4'](val, req, attribute) || rules['ipv6'](val, req, attribute);
	      }
	    };

	    var missedRuleValidator = function () {
	      throw new Error("Validator `" + this.name + "` is not defined!");
	    };

	    var missedRuleMessage;

	    function Rule(name, fn, async) {
	      this.name = name;
	      this.fn = fn;
	      this.passes = null;
	      this._customMessage = undefined;
	      this.async = async;
	    }

	    Rule.prototype = {
	      /**
	       * Validate rule
	       *
	       * @param  {mixed} inputValue
	       * @param  {mixed} ruleValue
	       * @param  {string} attribute
	       * @param  {function} callback
	       * @return {boolean|undefined}
	       */
	      validate: function (inputValue, ruleValue, attribute, callback) {
	        var _this = this;

	        this._setValidatingData(attribute, inputValue, ruleValue);

	        if (typeof callback === "function") {
	          this.callback = callback;

	          var handleResponse = function (passes, message) {
	            _this.response(passes, message);
	          };

	          if (this.async) {
	            return this._apply(inputValue, ruleValue, attribute, handleResponse);
	          } else {
	            return handleResponse(this._apply(inputValue, ruleValue, attribute));
	          }
	        }

	        return this._apply(inputValue, ruleValue, attribute);
	      },

	      /**
	       * Apply validation function
	       *
	       * @param  {mixed} inputValue
	       * @param  {mixed} ruleValue
	       * @param  {string} attribute
	       * @param  {function} callback
	       * @return {boolean|undefined}
	       */
	      _apply: function (inputValue, ruleValue, attribute, callback) {
	        var fn = this.isMissed() ? missedRuleValidator : this.fn;
	        return fn.apply(this, [inputValue, ruleValue, attribute, callback]);
	      },

	      /**
	       * Set validating data
	       *
	       * @param {string} attribute
	       * @param {mixed} inputValue
	       * @param {mixed} ruleValue
	       * @return {void}
	       */
	      _setValidatingData: function (attribute, inputValue, ruleValue) {
	        this.attribute = attribute;
	        this.inputValue = inputValue;
	        this.ruleValue = ruleValue;
	      },

	      /**
	       * Get parameters
	       *
	       * @return {array}
	       */
	      getParameters: function () {
	        var value = [];

	        if (typeof this.ruleValue === "string") {
	          value = this.ruleValue.split(",");
	        }

	        if (typeof this.ruleValue === "number") {
	          value.push(this.ruleValue);
	        }

	        if (this.ruleValue instanceof Array) {
	          value = this.ruleValue;
	        }

	        return value;
	      },

	      /**
	       * Get true size of value
	       *
	       * @return {integer|float}
	       */
	      getSize: function () {
	        var value = this.inputValue;

	        if (value instanceof Array) {
	          return value.length;
	        }

	        if (typeof value === "number") {
	          return value;
	        }

	        if (this.validator._hasNumericRule(this.attribute)) {
	          return parseFloat(value, 10);
	        }

	        return value.length;
	      },

	      /**
	       * Get the type of value being checked; numeric or string.
	       *
	       * @return {string}
	       */
	      _getValueType: function () {
	        if (typeof this.inputValue === "number" || this.validator._hasNumericRule(this.attribute)) {
	          return "numeric";
	        }

	        return "string";
	      },

	      /**
	       * Set the async callback response
	       *
	       * @param  {boolean|undefined} passes  Whether validation passed
	       * @param  {string|undefined} message Custom error message
	       * @return {void}
	       */
	      response: function (passes, message) {
	        this.passes = passes === undefined || passes === true;
	        this._customMessage = message;
	        this.callback(this.passes, message);
	      },

	      /**
	       * Set validator instance
	       *
	       * @param {Validator} validator
	       * @return {void}
	       */
	      setValidator: function (validator) {
	        this.validator = validator;
	      },

	      /**
	       * Check if rule is missed
	       *
	       * @return {boolean}
	       */
	      isMissed: function () {
	        return typeof this.fn !== "function";
	      },

	      get customMessage() {
	        return this.isMissed() ? missedRuleMessage : this._customMessage;
	      }

	    };
	    var manager = {
	      /**
	       * List of async rule names
	       *
	       * @type {Array}
	       */
	      asyncRules: [],

	      /**
	       * Implicit rules (rules to always validate)
	       *
	       * @type {Array}
	       */
	      implicitRules: ["required", "required_if", "required_unless", "required_with", "required_with_all", "required_without", "required_without_all", "accepted", "present"],

	      /**
	       * Get rule by name
	       *
	       * @param  {string} name
	       * @param {Validator}
	       * @return {Rule}
	       */
	      make: function (name, validator) {
	        var async = this.isAsync(name);
	        var rule = new Rule(name, rules[name], async);
	        rule.setValidator(validator);
	        return rule;
	      },

	      /**
	       * Determine if given rule is async
	       *
	       * @param  {string}  name
	       * @return {boolean}
	       */
	      isAsync: function (name) {
	        for (var i = 0, len = this.asyncRules.length; i < len; i++) {
	          if (this.asyncRules[i] === name) {
	            return true;
	          }
	        }

	        return false;
	      },

	      /**
	       * Determine if rule is implicit (should always validate)
	       *
	       * @param {string} name
	       * @return {boolean}
	       */
	      isImplicit: function (name) {
	        return this.implicitRules.indexOf(name) > -1;
	      },

	      /**
	       * Register new rule
	       *
	       * @param  {string}   name
	       * @param  {function} fn
	       * @return {void}
	       */
	      register: function (name, fn) {
	        rules[name] = fn;
	      },

	      /**
	       * Register new implicit rule
	       *
	       * @param  {string}   name
	       * @param  {function} fn
	       * @return {void}
	       */
	      registerImplicit: function (name, fn) {
	        this.register(name, fn);
	        this.implicitRules.push(name);
	      },

	      /**
	       * Register async rule
	       *
	       * @param  {string}   name
	       * @param  {function} fn
	       * @return {void}
	       */
	      registerAsync: function (name, fn) {
	        this.register(name, fn);
	        this.asyncRules.push(name);
	      },

	      /**
	       * Register implicit async rule
	       *
	       * @param  {string}   name
	       * @param  {function} fn
	       * @return {void}
	       */
	      registerAsyncImplicit: function (name, fn) {
	        this.registerImplicit(name, fn);
	        this.asyncRules.push(name);
	      },
	      registerMissedRuleValidator: function (fn, message) {
	        missedRuleValidator = fn;
	        missedRuleMessage = message;
	      }
	    };
	    var rules_1 = manager;
	    var replacements = {
	      /**
	       * Between replacement (replaces :min and :max)
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      between: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          min: parameters[0],
	          max: parameters[1]
	        });
	      },

	      /**
	       * Digits-Between replacement (replaces :min and :max)
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      digits_between: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          min: parameters[0],
	          max: parameters[1]
	        });
	      },

	      /**
	       * Required_if replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      required_if: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          other: this._getAttributeName(parameters[0]),
	          value: parameters[1]
	        });
	      },

	      /**
	       * Required_unless replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      required_unless: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          other: this._getAttributeName(parameters[0]),
	          value: parameters[1]
	        });
	      },

	      /**
	       * Required_with replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      required_with: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          field: this._getAttributeName(parameters[0])
	        });
	      },

	      /**
	       * Required_with_all replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      required_with_all: function (template, rule) {
	        var parameters = rule.getParameters();

	        var getAttributeName = this._getAttributeName.bind(this);

	        return this._replacePlaceholders(rule, template, {
	          fields: parameters.map(getAttributeName).join(', ')
	        });
	      },

	      /**
	       * Required_without replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      required_without: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          field: this._getAttributeName(parameters[0])
	        });
	      },

	      /**
	       * Required_without_all replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      required_without_all: function (template, rule) {
	        var parameters = rule.getParameters();

	        var getAttributeName = this._getAttributeName.bind(this);

	        return this._replacePlaceholders(rule, template, {
	          fields: parameters.map(getAttributeName).join(', ')
	        });
	      },

	      /**
	       * After replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      after: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          after: this._getAttributeName(parameters[0])
	        });
	      },

	      /**
	       * Before replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      before: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          before: this._getAttributeName(parameters[0])
	        });
	      },

	      /**
	       * After_or_equal replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      after_or_equal: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          after_or_equal: this._getAttributeName(parameters[0])
	        });
	      },

	      /**
	       * Before_or_equal replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      before_or_equal: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          before_or_equal: this._getAttributeName(parameters[0])
	        });
	      },

	      /**
	       * Same replacement.
	       *
	       * @param  {string} template
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      same: function (template, rule) {
	        var parameters = rule.getParameters();
	        return this._replacePlaceholders(rule, template, {
	          same: this._getAttributeName(parameters[0])
	        });
	      }
	    };

	    function formatter(attribute) {
	      return attribute.replace(/[_\[]/g, ' ').replace(/]/g, '');
	    }

	    var attributes = {
	      replacements: replacements,
	      formatter: formatter
	    };
	    var Attributes$1 = attributes;

	    var Messages$1 = function (lang, messages) {
	      this.lang = lang;
	      this.messages = messages;
	      this.customMessages = {};
	      this.attributeNames = {};
	    };

	    Messages$1.prototype = {
	      constructor: Messages$1,

	      /**
	       * Set custom messages
	       *
	       * @param {object} customMessages
	       * @return {void}
	       */
	      _setCustom: function (customMessages) {
	        this.customMessages = customMessages || {};
	      },

	      /**
	       * Set custom attribute names.
	       *
	       * @param {object} attributes
	       */
	      _setAttributeNames: function (attributes) {
	        this.attributeNames = attributes;
	      },

	      /**
	       * Set the attribute formatter.
	       *
	       * @param {fuction} func
	       * @return {void}
	       */
	      _setAttributeFormatter: function (func) {
	        this.attributeFormatter = func;
	      },

	      /**
	       * Get attribute name to display.
	       *
	       * @param  {string} attribute
	       * @return {string}
	       */
	      _getAttributeName: function (attribute) {
	        var name = attribute;

	        if (this.attributeNames.hasOwnProperty(attribute)) {
	          return this.attributeNames[attribute];
	        } else if (this.messages.attributes.hasOwnProperty(attribute)) {
	          name = this.messages.attributes[attribute];
	        }

	        if (this.attributeFormatter) {
	          name = this.attributeFormatter(name);
	        }

	        return name;
	      },

	      /**
	       * Get all messages
	       *
	       * @return {object}
	       */
	      all: function () {
	        return this.messages;
	      },

	      /**
	       * Render message
	       *
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      render: function (rule) {
	        if (rule.customMessage) {
	          return rule.customMessage;
	        }

	        var template = this._getTemplate(rule);

	        var message;

	        if (Attributes$1.replacements[rule.name]) {
	          message = Attributes$1.replacements[rule.name].apply(this, [template, rule]);
	        } else {
	          message = this._replacePlaceholders(rule, template, {});
	        }

	        return message;
	      },

	      /**
	       * Get the template to use for given rule
	       *
	       * @param  {Rule} rule
	       * @return {string}
	       */
	      _getTemplate: function (rule) {
	        var messages = this.messages;
	        var template = messages.def;
	        var customMessages = this.customMessages;
	        var formats = [rule.name + '.' + rule.attribute, rule.name];

	        for (var i = 0, format; i < formats.length; i++) {
	          format = formats[i];

	          if (customMessages.hasOwnProperty(format)) {
	            template = customMessages[format];
	            break;
	          } else if (messages.hasOwnProperty(format)) {
	            template = messages[format];
	            break;
	          }
	        }

	        if (typeof template === 'object') {
	          template = template[rule._getValueType()];
	        }

	        return template;
	      },

	      /**
	       * Replace placeholders in the template using the data object
	       *
	       * @param  {Rule} rule
	       * @param  {string} template
	       * @param  {object} data
	       * @return {string}
	       */
	      _replacePlaceholders: function (rule, template, data) {
	        var message, attribute;
	        data.attribute = this._getAttributeName(rule.attribute);
	        data[rule.name] = data[rule.name] || rule.getParameters().join(',');

	        if (typeof template === 'string' && typeof data === 'object') {
	          message = template;

	          for (attribute in data) {
	            message = message.replace(new RegExp(':' + attribute, 'g'), data[attribute]);
	          }
	        }

	        return message;
	      }
	    };
	    var messages$1 = Messages$1;
	    var en = {
	      accepted: 'The :attribute must be accepted.',
	      after: 'The :attribute must be after :after.',
	      after_or_equal: 'The :attribute must be equal or after :after_or_equal.',
	      alpha: 'The :attribute field must contain only alphabetic characters.',
	      alpha_dash: 'The :attribute field may only contain alpha-numeric characters, as well as dashes and underscores.',
	      alpha_num: 'The :attribute field must be alphanumeric.',
	      before: 'The :attribute must be before :before.',
	      before_or_equal: 'The :attribute must be equal or before :before_or_equal.',
	      between: {
	        numeric: 'The :attribute field must be between :min and :max.',
	        string: 'The :attribute field must be between :min and :max characters.'
	      },
	      confirmed: 'The :attribute confirmation does not match.',
	      email: 'The :attribute format is invalid.',
	      date: 'The :attribute is not a valid date format.',
	      def: 'The :attribute attribute has errors.',
	      digits: 'The :attribute must be :digits digits.',
	      digits_between: 'The :attribute field must be between :min and :max digits.',
	      different: 'The :attribute and :different must be different.',
	      in: 'The selected :attribute is invalid.',
	      integer: 'The :attribute must be an integer.',
	      hex: 'The :attribute field should have hexadecimal format',
	      min: {
	        numeric: 'The :attribute must be at least :min.',
	        string: 'The :attribute must be at least :min characters.'
	      },
	      max: {
	        numeric: 'The :attribute may not be greater than :max.',
	        string: 'The :attribute may not be greater than :max characters.'
	      },
	      not_in: 'The selected :attribute is invalid.',
	      numeric: 'The :attribute must be a number.',
	      present: 'The :attribute field must be present (but can be empty).',
	      required: 'The :attribute field is required.',
	      required_if: 'The :attribute field is required when :other is :value.',
	      required_unless: 'The :attribute field is required when :other is not :value.',
	      required_with: 'The :attribute field is required when :field is not empty.',
	      required_with_all: 'The :attribute field is required when :fields are not empty.',
	      required_without: 'The :attribute field is required when :field is empty.',
	      required_without_all: 'The :attribute field is required when :fields are empty.',
	      same: 'The :attribute and :same fields must match.',
	      size: {
	        numeric: 'The :attribute must be :size.',
	        string: 'The :attribute must be :size characters.'
	      },
	      string: 'The :attribute must be a string.',
	      url: 'The :attribute format is invalid.',
	      regex: 'The :attribute format is invalid.',
	      attributes: {}
	    };
	    var Messages = messages$1;
	    var require_method = commonjsRequire;
	    var container = {
	      messages: {},

	      /**
	       * Set messages for language
	       *
	       * @param {string} lang
	       * @param {object} rawMessages
	       * @return {void}
	       */
	      _set: function (lang, rawMessages) {
	        this.messages[lang] = rawMessages;
	      },

	      /**
	       * Set message for given language's rule.
	       *
	       * @param {string} lang
	       * @param {string} attribute
	       * @param {string|object} message
	       * @return {void}
	       */
	      _setRuleMessage: function (lang, attribute, message) {
	        this._load(lang);

	        if (message === undefined) {
	          message = this.messages[lang].def;
	        }

	        this.messages[lang][attribute] = message;
	      },

	      /**
	       * Load messages (if not already loaded)
	       *
	       * @param  {string} lang
	       * @return {void}
	       */
	      _load: function (lang) {
	        if (!this.messages[lang]) {
	          try {
	            var rawMessages = require_method('./lang/' + lang);

	            this._set(lang, rawMessages);
	          } catch (e) {}
	        }
	      },

	      /**
	       * Get raw messages for language
	       *
	       * @param  {string} lang
	       * @return {object}
	       */
	      _get: function (lang) {
	        this._load(lang);

	        return this.messages[lang];
	      },

	      /**
	       * Make messages for given language
	       *
	       * @param  {string} lang
	       * @return {Messages}
	       */
	      _make: function (lang) {
	        this._load(lang);

	        return new Messages(lang, this.messages[lang]);
	      }
	    };
	    var lang = container;

	    var Errors$1 = function () {
	      this.errors = {};
	    };

	    Errors$1.prototype = {
	      constructor: Errors$1,

	      /**
	       * Add new error message for given attribute
	       *
	       * @param  {string} attribute
	       * @param  {string} message
	       * @return {void}
	       */
	      add: function (attribute, message) {
	        if (!this.has(attribute)) {
	          this.errors[attribute] = [];
	        }

	        if (this.errors[attribute].indexOf(message) === -1) {
	          this.errors[attribute].push(message);
	        }
	      },

	      /**
	       * Returns an array of error messages for an attribute, or an empty array
	       *
	       * @param  {string} attribute A key in the data object being validated
	       * @return {array} An array of error messages
	       */
	      get: function (attribute) {
	        if (this.has(attribute)) {
	          return this.errors[attribute];
	        }

	        return [];
	      },

	      /**
	       * Returns the first error message for an attribute, false otherwise
	       *
	       * @param  {string} attribute A key in the data object being validated
	       * @return {string|false} First error message or false
	       */
	      first: function (attribute) {
	        if (this.has(attribute)) {
	          return this.errors[attribute][0];
	        }

	        return false;
	      },

	      /**
	       * Get all error messages from all failing attributes
	       *
	       * @return {Object} Failed attribute names for keys and an array of messages for values
	       */
	      all: function () {
	        return this.errors;
	      },

	      /**
	       * Determine if there are any error messages for an attribute
	       *
	       * @param  {string}  attribute A key in the data object being validated
	       * @return {boolean}
	       */
	      has: function (attribute) {
	        if (this.errors.hasOwnProperty(attribute)) {
	          return true;
	        }

	        return false;
	      }
	    };
	    var errors = Errors$1;

	    function AsyncResolvers$1(onFailedOne, onResolvedAll) {
	      this.onResolvedAll = onResolvedAll;
	      this.onFailedOne = onFailedOne;
	      this.resolvers = {};
	      this.resolversCount = 0;
	      this.passed = [];
	      this.failed = [];
	      this.firing = false;
	    }

	    AsyncResolvers$1.prototype = {
	      /**
	       * Add resolver
	       *
	       * @param {Rule} rule
	       * @return {integer}
	       */
	      add: function (rule) {
	        var index = this.resolversCount;
	        this.resolvers[index] = rule;
	        this.resolversCount++;
	        return index;
	      },

	      /**
	       * Resolve given index
	       *
	       * @param  {integer} index
	       * @return {void}
	       */
	      resolve: function (index) {
	        var rule = this.resolvers[index];

	        if (rule.passes === true) {
	          this.passed.push(rule);
	        } else if (rule.passes === false) {
	          this.failed.push(rule);
	          this.onFailedOne(rule);
	        }

	        this.fire();
	      },

	      /**
	       * Determine if all have been resolved
	       *
	       * @return {boolean}
	       */
	      isAllResolved: function () {
	        return this.passed.length + this.failed.length === this.resolversCount;
	      },

	      /**
	       * Attempt to fire final all resolved callback if completed
	       *
	       * @return {void}
	       */
	      fire: function () {
	        if (!this.firing) {
	          return;
	        }

	        if (this.isAllResolved()) {
	          this.onResolvedAll(this.failed.length === 0);
	        }
	      },

	      /**
	       * Enable firing
	       *
	       * @return {void}
	       */
	      enableFiring: function () {
	        this.firing = true;
	      }
	    };
	    var async = AsyncResolvers$1;
	    var Rules$1 = rules_1;
	    var Lang = lang;
	    var Errors = errors;
	    var Attributes = attributes;
	    var AsyncResolvers = async;

	    var Validator = function (input, rules, customMessages) {
	      var lang = Validator.getDefaultLang();
	      this.input = input || {};
	      this.messages = Lang._make(lang);

	      this.messages._setCustom(customMessages);

	      this.setAttributeFormatter(Validator.prototype.attributeFormatter);
	      this.errors = new Errors();
	      this.errorCount = 0;
	      this.hasAsync = false;
	      this.rules = this._parseRules(rules);
	    };

	    Validator.prototype = {
	      constructor: Validator,

	      /**
	       * Default language
	       *
	       * @type {string}
	       */
	      lang: 'en',

	      /**
	       * Numeric based rules
	       *
	       * @type {array}
	       */
	      numericRules: ['integer', 'numeric'],

	      /**
	       * Attribute formatter.
	       *
	       * @type {function}
	       */
	      attributeFormatter: Attributes.formatter,

	      /**
	       * Run validator
	       *
	       * @return {boolean} Whether it passes; true = passes, false = fails
	       */
	      check: function () {
	        for (var attribute in this.rules) {
	          var attributeRules = this.rules[attribute];

	          var inputValue = this._objectPath(this.input, attribute);

	          if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
	            continue;
	          }

	          for (var i = 0, len = attributeRules.length, rule, ruleOptions, rulePassed; i < len; i++) {
	            ruleOptions = attributeRules[i];
	            rule = this.getRule(ruleOptions.name);

	            if (!this._isValidatable(rule, inputValue)) {
	              continue;
	            }

	            rulePassed = rule.validate(inputValue, ruleOptions.value, attribute);

	            if (!rulePassed) {
	              this._addFailure(rule);
	            }

	            if (this._shouldStopValidating(attribute, rulePassed)) {
	              break;
	            }
	          }
	        }

	        return this.errorCount === 0;
	      },

	      /**
	       * Run async validator
	       *
	       * @param {function} passes
	       * @param {function} fails
	       * @return {void}
	       */
	      checkAsync: function (passes, fails) {
	        var _this = this;

	        passes = passes || function () {};

	        fails = fails || function () {};

	        var failsOne = function (rule, message) {
	          _this._addFailure(rule, message);
	        };

	        var resolvedAll = function (allPassed) {
	          if (allPassed) {
	            passes();
	          } else {
	            fails();
	          }
	        };

	        var asyncResolvers = new AsyncResolvers(failsOne, resolvedAll);

	        var validateRule = function (inputValue, ruleOptions, attribute, rule) {
	          return function () {
	            var resolverIndex = asyncResolvers.add(rule);
	            rule.validate(inputValue, ruleOptions.value, attribute, function () {
	              asyncResolvers.resolve(resolverIndex);
	            });
	          };
	        };

	        for (var attribute in this.rules) {
	          var attributeRules = this.rules[attribute];

	          var inputValue = this._objectPath(this.input, attribute);

	          if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
	            continue;
	          }

	          for (var i = 0, len = attributeRules.length, rule, ruleOptions; i < len; i++) {
	            ruleOptions = attributeRules[i];
	            rule = this.getRule(ruleOptions.name);

	            if (!this._isValidatable(rule, inputValue)) {
	              continue;
	            }

	            validateRule(inputValue, ruleOptions, attribute, rule)();
	          }
	        }

	        asyncResolvers.enableFiring();
	        asyncResolvers.fire();
	      },

	      /**
	       * Add failure and error message for given rule
	       *
	       * @param {Rule} rule
	       */
	      _addFailure: function (rule) {
	        var msg = this.messages.render(rule);
	        this.errors.add(rule.attribute, msg);
	        this.errorCount++;
	      },

	      /**
	       * Flatten nested object, normalizing { foo: { bar: 1 } } into: { 'foo.bar': 1 }
	       *
	       * @param  {object} nested object
	       * @return {object} flattened object
	       */
	      _flattenObject: function (obj) {
	        var flattened = {};

	        function recurse(current, property) {
	          if (!property && Object.getOwnPropertyNames(current).length === 0) {
	            return;
	          }

	          if (Object(current) !== current || Array.isArray(current)) {
	            flattened[property] = current;
	          } else {
	            var isEmpty = true;

	            for (var p in current) {
	              isEmpty = false;
	              recurse(current[p], property ? property + '.' + p : p);
	            }

	            if (isEmpty) {
	              flattened[property] = {};
	            }
	          }
	        }

	        if (obj) {
	          recurse(obj);
	        }

	        return flattened;
	      },

	      /**
	       * Extract value from nested object using string path with dot notation
	       *
	       * @param  {object} object to search in
	       * @param  {string} path inside object
	       * @return {any|void} value under the path
	       */
	      _objectPath: function (obj, path) {
	        if (Object.prototype.hasOwnProperty.call(obj, path)) {
	          return obj[path];
	        }

	        var keys = path.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '').split('.');
	        var copy = {};

	        for (var attr in obj) {
	          if (Object.prototype.hasOwnProperty.call(obj, attr)) {
	            copy[attr] = obj[attr];
	          }
	        }

	        for (var i = 0, l = keys.length; i < l; i++) {
	          if (typeof copy === 'object' && copy !== null && Object.hasOwnProperty.call(copy, keys[i])) {
	            copy = copy[keys[i]];
	          } else {
	            return;
	          }
	        }

	        return copy;
	      },

	      /**
	       * Parse rules, normalizing format into: { attribute: [{ name: 'age', value: 3 }] }
	       *
	       * @param  {object} rules
	       * @return {object}
	       */
	      _parseRules: function (rules) {
	        var parsedRules = {};
	        rules = this._flattenObject(rules);

	        for (var attribute in rules) {
	          var rulesArray = rules[attribute];

	          this._parseRulesCheck(attribute, rulesArray, parsedRules);
	        }

	        return parsedRules;
	      },
	      _parseRulesCheck: function (attribute, rulesArray, parsedRules, wildCardValues) {
	        if (attribute.indexOf('*') > -1) {
	          this._parsedRulesRecurse(attribute, rulesArray, parsedRules, wildCardValues);
	        } else {
	          this._parseRulesDefault(attribute, rulesArray, parsedRules, wildCardValues);
	        }
	      },
	      _parsedRulesRecurse: function (attribute, rulesArray, parsedRules, wildCardValues) {
	        var parentPath = attribute.substr(0, attribute.indexOf('*') - 1);

	        var propertyValue = this._objectPath(this.input, parentPath);

	        if (propertyValue) {
	          for (var propertyNumber = 0; propertyNumber < propertyValue.length; propertyNumber++) {
	            var workingValues = wildCardValues ? wildCardValues.slice() : [];
	            workingValues.push(propertyNumber);

	            this._parseRulesCheck(attribute.replace('*', propertyNumber), rulesArray, parsedRules, workingValues);
	          }
	        }
	      },
	      _parseRulesDefault: function (attribute, rulesArray, parsedRules, wildCardValues) {
	        var attributeRules = [];

	        if (rulesArray instanceof Array) {
	          rulesArray = this._prepareRulesArray(rulesArray);
	        }

	        if (typeof rulesArray === 'string') {
	          rulesArray = rulesArray.split('|');
	        }

	        for (var i = 0, len = rulesArray.length, rule; i < len; i++) {
	          rule = typeof rulesArray[i] === 'string' ? this._extractRuleAndRuleValue(rulesArray[i]) : rulesArray[i];

	          if (rule.value) {
	            rule.value = this._replaceWildCards(rule.value, wildCardValues);

	            this._replaceWildCardsMessages(wildCardValues);
	          }

	          if (Rules$1.isAsync(rule.name)) {
	            this.hasAsync = true;
	          }

	          attributeRules.push(rule);
	        }

	        parsedRules[attribute] = attributeRules;
	      },
	      _replaceWildCards: function (path, nums) {
	        if (!nums) {
	          return path;
	        }

	        var path2 = path;
	        nums.forEach(function (value) {
	          if (Array.isArray(path2)) {
	            path2 = path2[0];
	          }

	          const pos = path2.indexOf('*');

	          if (pos === -1) {
	            return path2;
	          }

	          path2 = path2.substr(0, pos) + value + path2.substr(pos + 1);
	        });

	        if (Array.isArray(path)) {
	          path[0] = path2;
	          path2 = path;
	        }

	        return path2;
	      },
	      _replaceWildCardsMessages: function (nums) {
	        var customMessages = this.messages.customMessages;
	        var self = this;
	        Object.keys(customMessages).forEach(function (key) {
	          if (nums) {
	            var newKey = self._replaceWildCards(key, nums);

	            customMessages[newKey] = customMessages[key];
	          }
	        });

	        this.messages._setCustom(customMessages);
	      },

	      /**
	       * Prepare rules if it comes in Array. Check for objects. Need for type validation.
	       *
	       * @param  {array} rulesArray
	       * @return {array}
	       */
	      _prepareRulesArray: function (rulesArray) {
	        var rules = [];

	        for (var i = 0, len = rulesArray.length; i < len; i++) {
	          if (typeof rulesArray[i] === 'object') {
	            for (var rule in rulesArray[i]) {
	              rules.push({
	                name: rule,
	                value: rulesArray[i][rule]
	              });
	            }
	          } else {
	            rules.push(rulesArray[i]);
	          }
	        }

	        return rules;
	      },

	      /**
	       * Determines if the attribute is supplied with the original data object.
	       *
	       * @param  {array} attribute
	       * @return {boolean}
	       */
	      _suppliedWithData: function (attribute) {
	        return this.input.hasOwnProperty(attribute);
	      },

	      /**
	       * Extract a rule and a value from a ruleString (i.e. min:3), rule = min, value = 3
	       *
	       * @param  {string} ruleString min:3
	       * @return {object} object containing the name of the rule and value
	       */
	      _extractRuleAndRuleValue: function (ruleString) {
	        var rule = {},
	            ruleArray;
	        rule.name = ruleString;

	        if (ruleString.indexOf(':') >= 0) {
	          ruleArray = ruleString.split(':');
	          rule.name = ruleArray[0];
	          rule.value = ruleArray.slice(1).join(':');
	        }

	        return rule;
	      },

	      /**
	       * Determine if attribute has any of the given rules
	       *
	       * @param  {string}  attribute
	       * @param  {array}   findRules
	       * @return {boolean}
	       */
	      _hasRule: function (attribute, findRules) {
	        var rules = this.rules[attribute] || [];

	        for (var i = 0, len = rules.length; i < len; i++) {
	          if (findRules.indexOf(rules[i].name) > -1) {
	            return true;
	          }
	        }

	        return false;
	      },

	      /**
	       * Determine if attribute has any numeric-based rules.
	       *
	       * @param  {string}  attribute
	       * @return {Boolean}
	       */
	      _hasNumericRule: function (attribute) {
	        return this._hasRule(attribute, this.numericRules);
	      },

	      /**
	       * Determine if rule is validatable
	       *
	       * @param  {Rule}   rule
	       * @param  {mixed}  value
	       * @return {boolean}
	       */
	      _isValidatable: function (rule, value) {
	        if (Array.isArray(value)) {
	          return true;
	        }

	        if (Rules$1.isImplicit(rule.name)) {
	          return true;
	        }

	        return this.getRule('required').validate(value);
	      },

	      /**
	       * Determine if we should stop validating.
	       *
	       * @param  {string} attribute
	       * @param  {boolean} rulePassed
	       * @return {boolean}
	       */
	      _shouldStopValidating: function (attribute, rulePassed) {
	        var stopOnAttributes = this.stopOnAttributes;

	        if (typeof stopOnAttributes === 'undefined' || stopOnAttributes === false || rulePassed === true) {
	          return false;
	        }

	        if (stopOnAttributes instanceof Array) {
	          return stopOnAttributes.indexOf(attribute) > -1;
	        }

	        return true;
	      },

	      /**
	       * Set custom attribute names.
	       *
	       * @param {object} attributes
	       * @return {void}
	       */
	      setAttributeNames: function (attributes) {
	        this.messages._setAttributeNames(attributes);
	      },

	      /**
	       * Set the attribute formatter.
	       *
	       * @param {fuction} func
	       * @return {void}
	       */
	      setAttributeFormatter: function (func) {
	        this.messages._setAttributeFormatter(func);
	      },

	      /**
	       * Get validation rule
	       *
	       * @param  {string} name
	       * @return {Rule}
	       */
	      getRule: function (name) {
	        return Rules$1.make(name, this);
	      },

	      /**
	       * Stop on first error.
	       *
	       * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
	       * @return {void}
	       */
	      stopOnError: function (attributes) {
	        this.stopOnAttributes = attributes;
	      },

	      /**
	       * Determine if validation passes
	       *
	       * @param {function} passes
	       * @return {boolean|undefined}
	       */
	      passes: function (passes) {
	        var async = this._checkAsync('passes', passes);

	        if (async) {
	          return this.checkAsync(passes);
	        }

	        return this.check();
	      },

	      /**
	       * Determine if validation fails
	       *
	       * @param {function} fails
	       * @return {boolean|undefined}
	       */
	      fails: function (fails) {
	        var async = this._checkAsync('fails', fails);

	        if (async) {
	          return this.checkAsync(function () {}, fails);
	        }

	        return !this.check();
	      },

	      /**
	       * Check if validation should be called asynchronously
	       *
	       * @param  {string}   funcName Name of the caller
	       * @param  {function} callback
	       * @return {boolean}
	       */
	      _checkAsync: function (funcName, callback) {
	        var hasCallback = typeof callback === 'function';

	        if (this.hasAsync && !hasCallback) {
	          throw funcName + ' expects a callback when async rules are being tested.';
	        }

	        return this.hasAsync || hasCallback;
	      }
	    };
	    /**
	     * Set messages for language
	     *
	     * @param {string} lang
	     * @param {object} messages
	     * @return {this}
	     */

	    Validator.setMessages = function (lang, messages) {
	      Lang._set(lang, messages);

	      return this;
	    };
	    /**
	     * Get messages for given language
	     *
	     * @param  {string} lang
	     * @return {Messages}
	     */


	    Validator.getMessages = function (lang) {
	      return Lang._get(lang);
	    };
	    /**
	     * Set default language to use
	     *
	     * @param {string} lang
	     * @return {void}
	     */


	    Validator.useLang = function (lang) {
	      this.prototype.lang = lang;
	    };
	    /**
	     * Get default language
	     *
	     * @return {string}
	     */


	    Validator.getDefaultLang = function () {
	      return this.prototype.lang;
	    };
	    /**
	     * Set the attribute formatter.
	     *
	     * @param {fuction} func
	     * @return {void}
	     */


	    Validator.setAttributeFormatter = function (func) {
	      this.prototype.attributeFormatter = func;
	    };
	    /**
	     * Stop on first error.
	     *
	     * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
	     * @return {void}
	     */


	    Validator.stopOnError = function (attributes) {
	      this.prototype.stopOnAttributes = attributes;
	    };
	    /**
	     * Register custom validation rule
	     *
	     * @param  {string}   name
	     * @param  {function} fn
	     * @param  {string}   message
	     * @return {void}
	     */


	    Validator.register = function (name, fn, message, fnReplacement) {
	      var lang = Validator.getDefaultLang();
	      Rules$1.register(name, fn);

	      Lang._setRuleMessage(lang, name, message);
	    };
	    /**
	     * Register custom validation rule
	     *
	     * @param  {string}   name
	     * @param  {function} fn
	     * @param  {string}   message
	     * @param  {function} fnReplacement
	     * @return {void}
	     */


	    Validator.registerImplicit = function (name, fn, message, fnReplacement) {
	      var lang = Validator.getDefaultLang();
	      Rules$1.registerImplicit(name, fn);

	      Lang._setRuleMessage(lang, name, message);
	    };
	    /**
	     * Register asynchronous validation rule
	     *
	     * @param  {string}   name
	     * @param  {function} fn
	     * @param  {string}   message
	     * @return {void}
	     */


	    Validator.registerAsync = function (name, fn, message, fnReplacement) {
	      var lang = Validator.getDefaultLang();
	      Rules$1.registerAsync(name, fn);

	      Lang._setRuleMessage(lang, name, message);
	    };
	    /**
	     * Register asynchronous validation rule
	     *
	     * @param  {string}   name
	     * @param  {function} fn
	     * @param  {string}   message
	     * @return {void}
	     */


	    Validator.registerAsyncImplicit = function (name, fn, message) {
	      var lang = Validator.getDefaultLang();
	      Rules$1.registerAsyncImplicit(name, fn);

	      Lang._setRuleMessage(lang, name, message);
	    };
	    /**
	     * Register validator for missed validation rule
	     *
	     * @param  {string}   name
	     * @param  {function} fn
	     * @param  {string}   message
	     * @return {void}
	     */


	    Validator.registerMissedRuleValidator = function (fn, message) {
	      Rules$1.registerMissedRuleValidator(fn, message);
	    };

	    var validator$2 = Validator; // It is not possible to dynamically require language files when a package that has validatorjs as a dependency
	    // is compiled using rollup. Validatorjs does this internally.
	    // When this package is used in conjunction with a rollup compiled package, due to the global nature of
	    // a lot of features within validatorjs, this fails!
	    // Loading 'en' here, as it is the default language. This is also referenced internally
	    // for some methods that are not directly related to validation errors.

	    validator$2.setMessages('en', en || {
	      def: 'The :attribute attribute has errors.',
	      attributes: {}
	    });
	    /**
	     * Stub or implement the rules not supported by https://github.com/mikeerickson/validatorjs,
	     * but passed to the frontend by https://bitbucket.org/eventix/http/src/master/src/FrontendRules.php
	    */

	    /*
	    [
	        'active_url',
	        'accepted_if',
	        'bail',
	        'date_equals',
	        'date_format',
	        'declined',
	        'declined_if',
	        'distinct',
	        'ends_with',
	        'enum',
	        'filled',
	        'gt',
	        'gte',
	        'json',
	        'lt',
	        'lte',
	        'multiple_of',
	        'not_regex',
	        'nullable',
	        'prohibited',
	        'prohibited_if',
	        'prohibited_unless',
	        'prohibits',
	        'sometimes',
	        'starts_with',
	        'timezone',
	        'uuid',
	    ];
	    */

	    validator$2.registerMissedRuleValidator(() => true); // https://docs.microsoft.com/en-us/office/troubleshoot/excel/determine-a-leap-year

	    function leapYear(year) {
	      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	    }

	    function checkFalsePositiveDates(dateString = '') {
	      if (dateString.length === 10) {
	        // massage input to use yyyy-mm-dd format
	        // we support yyyy/mm/dd or yyyy.mm.dd
	        const normalizedDate = dateString.replace('.', '-').replace('/', '-');
	        const parts = normalizedDate.split('-');

	        if (parts.length === 3) {
	          if (parts[0].length === 4) {
	            // yyyy-mm-dd format
	            const y = parseInt(parts[0], 10);
	            const m = parseInt(parts[1], 10);
	            const d = parseInt(parts[2], 10);

	            if (m === 2) {
	              // return leapYear(y) ? d <= 29 : d <= 28;
	              if (leapYear(y)) {
	                if (d > 29) {
	                  return false;
	                }
	              } else if (d > 28) {
	                return false;
	              }
	            }

	            if (m === 4 || m === 6 || m === 9 || m === 11) {
	              if (d > 30) {
	                return false;
	              }
	            }
	          }
	        }

	        return true; // we are not in february, proceed
	      }

	      return true; // we are not testing formatted date, proceed to rest of validation
	    }

	    function isValidDate(dateString) {
	      let testDate;

	      if (typeof dateString === 'number') {
	        testDate = new Date(dateString);

	        if (typeof testDate === 'object') {
	          return true;
	        }

	        dateString = `${dateString}`;
	      } else if (typeof dateString === 'boolean') {
	        return false;
	      } // first convert incoming string to date object and see if it corrects date and format


	      testDate = new Date(dateString);

	      if (typeof testDate === 'object') {
	        if (testDate.toString() === 'Invalid Date') {
	          return false;
	        }
	        /**
	         * Check for false positive dates
	         * perform special check on february as JS `new Date` incorrectly returns valid date
	         * E.g.  let newDate = new Date('2020-02-29')  // returns as March 02, 2020.
	         * E.g.  let newDate = new Date('2019-02-29')  // returns as March 01, 2020.
	         * E.g.  let newDate = new Date('2019-04-31')  // returns as April 30, 2020.
	         */


	        if (!checkFalsePositiveDates(dateString)) {
	          return false;
	        } // valid date object and not a february date


	        return true;
	      } // First check for the pattern


	      const regex_date = /^\d{4}-\d{1,2}-\d{1,2}$/;

	      if (!regex_date.test(dateString)) {
	        return false;
	      } // Parse the date parts to integers


	      const parts = dateString.split('-');
	      const day = parseInt(parts[2], 10);
	      const month = parseInt(parts[1], 10);
	      const year = parseInt(parts[0], 10); // Check the ranges of month and year

	      if (year < 1000 || year > 3000 || month === 0 || month > 12) {
	        return false;
	      }

	      const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Adjust for leap years

	      if (year % 400 === 0 || year % 100 !== 0 && year % 4 === 0) {
	        monthLength[1] = 29;
	      } // Check the range of the day


	      return day > 0 && day <= monthLength[month - 1];
	    }

	    function after(val, req) {
	      let val1 = req;

	      if (!isValidDate(val)) {
	        return false;
	      }

	      if (!isValidDate(val1)) {
	        val1 = this.validator.input[val1];

	        if (!isValidDate(val1)) {
	          return false;
	        }
	      }

	      return new Date(val1).getTime() < new Date(val).getTime();
	    }

	    function after_or_equal(val, req) {
	      let val1 = req;

	      if (!isValidDate(val)) {
	        return false;
	      }

	      if (!isValidDate(val1)) {
	        val1 = this.validator.input[val1];

	        if (!isValidDate(val1)) {
	          return false;
	        }
	      }

	      return new Date(val1).getTime() <= new Date(val).getTime();
	    }

	    function before(val, req) {
	      let val1 = req;

	      if (!isValidDate(val)) {
	        return false;
	      }

	      if (!isValidDate(val1)) {
	        val1 = this.validator.input[val1];

	        if (!isValidDate(val1)) {
	          return false;
	        }
	      }

	      return new Date(val1).getTime() > new Date(val).getTime();
	    }

	    function before_or_equal(val, req) {
	      let val1 = req;

	      if (!isValidDate(val)) {
	        return false;
	      }

	      if (!isValidDate(val1)) {
	        val1 = this.validator.input[val1];

	        if (!isValidDate(val1)) {
	          return false;
	        }
	      }

	      return new Date(val1).getTime() >= new Date(val).getTime();
	    }

	    const messages = validator$2.getMessages(validator$2.getDefaultLang());
	    validator$2.register('after', after, messages && typeof messages.after === 'string' ? messages.after : undefined);
	    validator$2.register('after_or_equal', after_or_equal, messages && typeof messages.after_or_equal === 'string' ? messages.after_or_equal : undefined);
	    validator$2.register('before', before, messages && typeof messages.before === 'string' ? messages.before : undefined);
	    validator$2.register('before_or_equal', before_or_equal, messages && typeof messages.before_or_equal === 'string' ? messages.before_or_equal : undefined);

	    function isCrudApiError(e) {
	      if (!e) {
	        return false;
	      } // This type cast is as of yet not valid,
	      // BUT this whole method is designed to check this validity,
	      // therefore it is expected to assume it will be valid.


	      const crudApiError = e;
	      return !!crudApiError.response && crudApiError.response.status !== undefined && Number.isInteger(crudApiError.response.status) && crudApiError.response.statusText !== undefined && !!crudApiError.response.data && crudApiError.response.data.status_code !== undefined && crudApiError.response.data.error_description !== undefined;
	    }

	    function marshalCrudValidationData(data) {
	      if (!isCrudApiError(data)) {
	        const unexpectedError = new UnexpectedError(data);
	        const unexpectedSlug = unexpectedError.toSlug();
	        return {
	          slug: unexpectedSlug.key,
	          data: { ...unexpectedSlug.data,
	            message: unexpectedError.toString()
	          },
	          messages: {}
	        };
	      }

	      const slugData = {
	        status: data.response.status,
	        statusText: data.response.statusText,
	        statusCode: data.response.data.status_code
	      };

	      if (typeof data.response.data.error_description === 'string') {
	        slugData.message = data.response.data.error_description;
	      }

	      const messages = {};
	      let errorDescription = data.response.data.error_description;

	      if (typeof errorDescription === 'object') {
	        if (typeof errorDescription.message === 'object') {
	          errorDescription = errorDescription.message;
	        }

	        for (const errorDescriptionKey in errorDescription) {
	          if (!Object.prototype.hasOwnProperty.call(errorDescription, errorDescriptionKey)) {
	            continue;
	          }

	          if (typeof errorDescription[errorDescriptionKey] === 'string' || Array.isArray(errorDescription[errorDescriptionKey])) {
	            messages[errorDescriptionKey] = errorDescription[errorDescriptionKey];
	          }
	        }
	      }

	      return {
	        slug: 'sdkhelpers.crud.errors.validation_error',
	        data: slugData,
	        messages
	      };
	    }

	    function isCrudValidationError(e) {
	      return e && e._isCrudValidationError;
	    }

	    class CrudValidationError extends BaseError {
	      constructor(data) {
	        super(marshalCrudValidationData(data));
	        this._isCrudValidationError = true;
	      }

	      toString() {
	        // TODO @Rik.. No clue what to make of this...
	        throw new Error('CrudValidationError.toString not yet implemented.');
	      }

	      toSlug() {
	        return {
	          key: this.data.slug,
	          data: this.data.data
	        };
	      }

	    }

	    class FormValidationResult {
	      constructor(data) {
	        this.valid = false;
	        this._data = data;
	      }

	      static create(data) {
	        if (!data || Object.values(data.messages).every(message => !message || !message.length)) {
	          return this.valid();
	        }

	        return this.invalid(data);
	      }

	      static valid() {
	        return {
	          valid: true
	        };
	      }

	      static invalid(data) {
	        return new this(data);
	      }

	      get result() {
	        return this._data;
	      }

	    }

	    class ModelForm extends Form {
	      constructor(relation, model) {
	        super({
	          data: model.props,
	          submit: (data, original) => this._submit(data, original),
	          validate: data => this._validate(data)
	        });
	        this._model = model;
	        this._relation = relation;

	        if (relation.rules) {
	          void relation.rules().then(rules => {
	            if (!rules) {
	              return;
	            }

	            this._rules = rules;

	            for (const key in rules) {
	              if (!this.props[key]) {
	                // Got rules for undefined prop
	                continue;
	              }

	              this.props[key].rules = rules[key];
	            }
	          });
	        }
	      }

	      async _submit(data, original) {
	        // Only send props that follow one of the following constraints:
	        // - The prop is `required` as implied by its rules
	        // - The new value differs from the original value and has therefore changed
	        const filteredData = {};

	        for (const key in data) {
	          if (!Object.prototype.hasOwnProperty.call(data, key)) {
	            continue;
	          }

	          if (original[key] !== data[key] || this.props[key].rules.includes('required')) {
	            filteredData[key] = data[key];
	          }
	        }

	        try {
	          if (this._model.isNew) {
	            await this._relation.create(filteredData, this._model);
	          } else {
	            await this._relation.update(filteredData, this._model);
	          }
	        } catch (e) {
	          if (isCrudValidationError(e)) {
	            throw new FormValidationError(e.data);
	          }

	          throw e;
	        }
	      }

	      async _validate(data) {
	        const validation = new validator$2(data, this._rules);

	        if (validation.check()) {
	          return FormValidationResult.valid();
	        }

	        return FormValidationResult.invalid({
	          slug: 'libsdkhelpers.form.model_form.validation_error',
	          messages: validation.errors.errors
	        });
	      }

	    }

	    var urlJoin$1 = {
	      exports: {}
	    };

	    (function (module) {
	      (function (name, context, definition) {
	        if (module.exports) module.exports = definition();else context[name] = definition();
	      })('urljoin', commonjsGlobal$1, function () {
	        function normalize(strArray) {
	          var resultArray = [];

	          if (strArray.length === 0) {
	            return '';
	          }

	          if (typeof strArray[0] !== 'string') {
	            throw new TypeError('Url must be a string. Received ' + strArray[0]);
	          } // If the first part is a plain protocol, we combine it with the next part.


	          if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
	            var first = strArray.shift();
	            strArray[0] = first + strArray[0];
	          } // There must be two or three slashes in the file protocol, two slashes in anything else.


	          if (strArray[0].match(/^file:\/\/\//)) {
	            strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1:///');
	          } else {
	            strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1://');
	          }

	          for (var i = 0; i < strArray.length; i++) {
	            var component = strArray[i];

	            if (typeof component !== 'string') {
	              throw new TypeError('Url must be a string. Received ' + component);
	            }

	            if (component === '') {
	              continue;
	            }

	            if (i > 0) {
	              // Removing the starting slashes for each component but the first.
	              component = component.replace(/^[\/]+/, '');
	            }

	            if (i < strArray.length - 1) {
	              // Removing the ending slashes for each component but the last.
	              component = component.replace(/[\/]+$/, '');
	            } else {
	              // For the last component we will combine multiple slashes to a single one.
	              component = component.replace(/[\/]+$/, '/');
	            }

	            resultArray.push(component);
	          }

	          var str = resultArray.join('/'); // Each input component is now separated by a single slash except the possible first plain protocol part.
	          // remove trailing slash before parameters or hash

	          str = str.replace(/\/(\?|&|#[^!])/g, '$1'); // replace ? in parameters with &

	          var parts = str.split('?');
	          str = parts.shift() + (parts.length > 0 ? '?' : '') + parts.join('&');
	          return str;
	        }

	        return function () {
	          var input;

	          if (typeof arguments[0] === 'object') {
	            input = arguments[0];
	          } else {
	            input = [].slice.call(arguments);
	          }

	          return normalize(input);
	        };
	      });
	    })(urlJoin$1);

	    var urlJoin = urlJoin$1.exports;

	    class CrudNode {
	      constructor(parent, type, paths) {
	        this._parent = parent;
	        this._type = type;
	        this.paths = paths || [];
	      }

	      get $path() {
	        throw Error('$path not implemented');
	      }

	      get $routes() {
	        return [];
	      }

	      get $http() {
	        return this._parent.$http;
	      }

	      get $log() {
	        return this._parent.$log;
	      }

	      get $root() {
	        return this._parent.$root;
	      }

	      get $factory() {
	        return this._parent.$factory;
	      }

	      get type() {
	        return this._type;
	      }

	      get parent() {
	        return this._parent;
	      }

	    }

	    class CrudToOne extends CrudNode {
	      constructor(parent, type, config) {
	        super(parent, type);
	        this._config = config;
	      }

	      get $path() {
	        return urlJoin(this._parent.$path, this._config.path || this.type);
	      }

	      async link(model) {
	        const path = urlJoin(this.$path, model.guid);
	        await this.$http.put(path);
	        this._model = model;
	      }

	      async get() {
	        if (this._model) {
	          return this._model;
	        }

	        const response = await this.$http.get(this.$path);
	        return this._model = this.$factory.getOrCreate(this.rootRelation, this.type, response.data);
	      }

	      set(data) {
	        if (!data.guid) {
	          throw Error('to_one.set data has not guid');
	        }

	        this._model = this.$factory.getOrCreate(this.rootRelation, this.type, data);
	      }

	      get rootRelation() {
	        if (this.parent !== this.$root) {
	          return this.$root.getRelation(this.type);
	        }

	        return this;
	      }

	    } // Add a getter so that the mixins can access methods and properties of the CrudToMany instance


	    class CrudToManyMixin {
	      constructor(instance) {
	        this.instance = instance;
	      }

	      get rootRelation() {
	        if (this.instance.parent !== this.instance.$root) {
	          return this.instance.$root.getRelation(this.instance.type);
	        }

	        return this.instance;
	      }

	      rawDataToModels(data, type = this.instance.type) {
	        return data.map(item => this.instance.$factory.getOrCreate(this.rootRelation, type, item));
	      }

	    }

	    CrudToManyMixin.mixin = '<mixin-name>';
	    CrudToManyMixin.routes = [];

	    class Sort extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.getSortedPage = async request => {
	          const rawResponse = await this.instance.$http.get(this.instance.$path, {
	            params: request
	          });
	          return { ...rawResponse.data,
	            data: this.rawDataToModels(rawResponse.data.data)
	          };
	        };
	      }
	      /**
	       *
	       * Used to reposition a model.
	       *
	       * @param model The model to reposition
	       * @param order Where to position the model relative to the anchor model
	       * @param anchor The model after (or before) which the given model will be positioned
	       *
	       */


	      async sortModel(model, order, anchor) {
	        const path = urlJoin(this.instance.$path, encodeURIComponent(anchor.guid), order, encodeURIComponent(model.guid));
	        await this.instance.$http.put(path);
	      }

	    }

	    Sort.mixin = 'sort';
	    Sort.routes = [{
	      method: 'PUT',
	      uri: 'sort'
	    }, {
	      method: 'GET|HEAD',
	      uri: ''
	    }];
	    /**
	     * CRUD mixin implementation of the Pickable interface
	     */

	    class Pick extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.getPickerPage = async request => {
	          const rawResponse = await this.instance.$http.get(`${this.instance.$path}/pick`, {
	            params: request
	          });
	          return { ...rawResponse.data,
	            data: this.rawDataToModels(rawResponse.data.data)
	          };
	        };

	        this.linkPickerModels = async models => {
	          const path = urlJoin(this.instance.$path, 'multi');
	          await this.instance.$http.put(path, models);
	        };

	        this.unlinkPickerModels = async models => {
	          const path = urlJoin(this.instance.$path, 'multi');
	          await this.instance.$http.delete(path, {
	            data: models
	          });
	        };
	      }

	    }

	    Pick.mixin = 'pick';
	    Pick.routes = [{
	      method: 'GET|HEAD',
	      uri: 'pick'
	    }];
	    /**
	     * CRUD mixin implementation of the NestedPickable interface
	     */

	    class NestedPick extends CrudToManyMixin {
	      constructor() {
	        super(...arguments); // Returns the page of the sums pagination route

	        this.getPickerSumsPage = async request => {
	          const rawResponse = await this.instance.$http.get(`${this.instance.$path}/pick/sums`, {
	            params: request
	          }); // The PickerSumsModel's type is not part of the default CRUD structure at the moment,
	          // it is defined as an optional property in the CrudToManyConfig.

	          const type = this.instance._config.pickerSumsType; // Since this cannot be enforced with TypeScript at the moment, do a manual runtime check
	          // and throw when is is not defined.

	          if (!type) {
	            throw Error('pickerSumsType is not defined on ToMany config');
	          }

	          return { ...rawResponse.data,
	            data: this.rawDataToModels(rawResponse.data.data, type)
	          };
	        }; // Returns the page of the nested pagination route, by PickerSumsModel.guid


	        this.getPickerNestedPage = async request => {
	          const rawResponse = await this.instance.$http.get(`${this.instance.$path}/pick/${request.guid}`, {
	            params: request
	          });
	          return { ...rawResponse.data,
	            data: this.rawDataToModels(rawResponse.data.data)
	          };
	        };

	        this.linkPickerModels = async models => {
	          const path = urlJoin(this.instance.$path, 'multi');
	          await this.instance.$http.put(path, models);
	        };

	        this.unlinkPickerModels = async models => {
	          const path = urlJoin(this.instance.$path, 'multi');
	          await this.instance.$http.delete(path, {
	            data: models
	          });
	        };
	      }

	    }

	    NestedPick.mixin = 'multi_picker';
	    NestedPick.routes = [{
	      method: 'GET|HEAD',
	      uri: 'pick/sums'
	    }, {
	      method: 'GET|HEAD',
	      uri: 'pick/{id}'
	    }];

	    class Create extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.create = async (data, model) => {
	          try {
	            const response = await this.instance.$http.post(this.instance.$path, data);
	            model.setData(response.data);
	            this.instance.$factory.add(this.instance.type, model);
	          } catch (e) {
	            if (isCrudApiError(e) && e.response.status === 406) {
	              throw new CrudValidationError(e);
	            }

	            throw new UnexpectedError(e);
	          }
	        };
	      }

	      new(data) {
	        const newModel = this.instance.$factory.new(this.rootRelation, this.instance.type);

	        if (data) {
	          newModel.setData(data);
	        }

	        return newModel;
	      }

	    }

	    Create.mixin = 'create';
	    Create.routes = [{
	      method: 'POST',
	      uri: ''
	    }];

	    class Link extends CrudToManyMixin {
	      async link(model) {
	        const path = urlJoin(this.instance.$path, encodeURIComponent(model.guid));
	        await this.instance.$http.put(path);
	      }

	    }

	    Link.mixin = 'link';
	    Link.routes = [{
	      method: 'PUT',
	      uri: '{id}'
	    }];

	    class LinkMulti extends CrudToManyMixin {
	      async linkMulti(models) {
	        const path = urlJoin(this.instance.$path, 'multi');
	        await this.instance.$http.put(path, models.map(model => model.guid));
	      }

	    }

	    LinkMulti.mixin = 'link_multi';
	    LinkMulti.routes = [{
	      method: 'PUT',
	      uri: 'multi'
	    }];

	    class Rules extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.rules = async () => {
	          if (this.instance.__rules) {
	            return this.instance.__rules;
	          }

	          const path = urlJoin(this.instance.$path, 'rules');
	          const response = await this.instance.$http.get(path);
	          return this.instance.__rules = response.data;
	        };
	      }

	    }

	    Rules.mixin = 'rules';
	    Rules.routes = [{
	      method: 'GET|HEAD',
	      uri: 'rules'
	    }];

	    class Delete extends CrudToManyMixin {
	      async delete(model) {
	        const path = urlJoin(this.instance.$path, encodeURIComponent(model.guid));
	        await this.instance.$http.delete(path);
	      }

	    }

	    Delete.mixin = 'delete';
	    Delete.routes = [{
	      method: 'DELETE',
	      uri: '{id}'
	    }];

	    class List extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.getPage = async request => {
	          const rawResponse = await this.instance.$http.get(this.instance.$path, {
	            params: request
	          });

	          this.instance._setAdditionalFields(rawResponse.data);

	          return { ...rawResponse.data,
	            data: this.rawDataToModels(rawResponse.data.data)
	          };
	        };
	      }

	      canOrder(field) {
	        if (!this.instance.__filters) {
	          return false;
	        }

	        for (const filter of Object.values(this.instance.__filters)) {
	          if (filter.target !== field) {
	            continue;
	          }

	          return filter.match === 'exact' || filter.match === 'partial';
	        }

	        return false;
	      }

	    }

	    List.mixin = 'list';
	    List.routes = [{
	      method: 'GET|HEAD',
	      uri: ''
	    }];

	    class ListAll extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.getPageByType = async request => {
	          const rawResponse = await this.instance.$http.get(this.instance.$path, {
	            params: request
	          });
	          return { ...rawResponse.data,
	            data: this.rawDataToModels(rawResponse.data.data)
	          };
	        };
	      }

	    }

	    ListAll.mixin = 'list_all';
	    ListAll.routes = [{
	      method: 'GET|HEAD',
	      uri: ''
	    }, {
	      method: 'GET|HEAD',
	      uri: 'list/{type}'
	    }];

	    class Reinstate extends CrudToManyMixin {
	      async reinstate(guid) {
	        const path = urlJoin(this.instance.$path, encodeURIComponent(guid), 'reinstate');
	        await this.instance.$http.post(path);
	      }

	    }

	    Reinstate.mixin = 'reinstate';
	    Reinstate.routes = [{
	      method: 'POST',
	      uri: '{id}/reinstate'
	    }];

	    class Unlink extends CrudToManyMixin {
	      async unlink(model) {
	        const path = urlJoin(this.instance.$path, encodeURIComponent(model.guid));
	        await this.instance.$http.delete(path);
	      }

	    }

	    Unlink.mixin = 'detach';
	    Unlink.routes = [{
	      method: 'DELETE',
	      uri: '{id}'
	    }];

	    class UnlinkMulti extends CrudToManyMixin {
	      async unlinkMulti(models) {
	        const path = urlJoin(this.instance.$path, 'multi');
	        await this.instance.$http.delete(path, {
	          data: models.map(model => model.guid)
	        });
	      }

	    }

	    UnlinkMulti.mixin = 'unlink_multi';
	    UnlinkMulti.routes = [{
	      method: 'DELETE',
	      uri: 'multi'
	    }];

	    class Filters extends CrudToManyMixin {
	      async getFilters() {
	        if (this.instance.__filters) {
	          return this.instance.__filters;
	        }

	        const path = urlJoin(this.instance.$path, 'filters');
	        const response = await this.instance.$http.get(path);
	        return this.instance.__filters = response.data;
	      }

	    }

	    Filters.mixin = 'filters';
	    Filters.routes = [{
	      method: 'GET|HEAD',
	      uri: 'filters'
	    }];

	    class Get extends CrudToManyMixin {
	      async get(guid) {
	        const path = urlJoin(this.instance.$path, encodeURIComponent(guid));
	        const response = await this.instance.$http.get(path);
	        return this.instance.$factory.getOrCreate(this.rootRelation, this.instance.type, response.data);
	      }

	    }

	    Get.mixin = 'get';
	    Get.routes = [{
	      method: 'GET|HEAD',
	      uri: '{id}'
	    }];

	    class Update extends CrudToManyMixin {
	      constructor() {
	        super(...arguments);

	        this.update = async (data, model) => {
	          try {
	            const path = urlJoin(this.instance.$path, encodeURIComponent(model.guid));
	            await this.instance.$http.patch(path, data);
	            model.setData(data);
	          } catch (e) {
	            if (isCrudApiError(e) && e.response.status === 406) {
	              throw new CrudValidationError(e);
	            }

	            throw new UnexpectedError(e);
	          }
	        };
	      }

	    }

	    Update.mixin = 'update';
	    Update.routes = [{
	      method: 'PATCH',
	      uri: '{id}'
	    }];
	    var index = /*#__PURE__*/Object.freeze({
	      __proto__: null,
	      Sort: Sort,
	      Pick: Pick,
	      NestedPick: NestedPick,
	      Create: Create,
	      Link: Link,
	      LinkMulti: LinkMulti,
	      Rules: Rules,
	      Delete: Delete,
	      List: List,
	      ListAll: ListAll,
	      Reinstate: Reinstate,
	      Unlink: Unlink,
	      UnlinkMulti: UnlinkMulti,
	      Filters: Filters,
	      Get: Get,
	      Update: Update
	    });

	    function toMany(parent, type, config) {
	      return new CrudToMany(parent, type, config);
	    }

	    class CrudToMany extends CrudNode {
	      constructor(parent, type, config) {
	        super(parent, type); // Contains the identifiers of the applied mixins

	        this.mixins = []; // Relation cache

	        this.__cache = {}; // Registered routes from the applied mixins

	        this._mixinRoutes = [];
	        this._config = config; // Add mixin helpers

	        this._applyMixin(CrudToManyMixin);
	      }

	      get $path() {
	        return urlJoin(this._parent.$path, this._config.path);
	      }

	      get $routes() {
	        const routes = [];
	        routes.push(...this._mixinRoutes);

	        if (this.parent === this.$root) {
	          const data = {
	            guid: '{id}',
	            created_at: '',
	            updated_at: ''
	          };
	          const model = this.$factory.getOrCreate(this, this.type, data);
	          routes.push(...model.$routes);
	        }

	        return routes;
	      }

	      with(ctor) {
	        // Keep track of applied mixins
	        this.mixins.push(ctor.mixin); // Add base path to mixin routes

	        const routes = ctor.routes.map(route => ({
	          method: route.method,
	          uri: urlJoin(this.$path, route.uri)
	        })); // Save the routes

	        this._mixinRoutes.push(...routes); // Copy prototype keys


	        this._applyMixin(ctor);

	        return this;
	      }

	      _applyMixin(constructor) {
	        const instance = this; // Reference: https://www.typescriptlang.org/docs/handbook/mixins.html
	        // Set properties

	        const mixinInstance = new constructor(instance);
	        Object.getOwnPropertyNames(mixinInstance).forEach(name => {
	          if (instance[name] === undefined) {
	            Object.defineProperty(instance, name, Object.getOwnPropertyDescriptor(mixinInstance, name) || Object.create(null));
	          }
	        }); // Set methods

	        Object.getOwnPropertyNames(constructor.prototype).forEach(name => {
	          if (instance[name] === undefined) {
	            Object.defineProperty(instance, name, Object.getOwnPropertyDescriptor(constructor.prototype, name) || Object.create(null));
	          }
	        });
	        return this;
	      }

	      _setAdditionalFields(response) {
	        this.__appends = this.__appends || response.__appends;
	        this.__filters = this.__filters || response.__filters;
	        this.__includes = this.__includes || response.__includes;
	        this.__rules = this.__rules || response.__rules;
	      }

	    }

	    exports.CrudModelPropType = void 0;

	    (function (CrudModelPropType) {
	      CrudModelPropType["String"] = "string";
	      CrudModelPropType["Boolean"] = "boolean";
	      CrudModelPropType["Number"] = "number";
	      CrudModelPropType["Date"] = "date";
	      CrudModelPropType["Array"] = "array";
	    })(exports.CrudModelPropType || (exports.CrudModelPropType = {}));

	    const CrudModelProps = {
	      guid: exports.CrudModelPropType.String
	    };

	    class CrudModel extends CrudNode {
	      constructor(parent, type, config) {
	        super(parent, type);

	        if (parent !== this.$root && parent.parent !== this.$root) {
	          throw Error(`Invalid parent for model of type ${type}`);
	        }

	        this._props = CrudModel.parsePropConfig({ ...config.props,
	          ...CrudModelProps
	        });
	        this.raw = { ...config.data
	        }; // Here

	        this.props = this._getPropValues(this._props, config.data);
	        this._config = config;
	      }

	      static parsePropConfig(config) {
	        const props = {};
	        Object.keys(config).forEach(key => {
	          let propConfig = config[key];

	          if (typeof propConfig !== 'object') {
	            propConfig = {
	              type: propConfig
	            };
	          }

	          props[key] = {
	            type: propConfig.type,
	            default: propConfig.default !== undefined ? propConfig.default : null,
	            props: propConfig.props,
	            value: null,
	            rules: propConfig.rules || []
	          };
	        });
	        return props;
	      }

	      get guid() {
	        return this.props.guid;
	      }

	      get isNew() {
	        return !this.props.guid;
	      }

	      get $path() {
	        if (this.parent instanceof CrudToMany && this.props.guid) {
	          return urlJoin(this.parent.$path, encodeURIComponent(this.props.guid));
	        }

	        return urlJoin(this.parent.$path, this.type);
	      }

	      get $routes() {
	        const routes = [];

	        for (const node of Object.values(this)) {
	          if (node instanceof CrudNode && node !== this.parent) {
	            routes.push(...node.$routes);
	          }
	        }

	        return routes;
	      }

	      setData(data) {
	        Object.keys(data).forEach(strKey => {
	          const key = strKey;
	          this.props[key] = data[key];
	        });
	      }

	      _getPropValues(props, data) {
	        const _props = {};

	        for (const key of Object.keys(props)) {
	          if (data && data[key] !== undefined) {
	            _props[key] = data[key];
	          } else {
	            _props[key] = props[key].value;
	          }
	        }

	        return _props;
	      }

	    }

	    CrudModel.type = '<type>';
	    CrudModel.props = CrudModel.parsePropConfig(CrudModelProps);

	    class CrudFactory {
	      constructor(config) {
	        this._blueprints = {};
	        this._cache = {};
	        this._config = config;

	        for (const blueprint of config.models) {
	          this._blueprints[blueprint.type] = blueprint;
	          this._cache[blueprint.type] = {};
	        }
	      }

	      new(parent, type) {
	        return new this._blueprints[type](parent);
	      }

	      add(type, model) {
	        if (!model.props.guid) {
	          throw Error('No guid set on model');
	        }

	        this._cache[type][model.props.guid] = model;
	      }

	      getOrCreate(parent, type, data) {
	        let model = this._cache[type][data.guid];

	        if (model) {
	          model.setData(data);
	          return model;
	        }

	        model = new this._blueprints[type](parent, data);
	        this.add(type, model);
	        return model;
	      }

	    }

	    var axios$2 = {
	      exports: {}
	    };

	    var bind$2 = function bind(fn, thisArg) {
	      return function wrap() {
	        var args = new Array(arguments.length);

	        for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i];
	        }

	        return fn.apply(thisArg, args);
	      };
	    };

	    var bind$1 = bind$2; // utils is a library of generic helper functions non-specific to axios

	    var toString = Object.prototype.toString;
	    /**
	     * Determine if a value is an Array
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is an Array, otherwise false
	     */

	    function isArray(val) {
	      return toString.call(val) === '[object Array]';
	    }
	    /**
	     * Determine if a value is undefined
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if the value is undefined, otherwise false
	     */


	    function isUndefined(val) {
	      return typeof val === 'undefined';
	    }
	    /**
	     * Determine if a value is a Buffer
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a Buffer, otherwise false
	     */


	    function isBuffer(val) {
	      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	    }
	    /**
	     * Determine if a value is an ArrayBuffer
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	     */


	    function isArrayBuffer(val) {
	      return toString.call(val) === '[object ArrayBuffer]';
	    }
	    /**
	     * Determine if a value is a FormData
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is an FormData, otherwise false
	     */


	    function isFormData(val) {
	      return typeof FormData !== 'undefined' && val instanceof FormData;
	    }
	    /**
	     * Determine if a value is a view on an ArrayBuffer
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	     */


	    function isArrayBufferView(val) {
	      var result;

	      if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
	        result = ArrayBuffer.isView(val);
	      } else {
	        result = val && val.buffer && val.buffer instanceof ArrayBuffer;
	      }

	      return result;
	    }
	    /**
	     * Determine if a value is a String
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a String, otherwise false
	     */


	    function isString(val) {
	      return typeof val === 'string';
	    }
	    /**
	     * Determine if a value is a Number
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a Number, otherwise false
	     */


	    function isNumber(val) {
	      return typeof val === 'number';
	    }
	    /**
	     * Determine if a value is an Object
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is an Object, otherwise false
	     */


	    function isObject(val) {
	      return val !== null && typeof val === 'object';
	    }
	    /**
	     * Determine if a value is a plain Object
	     *
	     * @param {Object} val The value to test
	     * @return {boolean} True if value is a plain Object, otherwise false
	     */


	    function isPlainObject(val) {
	      if (toString.call(val) !== '[object Object]') {
	        return false;
	      }

	      var prototype = Object.getPrototypeOf(val);
	      return prototype === null || prototype === Object.prototype;
	    }
	    /**
	     * Determine if a value is a Date
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a Date, otherwise false
	     */


	    function isDate(val) {
	      return toString.call(val) === '[object Date]';
	    }
	    /**
	     * Determine if a value is a File
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a File, otherwise false
	     */


	    function isFile(val) {
	      return toString.call(val) === '[object File]';
	    }
	    /**
	     * Determine if a value is a Blob
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a Blob, otherwise false
	     */


	    function isBlob(val) {
	      return toString.call(val) === '[object Blob]';
	    }
	    /**
	     * Determine if a value is a Function
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a Function, otherwise false
	     */


	    function isFunction(val) {
	      return toString.call(val) === '[object Function]';
	    }
	    /**
	     * Determine if a value is a Stream
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a Stream, otherwise false
	     */


	    function isStream(val) {
	      return isObject(val) && isFunction(val.pipe);
	    }
	    /**
	     * Determine if a value is a URLSearchParams object
	     *
	     * @param {Object} val The value to test
	     * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	     */


	    function isURLSearchParams(val) {
	      return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	    }
	    /**
	     * Trim excess whitespace off the beginning and end of a string
	     *
	     * @param {String} str The String to trim
	     * @returns {String} The String freed of excess whitespace
	     */


	    function trim(str) {
	      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	    }
	    /**
	     * Determine if we're running in a standard browser environment
	     *
	     * This allows axios to run in a web worker, and react-native.
	     * Both environments support XMLHttpRequest, but not fully standard globals.
	     *
	     * web workers:
	     *  typeof window -> undefined
	     *  typeof document -> undefined
	     *
	     * react-native:
	     *  navigator.product -> 'ReactNative'
	     * nativescript
	     *  navigator.product -> 'NativeScript' or 'NS'
	     */


	    function isStandardBrowserEnv() {
	      if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
	        return false;
	      }

	      return typeof window !== 'undefined' && typeof document !== 'undefined';
	    }
	    /**
	     * Iterate over an Array or an Object invoking a function for each item.
	     *
	     * If `obj` is an Array callback will be called passing
	     * the value, index, and complete array for each item.
	     *
	     * If 'obj' is an Object callback will be called passing
	     * the value, key, and complete object for each property.
	     *
	     * @param {Object|Array} obj The object to iterate
	     * @param {Function} fn The callback to invoke for each item
	     */


	    function forEach(obj, fn) {
	      // Don't bother if no value provided
	      if (obj === null || typeof obj === 'undefined') {
	        return;
	      } // Force an array if not already something iterable


	      if (typeof obj !== 'object') {
	        /*eslint no-param-reassign:0*/
	        obj = [obj];
	      }

	      if (isArray(obj)) {
	        // Iterate over array values
	        for (var i = 0, l = obj.length; i < l; i++) {
	          fn.call(null, obj[i], i, obj);
	        }
	      } else {
	        // Iterate over object keys
	        for (var key in obj) {
	          if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            fn.call(null, obj[key], key, obj);
	          }
	        }
	      }
	    }
	    /**
	     * Accepts varargs expecting each argument to be an object, then
	     * immutably merges the properties of each object and returns result.
	     *
	     * When multiple objects contain the same key the later object in
	     * the arguments list will take precedence.
	     *
	     * Example:
	     *
	     * ```js
	     * var result = merge({foo: 123}, {foo: 456});
	     * console.log(result.foo); // outputs 456
	     * ```
	     *
	     * @param {Object} obj1 Object to merge
	     * @returns {Object} Result of all merge properties
	     */


	    function
	    /* obj1, obj2, obj3, ... */
	    merge() {
	      var result = {};

	      function assignValue(val, key) {
	        if (isPlainObject(result[key]) && isPlainObject(val)) {
	          result[key] = merge(result[key], val);
	        } else if (isPlainObject(val)) {
	          result[key] = merge({}, val);
	        } else if (isArray(val)) {
	          result[key] = val.slice();
	        } else {
	          result[key] = val;
	        }
	      }

	      for (var i = 0, l = arguments.length; i < l; i++) {
	        forEach(arguments[i], assignValue);
	      }

	      return result;
	    }
	    /**
	     * Extends object a by mutably adding to it the properties of object b.
	     *
	     * @param {Object} a The object to be extended
	     * @param {Object} b The object to copy properties from
	     * @param {Object} thisArg The object to bind function to
	     * @return {Object} The resulting value of object a
	     */


	    function extend(a, b, thisArg) {
	      forEach(b, function assignValue(val, key) {
	        if (thisArg && typeof val === 'function') {
	          a[key] = bind$1(val, thisArg);
	        } else {
	          a[key] = val;
	        }
	      });
	      return a;
	    }
	    /**
	     * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	     *
	     * @param {string} content with BOM
	     * @return {string} content value without BOM
	     */


	    function stripBOM(content) {
	      if (content.charCodeAt(0) === 0xFEFF) {
	        content = content.slice(1);
	      }

	      return content;
	    }

	    var utils$d = {
	      isArray: isArray,
	      isArrayBuffer: isArrayBuffer,
	      isBuffer: isBuffer,
	      isFormData: isFormData,
	      isArrayBufferView: isArrayBufferView,
	      isString: isString,
	      isNumber: isNumber,
	      isObject: isObject,
	      isPlainObject: isPlainObject,
	      isUndefined: isUndefined,
	      isDate: isDate,
	      isFile: isFile,
	      isBlob: isBlob,
	      isFunction: isFunction,
	      isStream: isStream,
	      isURLSearchParams: isURLSearchParams,
	      isStandardBrowserEnv: isStandardBrowserEnv,
	      forEach: forEach,
	      merge: merge,
	      extend: extend,
	      trim: trim,
	      stripBOM: stripBOM
	    };
	    var utils$c = utils$d;

	    function encode(val) {
	      return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
	    }
	    /**
	     * Build a URL by appending params to the end
	     *
	     * @param {string} url The base of the url (e.g., http://www.google.com)
	     * @param {object} [params] The params to be appended
	     * @returns {string} The formatted url
	     */


	    var buildURL$2 = function buildURL(url, params, paramsSerializer) {
	      /*eslint no-param-reassign:0*/
	      if (!params) {
	        return url;
	      }

	      var serializedParams;

	      if (paramsSerializer) {
	        serializedParams = paramsSerializer(params);
	      } else if (utils$c.isURLSearchParams(params)) {
	        serializedParams = params.toString();
	      } else {
	        var parts = [];
	        utils$c.forEach(params, function serialize(val, key) {
	          if (val === null || typeof val === 'undefined') {
	            return;
	          }

	          if (utils$c.isArray(val)) {
	            key = key + '[]';
	          } else {
	            val = [val];
	          }

	          utils$c.forEach(val, function parseValue(v) {
	            if (utils$c.isDate(v)) {
	              v = v.toISOString();
	            } else if (utils$c.isObject(v)) {
	              v = JSON.stringify(v);
	            }

	            parts.push(encode(key) + '=' + encode(v));
	          });
	        });
	        serializedParams = parts.join('&');
	      }

	      if (serializedParams) {
	        var hashmarkIndex = url.indexOf('#');

	        if (hashmarkIndex !== -1) {
	          url = url.slice(0, hashmarkIndex);
	        }

	        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	      }

	      return url;
	    };

	    var utils$b = utils$d;

	    function InterceptorManager$1() {
	      this.handlers = [];
	    }
	    /**
	     * Add a new interceptor to the stack
	     *
	     * @param {Function} fulfilled The function to handle `then` for a `Promise`
	     * @param {Function} rejected The function to handle `reject` for a `Promise`
	     *
	     * @return {Number} An ID used to remove interceptor later
	     */


	    InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
	      this.handlers.push({
	        fulfilled: fulfilled,
	        rejected: rejected,
	        synchronous: options ? options.synchronous : false,
	        runWhen: options ? options.runWhen : null
	      });
	      return this.handlers.length - 1;
	    };
	    /**
	     * Remove an interceptor from the stack
	     *
	     * @param {Number} id The ID that was returned by `use`
	     */


	    InterceptorManager$1.prototype.eject = function eject(id) {
	      if (this.handlers[id]) {
	        this.handlers[id] = null;
	      }
	    };
	    /**
	     * Iterate over all the registered interceptors
	     *
	     * This method is particularly useful for skipping over any
	     * interceptors that may have become `null` calling `eject`.
	     *
	     * @param {Function} fn The function to call for each interceptor
	     */


	    InterceptorManager$1.prototype.forEach = function forEach(fn) {
	      utils$b.forEach(this.handlers, function forEachHandler(h) {
	        if (h !== null) {
	          fn(h);
	        }
	      });
	    };

	    var InterceptorManager_1 = InterceptorManager$1;
	    var utils$a = utils$d;

	    var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
	      utils$a.forEach(headers, function processHeader(value, name) {
	        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	          headers[normalizedName] = value;
	          delete headers[name];
	        }
	      });
	    };
	    /**
	     * Update an Error with the specified config, error code, and response.
	     *
	     * @param {Error} error The error to update.
	     * @param {Object} config The config.
	     * @param {string} [code] The error code (for example, 'ECONNABORTED').
	     * @param {Object} [request] The request.
	     * @param {Object} [response] The response.
	     * @returns {Error} The error.
	     */


	    var enhanceError$2 = function enhanceError(error, config, code, request, response) {
	      error.config = config;

	      if (code) {
	        error.code = code;
	      }

	      error.request = request;
	      error.response = response;
	      error.isAxiosError = true;

	      error.toJSON = function toJSON() {
	        return {
	          // Standard
	          message: this.message,
	          name: this.name,
	          // Microsoft
	          description: this.description,
	          number: this.number,
	          // Mozilla
	          fileName: this.fileName,
	          lineNumber: this.lineNumber,
	          columnNumber: this.columnNumber,
	          stack: this.stack,
	          // Axios
	          config: this.config,
	          code: this.code,
	          status: this.response && this.response.status ? this.response.status : null
	        };
	      };

	      return error;
	    };

	    var enhanceError$1 = enhanceError$2;
	    /**
	     * Create an Error with the specified message, config, error code, request and response.
	     *
	     * @param {string} message The error message.
	     * @param {Object} config The config.
	     * @param {string} [code] The error code (for example, 'ECONNABORTED').
	     * @param {Object} [request] The request.
	     * @param {Object} [response] The response.
	     * @returns {Error} The created error.
	     */

	    var createError$2 = function createError(message, config, code, request, response) {
	      var error = new Error(message);
	      return enhanceError$1(error, config, code, request, response);
	    };

	    var createError$1 = createError$2;
	    /**
	     * Resolve or reject a Promise based on response status.
	     *
	     * @param {Function} resolve A function that resolves the promise.
	     * @param {Function} reject A function that rejects the promise.
	     * @param {object} response The response.
	     */

	    var settle$1 = function settle(resolve, reject, response) {
	      var validateStatus = response.config.validateStatus;

	      if (!response.status || !validateStatus || validateStatus(response.status)) {
	        resolve(response);
	      } else {
	        reject(createError$1('Request failed with status code ' + response.status, response.config, null, response.request, response));
	      }
	    };

	    var utils$9 = utils$d;
	    var cookies$1 = utils$9.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
	    function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));

	          if (utils$9.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }

	          if (utils$9.isString(path)) {
	            cookie.push('path=' + path);
	          }

	          if (utils$9.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }

	          if (secure === true) {
	            cookie.push('secure');
	          }

	          document.cookie = cookie.join('; ');
	        },
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return match ? decodeURIComponent(match[3]) : null;
	        },
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    }() : // Non standard browser env (web workers, react-native) lack needed support.
	    function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() {
	          return null;
	        },
	        remove: function remove() {}
	      };
	    }();
	    /**
	     * Determines whether the specified URL is absolute
	     *
	     * @param {string} url The URL to test
	     * @returns {boolean} True if the specified URL is absolute, otherwise false
	     */

	    var isAbsoluteURL$1 = function isAbsoluteURL(url) {
	      // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	      // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	      // by any combination of letters, digits, plus, period, or hyphen.
	      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	    };
	    /**
	     * Creates a new URL by combining the specified URLs
	     *
	     * @param {string} baseURL The base URL
	     * @param {string} relativeURL The relative URL
	     * @returns {string} The combined URL
	     */


	    var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
	      return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
	    };

	    var isAbsoluteURL = isAbsoluteURL$1;
	    var combineURLs = combineURLs$1;
	    /**
	     * Creates a new URL by combining the baseURL with the requestedURL,
	     * only when the requestedURL is not already an absolute URL.
	     * If the requestURL is absolute, this function returns the requestedURL untouched.
	     *
	     * @param {string} baseURL The base URL
	     * @param {string} requestedURL Absolute or relative URL to combine
	     * @returns {string} The combined full path
	     */

	    var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
	      if (baseURL && !isAbsoluteURL(requestedURL)) {
	        return combineURLs(baseURL, requestedURL);
	      }

	      return requestedURL;
	    };

	    var utils$8 = utils$d; // Headers whose duplicates are ignored by node
	    // c.f. https://nodejs.org/api/http.html#http_message_headers

	    var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
	    /**
	     * Parse headers into an object
	     *
	     * ```
	     * Date: Wed, 27 Aug 2014 08:58:49 GMT
	     * Content-Type: application/json
	     * Connection: keep-alive
	     * Transfer-Encoding: chunked
	     * ```
	     *
	     * @param {String} headers Headers needing to be parsed
	     * @returns {Object} Headers parsed into an object
	     */

	    var parseHeaders$1 = function parseHeaders(headers) {
	      var parsed = {};
	      var key;
	      var val;
	      var i;

	      if (!headers) {
	        return parsed;
	      }

	      utils$8.forEach(headers.split('\n'), function parser(line) {
	        i = line.indexOf(':');
	        key = utils$8.trim(line.substr(0, i)).toLowerCase();
	        val = utils$8.trim(line.substr(i + 1));

	        if (key) {
	          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	            return;
	          }

	          if (key === 'set-cookie') {
	            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	          } else {
	            parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	          }
	        }
	      });
	      return parsed;
	    };

	    var utils$7 = utils$d;
	    var isURLSameOrigin$1 = utils$7.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
	    // whether the request URL is of the same origin as current location.
	    function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	      /**
	      * Parse a URL to discover it's components
	      *
	      * @param {String} url The URL to be parsed
	      * @returns {Object}
	      */

	      function resolveURL(url) {
	        var href = url;

	        if (msie) {
	          // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }

	        urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
	        };
	      }

	      originURL = resolveURL(window.location.href);
	      /**
	      * Determine if a URL shares the same origin as the current location
	      *
	      * @param {String} requestURL The URL to test
	      * @returns {boolean} True if URL shares the same origin, otherwise false
	      */

	      return function isURLSameOrigin(requestURL) {
	        var parsed = utils$7.isString(requestURL) ? resolveURL(requestURL) : requestURL;
	        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
	      };
	    }() : // Non standard browser envs (web workers, react-native) lack needed support.
	    function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    }();
	    /**
	     * A `Cancel` is an object that is thrown when an operation is canceled.
	     *
	     * @class
	     * @param {string=} message The message.
	     */

	    function Cancel$3(message) {
	      this.message = message;
	    }

	    Cancel$3.prototype.toString = function toString() {
	      return 'Cancel' + (this.message ? ': ' + this.message : '');
	    };

	    Cancel$3.prototype.__CANCEL__ = true;
	    var Cancel_1 = Cancel$3;
	    var utils$6 = utils$d;
	    var settle = settle$1;
	    var cookies = cookies$1;
	    var buildURL$1 = buildURL$2;
	    var buildFullPath = buildFullPath$1;
	    var parseHeaders = parseHeaders$1;
	    var isURLSameOrigin = isURLSameOrigin$1;
	    var createError = createError$2;
	    var defaults$4 = defaults_1;
	    var Cancel$2 = Cancel_1;

	    var xhr = function xhrAdapter(config) {
	      return new Promise(function dispatchXhrRequest(resolve, reject) {
	        var requestData = config.data;
	        var requestHeaders = config.headers;
	        var responseType = config.responseType;
	        var onCanceled;

	        function done() {
	          if (config.cancelToken) {
	            config.cancelToken.unsubscribe(onCanceled);
	          }

	          if (config.signal) {
	            config.signal.removeEventListener('abort', onCanceled);
	          }
	        }

	        if (utils$6.isFormData(requestData)) {
	          delete requestHeaders['Content-Type']; // Let the browser set it
	        }

	        var request = new XMLHttpRequest(); // HTTP basic authentication

	        if (config.auth) {
	          var username = config.auth.username || '';
	          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	          requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	        }

	        var fullPath = buildFullPath(config.baseURL, config.url);
	        request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

	        request.timeout = config.timeout;

	        function onloadend() {
	          if (!request) {
	            return;
	          } // Prepare the response


	          var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	          var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
	          var response = {
	            data: responseData,
	            status: request.status,
	            statusText: request.statusText,
	            headers: responseHeaders,
	            config: config,
	            request: request
	          };
	          settle(function _resolve(value) {
	            resolve(value);
	            done();
	          }, function _reject(err) {
	            reject(err);
	            done();
	          }, response); // Clean up request

	          request = null;
	        }

	        if ('onloadend' in request) {
	          // Use onloadend if available
	          request.onloadend = onloadend;
	        } else {
	          // Listen for ready state to emulate onloadend
	          request.onreadystatechange = function handleLoad() {
	            if (!request || request.readyState !== 4) {
	              return;
	            } // The request errored out and we didn't get a response, this will be
	            // handled by onerror instead
	            // With one exception: request that using file: protocol, most browsers
	            // will return status as 0 even though it's a successful request


	            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	              return;
	            } // readystate handler is calling before onerror or ontimeout handlers,
	            // so we should call onloadend on the next 'tick'


	            setTimeout(onloadend);
	          };
	        } // Handle browser request cancellation (as opposed to a manual cancellation)


	        request.onabort = function handleAbort() {
	          if (!request) {
	            return;
	          }

	          reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

	          request = null;
	        }; // Handle low level network errors


	        request.onerror = function handleError() {
	          // Real errors are hidden from us by the browser
	          // onerror should only fire if it's a network error
	          reject(createError('Network Error', config, null, request)); // Clean up request

	          request = null;
	        }; // Handle timeout


	        request.ontimeout = function handleTimeout() {
	          var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
	          var transitional = config.transitional || defaults$4.transitional;

	          if (config.timeoutErrorMessage) {
	            timeoutErrorMessage = config.timeoutErrorMessage;
	          }

	          reject(createError(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request)); // Clean up request

	          request = null;
	        }; // Add xsrf header
	        // This is only done if running in a standard browser environment.
	        // Specifically not if we're in a web worker, or react-native.


	        if (utils$6.isStandardBrowserEnv()) {
	          // Add xsrf header
	          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

	          if (xsrfValue) {
	            requestHeaders[config.xsrfHeaderName] = xsrfValue;
	          }
	        } // Add headers to the request


	        if ('setRequestHeader' in request) {
	          utils$6.forEach(requestHeaders, function setRequestHeader(val, key) {
	            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	              // Remove Content-Type if data is undefined
	              delete requestHeaders[key];
	            } else {
	              // Otherwise add header to the request
	              request.setRequestHeader(key, val);
	            }
	          });
	        } // Add withCredentials to request if needed


	        if (!utils$6.isUndefined(config.withCredentials)) {
	          request.withCredentials = !!config.withCredentials;
	        } // Add responseType to request if needed


	        if (responseType && responseType !== 'json') {
	          request.responseType = config.responseType;
	        } // Handle progress if needed


	        if (typeof config.onDownloadProgress === 'function') {
	          request.addEventListener('progress', config.onDownloadProgress);
	        } // Not all browsers support upload events


	        if (typeof config.onUploadProgress === 'function' && request.upload) {
	          request.upload.addEventListener('progress', config.onUploadProgress);
	        }

	        if (config.cancelToken || config.signal) {
	          // Handle cancellation
	          // eslint-disable-next-line func-names
	          onCanceled = function (cancel) {
	            if (!request) {
	              return;
	            }

	            reject(!cancel || cancel && cancel.type ? new Cancel$2('canceled') : cancel);
	            request.abort();
	            request = null;
	          };

	          config.cancelToken && config.cancelToken.subscribe(onCanceled);

	          if (config.signal) {
	            config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
	          }
	        }

	        if (!requestData) {
	          requestData = null;
	        } // Send the request


	        request.send(requestData);
	      });
	    };

	    var utils$5 = utils$d;
	    var normalizeHeaderName = normalizeHeaderName$1;
	    var enhanceError = enhanceError$2;
	    var DEFAULT_CONTENT_TYPE = {
	      'Content-Type': 'application/x-www-form-urlencoded'
	    };

	    function setContentTypeIfUnset(headers, value) {
	      if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers['Content-Type'])) {
	        headers['Content-Type'] = value;
	      }
	    }

	    function getDefaultAdapter() {
	      var adapter;

	      if (typeof XMLHttpRequest !== 'undefined') {
	        // For browsers use XHR adapter
	        adapter = xhr;
	      } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	        // For node use HTTP adapter
	        adapter = xhr;
	      }

	      return adapter;
	    }

	    function stringifySafely(rawValue, parser, encoder) {
	      if (utils$5.isString(rawValue)) {
	        try {
	          (parser || JSON.parse)(rawValue);
	          return utils$5.trim(rawValue);
	        } catch (e) {
	          if (e.name !== 'SyntaxError') {
	            throw e;
	          }
	        }
	      }

	      return (encoder || JSON.stringify)(rawValue);
	    }

	    var defaults$3 = {
	      transitional: {
	        silentJSONParsing: true,
	        forcedJSONParsing: true,
	        clarifyTimeoutError: false
	      },
	      adapter: getDefaultAdapter(),
	      transformRequest: [function transformRequest(data, headers) {
	        normalizeHeaderName(headers, 'Accept');
	        normalizeHeaderName(headers, 'Content-Type');

	        if (utils$5.isFormData(data) || utils$5.isArrayBuffer(data) || utils$5.isBuffer(data) || utils$5.isStream(data) || utils$5.isFile(data) || utils$5.isBlob(data)) {
	          return data;
	        }

	        if (utils$5.isArrayBufferView(data)) {
	          return data.buffer;
	        }

	        if (utils$5.isURLSearchParams(data)) {
	          setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	          return data.toString();
	        }

	        if (utils$5.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
	          setContentTypeIfUnset(headers, 'application/json');
	          return stringifySafely(data);
	        }

	        return data;
	      }],
	      transformResponse: [function transformResponse(data) {
	        var transitional = this.transitional || defaults$3.transitional;
	        var silentJSONParsing = transitional && transitional.silentJSONParsing;
	        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	        var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

	        if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data) && data.length) {
	          try {
	            return JSON.parse(data);
	          } catch (e) {
	            if (strictJSONParsing) {
	              if (e.name === 'SyntaxError') {
	                throw enhanceError(e, this, 'E_JSON_PARSE');
	              }

	              throw e;
	            }
	          }
	        }

	        return data;
	      }],

	      /**
	       * A timeout in milliseconds to abort a request. If set to 0 (default) a
	       * timeout is not created.
	       */
	      timeout: 0,
	      xsrfCookieName: 'XSRF-TOKEN',
	      xsrfHeaderName: 'X-XSRF-TOKEN',
	      maxContentLength: -1,
	      maxBodyLength: -1,
	      validateStatus: function validateStatus(status) {
	        return status >= 200 && status < 300;
	      },
	      headers: {
	        common: {
	          'Accept': 'application/json, text/plain, */*'
	        }
	      }
	    };
	    utils$5.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	      defaults$3.headers[method] = {};
	    });
	    utils$5.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	      defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
	    });
	    var defaults_1 = defaults$3;
	    var utils$4 = utils$d;
	    var defaults$2 = defaults_1;
	    /**
	     * Transform the data for a request or a response
	     *
	     * @param {Object|String} data The data to be transformed
	     * @param {Array} headers The headers for the request or response
	     * @param {Array|Function} fns A single function or Array of functions
	     * @returns {*} The resulting transformed data
	     */

	    var transformData$1 = function transformData(data, headers, fns) {
	      var context = this || defaults$2;
	      /*eslint no-param-reassign:0*/

	      utils$4.forEach(fns, function transform(fn) {
	        data = fn.call(context, data, headers);
	      });
	      return data;
	    };

	    var isCancel$1 = function isCancel(value) {
	      return !!(value && value.__CANCEL__);
	    };

	    var utils$3 = utils$d;
	    var transformData = transformData$1;
	    var isCancel = isCancel$1;
	    var defaults$1 = defaults_1;
	    var Cancel$1 = Cancel_1;
	    /**
	     * Throws a `Cancel` if cancellation has been requested.
	     */

	    function throwIfCancellationRequested(config) {
	      if (config.cancelToken) {
	        config.cancelToken.throwIfRequested();
	      }

	      if (config.signal && config.signal.aborted) {
	        throw new Cancel$1('canceled');
	      }
	    }
	    /**
	     * Dispatch a request to the server using the configured adapter.
	     *
	     * @param {object} config The config that is to be used for the request
	     * @returns {Promise} The Promise to be fulfilled
	     */


	    var dispatchRequest$1 = function dispatchRequest(config) {
	      throwIfCancellationRequested(config); // Ensure headers exist

	      config.headers = config.headers || {}; // Transform request data

	      config.data = transformData.call(config, config.data, config.headers, config.transformRequest); // Flatten headers

	      config.headers = utils$3.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
	      utils$3.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
	        delete config.headers[method];
	      });
	      var adapter = config.adapter || defaults$1.adapter;
	      return adapter(config).then(function onAdapterResolution(response) {
	        throwIfCancellationRequested(config); // Transform response data

	        response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
	        return response;
	      }, function onAdapterRejection(reason) {
	        if (!isCancel(reason)) {
	          throwIfCancellationRequested(config); // Transform response data

	          if (reason && reason.response) {
	            reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
	          }
	        }

	        return Promise.reject(reason);
	      });
	    };

	    var utils$2 = utils$d;
	    /**
	     * Config-specific merge-function which creates a new config-object
	     * by merging two configuration objects together.
	     *
	     * @param {Object} config1
	     * @param {Object} config2
	     * @returns {Object} New object resulting from merging config2 to config1
	     */

	    var mergeConfig$2 = function mergeConfig(config1, config2) {
	      // eslint-disable-next-line no-param-reassign
	      config2 = config2 || {};
	      var config = {};

	      function getMergedValue(target, source) {
	        if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
	          return utils$2.merge(target, source);
	        } else if (utils$2.isPlainObject(source)) {
	          return utils$2.merge({}, source);
	        } else if (utils$2.isArray(source)) {
	          return source.slice();
	        }

	        return source;
	      } // eslint-disable-next-line consistent-return


	      function mergeDeepProperties(prop) {
	        if (!utils$2.isUndefined(config2[prop])) {
	          return getMergedValue(config1[prop], config2[prop]);
	        } else if (!utils$2.isUndefined(config1[prop])) {
	          return getMergedValue(undefined, config1[prop]);
	        }
	      } // eslint-disable-next-line consistent-return


	      function valueFromConfig2(prop) {
	        if (!utils$2.isUndefined(config2[prop])) {
	          return getMergedValue(undefined, config2[prop]);
	        }
	      } // eslint-disable-next-line consistent-return


	      function defaultToConfig2(prop) {
	        if (!utils$2.isUndefined(config2[prop])) {
	          return getMergedValue(undefined, config2[prop]);
	        } else if (!utils$2.isUndefined(config1[prop])) {
	          return getMergedValue(undefined, config1[prop]);
	        }
	      } // eslint-disable-next-line consistent-return


	      function mergeDirectKeys(prop) {
	        if (prop in config2) {
	          return getMergedValue(config1[prop], config2[prop]);
	        } else if (prop in config1) {
	          return getMergedValue(undefined, config1[prop]);
	        }
	      }

	      var mergeMap = {
	        'url': valueFromConfig2,
	        'method': valueFromConfig2,
	        'data': valueFromConfig2,
	        'baseURL': defaultToConfig2,
	        'transformRequest': defaultToConfig2,
	        'transformResponse': defaultToConfig2,
	        'paramsSerializer': defaultToConfig2,
	        'timeout': defaultToConfig2,
	        'timeoutMessage': defaultToConfig2,
	        'withCredentials': defaultToConfig2,
	        'adapter': defaultToConfig2,
	        'responseType': defaultToConfig2,
	        'xsrfCookieName': defaultToConfig2,
	        'xsrfHeaderName': defaultToConfig2,
	        'onUploadProgress': defaultToConfig2,
	        'onDownloadProgress': defaultToConfig2,
	        'decompress': defaultToConfig2,
	        'maxContentLength': defaultToConfig2,
	        'maxBodyLength': defaultToConfig2,
	        'transport': defaultToConfig2,
	        'httpAgent': defaultToConfig2,
	        'httpsAgent': defaultToConfig2,
	        'cancelToken': defaultToConfig2,
	        'socketPath': defaultToConfig2,
	        'responseEncoding': defaultToConfig2,
	        'validateStatus': mergeDirectKeys
	      };
	      utils$2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
	        var merge = mergeMap[prop] || mergeDeepProperties;
	        var configValue = merge(prop);
	        utils$2.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
	      });
	      return config;
	    };

	    var data = {
	      "version": "0.24.0"
	    };
	    var VERSION = data.version;
	    var validators$1 = {}; // eslint-disable-next-line func-names

	    ['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
	      validators$1[type] = function validator(thing) {
	        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	      };
	    });
	    var deprecatedWarnings = {};
	    /**
	     * Transitional option validator
	     * @param {function|boolean?} validator - set to false if the transitional option has been removed
	     * @param {string?} version - deprecated version / removed since version
	     * @param {string?} message - some message with additional info
	     * @returns {function}
	     */

	    validators$1.transitional = function transitional(validator, version, message) {
	      function formatMessage(opt, desc) {
	        return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	      } // eslint-disable-next-line func-names


	      return function (value, opt, opts) {
	        if (validator === false) {
	          throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
	        }

	        if (version && !deprecatedWarnings[opt]) {
	          deprecatedWarnings[opt] = true; // eslint-disable-next-line no-console

	          console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
	        }

	        return validator ? validator(value, opt, opts) : true;
	      };
	    };
	    /**
	     * Assert object's properties type
	     * @param {object} options
	     * @param {object} schema
	     * @param {boolean?} allowUnknown
	     */


	    function assertOptions(options, schema, allowUnknown) {
	      if (typeof options !== 'object') {
	        throw new TypeError('options must be an object');
	      }

	      var keys = Object.keys(options);
	      var i = keys.length;

	      while (i-- > 0) {
	        var opt = keys[i];
	        var validator = schema[opt];

	        if (validator) {
	          var value = options[opt];
	          var result = value === undefined || validator(value, opt, options);

	          if (result !== true) {
	            throw new TypeError('option ' + opt + ' must be ' + result);
	          }

	          continue;
	        }

	        if (allowUnknown !== true) {
	          throw Error('Unknown option ' + opt);
	        }
	      }
	    }

	    var validator$1 = {
	      assertOptions: assertOptions,
	      validators: validators$1
	    };
	    var utils$1 = utils$d;
	    var buildURL = buildURL$2;
	    var InterceptorManager = InterceptorManager_1;
	    var dispatchRequest = dispatchRequest$1;
	    var mergeConfig$1 = mergeConfig$2;
	    var validator = validator$1;
	    var validators = validator.validators;
	    /**
	     * Create a new instance of Axios
	     *
	     * @param {Object} instanceConfig The default config for the instance
	     */

	    function Axios$1(instanceConfig) {
	      this.defaults = instanceConfig;
	      this.interceptors = {
	        request: new InterceptorManager(),
	        response: new InterceptorManager()
	      };
	    }
	    /**
	     * Dispatch a request
	     *
	     * @param {Object} config The config specific for this request (merged with this.defaults)
	     */


	    Axios$1.prototype.request = function request(config) {
	      /*eslint no-param-reassign:0*/
	      // Allow for axios('example/url'[, config]) a la fetch API
	      if (typeof config === 'string') {
	        config = arguments[1] || {};
	        config.url = arguments[0];
	      } else {
	        config = config || {};
	      }

	      config = mergeConfig$1(this.defaults, config); // Set config.method

	      if (config.method) {
	        config.method = config.method.toLowerCase();
	      } else if (this.defaults.method) {
	        config.method = this.defaults.method.toLowerCase();
	      } else {
	        config.method = 'get';
	      }

	      var transitional = config.transitional;

	      if (transitional !== undefined) {
	        validator.assertOptions(transitional, {
	          silentJSONParsing: validators.transitional(validators.boolean),
	          forcedJSONParsing: validators.transitional(validators.boolean),
	          clarifyTimeoutError: validators.transitional(validators.boolean)
	        }, false);
	      } // filter out skipped interceptors


	      var requestInterceptorChain = [];
	      var synchronousRequestInterceptors = true;
	      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	          return;
	        }

	        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	      });
	      var responseInterceptorChain = [];
	      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	      });
	      var promise;

	      if (!synchronousRequestInterceptors) {
	        var chain = [dispatchRequest, undefined];
	        Array.prototype.unshift.apply(chain, requestInterceptorChain);
	        chain = chain.concat(responseInterceptorChain);
	        promise = Promise.resolve(config);

	        while (chain.length) {
	          promise = promise.then(chain.shift(), chain.shift());
	        }

	        return promise;
	      }

	      var newConfig = config;

	      while (requestInterceptorChain.length) {
	        var onFulfilled = requestInterceptorChain.shift();
	        var onRejected = requestInterceptorChain.shift();

	        try {
	          newConfig = onFulfilled(newConfig);
	        } catch (error) {
	          onRejected(error);
	          break;
	        }
	      }

	      try {
	        promise = dispatchRequest(newConfig);
	      } catch (error) {
	        return Promise.reject(error);
	      }

	      while (responseInterceptorChain.length) {
	        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	      }

	      return promise;
	    };

	    Axios$1.prototype.getUri = function getUri(config) {
	      config = mergeConfig$1(this.defaults, config);
	      return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	    }; // Provide aliases for supported request methods


	    utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	      /*eslint func-names:0*/
	      Axios$1.prototype[method] = function (url, config) {
	        return this.request(mergeConfig$1(config || {}, {
	          method: method,
	          url: url,
	          data: (config || {}).data
	        }));
	      };
	    });
	    utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	      /*eslint func-names:0*/
	      Axios$1.prototype[method] = function (url, data, config) {
	        return this.request(mergeConfig$1(config || {}, {
	          method: method,
	          url: url,
	          data: data
	        }));
	      };
	    });
	    var Axios_1 = Axios$1;
	    var Cancel = Cancel_1;
	    /**
	     * A `CancelToken` is an object that can be used to request cancellation of an operation.
	     *
	     * @class
	     * @param {Function} executor The executor function.
	     */

	    function CancelToken(executor) {
	      if (typeof executor !== 'function') {
	        throw new TypeError('executor must be a function.');
	      }

	      var resolvePromise;
	      this.promise = new Promise(function promiseExecutor(resolve) {
	        resolvePromise = resolve;
	      });
	      var token = this; // eslint-disable-next-line func-names

	      this.promise.then(function (cancel) {
	        if (!token._listeners) return;
	        var i;
	        var l = token._listeners.length;

	        for (i = 0; i < l; i++) {
	          token._listeners[i](cancel);
	        }

	        token._listeners = null;
	      }); // eslint-disable-next-line func-names

	      this.promise.then = function (onfulfilled) {
	        var _resolve; // eslint-disable-next-line func-names


	        var promise = new Promise(function (resolve) {
	          token.subscribe(resolve);
	          _resolve = resolve;
	        }).then(onfulfilled);

	        promise.cancel = function reject() {
	          token.unsubscribe(_resolve);
	        };

	        return promise;
	      };

	      executor(function cancel(message) {
	        if (token.reason) {
	          // Cancellation has already been requested
	          return;
	        }

	        token.reason = new Cancel(message);
	        resolvePromise(token.reason);
	      });
	    }
	    /**
	     * Throws a `Cancel` if cancellation has been requested.
	     */


	    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	      if (this.reason) {
	        throw this.reason;
	      }
	    };
	    /**
	     * Subscribe to the cancel signal
	     */


	    CancelToken.prototype.subscribe = function subscribe(listener) {
	      if (this.reason) {
	        listener(this.reason);
	        return;
	      }

	      if (this._listeners) {
	        this._listeners.push(listener);
	      } else {
	        this._listeners = [listener];
	      }
	    };
	    /**
	     * Unsubscribe from the cancel signal
	     */


	    CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
	      if (!this._listeners) {
	        return;
	      }

	      var index = this._listeners.indexOf(listener);

	      if (index !== -1) {
	        this._listeners.splice(index, 1);
	      }
	    };
	    /**
	     * Returns an object that contains a new `CancelToken` and a function that, when called,
	     * cancels the `CancelToken`.
	     */


	    CancelToken.source = function source() {
	      var cancel;
	      var token = new CancelToken(function executor(c) {
	        cancel = c;
	      });
	      return {
	        token: token,
	        cancel: cancel
	      };
	    };

	    var CancelToken_1 = CancelToken;
	    /**
	     * Syntactic sugar for invoking a function and expanding an array for arguments.
	     *
	     * Common use case would be to use `Function.prototype.apply`.
	     *
	     *  ```js
	     *  function f(x, y, z) {}
	     *  var args = [1, 2, 3];
	     *  f.apply(null, args);
	     *  ```
	     *
	     * With `spread` this example can be re-written.
	     *
	     *  ```js
	     *  spread(function(x, y, z) {})([1, 2, 3]);
	     *  ```
	     *
	     * @param {Function} callback
	     * @returns {Function}
	     */

	    var spread = function spread(callback) {
	      return function wrap(arr) {
	        return callback.apply(null, arr);
	      };
	    };
	    /**
	     * Determines whether the payload is an error thrown by Axios
	     *
	     * @param {*} payload The value to test
	     * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	     */


	    var isAxiosError = function isAxiosError(payload) {
	      return typeof payload === 'object' && payload.isAxiosError === true;
	    };

	    var utils = utils$d;
	    var bind = bind$2;
	    var Axios = Axios_1;
	    var mergeConfig = mergeConfig$2;
	    var defaults = defaults_1;
	    /**
	     * Create an instance of Axios
	     *
	     * @param {Object} defaultConfig The default config for the instance
	     * @return {Axios} A new instance of Axios
	     */

	    function createInstance(defaultConfig) {
	      var context = new Axios(defaultConfig);
	      var instance = bind(Axios.prototype.request, context); // Copy axios.prototype to instance

	      utils.extend(instance, Axios.prototype, context); // Copy context to instance

	      utils.extend(instance, context); // Factory for creating new instances

	      instance.create = function create(instanceConfig) {
	        return createInstance(mergeConfig(defaultConfig, instanceConfig));
	      };

	      return instance;
	    } // Create the default instance to be exported


	    var axios$1 = createInstance(defaults); // Expose Axios class to allow class inheritance

	    axios$1.Axios = Axios; // Expose Cancel & CancelToken

	    axios$1.Cancel = Cancel_1;
	    axios$1.CancelToken = CancelToken_1;
	    axios$1.isCancel = isCancel$1;
	    axios$1.VERSION = data.version; // Expose all/spread

	    axios$1.all = function all(promises) {
	      return Promise.all(promises);
	    };

	    axios$1.spread = spread; // Expose isAxiosError

	    axios$1.isAxiosError = isAxiosError;
	    axios$2.exports = axios$1; // Allow use of default import syntax in TypeScript

	    axios$2.exports.default = axios$1;
	    var axios = axios$2.exports;
	    exports.Level = void 0;

	    (function (Level) {
	      Level["None"] = "none";
	      Level["Fatal"] = "fatal";
	      Level["Error"] = "error";
	      Level["Warning"] = "warning";
	      Level["Info"] = "info";
	      Level["Debug"] = "debug";
	    })(exports.Level || (exports.Level = {}));

	    exports.LevelNumber = void 0;

	    (function (LevelNumber) {
	      LevelNumber[LevelNumber["None"] = 1] = "None";
	      LevelNumber[LevelNumber["Fatal"] = 2] = "Fatal";
	      LevelNumber[LevelNumber["Error"] = 3] = "Error";
	      LevelNumber[LevelNumber["Warning"] = 4] = "Warning";
	      LevelNumber[LevelNumber["Info"] = 5] = "Info";
	      LevelNumber[LevelNumber["Debug"] = 6] = "Debug";
	    })(exports.LevelNumber || (exports.LevelNumber = {}));

	    const levelNumberToLevel = {
	      [exports.LevelNumber.None]: exports.Level.None,
	      [exports.LevelNumber.Fatal]: exports.Level.Fatal,
	      [exports.LevelNumber.Error]: exports.Level.Error,
	      [exports.LevelNumber.Warning]: exports.Level.Warning,
	      [exports.LevelNumber.Info]: exports.Level.Info,
	      [exports.LevelNumber.Debug]: exports.Level.Debug
	    };
	    const levelToLevelNumber = {
	      [exports.Level.None]: exports.LevelNumber.None,
	      [exports.Level.Fatal]: exports.LevelNumber.Fatal,
	      [exports.Level.Error]: exports.LevelNumber.Error,
	      [exports.Level.Warning]: exports.LevelNumber.Warning,
	      [exports.Level.Info]: exports.LevelNumber.Info,
	      [exports.Level.Debug]: exports.LevelNumber.Debug
	    };

	    class BaseOutput {
	      constructor(sessionId, origin, settings) {
	        this._level = exports.LevelNumber.None;

	        if (!sessionId || !sessionId.length) {
	          throw new Error('Invalid first argument sessionsId. Expected a non zero length string.');
	        }

	        if (!origin || !origin) {
	          throw new Error('Invalid second argument origin. Expected a non zero length string.');
	        }

	        this._sessionId = sessionId;
	        this._origin = origin;

	        if (settings && settings.level) {
	          this.setLevel(settings.level);
	        } else {
	          this.setLevel(exports.Level.Info);
	        }
	      }

	      setLevel(level) {
	        if (!levelToLevelNumber[level]) {
	          console.warn('hello');
	          throw new Error('Invalid level, cannot transform to level number');
	        }

	        this._level = levelToLevelNumber[level];
	      }

	    }

	    class ConsoleOutput extends BaseOutput {
	      constructor() {
	        super(...arguments);
	        this._level = exports.LevelNumber.Debug;
	      }

	      send(err) {
	        const consoleMethod = this._getConsoleMethod(exports.LevelNumber.Debug); // TODO err.level !!!


	        consoleMethod(this._marshalMessage(err), err.toFlatData());
	      }
	      /**
	       *  Retrieve the correct console processor.
	       *
	       *  Depends on the console logging level.
	       */


	      _getConsoleMethod(errorLevel) {
	        // If the logging level is higher (e.g.: Less important)
	        // than the set level, return a no-op function
	        if (errorLevel > this._level) {
	          return () => {};
	        }

	        switch (errorLevel) {
	          case exports.LevelNumber.Debug:
	            // eslint-disable-next-line no-console
	            return window.console.debug;

	          case exports.LevelNumber.Info:
	            // eslint-disable-next-line no-console
	            return window.console.info;

	          case exports.LevelNumber.Warning:
	            return window.console.warn;

	          case exports.LevelNumber.Error:
	          case exports.LevelNumber.Fatal:
	          default:
	            return window.console.error;
	        }
	      }

	      _marshalMessage(error) {
	        const parts = [[this._sessionId, this._origin, error.at.toLocaleTimeString()].join(' | '), error.toSlug().key, error.toString()];
	        return parts.join('\n');
	      }

	    }

	    const SIZEOF_SHORT = 2;
	    const SIZEOF_INT = 4;
	    const FILE_IDENTIFIER_LENGTH = 4;
	    const SIZE_PREFIX_LENGTH = 4;
	    const int32 = new Int32Array(2);
	    const float32 = new Float32Array(int32.buffer);
	    const float64 = new Float64Array(int32.buffer);
	    const isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;

	    class Long {
	      constructor(low, high) {
	        this.low = low | 0;
	        this.high = high | 0;
	      }

	      static create(low, high) {
	        // Special-case zero to avoid GC overhead for default values
	        return low == 0 && high == 0 ? Long.ZERO : new Long(low, high);
	      }

	      toFloat64() {
	        return (this.low >>> 0) + this.high * 0x100000000;
	      }

	      equals(other) {
	        return this.low == other.low && this.high == other.high;
	      }

	    }

	    Long.ZERO = new Long(0, 0);
	    var Encoding;

	    (function (Encoding) {
	      Encoding[Encoding["UTF8_BYTES"] = 1] = "UTF8_BYTES";
	      Encoding[Encoding["UTF16_STRING"] = 2] = "UTF16_STRING";
	    })(Encoding || (Encoding = {}));

	    class ByteBuffer {
	      /**
	       * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
	       */
	      constructor(bytes_) {
	        this.bytes_ = bytes_;
	        this.position_ = 0;
	      }
	      /**
	       * Create and allocate a new ByteBuffer with a given size.
	       */


	      static allocate(byte_size) {
	        return new ByteBuffer(new Uint8Array(byte_size));
	      }

	      clear() {
	        this.position_ = 0;
	      }
	      /**
	       * Get the underlying `Uint8Array`.
	       */


	      bytes() {
	        return this.bytes_;
	      }
	      /**
	       * Get the buffer's position.
	       */


	      position() {
	        return this.position_;
	      }
	      /**
	       * Set the buffer's position.
	       */


	      setPosition(position) {
	        this.position_ = position;
	      }
	      /**
	       * Get the buffer's capacity.
	       */


	      capacity() {
	        return this.bytes_.length;
	      }

	      readInt8(offset) {
	        return this.readUint8(offset) << 24 >> 24;
	      }

	      readUint8(offset) {
	        return this.bytes_[offset];
	      }

	      readInt16(offset) {
	        return this.readUint16(offset) << 16 >> 16;
	      }

	      readUint16(offset) {
	        return this.bytes_[offset] | this.bytes_[offset + 1] << 8;
	      }

	      readInt32(offset) {
	        return this.bytes_[offset] | this.bytes_[offset + 1] << 8 | this.bytes_[offset + 2] << 16 | this.bytes_[offset + 3] << 24;
	      }

	      readUint32(offset) {
	        return this.readInt32(offset) >>> 0;
	      }

	      readInt64(offset) {
	        return new Long(this.readInt32(offset), this.readInt32(offset + 4));
	      }

	      readUint64(offset) {
	        return new Long(this.readUint32(offset), this.readUint32(offset + 4));
	      }

	      readFloat32(offset) {
	        int32[0] = this.readInt32(offset);
	        return float32[0];
	      }

	      readFloat64(offset) {
	        int32[isLittleEndian ? 0 : 1] = this.readInt32(offset);
	        int32[isLittleEndian ? 1 : 0] = this.readInt32(offset + 4);
	        return float64[0];
	      }

	      writeInt8(offset, value) {
	        this.bytes_[offset] = value;
	      }

	      writeUint8(offset, value) {
	        this.bytes_[offset] = value;
	      }

	      writeInt16(offset, value) {
	        this.bytes_[offset] = value;
	        this.bytes_[offset + 1] = value >> 8;
	      }

	      writeUint16(offset, value) {
	        this.bytes_[offset] = value;
	        this.bytes_[offset + 1] = value >> 8;
	      }

	      writeInt32(offset, value) {
	        this.bytes_[offset] = value;
	        this.bytes_[offset + 1] = value >> 8;
	        this.bytes_[offset + 2] = value >> 16;
	        this.bytes_[offset + 3] = value >> 24;
	      }

	      writeUint32(offset, value) {
	        this.bytes_[offset] = value;
	        this.bytes_[offset + 1] = value >> 8;
	        this.bytes_[offset + 2] = value >> 16;
	        this.bytes_[offset + 3] = value >> 24;
	      }

	      writeInt64(offset, value) {
	        this.writeInt32(offset, value.low);
	        this.writeInt32(offset + 4, value.high);
	      }

	      writeUint64(offset, value) {
	        this.writeUint32(offset, value.low);
	        this.writeUint32(offset + 4, value.high);
	      }

	      writeFloat32(offset, value) {
	        float32[0] = value;
	        this.writeInt32(offset, int32[0]);
	      }

	      writeFloat64(offset, value) {
	        float64[0] = value;
	        this.writeInt32(offset, int32[isLittleEndian ? 0 : 1]);
	        this.writeInt32(offset + 4, int32[isLittleEndian ? 1 : 0]);
	      }
	      /**
	       * Return the file identifier.   Behavior is undefined for FlatBuffers whose
	       * schema does not include a file_identifier (likely points at padding or the
	       * start of a the root vtable).
	       */


	      getBufferIdentifier() {
	        if (this.bytes_.length < this.position_ + SIZEOF_INT + FILE_IDENTIFIER_LENGTH) {
	          throw new Error('FlatBuffers: ByteBuffer is too short to contain an identifier.');
	        }

	        let result = "";

	        for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
	          result += String.fromCharCode(this.readInt8(this.position_ + SIZEOF_INT + i));
	        }

	        return result;
	      }
	      /**
	       * Look up a field in the vtable, return an offset into the object, or 0 if the
	       * field is not present.
	       */


	      __offset(bb_pos, vtable_offset) {
	        const vtable = bb_pos - this.readInt32(bb_pos);
	        return vtable_offset < this.readInt16(vtable) ? this.readInt16(vtable + vtable_offset) : 0;
	      }
	      /**
	       * Initialize any Table-derived type to point to the union at the given offset.
	       */


	      __union(t, offset) {
	        t.bb_pos = offset + this.readInt32(offset);
	        t.bb = this;
	        return t;
	      }
	      /**
	       * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
	       * This allocates a new string and converts to wide chars upon each access.
	       *
	       * To avoid the conversion to UTF-16, pass Encoding.UTF8_BYTES as
	       * the "optionalEncoding" argument. This is useful for avoiding conversion to
	       * and from UTF-16 when the data will just be packaged back up in another
	       * FlatBuffer later on.
	       *
	       * @param offset
	       * @param opt_encoding Defaults to UTF16_STRING
	       */


	      __string(offset, opt_encoding) {
	        offset += this.readInt32(offset);
	        const length = this.readInt32(offset);
	        let result = '';
	        let i = 0;
	        offset += SIZEOF_INT;

	        if (opt_encoding === Encoding.UTF8_BYTES) {
	          return this.bytes_.subarray(offset, offset + length);
	        }

	        while (i < length) {
	          let codePoint; // Decode UTF-8

	          const a = this.readUint8(offset + i++);

	          if (a < 0xC0) {
	            codePoint = a;
	          } else {
	            const b = this.readUint8(offset + i++);

	            if (a < 0xE0) {
	              codePoint = (a & 0x1F) << 6 | b & 0x3F;
	            } else {
	              const c = this.readUint8(offset + i++);

	              if (a < 0xF0) {
	                codePoint = (a & 0x0F) << 12 | (b & 0x3F) << 6 | c & 0x3F;
	              } else {
	                const d = this.readUint8(offset + i++);
	                codePoint = (a & 0x07) << 18 | (b & 0x3F) << 12 | (c & 0x3F) << 6 | d & 0x3F;
	              }
	            }
	          } // Encode UTF-16


	          if (codePoint < 0x10000) {
	            result += String.fromCharCode(codePoint);
	          } else {
	            codePoint -= 0x10000;
	            result += String.fromCharCode((codePoint >> 10) + 0xD800, (codePoint & (1 << 10) - 1) + 0xDC00);
	          }
	        }

	        return result;
	      }
	      /**
	       * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
	       * if a string then return a new one
	       *
	       * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
	       * makes the behaviour of __union_with_string different compared to __union
	       */


	      __union_with_string(o, offset) {
	        if (typeof o === 'string') {
	          return this.__string(offset);
	        }

	        return this.__union(o, offset);
	      }
	      /**
	       * Retrieve the relative offset stored at "offset"
	       */


	      __indirect(offset) {
	        return offset + this.readInt32(offset);
	      }
	      /**
	       * Get the start of data of a vector whose offset is stored at "offset" in this object.
	       */


	      __vector(offset) {
	        return offset + this.readInt32(offset) + SIZEOF_INT; // data starts after the length
	      }
	      /**
	       * Get the length of a vector whose offset is stored at "offset" in this object.
	       */


	      __vector_len(offset) {
	        return this.readInt32(offset + this.readInt32(offset));
	      }

	      __has_identifier(ident) {
	        if (ident.length != FILE_IDENTIFIER_LENGTH) {
	          throw new Error('FlatBuffers: file identifier must be length ' + FILE_IDENTIFIER_LENGTH);
	        }

	        for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
	          if (ident.charCodeAt(i) != this.readInt8(this.position() + SIZEOF_INT + i)) {
	            return false;
	          }
	        }

	        return true;
	      }
	      /**
	       * A helper function to avoid generated code depending on this file directly.
	       */


	      createLong(low, high) {
	        return Long.create(low, high);
	      }
	      /**
	       * A helper function for generating list for obj api
	       */


	      createScalarList(listAccessor, listLength) {
	        const ret = [];

	        for (let i = 0; i < listLength; ++i) {
	          if (listAccessor(i) !== null) {
	            ret.push(listAccessor(i));
	          }
	        }

	        return ret;
	      }
	      /**
	       * A helper function for generating list for obj api
	       * @param listAccessor function that accepts an index and return data at that index
	       * @param listLength listLength
	       * @param res result list
	       */


	      createObjList(listAccessor, listLength) {
	        const ret = [];

	        for (let i = 0; i < listLength; ++i) {
	          const val = listAccessor(i);

	          if (val !== null) {
	            ret.push(val.unpack());
	          }
	        }

	        return ret;
	      }

	    }

	    class Builder {
	      /**
	       * Create a FlatBufferBuilder.
	       */
	      constructor(opt_initial_size) {
	        /** Minimum alignment encountered so far. */
	        this.minalign = 1;
	        /** The vtable for the current table. */

	        this.vtable = null;
	        /** The amount of fields we're actually using. */

	        this.vtable_in_use = 0;
	        /** Whether we are currently serializing a table. */

	        this.isNested = false;
	        /** Starting offset of the current struct/table. */

	        this.object_start = 0;
	        /** List of offsets of all vtables. */

	        this.vtables = [];
	        /** For the current vector being built. */

	        this.vector_num_elems = 0;
	        /** False omits default values from the serialized data */

	        this.force_defaults = false;
	        this.string_maps = null;
	        let initial_size;

	        if (!opt_initial_size) {
	          initial_size = 1024;
	        } else {
	          initial_size = opt_initial_size;
	        }
	        /**
	         * @type {ByteBuffer}
	         * @private
	         */


	        this.bb = ByteBuffer.allocate(initial_size);
	        this.space = initial_size;
	      }

	      clear() {
	        this.bb.clear();
	        this.space = this.bb.capacity();
	        this.minalign = 1;
	        this.vtable = null;
	        this.vtable_in_use = 0;
	        this.isNested = false;
	        this.object_start = 0;
	        this.vtables = [];
	        this.vector_num_elems = 0;
	        this.force_defaults = false;
	        this.string_maps = null;
	      }
	      /**
	       * In order to save space, fields that are set to their default value
	       * don't get serialized into the buffer. Forcing defaults provides a
	       * way to manually disable this optimization.
	       *
	       * @param forceDefaults true always serializes default values
	       */


	      forceDefaults(forceDefaults) {
	        this.force_defaults = forceDefaults;
	      }
	      /**
	       * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
	       * called finish(). The actual data starts at the ByteBuffer's current position,
	       * not necessarily at 0.
	       */


	      dataBuffer() {
	        return this.bb;
	      }
	      /**
	       * Get the bytes representing the FlatBuffer. Only call this after you've
	       * called finish().
	       */


	      asUint8Array() {
	        return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
	      }
	      /**
	       * Prepare to write an element of `size` after `additional_bytes` have been
	       * written, e.g. if you write a string, you need to align such the int length
	       * field is aligned to 4 bytes, and the string data follows it directly. If all
	       * you need to do is alignment, `additional_bytes` will be 0.
	       *
	       * @param size This is the of the new element to write
	       * @param additional_bytes The padding size
	       */


	      prep(size, additional_bytes) {
	        // Track the biggest thing we've ever aligned to.
	        if (size > this.minalign) {
	          this.minalign = size;
	        } // Find the amount of alignment needed such that `size` is properly
	        // aligned after `additional_bytes`


	        const align_size = ~(this.bb.capacity() - this.space + additional_bytes) + 1 & size - 1; // Reallocate the buffer if needed.

	        while (this.space < align_size + size + additional_bytes) {
	          const old_buf_size = this.bb.capacity();
	          this.bb = Builder.growByteBuffer(this.bb);
	          this.space += this.bb.capacity() - old_buf_size;
	        }

	        this.pad(align_size);
	      }

	      pad(byte_size) {
	        for (let i = 0; i < byte_size; i++) {
	          this.bb.writeInt8(--this.space, 0);
	        }
	      }

	      writeInt8(value) {
	        this.bb.writeInt8(this.space -= 1, value);
	      }

	      writeInt16(value) {
	        this.bb.writeInt16(this.space -= 2, value);
	      }

	      writeInt32(value) {
	        this.bb.writeInt32(this.space -= 4, value);
	      }

	      writeInt64(value) {
	        this.bb.writeInt64(this.space -= 8, value);
	      }

	      writeFloat32(value) {
	        this.bb.writeFloat32(this.space -= 4, value);
	      }

	      writeFloat64(value) {
	        this.bb.writeFloat64(this.space -= 8, value);
	      }
	      /**
	       * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
	       * @param value The `int8` to add the the buffer.
	       */


	      addInt8(value) {
	        this.prep(1, 0);
	        this.writeInt8(value);
	      }
	      /**
	       * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
	       * @param value The `int16` to add the the buffer.
	       */


	      addInt16(value) {
	        this.prep(2, 0);
	        this.writeInt16(value);
	      }
	      /**
	       * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
	       * @param value The `int32` to add the the buffer.
	       */


	      addInt32(value) {
	        this.prep(4, 0);
	        this.writeInt32(value);
	      }
	      /**
	       * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
	       * @param value The `int64` to add the the buffer.
	       */


	      addInt64(value) {
	        this.prep(8, 0);
	        this.writeInt64(value);
	      }
	      /**
	       * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
	       * @param value The `float32` to add the the buffer.
	       */


	      addFloat32(value) {
	        this.prep(4, 0);
	        this.writeFloat32(value);
	      }
	      /**
	       * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
	       * @param value The `float64` to add the the buffer.
	       */


	      addFloat64(value) {
	        this.prep(8, 0);
	        this.writeFloat64(value);
	      }

	      addFieldInt8(voffset, value, defaultValue) {
	        if (this.force_defaults || value != defaultValue) {
	          this.addInt8(value);
	          this.slot(voffset);
	        }
	      }

	      addFieldInt16(voffset, value, defaultValue) {
	        if (this.force_defaults || value != defaultValue) {
	          this.addInt16(value);
	          this.slot(voffset);
	        }
	      }

	      addFieldInt32(voffset, value, defaultValue) {
	        if (this.force_defaults || value != defaultValue) {
	          this.addInt32(value);
	          this.slot(voffset);
	        }
	      }

	      addFieldInt64(voffset, value, defaultValue) {
	        if (this.force_defaults || !value.equals(defaultValue)) {
	          this.addInt64(value);
	          this.slot(voffset);
	        }
	      }

	      addFieldFloat32(voffset, value, defaultValue) {
	        if (this.force_defaults || value != defaultValue) {
	          this.addFloat32(value);
	          this.slot(voffset);
	        }
	      }

	      addFieldFloat64(voffset, value, defaultValue) {
	        if (this.force_defaults || value != defaultValue) {
	          this.addFloat64(value);
	          this.slot(voffset);
	        }
	      }

	      addFieldOffset(voffset, value, defaultValue) {
	        if (this.force_defaults || value != defaultValue) {
	          this.addOffset(value);
	          this.slot(voffset);
	        }
	      }
	      /**
	       * Structs are stored inline, so nothing additional is being added. `d` is always 0.
	       */


	      addFieldStruct(voffset, value, defaultValue) {
	        if (value != defaultValue) {
	          this.nested(value);
	          this.slot(voffset);
	        }
	      }
	      /**
	       * Structures are always stored inline, they need to be created right
	       * where they're used.  You'll get this assertion failure if you
	       * created it elsewhere.
	       */


	      nested(obj) {
	        if (obj != this.offset()) {
	          throw new Error('FlatBuffers: struct must be serialized inline.');
	        }
	      }
	      /**
	       * Should not be creating any other object, string or vector
	       * while an object is being constructed
	       */


	      notNested() {
	        if (this.isNested) {
	          throw new Error('FlatBuffers: object serialization must not be nested.');
	        }
	      }
	      /**
	       * Set the current vtable at `voffset` to the current location in the buffer.
	       */


	      slot(voffset) {
	        if (this.vtable !== null) this.vtable[voffset] = this.offset();
	      }
	      /**
	       * @returns Offset relative to the end of the buffer.
	       */


	      offset() {
	        return this.bb.capacity() - this.space;
	      }
	      /**
	       * Doubles the size of the backing ByteBuffer and copies the old data towards
	       * the end of the new buffer (since we build the buffer backwards).
	       *
	       * @param bb The current buffer with the existing data
	       * @returns A new byte buffer with the old data copied
	       * to it. The data is located at the end of the buffer.
	       *
	       * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
	       * it a uint8Array we need to suppress the type check:
	       * @suppress {checkTypes}
	       */


	      static growByteBuffer(bb) {
	        const old_buf_size = bb.capacity(); // Ensure we don't grow beyond what fits in an int.

	        if (old_buf_size & 0xC0000000) {
	          throw new Error('FlatBuffers: cannot grow buffer beyond 2 gigabytes.');
	        }

	        const new_buf_size = old_buf_size << 1;
	        const nbb = ByteBuffer.allocate(new_buf_size);
	        nbb.setPosition(new_buf_size - old_buf_size);
	        nbb.bytes().set(bb.bytes(), new_buf_size - old_buf_size);
	        return nbb;
	      }
	      /**
	       * Adds on offset, relative to where it will be written.
	       *
	       * @param offset The offset to add.
	       */


	      addOffset(offset) {
	        this.prep(SIZEOF_INT, 0); // Ensure alignment is already done.

	        this.writeInt32(this.offset() - offset + SIZEOF_INT);
	      }
	      /**
	       * Start encoding a new object in the buffer.  Users will not usually need to
	       * call this directly. The FlatBuffers compiler will generate helper methods
	       * that call this method internally.
	       */


	      startObject(numfields) {
	        this.notNested();

	        if (this.vtable == null) {
	          this.vtable = [];
	        }

	        this.vtable_in_use = numfields;

	        for (let i = 0; i < numfields; i++) {
	          this.vtable[i] = 0; // This will push additional elements as needed
	        }

	        this.isNested = true;
	        this.object_start = this.offset();
	      }
	      /**
	       * Finish off writing the object that is under construction.
	       *
	       * @returns The offset to the object inside `dataBuffer`
	       */


	      endObject() {
	        if (this.vtable == null || !this.isNested) {
	          throw new Error('FlatBuffers: endObject called without startObject');
	        }

	        this.addInt32(0);
	        const vtableloc = this.offset(); // Trim trailing zeroes.

	        let i = this.vtable_in_use - 1; // eslint-disable-next-line no-empty

	        for (; i >= 0 && this.vtable[i] == 0; i--) {}

	        const trimmed_size = i + 1; // Write out the current vtable.

	        for (; i >= 0; i--) {
	          // Offset relative to the start of the table.
	          this.addInt16(this.vtable[i] != 0 ? vtableloc - this.vtable[i] : 0);
	        }

	        const standard_fields = 2; // The fields below:

	        this.addInt16(vtableloc - this.object_start);
	        const len = (trimmed_size + standard_fields) * SIZEOF_SHORT;
	        this.addInt16(len); // Search for an existing vtable that matches the current one.

	        let existing_vtable = 0;
	        const vt1 = this.space;

	        outer_loop: for (i = 0; i < this.vtables.length; i++) {
	          const vt2 = this.bb.capacity() - this.vtables[i];

	          if (len == this.bb.readInt16(vt2)) {
	            for (let j = SIZEOF_SHORT; j < len; j += SIZEOF_SHORT) {
	              if (this.bb.readInt16(vt1 + j) != this.bb.readInt16(vt2 + j)) {
	                continue outer_loop;
	              }
	            }

	            existing_vtable = this.vtables[i];
	            break;
	          }
	        }

	        if (existing_vtable) {
	          // Found a match:
	          // Remove the current vtable.
	          this.space = this.bb.capacity() - vtableloc; // Point table to existing vtable.

	          this.bb.writeInt32(this.space, existing_vtable - vtableloc);
	        } else {
	          // No match:
	          // Add the location of the current vtable to the list of vtables.
	          this.vtables.push(this.offset()); // Point table to current vtable.

	          this.bb.writeInt32(this.bb.capacity() - vtableloc, this.offset() - vtableloc);
	        }

	        this.isNested = false;
	        return vtableloc;
	      }
	      /**
	       * Finalize a buffer, poiting to the given `root_table`.
	       */


	      finish(root_table, opt_file_identifier, opt_size_prefix) {
	        const size_prefix = opt_size_prefix ? SIZE_PREFIX_LENGTH : 0;

	        if (opt_file_identifier) {
	          const file_identifier = opt_file_identifier;
	          this.prep(this.minalign, SIZEOF_INT + FILE_IDENTIFIER_LENGTH + size_prefix);

	          if (file_identifier.length != FILE_IDENTIFIER_LENGTH) {
	            throw new Error('FlatBuffers: file identifier must be length ' + FILE_IDENTIFIER_LENGTH);
	          }

	          for (let i = FILE_IDENTIFIER_LENGTH - 1; i >= 0; i--) {
	            this.writeInt8(file_identifier.charCodeAt(i));
	          }
	        }

	        this.prep(this.minalign, SIZEOF_INT + size_prefix);
	        this.addOffset(root_table);

	        if (size_prefix) {
	          this.addInt32(this.bb.capacity() - this.space);
	        }

	        this.bb.setPosition(this.space);
	      }
	      /**
	       * Finalize a size prefixed buffer, pointing to the given `root_table`.
	       */


	      finishSizePrefixed(root_table, opt_file_identifier) {
	        this.finish(root_table, opt_file_identifier, true);
	      }
	      /**
	       * This checks a required field has been set in a given table that has
	       * just been constructed.
	       */


	      requiredField(table, field) {
	        const table_start = this.bb.capacity() - table;
	        const vtable_start = table_start - this.bb.readInt32(table_start);
	        const ok = this.bb.readInt16(vtable_start + field) != 0; // If this fails, the caller will show what field needs to be set.

	        if (!ok) {
	          throw new Error('FlatBuffers: field ' + field + ' must be set');
	        }
	      }
	      /**
	       * Start a new array/vector of objects.  Users usually will not call
	       * this directly. The FlatBuffers compiler will create a start/end
	       * method for vector types in generated code.
	       *
	       * @param elem_size The size of each element in the array
	       * @param num_elems The number of elements in the array
	       * @param alignment The alignment of the array
	       */


	      startVector(elem_size, num_elems, alignment) {
	        this.notNested();
	        this.vector_num_elems = num_elems;
	        this.prep(SIZEOF_INT, elem_size * num_elems);
	        this.prep(alignment, elem_size * num_elems); // Just in case alignment > int.
	      }
	      /**
	       * Finish off the creation of an array and all its elements. The array must be
	       * created with `startVector`.
	       *
	       * @returns The offset at which the newly created array
	       * starts.
	       */


	      endVector() {
	        this.writeInt32(this.vector_num_elems);
	        return this.offset();
	      }
	      /**
	       * Encode the string `s` in the buffer using UTF-8. If the string passed has
	       * already been seen, we return the offset of the already written string
	       *
	       * @param s The string to encode
	       * @return The offset in the buffer where the encoded string starts
	       */


	      createSharedString(s) {
	        if (!s) {
	          return 0;
	        }

	        if (!this.string_maps) {
	          this.string_maps = new Map();
	        }

	        if (this.string_maps.has(s)) {
	          return this.string_maps.get(s);
	        }

	        const offset = this.createString(s);
	        this.string_maps.set(s, offset);
	        return offset;
	      }
	      /**
	       * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
	       * instead of a string, it is assumed to contain valid UTF-8 encoded data.
	       *
	       * @param s The string to encode
	       * @return The offset in the buffer where the encoded string starts
	       */


	      createString(s) {
	        if (!s) {
	          return 0;
	        }

	        let utf8;

	        if (s instanceof Uint8Array) {
	          utf8 = s;
	        } else {
	          utf8 = [];
	          let i = 0;

	          while (i < s.length) {
	            let codePoint; // Decode UTF-16

	            const a = s.charCodeAt(i++);

	            if (a < 0xD800 || a >= 0xDC00) {
	              codePoint = a;
	            } else {
	              const b = s.charCodeAt(i++);
	              codePoint = (a << 10) + b + (0x10000 - (0xD800 << 10) - 0xDC00);
	            } // Encode UTF-8


	            if (codePoint < 0x80) {
	              utf8.push(codePoint);
	            } else {
	              if (codePoint < 0x800) {
	                utf8.push(codePoint >> 6 & 0x1F | 0xC0);
	              } else {
	                if (codePoint < 0x10000) {
	                  utf8.push(codePoint >> 12 & 0x0F | 0xE0);
	                } else {
	                  utf8.push(codePoint >> 18 & 0x07 | 0xF0, codePoint >> 12 & 0x3F | 0x80);
	                }

	                utf8.push(codePoint >> 6 & 0x3F | 0x80);
	              }

	              utf8.push(codePoint & 0x3F | 0x80);
	            }
	          }
	        }

	        this.addInt8(0);
	        this.startVector(1, utf8.length, 1);
	        this.bb.setPosition(this.space -= utf8.length);

	        for (let i = 0, offset = this.space, bytes = this.bb.bytes(); i < utf8.length; i++) {
	          bytes[offset++] = utf8[i];
	        }

	        return this.endVector();
	      }
	      /**
	       * A helper function to avoid generated code depending on this file directly.
	       */


	      createLong(low, high) {
	        return Long.create(low, high);
	      }
	      /**
	       * A helper function to pack an object
	       *
	       * @returns offset of obj
	       */


	      createObjectOffset(obj) {
	        if (obj === null) {
	          return 0;
	        }

	        if (typeof obj === 'string') {
	          return this.createString(obj);
	        } else {
	          return obj.pack(this);
	        }
	      }
	      /**
	       * A helper function to pack a list of object
	       *
	       * @returns list of offsets of each non null object
	       */


	      createObjectOffsetList(list) {
	        const ret = [];

	        for (let i = 0; i < list.length; ++i) {
	          const val = list[i];

	          if (val !== null) {
	            ret.push(this.createObjectOffset(val));
	          } else {
	            throw new Error('FlatBuffers: Argument for createObjectOffsetList cannot contain null.');
	          }
	        }

	        return ret;
	      }

	      createStructOffsetList(list, startFunc) {
	        startFunc(this, list.length);
	        this.createObjectOffsetList(list);
	        return this.endVector();
	      }

	    }

	    function getProtocolAndHostPathFromUrl(url) {
	      const proto = url.startsWith('http://') ? 'http' : 'https';
	      const hostPath = url.replace(/^(?:[a-z]+:)?\/\//, '').replace(/\/*$/, '');
	      return [proto, hostPath];
	    }

	    function buildFlatBuffer(level, slug, data) {
	      const builder = new Builder(128);
	      const messageOffset = builder.createString(slug);
	      const fieldsArr = [];

	      for (const [key, value] of Object.entries(data)) {
	        const keyOffset = builder.createString(key);
	        const valueOffset = builder.createString(value);
	        builder.startObject(2);
	        builder.addFieldOffset(0, keyOffset, 0);
	        builder.addFieldOffset(1, valueOffset, 0);
	        fieldsArr.unshift(builder.endObject());
	      }

	      builder.startVector(4, fieldsArr.length, 4);

	      for (const offset of fieldsArr) {
	        builder.addOffset(offset);
	      }

	      const fieldsOffset = builder.endVector();
	      builder.startObject(3);
	      builder.addFieldOffset(0, messageOffset, 0);
	      builder.addFieldInt8(1, level, 0);
	      builder.addFieldOffset(2, fieldsOffset, 0);
	      builder.finish(builder.endObject());
	      return builder.asUint8Array();
	    }

	    class ServiceOutput extends BaseOutput {
	      constructor(sessionId, origin, settings) {
	        super(sessionId, origin, settings);
	        this._level = exports.LevelNumber.Error;

	        if (!settings) {
	          throw new Error('Missing settings for logging service output.');
	        }

	        if (!settings.baseUrl || !settings.baseUrl.trim().length) {
	          throw new Error('Missing baseUrl settings for logging service output.');
	        }

	        const [proto, hostPath] = getProtocolAndHostPathFromUrl(settings.baseUrl);

	        if (!hostPath.trim().length) {
	          throw new Error('Invalid base url for logging service output, expected a host name.');
	        }

	        this._url = `${proto}://${hostPath}`;
	        this._http = settings.http || axios.create();
	      }

	      async send(err) {
	        try {
	          // TODO err.level ?? NOW EVERYTHING IS FATAL!!!
	          await this._http.post(this._url, Buffer.from(buildFlatBuffer(exports.LevelNumber.Fatal, err.toString(), { ...err.toFlatData(),
	            sessionId: this._sessionId,
	            origin: this._origin
	          })));
	        } catch (e) {
	          window.console.error('Failed to send log to external service', e);
	        }
	      }

	    }

	    let random = bytes => crypto.getRandomValues(new Uint8Array(bytes));

	    let customRandom = (alphabet, size, getRandom) => {
	      let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
	      let step = -~(1.6 * mask * size / alphabet.length);
	      return () => {
	        let id = '';

	        while (true) {
	          let bytes = getRandom(step);
	          let j = step;

	          while (j--) {
	            id += alphabet[bytes[j] & mask] || '';
	            if (id.length === size) return id;
	          }
	        }
	      };
	    };

	    let customAlphabet = (alphabet, size) => customRandom(alphabet, size, random); // Note: with this alphabet and 12 chars, there is roughly a 1% chance of at least one collision after about 28 days.
	    // This is assuming 100.000 ids per hour.
	    // src: https://zelark.github.io/nano-id-cc/


	    const sessionIdGenerator = customAlphabet('346789ABCDEFGHJKLMNPQRTUVWXY', 12);

	    class Logger {
	      constructor(origin, config) {
	        this._outputs = [];
	        this._origin = origin;
	        this._sessionId = config && config.sessionId ? config.sessionId : Logger.generateSessionId();
	        this.addOutput(ConsoleOutput);
	      }

	      static generateSessionId() {
	        return sessionIdGenerator();
	      }

	      get sessionId() {
	        return this._sessionId;
	      }

	      addOutput(OutputConstructor, ...settings) {
	        const output = new OutputConstructor(this._sessionId, this._origin, ...settings);

	        this._outputs.push(output);

	        return output;
	      }

	      throw(error) {
	        if (!error || !error.isOpenTicketError) {
	          console.error('Failed to throw error, error object is not an OpenTicketError', error);
	          this.log(new UnexpectedError(error));
	        } else {
	          this.log(error);
	        }

	        throw error;
	      }

	      log(error) {
	        let err = error;

	        if (!error || !error.isOpenTicketError) {
	          console.error('Failed to properly log error, error object is not an OpenTicketError', error);
	          err = new UnexpectedError(error);
	        }

	        this._send(err);
	      }

	      _send(err) {
	        for (const output of this._outputs) {
	          // Any logging should be handled outside of execution scope.
	          // This should not block any other 'processes'.
	          void new Promise(resolve => {
	            output.send(err);
	            resolve();
	          });
	        }
	      }

	    }

	    class CrudRoot extends CrudNode {
	      constructor(config) {
	        super(null, 'root');
	        this.$config = config;
	        this._http = config.http || axios.create();
	        this._factory = new CrudFactory({
	          models: config.models
	        });
	        this._logger = new Logger(config.origin);
	      }

	      get $http() {
	        return this._http;
	      }

	      get $root() {
	        return this;
	      }

	      get $factory() {
	        return this._factory;
	      }

	      get $log() {
	        return this._logger;
	      }

	      get $path() {
	        return this.$config.baseUrl;
	      }

	      getRelation(type) {
	        for (const prop of Object.values(this)) {
	          if (prop instanceof CrudToMany && prop.type === type) {
	            return prop;
	          }
	        }

	        throw Error(`Root relation for type ${type} not found`);
	      }

	      get $routes() {
	        const routes = [];

	        for (const prop of Object.values(this)) {
	          if (prop instanceof CrudNode) {
	            routes.push(...prop.$routes);
	          }
	        }

	        return routes;
	      }

	    }
	    /**
	     * Class for interacting with Pickable implementations, such as the Pick CRUD mixin
	     */


	    class Picker {
	      constructor(parent) {
	        this.hasLocalChanges = false;
	        this.count = 0;
	        this.linked = {};
	        this._originalLinked = {};
	        this._models = {};
	        this.pending = {
	          link: [],
	          unlink: []
	        };

	        this.getPickerPage = async request => {
	          const response = await this._parent.getPickerPage(request);

	          this._updateLinkedData(response);

	          return response;
	        };

	        this._parent = parent;
	      } // Link a model in the local state, add as a pending operation


	      link(model) {
	        const unlinkIndex = this.pending.unlink.indexOf(model.guid);

	        if (unlinkIndex > -1) {
	          this.pending.unlink.splice(unlinkIndex, 1);
	        } else {
	          this.pending.link.push(model.guid);
	        }

	        this.linked[model.guid] = true;
	        this.count++;

	        this._updateHasLocalChanges();
	      } // Unlink a model in the local state, add as a pending operation


	      unlink(model) {
	        const linkIndex = this.pending.link.indexOf(model.guid);

	        if (linkIndex > -1) {
	          this.pending.link.splice(linkIndex, 1);
	        } else {
	          this.pending.unlink.push(model.guid);
	        }

	        this.linked[model.guid] = false;
	        this.count--;

	        this._updateHasLocalChanges();
	      } // Save the pending operations via the NestedPickable and apply changes
	      // to the local state.


	      async save() {
	        const promises = [];

	        if (this.pending.link.length) {
	          promises.push(this._parent.linkPickerModels(this.pending.link));
	        }

	        if (this.pending.unlink.length) {
	          promises.push(this._parent.unlinkPickerModels(this.pending.unlink));
	        }

	        if (!promises.length) {
	          return;
	        }

	        await Promise.all(promises);

	        for (const guid of this.pending.link) {
	          this._originalLinked[guid] = true;
	        }

	        for (const guid of this.pending.unlink) {
	          this._originalLinked[guid] = false;
	        } // Update local state to reflect applied changes


	        this.reset(); // Recount linked items

	        this.count = Object.values(this.linked).filter(linked => linked).length;
	      } // Undo pending changes and reset linked states


	      reset() {
	        this.pending.link = [];
	        this.pending.unlink = [];
	        Object.assign(this.linked, this._originalLinked);

	        this._updateHasLocalChanges();
	      } // set `.hasLocalChanges` depending on whether or not there are
	      // pending local changes to save.


	      _updateHasLocalChanges() {
	        this.hasLocalChanges = !!(this.pending.link.length || this.pending.unlink.length);
	      } // Add metadata to the local state


	      _updateLinkedData(response) {
	        for (let i = 0; i < response.data.length; i++) {
	          const item = response.data[i]; // Read the linked state of a model from the raw properties passed to it from the NestedPickable

	          this._originalLinked[item.guid] = !!item.raw.linked;
	          this.linked[item.guid] = !!item.raw.linked; // If linked, update the total linked count

	          if (!!item.raw.linked && !this._models[item.guid]) {
	            this.count++;
	          }

	          this._models[item.guid] = item;
	        }
	      }

	    }
	    /**
	     * Class for interacting with NestedPickable implementations, such as the NestedPick CRUD mixin
	     */


	    class NestedPicker {
	      // NestedPicker needs a NestedPickable implementation to function, for
	      // example the nested_pick CRUD mixin.
	      constructor(parent) {
	        // True when there are pending local changes
	        this.hasLocalChanges = false; // Nested map with to retrieve the linked state of an item,
	        // structure: [PickerSumsModel.guid][PickerModel.guid]

	        this.linked = {}; // Number of linked items per PickerSumsModel.guid

	        this.count = {}; // Pending operations

	        this.pending = {};
	        this._models = {}; // Get page of PickerModels by PickerSumsModel.guid

	        this.getNestedPage = async request => {
	          // Retrieve page from NestedPickable implementations
	          const response = await this._parent.getPickerNestedPage(request); // Set linked metadata

	          this._setLinkedStatus(request, response);

	          return response;
	        }; // Get page of PickerSumsModels


	        this.getSumsPage = async request => {
	          // Retrieve page from NestedPickable implementations
	          const response = await this._parent.getPickerSumsPage(request); // Set linked metadata

	          this._setSumsLinkedStatus(response);

	          return response;
	        };

	        this._parent = parent;
	      } // Save the pending operations via the NestedPickable and apply changes
	      // to the local state.


	      async save() {
	        const link = [];
	        const unlink = [];

	        for (const nestedPending of Object.values(this.pending)) {
	          link.push(...nestedPending.link);
	          unlink.push(...nestedPending.unlink);
	        }

	        const promises = []; // Add link call to pending promises

	        if (link.length) {
	          promises.push(this._parent.linkPickerModels(link));
	        } // Add unlink call to pending promises


	        if (unlink.length) {
	          promises.push(this._parent.unlinkPickerModels(unlink));
	        }

	        await Promise.all(promises); // Apply changes to local state, clear pending actions

	        for (const sumsGuid of Object.keys(this.pending)) {
	          for (const linked of this.pending[sumsGuid].link) {
	            this.linked[sumsGuid][linked] = true;
	          }

	          for (const unlinked of this.pending[sumsGuid].unlink) {
	            this.linked[sumsGuid][unlinked] = false;
	          }

	          this.pending[sumsGuid].link = [];
	          this.pending[sumsGuid].unlink = [];
	        } // Update local changes state, hasLocalChanges is `false` after
	        // a successful `.save` operation.


	        this._updateHasLocalChanges();
	      } // Undo pending changes and reset linked states


	      reset() {
	        for (const sumsGuid of Object.keys(this.pending)) {
	          for (const linked of this.pending[sumsGuid].link) {
	            this.linked[sumsGuid][linked] = false;
	          }

	          for (const unlinked of this.pending[sumsGuid].unlink) {
	            this.linked[sumsGuid][unlinked] = true;
	          }

	          this.pending[sumsGuid].link = [];
	          this.pending[sumsGuid].unlink = [];
	        }
	      } // Link a model in the local state, add as a pending operation


	      link(sumsGuid, model) {
	        const unlinkIndex = this.pending[sumsGuid].unlink.indexOf(model.guid);

	        if (unlinkIndex > -1) {
	          this.pending[sumsGuid].unlink.splice(unlinkIndex, 1);
	        } else {
	          this.pending[sumsGuid].link.push(model.guid);
	        }

	        this.linked[sumsGuid][model.guid] = true;
	        this.count[sumsGuid]++;

	        this._updateHasLocalChanges();
	      } // Unlink a model in the local state, add as a pending operation


	      unlink(sumsGuid, model) {
	        const linkIndex = this.pending[sumsGuid].link.indexOf(model.guid);

	        if (linkIndex > -1) {
	          this.pending[sumsGuid].link.splice(linkIndex, 1);
	        } else {
	          this.pending[sumsGuid].unlink.push(model.guid);
	        }

	        this.linked[sumsGuid][model.guid] = false;
	        this.count[sumsGuid]--;

	        this._updateHasLocalChanges();
	      } // Add sums metadata to the local state


	      _setSumsLinkedStatus(response) {
	        response.data.forEach(model => {
	          if (!this.count[model.guid]) {
	            this.count[model.guid] = model.raw.linked;
	          }
	        });
	      } // Add nested metadata to the local state


	      _setLinkedStatus(request, response) {
	        if (!this.linked[request.guid]) {
	          this.linked[request.guid] = {};
	        }

	        if (!this.pending[request.guid]) {
	          this.pending[request.guid] = {
	            link: [],
	            unlink: []
	          };
	        }

	        response.data.forEach(model => {
	          this._models[model.guid] = model;

	          if (this.linked[request.guid][model.guid] === undefined) {
	            this.linked[request.guid][model.guid] = !!model.raw.linked;
	          }
	        });
	      } // set `.hasLocalChanges` depending on whether or not there are
	      // pending local changes to save.


	      _updateHasLocalChanges() {
	        for (const nestedPending of Object.values(this.pending)) {
	          if (nestedPending.link.length || nestedPending.unlink.length) {
	            this.hasLocalChanges = true;
	            return;
	          }
	        }

	        this.hasLocalChanges = false;
	      }

	    }

	    function arr_move(arr, oldIndex, newIndex) {
	      const element = arr[oldIndex];
	      arr.splice(oldIndex, 1);
	      arr.splice(newIndex, 0, element);
	    }

	    class Sorter {
	      constructor(parent) {
	        this._dirty = [];
	        this._original = [];
	        this._events = [];

	        this.getPage = async request => {
	          const response = await this._parent.getSortedPage(request);

	          this._updateSortData(response);

	          return response;
	        };

	        this._parent = parent;
	      }

	      hasLocalChanges() {
	        for (let i = 0; i < this._original.length; i++) {
	          if (this._original[i].guid !== this._dirty[i].guid) {
	            return true;
	          }
	        }

	        return false;
	      }

	      move(oldIndex, newIndex) {
	        const item = this._dirty[oldIndex];
	        const anchor = this._dirty[newIndex]; // Depending on in which direction the move is, use 'after' or 'before'
	        // to specify the relative position to the anchor element

	        const order = newIndex > oldIndex ? 'after' : 'before';
	        arr_move(this._dirty, oldIndex, newIndex);

	        this._events.push({
	          item,
	          order,
	          anchor
	        });
	      }

	      async save() {
	        try {
	          for (const event of this._events) {
	            await this._parent.sortModel(event.item, event.order, event.anchor);

	            const oldIndex = this._dirty.findIndex(model => model.guid === event.item.guid);

	            const newIndex = this._dirty.findIndex(model => model.guid === event.anchor.guid);

	            arr_move(this._original, oldIndex, newIndex);
	          }
	        } finally {
	          this.reset();
	        }
	      }

	      reset() {
	        this._events = [];
	        this._dirty = Array.from(this._original);
	      }

	      _updateSortData(response) {
	        this._dirty.push(...response.data);

	        this._original.push(...response.data);
	      }

	    }

	    exports.PaginationOrder = void 0;

	    (function (PaginationOrder) {
	      PaginationOrder["ASC"] = "asc";
	      PaginationOrder["DESC"] = "desc";
	    })(exports.PaginationOrder || (exports.PaginationOrder = {}));
	    /**
	     * Filters are parsed to the correct laravel-query-builder format
	     * @param filters
	     */


	    function parseFilters(filters) {
	      const map = {};

	      for (const key of Object.keys(filters)) {
	        map[`filter[${key}]`] = `${filters[key]}`;
	      }

	      return map;
	    }
	    /**
	     * Ordering is parsed to the correct laravel-query-builder format
	     * @param ordering
	     */


	    function parseOrdering(ordering) {
	      const params = {
	        sort: ''
	      }; // Order the order rules by index

	      const ordered = Object.entries(ordering).map(([field, fieldOrdering]) => ({
	        field,
	        ...fieldOrdering
	      })).sort((a, b) => a.index - b.index);

	      for (const item of ordered) {
	        params.sort += item.order === exports.PaginationOrder.DESC ? `-${item.field}` : item.field;
	      }

	      return params;
	    }

	    class ArrayPaginatable {
	      constructor(data) {
	        this.getPage = async request => {
	          const total = this._data.length;
	          const page = request.page || 1;
	          const perPage = request.per_page || 5;
	          const lastPage = Math.ceil(total / perPage);
	          const data = [];

	          for (let i = 0; i < perPage; i++) {
	            const j = perPage * (page - 1) + i;

	            if (j >= total) {
	              break;
	            }

	            data.push(this._data[j]);
	          }

	          return {
	            current_page: page,
	            last_page: lastPage,
	            per_page: perPage,
	            total,
	            data,
	            path: '',
	            first_page_url: '',
	            last_page_url: '',
	            from: '',
	            to: ''
	          };
	        };

	        this._data = data;
	      }

	    }

	    const REFRESH_DEBOUNCE_MILLIS$1 = 300;

	    class Pagination {
	      /**
	       * @param paginatable
	       * @param optionals
	       */
	      constructor(paginatable, optionals) {
	        this.loading = false;
	        this.page = null;
	        this.filters = {};
	        this._ordering = {};
	        this._refreshDebounce = null;
	        this._refreshPromise = null;
	        this._refreshPromiseResolve = null;
	        this._initialized = false;

	        if (typeof paginatable === 'function') {
	          this._paginatable = paginatable;
	        } else {
	          this._paginatable = paginatable.getPage;
	        }

	        this._optionals = optionals || {};
	      }

	      defaults() {
	        return { ...this._request
	        };
	      }
	      /**
	       * Initialize with default or specified configuration and fetch the first page.
	       * @param _config
	       */


	      async init(_config) {
	        const config = _config || {};
	        this._request = {
	          page: 1,
	          ...config.defaults
	        };

	        if (config && config.filters) {
	          Object.assign(this.filters, config.filters);
	        }

	        await this.getPage(this._request);
	        this._initialized = true;
	      }
	      /**
	       * @param field
	       * @param value
	       */


	      async addFilter(field, value) {
	        this._checkIfInitialized();

	        this.filters[field] = value;
	        return this._refreshWithDebounce();
	      }
	      /**
	       * @param field
	       */


	      async removeFilter(field) {
	        this._checkIfInitialized();

	        delete this.filters[field];
	        return this._refreshWithDebounce();
	      }
	      /**
	       * Check if the canOrder method is implemented and the specified field can be ordered.
	       * @param field
	       */


	      canOrder(field) {
	        if (!this._optionals.canOrder) {
	          return false;
	        }

	        return this._optionals.canOrder(field);
	      }
	      /**
	       * Returns the ordering that is set for the specified field.
	       * @param field
	       */


	      getFieldOrder(field) {
	        if (this._ordering[field]) {
	          return this._ordering[field];
	        }

	        return null;
	      }
	      /**
	       * @param field
	       * @param order
	       */


	      async addOrder(field, order) {
	        this._checkIfInitialized();

	        if (!this.canOrder(field)) {
	          throw new StringError('Field cannot be ordered');
	        } // TODO: Add support for multiple orderings


	        this._ordering = {
	          [field]: {
	            order,
	            index: 0
	          }
	        };
	        return this._refreshWithDebounce();
	      }
	      /**
	       * @param field
	       */


	      async removeOrder(field) {
	        this._checkIfInitialized(); // TODO: Add support for multiple orderings


	        this._ordering = {};
	        return this._refreshWithDebounce();
	      }
	      /**
	       * Retrieves the page from the api again, overwriting the local state.
	       * If no custom request is specified the request in the local state is used.
	       * @param request
	       */


	      async refresh(request) {
	        return this.getPage(request || this._request);
	      }

	      async nextPage() {
	        this._checkIfInitialized();

	        return this.getPage({ ...this._request,
	          page: this.page.current_page + 1
	        });
	      }

	      async prevPage() {
	        this._checkIfInitialized();

	        return this.getPage({ ...this._request,
	          page: this.page.current_page - 1
	        });
	      }
	      /**
	       * Retrieve the correct page from the api based on the specified request.
	       * @param request
	       */


	      async getPage(request) {
	        this.loading = true;

	        try {
	          this.page = await this._paginatable({ ...parseFilters(this.filters),
	            ...parseOrdering(this._ordering),
	            ...this._request,
	            ...request
	          });
	          return this.page;
	        } finally {
	          this.loading = false;
	        }
	      }
	      /**
	       * Retrieves the page from the api with a debounce to keep the amount of api requests low.
	       * The local state request is used.
	       * @private
	       */


	      async _refreshWithDebounce() {
	        if (!this._refreshPromise) {
	          this._refreshPromise = new Promise(resolve => {
	            this._refreshPromiseResolve = resolve;
	          });
	        }

	        this.loading = true;

	        if (this._refreshDebounce) {
	          window.clearTimeout(this._refreshDebounce);
	        }

	        this._refreshDebounce = window.setTimeout(async () => {
	          this._refreshDebounce = null;
	          const p = await this.getPage(this._request);

	          this._refreshPromiseResolve(p);

	          this._refreshPromise = null;
	          this._refreshPromiseResolve = null;
	        }, REFRESH_DEBOUNCE_MILLIS$1);
	        return this._refreshPromise;
	      }
	      /**
	       * @private
	       */


	      _checkIfInitialized() {
	        if (!this._initialized) {
	          throw new StringError('Pagination not initialized');
	        }
	      }

	    }

	    const REFRESH_DEBOUNCE_MILLIS = 300;

	    class LazyList {
	      /**
	       * @param paginatable
	       * @param optionals
	       */
	      constructor(paginatable, optionals) {
	        this.loading = false;
	        this.filters = {};
	        this.data = [];
	        this.response = null;
	        this.hasMore = true;
	        this._refreshDebounce = null;
	        this._refreshPromise = null;
	        this._refreshPromiseResolve = null;

	        if (typeof paginatable === 'function') {
	          this._paginatable = paginatable;
	        } else {
	          this._paginatable = paginatable.getPage;
	        }

	        this._optionals = optionals || {};
	      }
	      /**
	       * Initialize with default or specified configuration and fetch the first data.
	       * @param _config
	       */


	      async init(_config) {
	        const config = _config || {};
	        this._request = {
	          page: 1,
	          ...config.defaults
	        };
	        this.data = [];
	        this.hasMore = true;

	        if (config && config.filters) {
	          Object.assign(this.filters, config.filters);
	        }

	        await this.loadMore();
	      }
	      /**
	       * @param key
	       * @param filter
	       */


	      async addFilter(key, filter) {
	        this.filters[key] = filter;
	        await this._refreshWithDebounce();
	      }
	      /**
	       * @param key
	       */


	      async removeFilter(key) {
	        delete this.filters[key];
	        await this._refreshWithDebounce();
	      }

	      async refresh() {
	        await this._refreshWithDebounce();
	      }
	      /**
	       * Load the next page and append it to the local state data.
	       */


	      async loadMore() {
	        if (!this.hasMore) {
	          throw new StringError('No items left to retrieve');
	        }

	        this.loading = true;

	        try {
	          const page = this._request.page++;
	          const res = await this._paginatable({ ...this._request,
	            ...parseFilters(this.filters),
	            page
	          });
	          this.data.push(...res.data);
	          this.response = { ...res,
	            data: undefined
	          };

	          if (this.data.length === res.total) {
	            this.hasMore = false;
	          }
	        } finally {
	          this.loading = false;
	        }
	      }
	      /**
	       * Load the next page and append it to the local state data with a debounce to keep the amount of api request low.
	       * @private
	       */


	      async _refreshWithDebounce() {
	        if (!this._refreshPromise) {
	          this._refreshPromise = new Promise(resolve => {
	            this._refreshPromiseResolve = resolve;
	          });
	        }

	        this.loading = true;
	        this.data = [];

	        if (this._refreshDebounce) {
	          window.clearTimeout(this._refreshDebounce);
	        }

	        this._refreshDebounce = window.setTimeout(async () => {
	          this._refreshDebounce = null;
	          this._request.page = 1;
	          await this.init({
	            defaults: this._request
	          });

	          this._refreshPromiseResolve();

	          this._refreshPromise = null;
	          this._refreshPromiseResolve = null;
	        }, REFRESH_DEBOUNCE_MILLIS);
	        return this._refreshPromise;
	      }

	    }

	    function addGlobal(scope, ref) {
	      let root = window || commonjsGlobal;

	      if (!root) {
	        return;
	      }

	      root = root.OpenTicket = root.OpenTicket || {};
	      root[scope] = ref;
	    }

	    exports.ArrayPaginatable = ArrayPaginatable;
	    exports.BaseError = BaseError;
	    exports.ConsoleOutput = ConsoleOutput;
	    exports.CrudFactory = CrudFactory;
	    exports.CrudModel = CrudModel;
	    exports.CrudModelProps = CrudModelProps;
	    exports.CrudNode = CrudNode;
	    exports.CrudRoot = CrudRoot;
	    exports.CrudRoute = index;
	    exports.CrudToMany = CrudToMany;
	    exports.CrudToManyMixin = CrudToManyMixin;
	    exports.CrudToOne = CrudToOne;
	    exports.Form = Form;
	    exports.FormValidationError = FormValidationError;
	    exports.LazyList = LazyList;
	    exports.Logger = Logger;
	    exports.ModelForm = ModelForm;
	    exports.NestedPicker = NestedPicker;
	    exports.Pagination = Pagination;
	    exports.Picker = Picker;
	    exports.ServiceOutput = ServiceOutput;
	    exports.Sorter = Sorter;
	    exports.StringError = StringError;
	    exports.UnexpectedError = UnexpectedError;
	    exports.addGlobal = addGlobal;
	    exports.levelNumberToLevel = levelNumberToLevel;
	    exports.levelToLevelNumber = levelToLevelNumber;
	    exports.parseFilters = parseFilters;
	    exports.parseOrdering = parseOrdering;
	    exports.toMany = toMany;
	    Object.defineProperty(exports, '__esModule', {
	      value: true
	    });
	  });
	})(helpers, helpers.exports);

	class OrderValidator extends BaseValidator {
	    metadata(metadata, mutateErrors) {
	        const validationErrors = validateMetadata(metadata, mutateErrors);
	        return {
	            valid: !validationErrors.length,
	            message: validationErrors[0] || '',
	            errors: validationErrors,
	        };
	    }
	}

	/* eslint-disable sort-keys, @typescript-eslint/no-unused-vars, @typescript-eslint/no-unsafe-assignment */
	// Structure of the orderdata response
	const struct = {
	    shop: {
	        type: 'shop',
	    },
	    tickets: {
	        type: 'ticket',
	        ticket: {
	            type: 'nested_ticket',
	            event: {
	                type: 'event',
	                payout_profile: {
	                    type: 'payout_profile',
	                },
	                refund_setting: {
	                    type: 'refund_setting',
	                },
	            },
	        },
	        products: {
	            type: 'product',
	            product: {
	                type: 'nested_product',
	                event_dates: {
	                    type: 'event_date',
	                    event: {
	                        type: 'event',
	                    },
	                    location: {
	                        type: 'location',
	                    },
	                },
	            },
	            metadata: {
	                type: 'metadata',
	                metadata: {
	                    type: 'nested_metadata',
	                },
	            },
	        },
	        metadata: {
	            type: 'metadata',
	            metadata: {
	                type: 'nested_metadata',
	            },
	        },
	    },
	    products: {
	        type: 'global_product',
	        product: {
	            type: 'nested_product',
	        },
	    },
	    payments: {
	        type: 'payment',
	        payment_method: {
	            type: 'payment_method',
	        },
	    },
	    metadata: {
	        type: 'metadata',
	        metadata: {
	            type: 'nested_metadata',
	        },
	    },
	};
	class OrderParser {
	    static parse(apiData) {
	        const order = OrderParser._parserApiOrder(apiData);
	        const map = {
	            global_product_map: {},
	            product_map: {},
	            event_map: {},
	            location_map: {},
	            event_date_map: {},
	            shop_map: {},
	            ticket_map: {},
	            payment_map: {},
	            payment_method_map: {},
	            payout_profile_map: {},
	            refund_setting_map: {},
	            metadata_map: {},
	        };
	        const pivots = {};
	        OrderParser._normalize(struct, apiData, map, pivots);
	        const relations = this._build(map, pivots);
	        return {
	            ...order,
	            ...map,
	            ...relations,
	        };
	    }
	    static _parserApiOrder(order) {
	        // Make sure download_link exists (for reactivity)
	        order.download_link = order.download_link ? order.download_link : null;
	        return order;
	    }
	    static _build(map, pivots) {
	        // Get the map of <guid, OrderEvent> from the map
	        const { event_map } = map;
	        // Do the nested operation for both 'tickets' and 'products'
	        for (const type of ['ticket', 'product']) {
	            const itemKey = `${type}_map`;
	            // Loop over all items in the <guid, OrderProduct | OrderTicket> maps
	            for (const item of Object.values(map[itemKey])) {
	                // Get the nested item ( 'ticket' for OrderTicket and 'product' for OrderProduct)
	                const nestedItem = item[type];
	                // The key on an OrderEvent, either 'tickets' or 'products'
	                const propName = `${type}s`;
	                // Check if the event is provided by the API, skip if not
	                if (nestedItem.event_id && event_map[nestedItem.event_id]) {
	                    // // Add the item to the event
	                    const arr = event_map[nestedItem.event_id][propName];
	                    if (arr) {
	                        arr.push(item);
	                    }
	                    else {
	                        event_map[nestedItem.event_id][propName] = [item];
	                    }
	                }
	            }
	        }
	        const events = Object.values(event_map);
	        const tickets = Object.values(map.ticket_map);
	        const global_products = Object.values(map.global_product_map);
	        const shop = Object.values(map.shop_map)[0];
	        return {
	            events,
	            tickets,
	            shop,
	            global_products,
	        };
	    }
	    static _normalize(struct, data, map, pivots) {
	        if (!struct || typeof struct !== 'object') {
	            return [];
	        }
	        const relations = {};
	        for (const prop of Object.keys(struct)) {
	            const value = data[prop];
	            if (!value || prop === 'type') {
	                continue;
	            }
	            if (Array.isArray(value)) {
	                for (const singleValue of value) {
	                    const items = OrderParser._normalize(struct[prop], singleValue, map, pivots);
	                    if (struct[prop].type) {
	                        const item = OrderParser._constructItem(struct[prop].type, singleValue, map, items);
	                        relations[prop] = relations[prop] || [];
	                        relations[prop].push(item);
	                    }
	                }
	            }
	            else {
	                const items = OrderParser._normalize(struct[prop], value, map, pivots);
	                if (struct[prop].type) {
	                    relations[prop] = OrderParser._constructItem(struct[prop].type, value, map, items);
	                }
	            }
	        }
	        return relations;
	    }
	    static _constructItem(type, item, rootMap, relations) {
	        const key = `${type}_map`;
	        // Use root map or tmp object if item does not have a root map
	        const map = rootMap[key] || {};
	        // MODIFY RELATIONS
	        // Be sure to implement BaseMetadataItem
	        if (type === 'metadata' && relations) {
	            relations.item = relations.metadata;
	        }
	        // END MODIFY RELATIONS
	        if (map[item.guid]) {
	            item = map[item.guid] = {
	                ...map[item.guid],
	                ...relations,
	            };
	            return item;
	        }
	        // MODIFY INTERFACE
	        // To be compatible with MetaInput.vue
	        if (type === 'metadata') {
	            item.errors = [];
	            // The API returns empty strings for numeric inputs, which results in a NaN value
	            if (item.metadata.extra
	                && Array.isArray(item.metadata.extra)
	                && item.metadata.extra.includes('numeric')
	                && item.value === '') {
	                item.value = null;
	            }
	        }
	        if (type === 'event') {
	            item.tickets = [];
	            item.products = [];
	        }
	        // Additional prop for the availability of the ticket pdf
	        if (type === 'ticket') {
	            item.computed_download_ready = false;
	        }
	        // To be compatible with MetaInput.vue
	        if (type === 'nested_metadata') {
	            if (item.extra) {
	                const typedItem = item;
	                typedItem.extra = item.extra.split('|');
	                if (typedItem.type === MetadataType.Enum || typedItem.type === MetadataType.EnumOther) {
	                    const rule = typedItem.extra.find((rule) => rule.includes('in:'));
	                    item.options = rule ? rule.split(':')[1].split(',') : [];
	                }
	            }
	            else {
	                item.extra = [];
	            }
	        }
	        // BOOLEAN CASTING
	        // END MODIFY INTERFACE
	        item = map[item.guid] = {
	            ...item,
	            ...relations,
	        };
	        return item;
	    }
	}

	let random = bytes => crypto.getRandomValues(new Uint8Array(bytes));

	let customRandom = (alphabet, size, getRandom) => {
	  let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
	  let step = -~(1.6 * mask * size / alphabet.length);
	  return () => {
	    let id = '';

	    while (true) {
	      let bytes = getRandom(step);
	      let j = step;

	      while (j--) {
	        id += alphabet[bytes[j] & mask] || '';
	        if (id.length === size) return id;
	      }
	    }
	  };
	};

	let customAlphabet = (alphabet, size) => customRandom(alphabet, size, random);

	// Note: with this alphabet and 12 chars, there is roughly a 1% chance of at least one collision after about 28 days.
	// This is assuming 100.000 ids per hour.
	// src: https://zelark.github.io/nano-id-cc/
	const sessionIdGenerator = customAlphabet('346789ABCDEFGHJKLMNPQRTUVWXY', 12);
	function parsePricing(price) {
	    const cents = typeof price === 'string' ? parseFloat(price) : price;
	    return `${(cents / 100).toFixed(2)}`;
	}
	class OrderTracking {
	    constructor() {
	        this._sessionId = sessionIdGenerator();
	    }
	    /**
	     *  The legacy order status page has two entry points for the order.
	     *  - A return from payment page
	     *  - A linked download page (i.e.: from email)
	     *  The payment page is the only page that should trigger the conversion events.
	     *  However the download page from the email should still trigger a page view event.
	     */
	    sendLegacyEventsWithoutConversion() {
	        this._contentView();
	    }
	    sendLegacyEvents(data, order) {
	        this._interaction({
	            action: 'Complete order',
	            category: 'OrderProcess',
	            label: `Payment: ${order.status}`,
	            value: parsePricing(order.finn_price),
	        });
	        for (const event of order.events) {
	            const rawPrice = order.conversions.events[event.guid].total;
	            this._interaction({
	                action: 'Completed order for event',
	                category: 'EventConversion',
	                label: `${event.guid}|-|${event.name}`,
	                value: parsePricing(rawPrice),
	            });
	            const { location } = event;
	            const dateArr = [];
	            if (event.start) {
	                dateArr.push(event.start.slice(0, 10));
	                if (event.end) {
	                    dateArr.push(event.end.slice(0, 10));
	                }
	            }
	            let coords = '';
	            if (location.latitude) {
	                coords += location.latitude;
	                if (location.longitude) {
	                    coords += `,${location.longitude}`;
	                }
	            }
	            this._interaction({
	                category: 'LocationAttend',
	                action: coords,
	                label: `${location.address || ''}`,
	                value: `${dateArr.join('_')}`,
	            });
	        }
	        this._orderData(data);
	        this._purchase(order);
	        this._contentView();
	    }
	    _interaction(event) {
	        this._send({
	            ...event,
	            event: 'interaction',
	        });
	    }
	    _contentView() {
	        this._send({
	            event: 'content-view',
	        });
	    }
	    _orderData(data) {
	        this._send({
	            event: 'order_data',
	            order: data,
	            orderConverions: data.conversions,
	            orderId: data.guid,
	        });
	    }
	    _purchase(order) {
	        let eventGuidName = '|-|';
	        if (order.events.length) {
	            const lastEvent = order.events[order.events.length - 1];
	            eventGuidName = lastEvent ? `${lastEvent.guid}|-|${lastEvent.name}` : '|-|';
	        }
	        const payment = Object.values(order.payment_map)[0];
	        if (!payment) {
	            return;
	        }
	        const event = {
	            event: 'purchase',
	            ecommerce: {
	                purchase: {
	                    actionField: {
	                        id: order.shop.guid,
	                        affiliation: order.shop.name,
	                        revenue: parsePricing(order.finn_price),
	                        action: 'purchase',
	                        step: 2,
	                    },
	                    products: Object.values(order.ticket_map).map((orderTicket) => {
	                        let coupon = '';
	                        for (const product of orderTicket.products) {
	                            if (product.coupon_code) {
	                                coupon = product.coupon_code.code;
	                            }
	                        }
	                        return {
	                            coupon,
	                            id: orderTicket.ticket.guid,
	                            name: orderTicket.ticket.name,
	                            price: parsePricing(orderTicket.finn_price - orderTicket.finn_service_fee),
	                            quantity: 1,
	                        };
	                    }),
	                },
	            },
	            label: eventGuidName,
	            value: parsePricing(payment.finn_value),
	        };
	        this._send(event);
	    }
	    addGTM(code) {
	        // Load Google Tag Manager js
	        const w = window;
	        const d = document;
	        const s = 'script';
	        const l = 'dataLayer';
	        w[l] = w[l] || [];
	        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
	        // @ts-expect-error
	        const e = {
	            'gtm.start': new Date().getTime(),
	            event: 'gtm.js',
	        };
	        w[l].push(e);
	        const f = d.getElementsByTagName(s)[0];
	        const j = d.createElement(s);
	        // const dl = l !== 'dataLayer' ? `&l=${l}` : '';
	        const dl = '';
	        j.async = true;
	        j.src = `https://www.googletagmanager.com/gtm.js?id=${code}${dl}`;
	        if (f.parentNode) {
	            f.parentNode.insertBefore(j, f);
	        }
	        else {
	            d.head.appendChild(j);
	        }
	        // Insert Google Tag Manager IFrame
	        const noscript = document.createElement('noscript');
	        const iframe = document.createElement('iframe');
	        iframe.src = `https://www.googletagmanager.com/ns.html?id=${code}`;
	        iframe.height = '0';
	        iframe.width = '0';
	        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
	        // @ts-expect-error
	        // noinspection JSConstantReassignment
	        iframe.style = 'display:none;visibility:hidden';
	        noscript.appendChild(iframe);
	        const { body } = document;
	        body.insertBefore(noscript, body.firstChild);
	    }
	    _send(event) {
	        if (!window.dataLayer) {
	            window.dataLayer = [];
	        }
	        window.dataLayer.push({
	            ...event,
	            userId: this._sessionId,
	            'content-name': window.location.pathname,
	        });
	    }
	}

	class OrderError extends helpers.exports.StringError {
	}

	class OrderRefundItemError extends helpers.exports.BaseError {
	    constructor() {
	        super(...arguments);
	        this._level = helpers.exports.LevelNumber.Debug;
	    }
	    toSlug() {
	        return {
	            data: {
	                name: this.data.name,
	            },
	            key: 'sdk.errors.not_refundable',
	        };
	    }
	    toString() {
	        return `Not refundable ${this.data.type} ${this.data.guid}`;
	    }
	    additionalFlatData() {
	        return this.data;
	    }
	}

	function jsonStringify(value, or) {
	    try {
	        return JSON.stringify(value);
	    }
	    catch (e) {
	        return or;
	    }
	}
	class OrderRefundMessage extends helpers.exports.BaseError {
	    constructor(slug, data) {
	        super(data);
	        this._level = helpers.exports.LevelNumber.Debug;
	        this._slug = slug;
	    }
	    toSlug() {
	        return {
	            key: this._slug,
	        };
	    }
	    toString() {
	        return `Refund debug message: ${this.toSlug().key}`;
	    }
	    additionalFlatData() {
	        const flatData = {
	            donatePercentage: jsonStringify(this.data.donatePercentage, 'NaN'),
	            items: jsonStringify(this.data.items, '[]'),
	            refundSetting: jsonStringify(this.data.refundSetting, 'null'),
	            toVoucher: jsonStringify(this.data.toVoucher, 'null'),
	        };
	        if (this.data.refundOrderId) {
	            flatData.refundOrderId = this.data.refundOrderId;
	        }
	        if (this.data.refundAmount) {
	            flatData.refundAmount = jsonStringify(this.data.refundAmount, 'NaN');
	        }
	        if (this.data.refundRedirectUrl) {
	            flatData.refundRedirectUrl = this.data.refundRedirectUrl;
	        }
	        return flatData;
	    }
	}

	// An UnknownOrderError should never occur.
	// It should only be used for unexpected errors.
	// The specific error should only appear ONCE the logs,
	// after which that particular error should be handled properly.
	class UnknownOrderError extends OrderError {
	    constructor(slug, message, error) {
	        super(slug, message);
	        this._error = error;
	    }
	    additionalFlatData() {
	        if (!this._error) {
	            return {
	                error: 'Unknown',
	            };
	        }
	        try {
	            const data = {
	                error: JSON.stringify({
	                    ...this._error,
	                }),
	                errorMessage: this._error.message,
	                errorName: this._error.name,
	            };
	            if (this._error.stack) {
	                data.errorStack = this._error.stack;
	            }
	            return data;
	        }
	        catch (e) {
	            if (e instanceof Error) {
	                return { error: 'Unknown', jsonError: `${e.name}: ${e.message}` };
	            }
	            return { error: 'Unknown', jsonError: 'Unknown' };
	        }
	    }
	}

	const POLL_DELAY = 10000;
	const POLL_TIME = 10 * 60 * 1000;
	const CANCELLED_STATUSES = ['cancelled', 'refunded', 'expired', 'failed'];
	const PENDING_STATUSES = ['pending', 'verify', 'paid decide', 'refunding'];
	const MAX_TICKETS_ALLOWED_FOR_POLLING = 10;
	/**
	 *  Determine if an event's refund limit has been reached.
	 *
	 *  This is the case iff the event has a refundable status,
	 *  there is a time limit set for visitors to request a refund
	 *  (otherwise requesting a refund is not necessary: all items will be refunded)
	 *  and the time limit has expired.
	 */
	function isNoLongerRefundableEvent(event) {
	    let statusUntil = null;
	    if (event.status_until) {
	        statusUntil = event.status_until;
	    }
	    else if (event.refund_setting && event.refund_setting.status_until) {
	        statusUntil = event.refund_setting.status_until;
	    }
	    // Tickets that do not have a time limit on refund requests can not be returned through the sdk.
	    // However, it is not a 'limit that has passed', therefore the check returns false!
	    if (!statusUntil) {
	        console.warn('event has no time limit on refund requests');
	        return false;
	    }
	    // Tickets from events that have a time limit on refund requests
	    // that have expired can no longer be returned through the sdk.
	    if (new Date(statusUntil) < new Date()) {
	        console.warn('event refund status passed', statusUntil, (new Date(statusUntil) < new Date()), new Date(statusUntil));
	        return true;
	    }
	    return false;
	}
	/**
	 *  Determine if an event is refundable.
	 *
	 *  This is the case iff the event has a refundable status,
	 *  there is a time limit set for visitors to request a refund
	 *  (otherwise requesting a refund is not necessary: all items will be refunded)
	 *  and the time limit has not expired yet.
	 */
	function isRefundableEvent(event) {
	    // Tickets from events that are not refunding or moving can not be returned through the sdk.
	    if (!['refunding', 'moving'].includes(event.status)) {
	        console.warn('not refunding/moving');
	        return false;
	    }
	    let statusUntil = null;
	    if (event.status_until) {
	        statusUntil = event.status_until;
	    }
	    else if (event.refund_setting && event.refund_setting.status_until) {
	        statusUntil = event.refund_setting.status_until;
	    }
	    // Tickets that do not have a time limit on refund requests can not be returned through the sdk.
	    if (!statusUntil) {
	        console.warn('event has no time limit on refund requests');
	        return false;
	    }
	    // Tickets from events that have a time limit on refund requests
	    // that have expired can not be returned through the sdk.
	    if (new Date(statusUntil) < new Date()) {
	        console.warn('event refund status passed', statusUntil, (new Date(statusUntil) < new Date()), new Date(statusUntil));
	        return false;
	    }
	    return true;
	}
	/**
	 *  Determine if an ordered product is refundable.
	 *
	 *  This is the case iff the product is from the currently evaluated event,
	 *  has been bought before the refundable before date (not yet implemented) and is not invalidated.
	 */
	function isRefundableProduct(event, orderProduct) {
	    // Refunding only happens per event.
	    // Any items not from that event can not be refunded!
	    if (orderProduct.product.event_id !== event.guid) {
	        console.warn('invalid event_id');
	        return false;
	    }
	    // TODO Refund settings refundable before
	    // Already invalidated products can not be refunded through the sdk.
	    return !orderProduct.invalidated_since;
	}
	/**
	 *  Determine if an ordered ticket is refundable.
	 *
	 *  This is the case iff the ticket is from the currently evaluated event,
	 *  has been bought before the refundable before date (not yet implemented) and is not invalidated.
	 */
	function isRefundableTicket(event, orderTicket) {
	    // Refunding only happens per event.
	    // Any items not from that event can not be refunded!
	    if (orderTicket.ticket.event_id !== event.guid) {
	        console.warn('invalid event_id');
	        return false;
	    }
	    // TODO Refund settings refundable before
	    // Already invalidated tickets can not be refunded through the sdk.
	    return !orderTicket.invalidated_since;
	}
	/**
	 *  Determine if an item blocks the return of payment (fees).
	 *
	 *  This is the case iff any valid items are left in the order after processing the refund request.
	 */
	function orderItemBlocksPaymentReturn(returnItems, item, type) {
	    // If the current checked ticket is already invalidated, don't block payment return
	    // This also counts for tickets that are not refunded.
	    if (item.invalidated_since) {
	        return false;
	    }
	    // If the current checked ticket is being returned, don't block payment return
	    if (returnItems.find((returnItem) => returnItem.type === type && returnItem.guid === item.guid)) {
	        return false;
	    }
	    // When any items are left valid after the refund, the payment (fees) should not be returned through the sdk.
	    return true;
	}
	function getOrderErrorSlug(errors) {
	    for (const error of errors) {
	        if (!error.reason) {
	            continue;
	        }
	        switch (error.reason) {
	            case 'cannot execute refund for order, please enter IBAN information':
	                return 'sdk.order.errors.refund_iban';
	            case 'Order cannot be found':
	                return 'sdk.order.errors.refund_order_not_found';
	            case 'Cannot handle returns for order, it was never paid':
	                return 'sdk.order.errors.refund_never_paid';
	            case 'payment present more than once':
	                return 'sdk.order.errors.refund_payment_duplicate';
	            case 'ticket present more than once':
	                return 'sdk.order.errors.refund_ticket_duplicate';
	            case 'product present more than once':
	                return 'sdk.order.errors.refund_product_duplicate';
	            case 'product not found':
	                return 'sdk.order.errors.refund_product_not_found';
	            case 'ticket not found':
	                return 'sdk.order.errors.refund_ticket_not_found';
	            case 'payment not found':
	                return 'sdk.order.errors.refund_payment_not_found';
	            case 'Arbitrary return larger than sum of item values':
	                return 'sdk.order.errors.refund_arbitrary_larger_than_sum';
	        }
	    }
	    return 'sdk.order.errors.failed_to_build_refund_order';
	}
	function marshalOrderError(e) {
	    if (e.response && e.response.data && e.response.data.errors && Array.isArray(e.response.data.errors)) {
	        const messages = e.response.data.errors
	            .map((error) => error.reason || '')
	            .filter((val) => !!val)
	            .join('\n');
	        return new OrderError(getOrderErrorSlug(e.response.data.errors), `Error while building refund order: ${messages}`);
	    }
	    return new UnknownOrderError('sdk.order.errors.failed_to_build_refund_order', 'Error while building refund order', e);
	}
	class OrderClient {
	    constructor(config) {
	        this.initialized = false;
	        this._orderBuilder = null;
	        this.isPolling = false;
	        this._http = axios.create();
	        this._initAt = new Date();
	        this.validator = new OrderValidator();
	        this.tracking = new OrderTracking();
	        this.logger = new helpers.exports.Logger('order', config);
	    }
	    async init(config) {
	        try {
	            if (config.loggingUrl) {
	                const output = this.logger.addOutput(helpers.exports.ServiceOutput, {
	                    baseUrl: config.loggingUrl,
	                });
	                if (config.loggingLevel !== undefined) {
	                    output.setLevel(config.loggingLevel);
	                }
	            }
	            else {
	                this.logger.log(new OrderError('sdk.order.init.no_logging_url_provided', 'No loggingUrl provided for external logging'));
	            }
	            this._config = config;
	            this._http.defaults.baseURL = urljoin(this._config.baseUrl, 'order');
	            const response = await this._http.get(`${this._config.orderGuid}?conversions=1`);
	            this._rawData = response.data;
	            this.data = OrderParser.parse(JSON.parse(JSON.stringify(response.data)));
	            this.initialized = true;
	            if (config.gtmCode) {
	                this.tracking.addGTM(config.gtmCode);
	            }
	            if (this.data.shop.google_tag) {
	                this.tracking.addGTM(this.data.shop.google_tag);
	            }
	            // If order.download_ready is true, all ticket pdf's are available
	            if (this.data.download_ready) {
	                for (const ticket of this.data.tickets) {
	                    if (!ticket.computed_download_ready) {
	                        ticket.computed_download_ready = true;
	                    }
	                }
	            }
	            void this._startPolling(POLL_DELAY);
	        }
	        catch (e) {
	            this.logger.throw(new OrderError('sdk.order.init.failed', `Failed to initialize OrderClient: ${e}`));
	        }
	    }
	    startPolling() {
	        void this._startPolling();
	    }
	    async _startPolling(initialDelay) {
	        // Do not poll if payment is cancelled
	        if (CANCELLED_STATUSES.includes(this.data.status)) {
	            return;
	        }
	        this.isPolling = true;
	        // Initial delay before polling starts
	        if (initialDelay) {
	            await new Promise((resolve) => {
	                setTimeout(() => {
	                    resolve();
	                }, initialDelay);
	            });
	        }
	        // Number of polling iterations
	        let iterations = Math.ceil(POLL_TIME / POLL_DELAY);
	        // If the order should updated on a poll
	        let shouldPollOrder = this._shouldPollOrder();
	        // What tickets should be updated on a poll
	        let pollableTickets = this._pollableTickets();
	        while (iterations && (shouldPollOrder || pollableTickets.length)) {
	            const response = await this._http.get(this._config.orderGuid);
	            const order = OrderParser.parse(response.data);
	            if (shouldPollOrder) {
	                this._updateOrder(order);
	                shouldPollOrder = this._shouldPollOrder();
	            }
	            // Only update tickets when order status is not pending
	            if (!PENDING_STATUSES.includes(this.data.status)) {
	                const promises = pollableTickets.map((ticketGuid) => {
	                    const newTicket = order.ticket_map[ticketGuid];
	                    return this._updateTicket(newTicket);
	                });
	                await Promise.all(promises);
	                pollableTickets = this._pollableTickets();
	            }
	            // Delay before the next poll
	            await new Promise((resolve) => {
	                setTimeout(() => {
	                    resolve();
	                }, POLL_DELAY);
	            });
	            iterations--;
	        }
	        this.isPolling = false;
	    }
	    _shouldPollOrder() {
	        if (this.data.status === 'paid') {
	            return !this.data.download_link || !this.data.download_ready;
	        }
	        return !CANCELLED_STATUSES.includes(this.data.status);
	    }
	    _pollableTickets() {
	        return Object.values(this.data.ticket_map).filter((ticket) => {
	            if (ticket.invalidated_since || ticket.retrievable_after) {
	                return false;
	            }
	            return !ticket.is_complete || !ticket.download_link || !ticket.computed_download_ready;
	        }).map((ticket) => ticket.guid);
	    }
	    _updateOrder(order) {
	        this.data.status = order.status;
	        this.data.download_link = order.download_link;
	        // If order.download_ready is true, all ticket pdf's are available
	        if (!this.data.download_ready && order.download_ready) {
	            for (const ticket of this.data.tickets) {
	                if (!ticket.computed_download_ready) {
	                    ticket.computed_download_ready = true;
	                }
	            }
	        }
	        this.data.download_ready = order.download_ready;
	    }
	    async _updateTicket(newTicket) {
	        const ticket = this.data.ticket_map[newTicket.guid];
	        ticket.download_link = newTicket.download_link;
	        ticket.is_complete = newTicket.is_complete;
	        if (!ticket.is_complete || !ticket.download_link || ticket.computed_download_ready) {
	            return;
	        }
	        // Cap the maximum amount of poll requests, DDL: Frontend 271E
	        if (this.data.tickets.length > MAX_TICKETS_ALLOWED_FOR_POLLING) {
	            return;
	        }
	        try {
	            await this._http.head(`${ticket.download_link}`);
	            ticket.computed_download_ready = true;
	        }
	        catch (e) {
	            // NO-OP
	        }
	    }
	    /**
	     *  Compute the booker information for the refund order.
	     */
	    getBookerInfo() {
	        const booker = factoryBookerCartMetadata();
	        booker.firstname.value = this.data.firstName;
	        booker.lastname.value = this.data.lastName;
	        booker.email.value = this.data.email;
	        return booker;
	    }
	    /**
	     *  Compute the payment method info.
	     *
	     *  For now, only orders with 1 payment can be refunded through the sdk.
	     */
	    getPaymentMethodInfo() {
	        const payments = Object.values(this.data.payment_map);
	        if (!payments.length) {
	            this.logger.throw(new OrderError('sdk.order.errors.refund_without_payment', 'Cannot refund order without payment'));
	        }
	        else if (payments.length !== 1) {
	            this.logger.throw(new OrderError('sdk.order.errors.refund_with_multiple_payments', 'Cannot refund order with multiple payments'));
	        }
	        return {
	            currency: payments[0].currency,
	            is_stripe: false,
	            item: {
	                guid: payments[0].payment_method_id,
	            },
	        };
	    }
	    /**
	     *  Compute a set of return items for the given event and list of tickets.
	     *
	     *  This will check if the event is refundable and
	     *  if all tickets and its children (i.e.: products) in the list are refundable.
	     */
	    getReturnItems(event, tickets, refundSetting) {
	        if (!isRefundableEvent(event)) {
	            return [];
	        }
	        const returnItems = [];
	        for (const orderTicket of tickets) {
	            if (!isRefundableTicket(event, orderTicket)) {
	                this.logger.log(new OrderRefundItemError({
	                    guid: orderTicket.ticket.guid,
	                    message: `Not refundable ${orderTicket.ticket.name}`,
	                    name: orderTicket.ticket.name,
	                    slug: 'sdk.order.errors.not_refundable',
	                    type: 'ticket',
	                }));
	                continue;
	            }
	            for (const orderProduct of orderTicket.products) {
	                if (!isRefundableProduct(event, orderProduct)) {
	                    this.logger.log(new OrderRefundItemError({
	                        guid: orderProduct.product.guid,
	                        message: `Not refundable ${orderProduct.product.name}`,
	                        name: orderProduct.product.name,
	                        slug: 'sdk.order.errors.not_refundable',
	                        type: 'product',
	                    }));
	                    continue;
	                }
	                returnItems.push({ guid: orderProduct.guid, type: 'product' });
	            }
	            returnItems.push({ guid: orderTicket.guid, type: 'ticket' });
	        }
	        if (refundSetting.refund_transaction_fees && this.shouldReturnPayments(returnItems)) {
	            returnItems.push(...Object.values(this.data.payment_map).map((payment) => ({
	                guid: payment.guid,
	                type: 'payment',
	            })));
	        }
	        return returnItems;
	    }
	    /**
	     *  Initialize the order builder.
	     *
	     *  This is required only when a refund is requested, therefore initialization should be lazy.
	     */
	    initOrderBuilder() {
	        if (!this._orderBuilder) {
	            this._orderBuilder = new Orderbuilder({
	                baseUrl: this._config.baseUrl,
	                guid: this.data.shop_id,
	            });
	        }
	        return this._orderBuilder;
	    }
	    /**
	     *  Request a refund
	     *
	     *  This requires a set of items to be returned and a linked payout profile.
	     */
	    async requestRefund(refundSetting, items, toVoucher = false, donatePercentage = 0) {
	        const logData = {
	            donatePercentage,
	            items,
	            refundSetting,
	            toVoucher,
	        };
	        this.logger.log(new OrderRefundMessage('sdk.order.refund.about_to_request', logData));
	        const orderBuilder = this.initOrderBuilder();
	        const returnOptions = {
	            includes_fees: refundSetting.refund_fees,
	            items,
	            order_id: this.data.guid,
	            reason: 'return by visitor',
	            to_voucher: toVoucher,
	        };
	        if (!refundSetting.refundable_by_voucher) {
	            returnOptions.to_voucher = false;
	        }
	        else if (!refundSetting.refundable_by_payment) {
	            returnOptions.to_voucher = true;
	        }
	        if (refundSetting.refund_donate_enabled && donatePercentage) {
	            returnOptions.donate_percentage = donatePercentage;
	        }
	        const orderBuilderOptions = {
	            // Required, static booker info
	            booker: {
	                bookerInfo: this.getBookerInfo(),
	                locale: this.data.locale,
	            },
	            cartInitAt: this._initAt,
	            extraTechData: {
	                originalOrderId: this.data.guid,
	            },
	            // Chosen payment method and needed info
	            paymentMethod: this.getPaymentMethodInfo(),
	            // The items to return
	            return: returnOptions,
	        };
	        try {
	            const response = await orderBuilder.handle(orderBuilderOptions);
	            /* eslint-disable @typescript-eslint/ban-ts-comment,@typescript-eslint/no-unsafe-assignment */
	            // TODO SDK-Shop PlaceOrderResponse interface is not complete yet!
	            //  Eslint & ts-ignore comments should be removed once this is done!
	            // @ts-ignore
	            logData.refundAmount = response.amount;
	            // @ts-ignore
	            logData.refundOrderId = response.order_id;
	            // @ts-ignore
	            logData.refundRedirectUrl = response.redirectUrl;
	            /* eslint-enable @typescript-eslint/ban-ts-comment */
	            this.logger.log(new OrderRefundMessage('sdk.order.refund.success', logData));
	            return response;
	        }
	        catch (e) {
	            this.logger.throw(marshalOrderError(e));
	        }
	        return Promise.reject();
	    }
	    /**
	     *  Determine if the payment should also be returned.
	     *
	     *  This is the case iff all tickets (including its products) and global products
	     *  are already invalidated or are currently being returned.
	     */
	    shouldReturnPayments(items) {
	        // TODO: Try and rework to an array of order_tickets instead of looping over the map.
	        for (const orderTicketId in this.data.ticket_map) {
	            if (!Object.prototype.hasOwnProperty.call(this.data.ticket_map, orderTicketId)) {
	                continue;
	            }
	            const orderTicket = this.data.ticket_map[orderTicketId];
	            if (orderItemBlocksPaymentReturn(items, orderTicket, 'ticket')) {
	                return false;
	            }
	            for (const orderProduct of orderTicket.products) {
	                if (orderItemBlocksPaymentReturn(items, orderProduct, 'product')) {
	                    return false;
	                }
	            }
	        }
	        for (const globalProduct of this.data.global_products) {
	            if (orderItemBlocksPaymentReturn(items, globalProduct, 'product')) {
	                return false;
	            }
	        }
	        return true;
	    }
	    async saveTicketMetadata(ticket) {
	        const metadata = Array.from(ticket.metadata);
	        for (const product of ticket.products) {
	            metadata.push(...product.metadata);
	        }
	        const response = await this._saveMetadata(metadata, ticket.guid, 'ticket');
	        if (response.order) {
	            const updatedTicket = response.order.tickets.find((t) => t.guid === ticket.guid);
	            if (updatedTicket) {
	                ticket.is_complete = !!updatedTicket.is_complete;
	                ticket.download_link = updatedTicket.download_link ? updatedTicket.download_link : null;
	            }
	        }
	        return response.personalize;
	    }
	    async _saveMetadata(metadata, guid, type) {
	        const errors = {};
	        for (const meta of metadata) {
	            const validation = this.validator.metadata(meta, true);
	            if (!validation.valid) {
	                errors[meta.item.name] = validation.message;
	            }
	        }
	        if (errors.length) {
	            this.logger.throw(new helpers.exports.FormValidationError({
	                slug: 'liborder.validation_error',
	                messages: errors,
	            }));
	        }
	        const data = {
	            // TODO: Invites are not supported for now, this will be implemented separately
	            //  Note invites are currently getting a small change in API (2021-06-21)
	            send_email: false,
	            values: metadata
	                .filter((m) => !!m.is_required || (m.value !== null && m.value !== ''))
	                .map((m) => ({
	                metadata_id: m.item.guid,
	                order_metadata_id: m.guid,
	                value: m.value,
	            })),
	        };
	        const personalizeResponse = (await this._http.put(`${this._config.baseUrl}/personalize/${type}/${guid}`, data)).data;
	        if (personalizeResponse.errors.length) {
	            return { personalize: personalizeResponse };
	        }
	        const orderResponse = (await this._http.get(`${this._config.orderGuid}`)).data;
	        // Check if order is complete after late personalisation
	        if (orderResponse.is_complete) {
	            this.data.is_complete = true;
	            this.data.download_link = orderResponse.download_link ? orderResponse.download_link : null;
	            this.data.download_ready = orderResponse.download_ready;
	        }
	        return {
	            order: orderResponse,
	            personalize: personalizeResponse,
	        };
	    }
	    // eslint-disable-next-line @typescript-eslint/require-await
	    async sendInvite() {
	        // ticket: string, email: string, name: string
	        // TODO
	        throw new Error('Invites currently disabled');
	    }
	    sendLegacyEvents() {
	        if (!this.initialized) {
	            this.logger.throw(new OrderError('sdk.order.tracking.conversion.error.initialized', 'Failed to send legacy tracking events. Cannot track anything before order client initialization.'));
	        }
	        try {
	            this.tracking.sendLegacyEvents(this._rawData, this.data);
	        }
	        catch (e) {
	            this.logger.throw(new OrderError('sdk.order.tracking.conversion.failed', 'Failed to send legacy tracking events'));
	        }
	    }
	    sendLegacyEventsWithoutConversion() {
	        if (!this.initialized) {
	            this.logger.throw(new OrderError('sdk.order.tracking.noconversion.error.initialized', 'Failed to send legacy tracking events without conversion. Cannot track anything before order client initialization.'));
	        }
	        try {
	            this.tracking.sendLegacyEventsWithoutConversion();
	        }
	        catch (e) {
	            this.logger.throw(new OrderError('sdk.order.tracking.noconversion.failed', 'Failed to send legacy tracking events without conversion'));
	        }
	    }
	}

	exports["default"] = OrderClient;
	exports.isNoLongerRefundableEvent = isNoLongerRefundableEvent;
	exports.isRefundableEvent = isRefundableEvent;
	exports.isRefundableProduct = isRefundableProduct;
	exports.isRefundableTicket = isRefundableTicket;

	Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=order.js.map
